/* tslint:disable */
/* eslint-disable */
/**
 * NETS(EFT) SET REST API
 * \"This module contains services to maintain surface design  \"
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AILog
 */
export interface AILog {
    /**
     * 
     * @type {number}
     * @memberof AILog
     */
    'aiLogsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AILog
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AILog
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof AILog
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AILog
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AILog
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AILog
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AILog
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof AILog
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AILog
     */
    'logMessageList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AILog
     */
    'logMessagesJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof AILog
     */
    'postNodeActionJson'?: string;
}
/**
 * 
 * @export
 * @interface AILogRequestDTO
 */
export interface AILogRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof AILogRequestDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AILogRequestDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof AILogRequestDTO
     */
    'description'?: string;
    /**
     * 
     * @type {Array<Entrystringstring>}
     * @memberof AILogRequestDTO
     */
    'processLogList'?: Array<Entrystringstring>;
}
/**
 * 
 * @export
 * @interface ActivityLogRequest
 */
export interface ActivityLogRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'activityContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'appAccessed'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'crudCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityLogRequest
     */
    'deleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'projUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'projectStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogRequest
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface ActivityLogResponse
 */
export interface ActivityLogResponse {
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'activityContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'appAccessed'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'creationDateUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'crudCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'lastChangeDateUtc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'projUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'projectStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogResponse
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface ActivitySummaryResponse
 */
export interface ActivitySummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'approvedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'approvedByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'approvedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'archivedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'archivedByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'archivedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'createdByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'designedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'designedByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'designedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'inProgressBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'inProgressByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'inProgressDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastAccessedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastAccessedByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastAccessedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastModifiedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastModifiedByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastModifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastReviewedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastReviewedByCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'lastReviewedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'projUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivitySummaryResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface AdjacentTerracesOrWaterwaysRequestDTO
 */
export interface AdjacentTerracesOrWaterwaysRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof AdjacentTerracesOrWaterwaysRequestDTO
     */
    'alignedElementParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdjacentTerracesOrWaterwaysRequestDTO
     */
    'searchDistance'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdjacentTerracesOrWaterwaysRequestDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {InputPoint}
     * @memberof AdjacentTerracesOrWaterwaysRequestDTO
     */
    'sourceStationPoint'?: InputPoint;
}
/**
 * 
 * @export
 * @interface AdjacentTerracesOrWaterwaysResponseDTO
 */
export interface AdjacentTerracesOrWaterwaysResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof AdjacentTerracesOrWaterwaysResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<MatchVertex>}
     * @memberof AdjacentTerracesOrWaterwaysResponseDTO
     */
    'matchedVertices'?: Array<MatchVertex>;
}
/**
 * 
 * @export
 * @interface AlignedElementCrossSectionRequest
 */
export interface AlignedElementCrossSectionRequest {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementCrossSectionRequest
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlignedElementCrossSectionRequest
     */
    'displayCurrentStationOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementCrossSectionRequest
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementCrossSectionRequest
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementCrossSectionRequest
     */
    'station'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementCrossSectionRequest
     */
    'stationIncrement'?: number;
}
/**
 * 
 * @export
 * @interface AlignedElementCrossSectionResponse
 */
export interface AlignedElementCrossSectionResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof AlignedElementCrossSectionResponse
     */
    'neighborStations'?: Array<number>;
    /**
     * 
     * @type {Array<StructureCrossSectionResponse>}
     * @memberof AlignedElementCrossSectionResponse
     */
    'structureCrossSectionResponses'?: Array<StructureCrossSectionResponse>;
}
/**
 * 
 * @export
 * @interface AlignedElementDesignParameters
 */
export interface AlignedElementDesignParameters {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'alignedFeatureDesignShapeJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'alignedFeatureName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'alignedFeatureSCChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'alignmentChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'alignmentSeedingBuffer'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'benchmarkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'benchmarkElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'benchmarkName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'constructBenchmark'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'creationDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'deleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'designControlJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'hydroChange'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'hydroParamsJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'reachesChange'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParameters
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParameters
     */
    'surfaceChange'?: number;
}
/**
 * 
 * @export
 * @interface AlignedElementDesignParamsRequestDTO
 */
export interface AlignedElementDesignParamsRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'alignedFeatureDesignShapeJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'alignedFeatureName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'alignedFeatureSCChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'alignmentChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'alignmentSeedingBuffer'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'benchmarkElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'benchmarkName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'channelEndGradeLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'channelStartGradeLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'constructBenchmark'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'designControlJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'hydroChange'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'hydroParamsJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'seedingBufferOption'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'surfaceChange'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsRequestDTO
     */
    'waterwayMiscDTO'?: string;
}
/**
 * 
 * @export
 * @interface AlignedElementDesignParamsResponseDTO
 */
export interface AlignedElementDesignParamsResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'alignedFeatureName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'reversedAlignment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementDesignParamsResponseDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface AlignedElementIdWithLiningMaterialDTO
 */
export interface AlignedElementIdWithLiningMaterialDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementIdWithLiningMaterialDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementIdWithLiningMaterialDTO
     */
    'waterwayMaterial'?: string;
}
/**
 * 
 * @export
 * @interface AlignedElementIdsAndNotificationsDto
 */
export interface AlignedElementIdsAndNotificationsDto {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'alignedFeatureSCChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'alignmentChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'hydroChange'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'projectStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'reachesChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'surfaceChange'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementIdsAndNotificationsDto
     */
    'waterwayName'?: string;
}
/**
 * 
 * @export
 * @interface AlignedElementShapeDTO
 */
export interface AlignedElementShapeDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignedElementShapeDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementShapeDTO
     */
    'alignedFeatureDesignShapeJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementShapeDTO
     */
    'comments'?: string;
}
/**
 * 
 * @export
 * @interface AlignedElementsWithNotificationsAndStatusResponse
 */
export interface AlignedElementsWithNotificationsAndStatusResponse {
    /**
     * 
     * @type {Array<AlignedElementIdsAndNotificationsDto>}
     * @memberof AlignedElementsWithNotificationsAndStatusResponse
     */
    'alignedElementIdsAndNotificationsDtoList'?: Array<AlignedElementIdsAndNotificationsDto>;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementsWithNotificationsAndStatusResponse
     */
    'validationStatusErrorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedElementsWithNotificationsAndStatusResponse
     */
    'validationStatusMessage'?: string;
}
/**
 * 
 * @export
 * @interface AlignedFeatureDesignShapeResponseDTO
 */
export interface AlignedFeatureDesignShapeResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {AlignedStructureShapeDTO}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'alignedStructureShapeDTO'?: AlignedStructureShapeDTO;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'contourLines'?: Array<ContourLineData>;
    /**
     * 
     * @type {string}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'createBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: XyzPoint; }>}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'crossSectionGeometries'?: Array<{ [key: string]: XyzPoint; }>;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'lastChangeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'maxCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'maxFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'seedingArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'status'?: string;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'tinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'totalFieldArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignedFeatureDesignShapeResponseDTO
     */
    'totalThicknessCut'?: number;
}
/**
 * 
 * @export
 * @interface AlignedStructureShapeDTO
 */
export interface AlignedStructureShapeDTO {
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof AlignedStructureShapeDTO
     */
    'borderPolygons'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof AlignedStructureShapeDTO
     */
    'bottomCenterLines'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {{ [key: string]: Array<BreaklineDTO>; }}
     * @memberof AlignedStructureShapeDTO
     */
    'breaklinesMap'?: { [key: string]: Array<BreaklineDTO>; };
    /**
     * 
     * @type {string}
     * @memberof AlignedStructureShapeDTO
     */
    'channelShape'?: string;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof AlignedStructureShapeDTO
     */
    'connectedLines'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof AlignedStructureShapeDTO
     */
    'crossPolygons'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<LineSegmentDto>}
     * @memberof AlignedStructureShapeDTO
     */
    'leftArrows'?: Array<LineSegmentDto>;
    /**
     * 
     * @type {Array<Polygon>}
     * @memberof AlignedStructureShapeDTO
     */
    'polygons'?: Array<Polygon>;
    /**
     * 
     * @type {Array<LineSegmentDto>}
     * @memberof AlignedStructureShapeDTO
     */
    'rightArrows'?: Array<LineSegmentDto>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof AlignedStructureShapeDTO
     */
    'seedingPolygons'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {{ [key: string]: Array<InputPoint>; }}
     * @memberof AlignedStructureShapeDTO
     */
    'structurePolygons'?: { [key: string]: Array<InputPoint>; };
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof AlignedStructureShapeDTO
     */
    'waterLevelLines'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof AlignedStructureShapeDTO
     */
    'waterflowDirections'?: Array<Array<InputPoint>>;
}
/**
 * 
 * @export
 * @interface AlignmentAOIRequest
 */
export interface AlignmentAOIRequest {
    /**
     * 
     * @type {Array<AlignmentStationAOIRequest>}
     * @memberof AlignmentAOIRequest
     */
    'alignmentStations'?: Array<AlignmentStationAOIRequest>;
    /**
     * 
     * @type {string}
     * @memberof AlignmentAOIRequest
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentAOIRequest
     */
    'surveyCoordinateSystem'?: string;
}
/**
 * 
 * @export
 * @interface AlignmentAOIResponse
 */
export interface AlignmentAOIResponse {
    /**
     * 
     * @type {string}
     * @memberof AlignmentAOIResponse
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentAOIResponse
     */
    'shape'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentAOIResponse
     */
    'srId'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentBySurveyIdsRequest
 */
export interface AlignmentBySurveyIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlignmentBySurveyIdsRequest
     */
    'surveyIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AlignmentCoordinateRequest
 */
export interface AlignmentCoordinateRequest {
    /**
     * 
     * @type {number}
     * @memberof AlignmentCoordinateRequest
     */
    'alignmentDesignElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentCoordinateRequest
     */
    'stationName'?: string;
}
/**
 * 
 * @export
 * @interface AlignmentCoordinateResponse
 */
export interface AlignmentCoordinateResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof AlignmentCoordinateResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof AlignmentCoordinateResponse
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentCoordinateResponse
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentCopyParmDTO
 */
export interface AlignmentCopyParmDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignmentCopyParmDTO
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentCopyParmDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentCopyParmDTO
     */
    'alignmentOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentCopyParmDTO
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentCopyParmDTO
     */
    'numberOfAlignmentCopies'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentDTO
 */
export interface AlignmentDTO {
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'alignmentApplyCurves'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'alignmentAutoCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'alignmentAutoGrow'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'alignmentEntryMethod'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentDTO
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'alignmentIncreasing'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {Array<AlignmentStationDTO>}
     * @memberof AlignmentDTO
     */
    'alignmentStations'?: Array<AlignmentStationDTO>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof AlignmentDTO
     */
    'alignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {number}
     * @memberof AlignmentDTO
     */
    'beginningStationDis'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentDTO
     */
    'beginningX'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentDTO
     */
    'beginningY'?: number;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof AlignmentDTO
     */
    'curvedAlignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {number}
     * @memberof AlignmentDTO
     */
    'designElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'designElementName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'sessionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentDTO
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentDTO
     */
    'surveyId'?: string;
}
/**
 * 
 * @export
 * @interface AlignmentEditRequestDTO
 */
export interface AlignmentEditRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignmentEditRequestDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof AlignmentEditRequestDTO
     */
    'alignmentStationList'?: Array<InputPoint>;
}
/**
 * 
 * @export
 * @interface AlignmentEditResponseDTO
 */
export interface AlignmentEditResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof AlignmentEditResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof AlignmentEditResponseDTO
     */
    'maxOffsetDis'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentEditResponseDTO
     */
    'offsetCode'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentExportRequest
 */
export interface AlignmentExportRequest {
    /**
     * 
     * @type {number}
     * @memberof AlignmentExportRequest
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentExportRequest
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentExportRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentExportRequest
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentExportRequest
     */
    'sampling'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentForWDTParamsDTO
 */
export interface AlignmentForWDTParamsDTO {
    /**
     * 
     * @type {string}
     * @memberof AlignmentForWDTParamsDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentForWDTParamsDTO
     */
    'alignmentStations'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentForWDTParamsDTO
     */
    'designElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentForWDTParamsDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface AlignmentForWDTRequestDTO
 */
export interface AlignmentForWDTRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof AlignmentForWDTRequestDTO
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentForWDTRequestDTO
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface AlignmentForWDTResponseDTO
 */
export interface AlignmentForWDTResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof AlignmentForWDTResponseDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentForWDTResponseDTO
     */
    'designElementJsonId'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentMetadataRequest
 */
export interface AlignmentMetadataRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AlignmentMetadataRequest
     */
    'surveyIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AlignmentMetadataResponse
 */
export interface AlignmentMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof AlignmentMetadataResponse
     */
    'alignmentEntryMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentMetadataResponse
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentMetadataResponse
     */
    'beginningX'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentMetadataResponse
     */
    'beginningY'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentMetadataResponse
     */
    'surveyDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AlignmentMetadataResponse
     */
    'surveyId'?: string;
}
/**
 * 
 * @export
 * @interface AlignmentProfileRequest
 */
export interface AlignmentProfileRequest {
    /**
     * 
     * @type {number}
     * @memberof AlignmentProfileRequest
     */
    'beginningStationDis'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof AlignmentProfileRequest
     */
    'crossSectionLine'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof AlignmentProfileRequest
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentProfileRequest
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface AlignmentRenameRequest
 */
export interface AlignmentRenameRequest {
    /**
     * 
     * @type {string}
     * @memberof AlignmentRenameRequest
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentRenameRequest
     */
    'designElementId'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentResponse
 */
export interface AlignmentResponse {
    /**
     * 
     * @type {number}
     * @memberof AlignmentResponse
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentResponse
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentResponse
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentResponse
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentStationAOIRequest
 */
export interface AlignmentStationAOIRequest {
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'angle'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'angleType'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStationAOIRequest
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'curveType'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'curveValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'distance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'distanceToPiStation'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStationAOIRequest
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationAOIRequest
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentStationDTO
 */
export interface AlignmentStationDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'alignmentStationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'angle'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'angleType'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStationDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'curveType'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'curveValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStationDTO
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'distance'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'distanceToPiStation'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStationDTO
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentStationDTO
     */
    'stationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentStationDTO
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentTotalLengthDTO
 */
export interface AlignmentTotalLengthDTO {
    /**
     * 
     * @type {number}
     * @memberof AlignmentTotalLengthDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentTotalLengthDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentTotalLengthDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentTotalLengthDTO
     */
    'alignmentTotalLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof AlignmentTotalLengthDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof AlignmentTotalLengthDTO
     */
    'waterwayMaxStation'?: number;
    /**
     * 
     * @type {number}
     * @memberof AlignmentTotalLengthDTO
     */
    'waterwayMinStation'?: number;
}
/**
 * 
 * @export
 * @interface AlignmentsToCSVResponse
 */
export interface AlignmentsToCSVResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof AlignmentsToCSVResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof AlignmentsToCSVResponse
     */
    'zipFileName'?: string;
}
/**
 * 
 * @export
 * @interface AutoDefaultReachesRequest
 */
export interface AutoDefaultReachesRequest {
    /**
     * 
     * @type {number}
     * @memberof AutoDefaultReachesRequest
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AutoDefaultReachesRequest
     */
    'cutDepth'?: number;
    /**
     * 
     * @type {string}
     * @memberof AutoDefaultReachesRequest
     */
    'liningMaterial'?: string;
    /**
     * 
     * @type {number}
     * @memberof AutoDefaultReachesRequest
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof AutoDefaultReachesRequest
     */
    'maxStation'?: number;
    /**
     * 
     * @type {number}
     * @memberof AutoDefaultReachesRequest
     */
    'minStation'?: number;
    /**
     * 
     * @type {number}
     * @memberof AutoDefaultReachesRequest
     */
    'stationInterval'?: number;
}
/**
 * 
 * @export
 * @interface BasinCharacteristicsDTO
 */
export interface BasinCharacteristicsDTO {
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof BasinCharacteristicsDTO
     */
    'basinBoundary'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof BasinCharacteristicsDTO
     */
    'basinName'?: string;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof BasinCharacteristicsDTO
     */
    'basinOutlet'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof BasinCharacteristicsDTO
     */
    'dimUnitHydrog'?: string;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'frequency'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BasinCharacteristicsDTO
     */
    'fullHydroModel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasinCharacteristicsDTO
     */
    'latLongInfo'?: string;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'peakFlow'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'precipitation'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'qu'?: number;
    /**
     * 
     * @type {string}
     * @memberof BasinCharacteristicsDTO
     */
    'rainfallCellID'?: string;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'runoffQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof BasinCharacteristicsDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof BasinCharacteristicsDTO
     */
    'stormType'?: string;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'timeOfConcentrate'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'totalRunOff'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'watershedArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'watershedCN'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof BasinCharacteristicsDTO
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface BlockStationDTO
 */
export interface BlockStationDTO {
    /**
     * 
     * @type {string}
     * @memberof BlockStationDTO
     */
    'blockHeight'?: string;
    /**
     * 
     * @type {number}
     * @memberof BlockStationDTO
     */
    'limits'?: number;
    /**
     * 
     * @type {InputPoint}
     * @memberof BlockStationDTO
     */
    'location'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof BlockStationDTO
     */
    'sideSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof BlockStationDTO
     */
    'sideSlopeMode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BlockStationDTO
     */
    'splitSubbasin'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BlockStationDTO
     */
    'topWidth'?: number;
}
/**
 * 
 * @export
 * @interface BorderDTO
 */
export interface BorderDTO {
    /**
     * 
     * @type {Array<CgPoint>}
     * @memberof BorderDTO
     */
    'points'?: Array<CgPoint>;
}
/**
 * 
 * @export
 * @interface BoxDropInletDto
 */
export interface BoxDropInletDto {
    /**
     * 
     * @type {number}
     * @memberof BoxDropInletDto
     */
    'floorElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoxDropInletDto
     */
    'headAboveWeir'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoxDropInletDto
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoxDropInletDto
     */
    'weirElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoxDropInletDto
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface BoxDropInletResponseDTO
 */
export interface BoxDropInletResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof BoxDropInletResponseDTO
     */
    'capacityQ'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof BoxDropInletResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof BoxDropInletResponseDTO
     */
    'minChannelWidth'?: string;
    /**
     * 
     * @type {Array<StageDischargeDto>}
     * @memberof BoxDropInletResponseDTO
     */
    'stageDischargeList'?: Array<StageDischargeDto>;
    /**
     * 
     * @type {string}
     * @memberof BoxDropInletResponseDTO
     */
    'topZ'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BoxDropInletResponseDTO
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface BreakLineDataResponseDTO
 */
export interface BreakLineDataResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof BreakLineDataResponseDTO
     */
    'breaklineId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreakLineDataResponseDTO
     */
    'breaklineType'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreakLineDataResponseDTO
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreakLineDataResponseDTO
     */
    'featureName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreakLineDataResponseDTO
     */
    'json'?: string;
}
/**
 * 
 * @export
 * @interface BreaklineDTO
 */
export interface BreaklineDTO {
    /**
     * 
     * @type {number}
     * @memberof BreaklineDTO
     */
    'breaklineId'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof BreaklineDTO
     */
    'breaklinePoints'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof BreaklineDTO
     */
    'groupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineDTO
     */
    'reachId'?: string;
}
/**
 * 
 * @export
 * @interface BreaklineDataRequestDTO
 */
export interface BreaklineDataRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof BreaklineDataRequestDTO
     */
    'breaklineId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineDataRequestDTO
     */
    'breaklineType'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineDataRequestDTO
     */
    'editing_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineDataRequestDTO
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineDataRequestDTO
     */
    'featureName'?: string;
    /**
     * 
     * @type {Array<CgPoint>}
     * @memberof BreaklineDataRequestDTO
     */
    'points'?: Array<CgPoint>;
}
/**
 * 
 * @export
 * @interface BreaklineRequestDTO
 */
export interface BreaklineRequestDTO {
    /**
     * 
     * @type {Array<BreaklineDataRequestDTO>}
     * @memberof BreaklineRequestDTO
     */
    'breaklines'?: Array<BreaklineDataRequestDTO>;
    /**
     * 
     * @type {number}
     * @memberof BreaklineRequestDTO
     */
    'featureTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BreaklineRequestDTO
     */
    'surfaceDefId'?: number;
}
/**
 * 
 * @export
 * @interface BreaklineResponse
 */
export interface BreaklineResponse {
    /**
     * 
     * @type {string}
     * @memberof BreaklineResponse
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof BreaklineResponse
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface BreaklineResponseDTO
 */
export interface BreaklineResponseDTO {
    /**
     * 
     * @type {Array<BreakLineDataResponseDTO>}
     * @memberof BreaklineResponseDTO
     */
    'breakLineDataResponse'?: Array<BreakLineDataResponseDTO>;
    /**
     * 
     * @type {number}
     * @memberof BreaklineResponseDTO
     */
    'surfaceDefId'?: number;
}
/**
 * 
 * @export
 * @interface CgPoint
 */
export interface CgPoint {
    /**
     * 
     * @type {string}
     * @memberof CgPoint
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CgPoint
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CgPoint
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof CgPoint
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof CgPoint
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface ChannelParametersDTO
 */
export interface ChannelParametersDTO {
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'backSlopeRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'bermWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChannelParametersDTO
     */
    'bottomDipStr'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChannelParametersDTO
     */
    'channelShapeStr'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChannelParametersDTO
     */
    'computeEndShape'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChannelParametersDTO
     */
    'computeStartShape'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'dipDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'endSlopeDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'freeBoard'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'leftSlopeRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'minBedWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'offset1'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'offset2'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'offset3'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'rightSlopeRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'sideSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'sideWidthLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChannelParametersDTO
     */
    'startSlopeDistance'?: number;
}
/**
 * 
 * @export
 * @interface CircleRequestDto
 */
export interface CircleRequestDto {
    /**
     * 
     * @type {number}
     * @memberof CircleRequestDto
     */
    'diameter'?: number;
}
/**
 * 
 * @export
 * @interface CircleResponseDto
 */
export interface CircleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof CircleResponseDto
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof CircleResponseDto
     */
    'circumference'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof CircleResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof CircleResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface CircularSectionRequestDto
 */
export interface CircularSectionRequestDto {
    /**
     * 
     * @type {number}
     * @memberof CircularSectionRequestDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof CircularSectionRequestDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof CircularSectionRequestDto
     */
    'pipeSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof CircularSectionRequestDto
     */
    'waterDepth'?: number;
}
/**
 * 
 * @export
 * @interface CircularSectionResponseDto
 */
export interface CircularSectionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CircularSectionResponseDto
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof CircularSectionResponseDto
     */
    'capacity'?: string;
    /**
     * 
     * @type {string}
     * @memberof CircularSectionResponseDto
     */
    'criticalDepth'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof CircularSectionResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof CircularSectionResponseDto
     */
    'hydraulicRadius'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CircularSectionResponseDto
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CircularSectionResponseDto
     */
    'velocity'?: string;
}
/**
 * 
 * @export
 * @interface CombineErrorResponsesRequest
 */
export interface CombineErrorResponsesRequest {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof CombineErrorResponsesRequest
     */
    'firstErrorResponse'?: ErrorResponse;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof CombineErrorResponsesRequest
     */
    'secondErrorResponse'?: ErrorResponse;
}
/**
 * 
 * @export
 * @interface CommonInletDto
 */
export interface CommonInletDto {
    /**
     * 
     * @type {string}
     * @memberof CommonInletDto
     */
    'inletEntry'?: string;
    /**
     * 
     * @type {number}
     * @memberof CommonInletDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonInletDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonInletDto
     */
    'pipeLength'?: number;
}
/**
 * 
 * @export
 * @interface CommonOutletDto
 */
export interface CommonOutletDto {
    /**
     * 
     * @type {number}
     * @memberof CommonOutletDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonOutletDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonOutletDto
     */
    'pipeLength'?: number;
}
/**
 * 
 * @export
 * @interface CommonPipeDto
 */
export interface CommonPipeDto {
    /**
     * 
     * @type {number}
     * @memberof CommonPipeDto
     */
    'extraPipeBeyondToe'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonPipeDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonPipeDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonPipeDto
     */
    'skewAngle'?: number;
}
/**
 * 
 * @export
 * @interface CommonSideSlopeDto
 */
export interface CommonSideSlopeDto {
    /**
     * 
     * @type {number}
     * @memberof CommonSideSlopeDto
     */
    'downStream'?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonSideSlopeDto
     */
    'upStream'?: number;
}
/**
 * 
 * @export
 * @interface ConnectedUgosResponse
 */
export interface ConnectedUgosResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof ConnectedUgosResponse
     */
    'connectedUgosList'?: Array<number>;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ConnectedUgosResponse
     */
    'errorResponse'?: ErrorResponse;
}
/**
 * 
 * @export
 * @interface ConstructionReportCollectionRequest
 */
export interface ConstructionReportCollectionRequest {
    /**
     * 
     * @type {{ [key: string]: Array<number>; }}
     * @memberof ConstructionReportCollectionRequest
     */
    'elementTypeAndIdListMap'?: { [key: string]: Array<number>; };
    /**
     * 
     * @type {string}
     * @memberof ConstructionReportCollectionRequest
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {{ [key: string]: TerracConstructionReportReqDTO; }}
     * @memberof ConstructionReportCollectionRequest
     */
    'terraceConstructionReportRequestsMap'?: { [key: string]: TerracConstructionReportReqDTO; };
    /**
     * 
     * @type {{ [key: string]: WaterwayConstructionReportReqDTO; }}
     * @memberof ConstructionReportCollectionRequest
     */
    'waterwayConstructionReportRequestsMap'?: { [key: string]: WaterwayConstructionReportReqDTO; };
}
/**
 * 
 * @export
 * @interface ConstructionReportCollectionResponse
 */
export interface ConstructionReportCollectionResponse {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ConstructionReportCollectionResponse
     */
    'elementTypeAndReportListMap'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ConstructionReportCollectionResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof ConstructionReportCollectionResponse
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface ContourLineData
 */
export interface ContourLineData {
    /**
     * 
     * @type {number}
     * @memberof ContourLineData
     */
    'elevation'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContourLineData
     */
    'major'?: boolean;
    /**
     * 
     * @type {Array<Point>}
     * @memberof ContourLineData
     */
    'points'?: Array<Point>;
}
/**
 * 
 * @export
 * @interface Coordinate
 */
export interface Coordinate {
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    'm'?: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinate
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface CoordinateSequence
 */
export interface CoordinateSequence {
    /**
     * 
     * @type {number}
     * @memberof CoordinateSequence
     */
    'dimension'?: number;
    /**
     * 
     * @type {number}
     * @memberof CoordinateSequence
     */
    'measures'?: number;
}
/**
 * 
 * @export
 * @interface CreateErrorResponseRequest
 */
export interface CreateErrorResponseRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateErrorResponseRequest
     */
    'customizedMessages'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateErrorResponseRequest
     */
    'originalErrorCode'?: string;
}
/**
 * 
 * @export
 * @interface CrossSectionImageDTO
 */
export interface CrossSectionImageDTO {
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSectionImageDTO
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSectionImageDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSectionImageDTO
     */
    'imageTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDTO
     */
    'imageURL'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDTO
     */
    'lastChangeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDTO
     */
    'stationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSectionImageDTO
     */
    'structureProfilesId'?: number;
}
/**
 * 
 * @export
 * @interface CrossSectionImageDto
 */
export interface CrossSectionImageDto {
    /**
     * 
     * @type {number}
     * @memberof CrossSectionImageDto
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSectionImageDto
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDto
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSectionImageDto
     */
    'stationId'?: string;
}
/**
 * 
 * @export
 * @interface CrossSlopeDTO
 */
export interface CrossSlopeDTO {
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeDTO
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeDTO
     */
    'crossSlopeId'?: number;
    /**
     * 
     * @type {Array<CrossSlopeStationDTO>}
     * @memberof CrossSlopeDTO
     */
    'crossSlopeStations'?: Array<CrossSlopeStationDTO>;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeDTO
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeDTO
     */
    'entryMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeDTO
     */
    'hiElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeDTO
     */
    'offsetType'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeDTO
     */
    'singleShotOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeDTO
     */
    'slopeWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeDTO
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeDTO
     */
    'stationStep'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeDTO
     */
    'uphillsTo'?: string;
}
/**
 * 
 * @export
 * @interface CrossSlopeStationDTO
 */
export interface CrossSlopeStationDTO {
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationDTO
     */
    'crossSlopeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationDTO
     */
    'crossSlopeStationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationDTO
     */
    'crossSlopeStationOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationDTO
     */
    'crossSlopeStationSlope'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStationDTO
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {Array<SurveyEngineeringProjectDTO>}
     * @memberof CrossSlopeStationDTO
     */
    'offsets'?: Array<SurveyEngineeringProjectDTO>;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationDTO
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface CrossSlopeStationOffsets
 */
export interface CrossSlopeStationOffsets {
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationOffsets
     */
    'crossSlopeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationOffsets
     */
    'crossSlopeStationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationOffsets
     */
    'crossSlopeStationOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationOffsets
     */
    'crossSlopeStationSlope'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStationOffsets
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStationOffsets
     */
    'keyString'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStationOffsets
     */
    'objectName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStationOffsets
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface CrossSlopeStations
 */
export interface CrossSlopeStations {
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStations
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStations
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStations
     */
    'crossSlopeId'?: number;
    /**
     * 
     * @type {Array<CrossSlopeStationOffsets>}
     * @memberof CrossSlopeStations
     */
    'crossSlopeStationOffsets'?: Array<CrossSlopeStationOffsets>;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStations
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStations
     */
    'entryMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStations
     */
    'hiElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStations
     */
    'keyString'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStations
     */
    'objectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStations
     */
    'offsetType'?: CrossSlopeStationsOffsetTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStations
     */
    'singleShotOffset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStations
     */
    'slopeWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStations
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeStations
     */
    'stationStep'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeStations
     */
    'uphillsTo'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CrossSlopeStationsOffsetTypeEnum {
    Elevation = 'TYPE_ELEVATION',
    Rod = 'TYPE_ROD'
}

/**
 * 
 * @export
 * @interface CrossSlopeSurvey
 */
export interface CrossSlopeSurvey {
    /**
     * 
     * @type {AlignmentDTO}
     * @memberof CrossSlopeSurvey
     */
    'alignment'?: AlignmentDTO;
    /**
     * 
     * @type {Array<CrossSlopeDTO>}
     * @memberof CrossSlopeSurvey
     */
    'crossSlopes'?: Array<CrossSlopeDTO>;
}
/**
 * 
 * @export
 * @interface CrossSlopeSurveyResponse
 */
export interface CrossSlopeSurveyResponse {
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeSurveyResponse
     */
    'alignmentApplyCurves'?: string;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeSurveyResponse
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {Array<AlignmentStationDTO>}
     * @memberof CrossSlopeSurveyResponse
     */
    'alignmentStations'?: Array<AlignmentStationDTO>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof CrossSlopeSurveyResponse
     */
    'alignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof CrossSlopeSurveyResponse
     */
    'contourLines'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof CrossSlopeSurveyResponse
     */
    'curvedAlignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<OffsetStationLineResponse>}
     * @memberof CrossSlopeSurveyResponse
     */
    'offsetStationLine'?: Array<OffsetStationLineResponse>;
    /**
     * 
     * @type {Array<StationOffsetResponse>}
     * @memberof CrossSlopeSurveyResponse
     */
    'projectPoints'?: Array<StationOffsetResponse>;
    /**
     * 
     * @type {number}
     * @memberof CrossSlopeSurveyResponse
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CrossSlopeSurveyResponse
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof CrossSlopeSurveyResponse
     */
    'tinTriangles'?: Array<TinTriangle>;
}
/**
 * 
 * @export
 * @interface DEMCRSResponse
 */
export interface DEMCRSResponse {
    /**
     * 
     * @type {string}
     * @memberof DEMCRSResponse
     */
    'demCRS'?: string;
    /**
     * 
     * @type {number}
     * @memberof DEMCRSResponse
     */
    'demPixelSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof DEMCRSResponse
     */
    'demType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMCRSResponse
     */
    'demUploadDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMCRSResponse
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMCRSResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMCRSResponse
     */
    'targetProjectionName'?: string;
}
/**
 * 
 * @export
 * @interface DEMOutletsResponseDTO
 */
export interface DEMOutletsResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof DEMOutletsResponseDTO
     */
    'displayName'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DEMOutletsResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DEMOutletsResponseDTO
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMOutletsResponseDTO
     */
    'horizontalUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof DEMOutletsResponseDTO
     */
    'pixelSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof DEMOutletsResponseDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMOutletsResponseDTO
     */
    'verticalUnit'?: string;
}
/**
 * 
 * @export
 * @interface DEMResourceResponse
 */
export interface DEMResourceResponse {
    /**
     * 
     * @type {string}
     * @memberof DEMResourceResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DEMResourceResponse
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DEMResourceResponse
     */
    'demImageserverUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DEMResourceResponse
     */
    'demResolution'?: number;
    /**
     * 
     * @type {string}
     * @memberof DEMResourceResponse
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DEMResourceResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof DEMResourceResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DEMResourceResponse
     */
    'lastChangedBy'?: string;
}
/**
 * 
 * @export
 * @interface DEMSurfaceResponse
 */
export interface DEMSurfaceResponse {
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'dataSourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DEMSurfaceResponse
     */
    'demPixelSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'demSurfaceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'demType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'demUploadDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'elevationUnit'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DEMSurfaceResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'linearUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'metadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof DEMSurfaceResponse
     */
    'sessionResourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DEMSurfaceResponse
     */
    'sessionResourceTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DEMSurfaceResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface DefaultReachesRequest
 */
export interface DefaultReachesRequest {
    /**
     * 
     * @type {number}
     * @memberof DefaultReachesRequest
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DefaultReachesRequest
     */
    'stationVertices'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface DefaultReachesResponse
 */
export interface DefaultReachesResponse {
    /**
     * 
     * @type {string}
     * @memberof DefaultReachesResponse
     */
    'status'?: string;
    /**
     * 
     * @type {Array<WaterwaySizingResponseDTO>}
     * @memberof DefaultReachesResponse
     */
    'waterwaySizingResponseDTOList'?: Array<WaterwaySizingResponseDTO>;
    /**
     * 
     * @type {Array<WaterwayVertexParamDTO>}
     * @memberof DefaultReachesResponse
     */
    'waterwayVertexParamDTOList'?: Array<WaterwayVertexParamDTO>;
}
/**
 * 
 * @export
 * @interface DefinedMapRequest
 */
export interface DefinedMapRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof DefinedMapRequest
     */
    'designElementIds'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof DefinedMapRequest
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DefinedMapRequest
     */
    'imageTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefinedMapRequest
     */
    'profileImageBase64String'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefinedMapRequest
     */
    'profileOrCrossSection'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefinedMapRequest
     */
    'stationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefinedMapRequest
     */
    'structureMapImageBase64String'?: string;
    /**
     * 
     * @type {number}
     * @memberof DefinedMapRequest
     */
    'structureProfilesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefinedMapRequest
     */
    'twoDimensionalGeometryJson'?: string;
}
/**
 * 
 * @export
 * @interface DefinedMapResponse
 */
export interface DefinedMapResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DefinedMapResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<number>}
     * @memberof DefinedMapResponse
     */
    'structureProfilesId'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DeleteSurveyResponse
 */
export interface DeleteSurveyResponse {
    /**
     * 
     * @type {string}
     * @memberof DeleteSurveyResponse
     */
    'deleteStatus'?: string;
}
/**
 * 
 * @export
 * @interface DeleteTerraceBlocksOrDrainsRequestDTO
 */
export interface DeleteTerraceBlocksOrDrainsRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof DeleteTerraceBlocksOrDrainsRequestDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteTerraceBlocksOrDrainsRequestDTO
     */
    'terraceType'?: number;
}
/**
 * 
 * @export
 * @interface DeleteTerraceBlocksOrDrainsResponseDTO
 */
export interface DeleteTerraceBlocksOrDrainsResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DeleteTerraceBlocksOrDrainsResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<ReachJson>}
     * @memberof DeleteTerraceBlocksOrDrainsResponseDTO
     */
    'reaches'?: Array<ReachJson>;
    /**
     * 
     * @type {string}
     * @memberof DeleteTerraceBlocksOrDrainsResponseDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface DeleteTerraceResponseDTO
 */
export interface DeleteTerraceResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof DeleteTerraceResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DeleteTerraceResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DeleteTerraceResponseDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface DeleteUgoResponse
 */
export interface DeleteUgoResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteUgoResponse
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DeleteUgoResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DeleteUgoResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface DemResourceRequestDTO
 */
export interface DemResourceRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof DemResourceRequestDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DemResourceRequestDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DemResourceRequestDTO
     */
    'demImageserverUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DemResourceRequestDTO
     */
    'demResolution'?: number;
    /**
     * 
     * @type {string}
     * @memberof DemResourceRequestDTO
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemResourceRequestDTO
     */
    'lastChangedBy'?: string;
}
/**
 * 
 * @export
 * @interface DemSurfaceMetadataRequest
 */
export interface DemSurfaceMetadataRequest {
    /**
     * 
     * @type {string}
     * @memberof DemSurfaceMetadataRequest
     */
    'horizontalMeasurementUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemSurfaceMetadataRequest
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DemSurfaceMetadataRequest
     */
    'verticalMeasurementUnit'?: string;
}
/**
 * 
 * @export
 * @interface DemSurfaceMetadataResponse
 */
export interface DemSurfaceMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof DemSurfaceMetadataResponse
     */
    'demFileName'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DemSurfaceMetadataResponse
     */
    'errorResponse'?: ErrorResponse;
}
/**
 * 
 * @export
 * @interface DesignControlChannelEndsDTO
 */
export interface DesignControlChannelEndsDTO {
    /**
     * 
     * @type {number}
     * @memberof DesignControlChannelEndsDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlChannelEndsDTO
     */
    'channelEndsControlType'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DesignControlChannelEndsDTO
     */
    'designControlSyncDisabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DesignControlChannelEndsDTO
     */
    'endSlopeDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlChannelEndsDTO
     */
    'endSlopePercentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlChannelEndsDTO
     */
    'startSlopeDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlChannelEndsDTO
     */
    'startSlopePercentage'?: number;
}
/**
 * 
 * @export
 * @interface DesignControlDTO
 */
export interface DesignControlDTO {
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'backSlopeRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'bermWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignControlDTO
     */
    'channelControl'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'channelEndControl'?: number;
    /**
     * 
     * @type {ChannelParametersDTO}
     * @memberof DesignControlDTO
     */
    'channelParameters'?: ChannelParametersDTO;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'channelTranDistance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DesignControlDTO
     */
    'computeEndShape'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignControlDTO
     */
    'computeStartShape'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'endGradeSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'endSlopeDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'freeBoard'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DesignControlDTO
     */
    'peakFlowQEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'seedingBufferOption'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'sideSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'sideWidthLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'startGradeSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignControlDTO
     */
    'startSlopeDistance'?: number;
}
/**
 * 
 * @export
 * @interface DesignElementDownloadDTO
 */
export interface DesignElementDownloadDTO {
    /**
     * 
     * @type {Array<AlignmentExportRequest>}
     * @memberof DesignElementDownloadDTO
     */
    'alignmentExportRequest'?: Array<AlignmentExportRequest>;
    /**
     * 
     * @type {Array<ExportStakeOutPointsRequest>}
     * @memberof DesignElementDownloadDTO
     */
    'landLevelingExportRequest'?: Array<ExportStakeOutPointsRequest>;
    /**
     * 
     * @type {string}
     * @memberof DesignElementDownloadDTO
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignElementDownloadDTO
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {Array<SurveyExportRequest>}
     * @memberof DesignElementDownloadDTO
     */
    'surveyExportRequest'?: Array<SurveyExportRequest>;
    /**
     * 
     * @type {Array<WaterwayExportDTO>}
     * @memberof DesignElementDownloadDTO
     */
    'waterwayExportRequest'?: Array<WaterwayExportDTO>;
}
/**
 * 
 * @export
 * @interface DesignElementExportDTO
 */
export interface DesignElementExportDTO {
    /**
     * 
     * @type {Array<DesignElementProjectResponse>}
     * @memberof DesignElementExportDTO
     */
    'designElementProjectResponseList'?: Array<DesignElementProjectResponse>;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DesignElementExportDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DesignElementExportDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {SurfaceDefResponse}
     * @memberof DesignElementExportDTO
     */
    'surfaceDefResponse'?: SurfaceDefResponse;
    /**
     * 
     * @type {Array<SurfaceDefResponse>}
     * @memberof DesignElementExportDTO
     */
    'surfaceDefResponseList'?: Array<SurfaceDefResponse>;
    /**
     * 
     * @type {Array<TerraceDesignSummaryDto>}
     * @memberof DesignElementExportDTO
     */
    'terraceDesignSummaryDtoList'?: Array<TerraceDesignSummaryDto>;
    /**
     * 
     * @type {Array<UgoSummaryDTO>}
     * @memberof DesignElementExportDTO
     */
    'ugoDesignSummaryDtoList'?: Array<UgoSummaryDTO>;
    /**
     * 
     * @type {Array<WaterwayDesignSummaryDto>}
     * @memberof DesignElementExportDTO
     */
    'waterwayDesignSummaryDtoList'?: Array<WaterwayDesignSummaryDto>;
}
/**
 * 
 * @export
 * @interface DesignElementJsonKeyValueDto
 */
export interface DesignElementJsonKeyValueDto {
    /**
     * 
     * @type {string}
     * @memberof DesignElementJsonKeyValueDto
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignElementJsonKeyValueDto
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface DesignElementProjectResponse
 */
export interface DesignElementProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof DesignElementProjectResponse
     */
    'designElementType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignElementProjectResponse
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {Array<DesignElementResponse>}
     * @memberof DesignElementProjectResponse
     */
    'designElements'?: Array<DesignElementResponse>;
    /**
     * 
     * @type {number}
     * @memberof DesignElementProjectResponse
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface DesignElementRequest
 */
export interface DesignElementRequest {
    /**
     * 
     * @type {number}
     * @memberof DesignElementRequest
     */
    'contourInterval'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignElementRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignElementRequest
     */
    'designElementName'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignElementRequest
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignElementRequest
     */
    'json'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignElementRequest
     */
    'sessionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignElementRequest
     */
    'surfaceDefId'?: number;
}
/**
 * 
 * @export
 * @interface DesignElementResponse
 */
export interface DesignElementResponse {
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'createdDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignElementResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'designElementName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'designElementType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignElementResponse
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignElementResponse
     */
    'flagUpToDate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'json'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'processStatus'?: string;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof DesignElementResponse
     */
    'profileDTO'?: ProfileDTO;
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'sessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignElementResponse
     */
    'surveyName'?: string;
}
/**
 * 
 * @export
 * @interface DesignElementResponseDto
 */
export interface DesignElementResponseDto {
    /**
     * 
     * @type {Array<DesignElementResponse>}
     * @memberof DesignElementResponseDto
     */
    'designElementResponses'?: Array<DesignElementResponse>;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DesignElementResponseDto
     */
    'errorResponse'?: ErrorResponse;
}
/**
 * 
 * @export
 * @interface DesignReportCollectionRequest
 */
export interface DesignReportCollectionRequest {
    /**
     * 
     * @type {{ [key: string]: Array<number>; }}
     * @memberof DesignReportCollectionRequest
     */
    'elementTypeAndIdListMap'?: { [key: string]: Array<number>; };
    /**
     * 
     * @type {string}
     * @memberof DesignReportCollectionRequest
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface DesignReportCollectionResponse
 */
export interface DesignReportCollectionResponse {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof DesignReportCollectionResponse
     */
    'elementTypeAndReportListMap'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DesignReportCollectionResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DesignReportCollectionResponse
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface DesignSurfaceRequest
 */
export interface DesignSurfaceRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DesignSurfaceRequest
     */
    'includeContour'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DesignSurfaceRequest
     */
    'inputContourInterval'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DesignSurfaceRequest
     */
    'linear'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignSurfaceRequest
     */
    'sessionId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DesignSurfaceRequest
     */
    'structureDesElemIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DesignSurfaceResponse
 */
export interface DesignSurfaceResponse {
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof DesignSurfaceResponse
     */
    'designedContours'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof DesignSurfaceResponse
     */
    'designedTinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DesignSurfaceResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DesignSurfaceResponse
     */
    'projectSessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignSurfaceResponse
     */
    'warningMsg'?: string;
}
/**
 * 
 * @export
 * @interface DikedPitRequest
 */
export interface DikedPitRequest {
    /**
     * 
     * @type {InputPoint}
     * @memberof DikedPitRequest
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {Array<number>}
     * @memberof DikedPitRequest
     */
    'cutSlopes'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof DikedPitRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DikedPitRequest
     */
    'equalCutSlopes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DikedPitRequest
     */
    'equalFillSlopes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DikedPitRequest
     */
    'equalSideSlopes'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof DikedPitRequest
     */
    'fillSlopes'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof DikedPitRequest
     */
    'includeDesignSurface'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DikedPitRequest
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof DikedPitRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DikedPitRequest
     */
    'orienAzimuth'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DikedPitRequest
     */
    'sideSlopes'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof DikedPitRequest
     */
    'topElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof DikedPitRequest
     */
    'topWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof DikedPitRequest
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DikedPitRequest
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface DikedPitResponse
 */
export interface DikedPitResponse {
    /**
     * 
     * @type {InputPoint}
     * @memberof DikedPitResponse
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DikedPitResponse
     */
    'cutSlopes'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'cutVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof DikedPitResponse
     */
    'designedContours'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof DikedPitResponse
     */
    'designedTinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {boolean}
     * @memberof DikedPitResponse
     */
    'equalCutSlopes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DikedPitResponse
     */
    'equalFillSlopes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DikedPitResponse
     */
    'equalSideSlopes'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof DikedPitResponse
     */
    'fillSlopes'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'fillVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof DikedPitResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'orienAzimuth'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof DikedPitResponse
     */
    'padBorders'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof DikedPitResponse
     */
    'padEdgeBreaklines'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof DikedPitResponse
     */
    'padRays'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof DikedPitResponse
     */
    'padVertices'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof DikedPitResponse
     */
    'pitBorders'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof DikedPitResponse
     */
    'pitRays'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof DikedPitResponse
     */
    'pitVertices'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DikedPitResponse
     */
    'sideSlopes'?: Array<number>;
    /**
     * 
     * @type {Array<LineSegmentDto>}
     * @memberof DikedPitResponse
     */
    'slopeArrows'?: Array<LineSegmentDto>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof DikedPitResponse
     */
    'stakeoutPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'storageDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'storageVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'topElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'topWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof DikedPitResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DikedPitResponse
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DikedPitResponse
     */
    'warningMsg'?: string;
    /**
     * 
     * @type {number}
     * @memberof DikedPitResponse
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface Disposable
 */
export interface Disposable {
    /**
     * 
     * @type {boolean}
     * @memberof Disposable
     */
    'disposed'?: boolean;
}
/**
 * 
 * @export
 * @interface DrainStationDTO
 */
export interface DrainStationDTO {
    /**
     * 
     * @type {number}
     * @memberof DrainStationDTO
     */
    'drainFraction'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrainStationDTO
     */
    'drainId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DrainStationDTO
     */
    'drainName'?: string;
    /**
     * 
     * @type {number}
     * @memberof DrainStationDTO
     */
    'drainOffset'?: number;
    /**
     * 
     * @type {InputPoint}
     * @memberof DrainStationDTO
     */
    'location'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof DrainStationDTO
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof DrainStationDTO
     */
    'terraceAlignedId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrainStationDTO
     */
    'ugoAndInlet'?: string;
}
/**
 * 
 * @export
 * @interface Drawing
 */
export interface Drawing {
    /**
     * 
     * @type {string}
     * @memberof Drawing
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof Drawing
     */
    'drawingType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Drawing
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Drawing
     */
    'featureName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Drawing
     */
    'keyString'?: string;
    /**
     * 
     * @type {string}
     * @memberof Drawing
     */
    'objectName'?: string;
    /**
     * 
     * @type {Array<Xyzarray>}
     * @memberof Drawing
     */
    'xyzarray'?: Array<Xyzarray>;
}
/**
 * 
 * @export
 * @interface DrawingDesign
 */
export interface DrawingDesign {
    /**
     * 
     * @type {Array<Drawing>}
     * @memberof DrawingDesign
     */
    'drawings'?: Array<Drawing>;
}
/**
 * 
 * @export
 * @interface DrawingRequestDto
 */
export interface DrawingRequestDto {
    /**
     * 
     * @type {number}
     * @memberof DrawingRequestDto
     */
    'designElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrawingRequestDto
     */
    'designElementName'?: string;
    /**
     * 
     * @type {number}
     * @memberof DrawingRequestDto
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {DrawingDesign}
     * @memberof DrawingRequestDto
     */
    'drawingDesign'?: DrawingDesign;
    /**
     * 
     * @type {string}
     * @memberof DrawingRequestDto
     */
    'session_UUID'?: string;
}
/**
 * 
 * @export
 * @interface DryHydrantElevationDto
 */
export interface DryHydrantElevationDto {
    /**
     * 
     * @type {number}
     * @memberof DryHydrantElevationDto
     */
    'hydrantCenterlineElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof DryHydrantElevationDto
     */
    'inletCenterlineElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof DryHydrantElevationDto
     */
    'normalWaterElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof DryHydrantElevationDto
     */
    'pumpCenterlineElev'?: number;
}
/**
 * 
 * @export
 * @interface DryHydrantRequestDto
 */
export interface DryHydrantRequestDto {
    /**
     * 
     * @type {DryHydrantElevationDto}
     * @memberof DryHydrantRequestDto
     */
    'dryHydrantElevationDto'?: DryHydrantElevationDto;
    /**
     * 
     * @type {PipelineDto}
     * @memberof DryHydrantRequestDto
     */
    'pipelineDto'?: PipelineDto;
    /**
     * 
     * @type {number}
     * @memberof DryHydrantRequestDto
     */
    'waterNeeded'?: number;
}
/**
 * 
 * @export
 * @interface DryHydrantResponseDto
 */
export interface DryHydrantResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof DryHydrantResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof DryHydrantResponseDto
     */
    'headLoss'?: string;
    /**
     * 
     * @type {string}
     * @memberof DryHydrantResponseDto
     */
    'materials'?: string;
    /**
     * 
     * @type {string}
     * @memberof DryHydrantResponseDto
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DryHydrantResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface DuplicateAlignmentsResponse
 */
export interface DuplicateAlignmentsResponse {
    /**
     * 
     * @type {{ [key: string]: DesignElementResponse; }}
     * @memberof DuplicateAlignmentsResponse
     */
    'duplicateAlignmentsMap'?: { [key: string]: DesignElementResponse; };
}
/**
 * 
 * @export
 * @interface ETriangleRequestDto
 */
export interface ETriangleRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ETriangleRequestDto
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof ETriangleRequestDto
     */
    'sideA'?: number;
}
/**
 * 
 * @export
 * @interface ETriangleResponseDto
 */
export interface ETriangleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ETriangleResponseDto
     */
    'area'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ETriangleResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof ETriangleResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface EarthWorksDto
 */
export interface EarthWorksDto {
    /**
     * 
     * @type {number}
     * @memberof EarthWorksDto
     */
    'dsToeElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof EarthWorksDto
     */
    'topWidth'?: number;
}
/**
 * 
 * @export
 * @interface EftStatusResponse
 */
export interface EftStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof EftStatusResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface ElevationDto
 */
export interface ElevationDto {
    /**
     * 
     * @type {number}
     * @memberof ElevationDto
     */
    'bendLossCoeff'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationDto
     */
    'entranceLossCoeff'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationDto
     */
    'invertOutletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationDto
     */
    'pipeLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationDto
     */
    'waterSurfaceElev'?: number;
}
/**
 * 
 * @export
 * @interface ElevationRequest
 */
export interface ElevationRequest {
    /**
     * 
     * @type {InputPoint}
     * @memberof ElevationRequest
     */
    'basePoint'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof ElevationRequest
     */
    'designElementId'?: number;
}
/**
 * 
 * @export
 * @interface ElevationRequestDTO
 */
export interface ElevationRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof ElevationRequestDTO
     */
    'projectUUID'?: string;
    /**
     * 
     * @type {number}
     * @memberof ElevationRequestDTO
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationRequestDTO
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface ElevationResponse
 */
export interface ElevationResponse {
    /**
     * 
     * @type {InputPoint}
     * @memberof ElevationResponse
     */
    'basePoint'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof ElevationResponse
     */
    'designElementId'?: number;
}
/**
 * 
 * @export
 * @interface ElevationResponseDTO
 */
export interface ElevationResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof ElevationResponseDTO
     */
    'projectUUID'?: string;
    /**
     * 
     * @type {number}
     * @memberof ElevationResponseDTO
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationResponseDTO
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof ElevationResponseDTO
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface ElevationVelocityRequestDto
 */
export interface ElevationVelocityRequestDto {
    /**
     * 
     * @type {InputPoint}
     * @memberof ElevationVelocityRequestDto
     */
    'basePoint'?: InputPoint;
    /**
     * 
     * @type {string}
     * @memberof ElevationVelocityRequestDto
     */
    'designElementId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ElevationVelocityRequestDto
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface Entrystringstring
 */
export interface Entrystringstring {
    /**
     * 
     * @type {string}
     * @memberof Entrystringstring
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof Entrystringstring
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface Envelope
 */
export interface Envelope {
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'diameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'maxX'?: number;
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'maxY'?: number;
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'minX'?: number;
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'minY'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Envelope
     */
    'null'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Envelope
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface EpisodeMetadata
 */
export interface EpisodeMetadata {
    /**
     * 
     * @type {number}
     * @memberof EpisodeMetadata
     */
    'cutFillChange'?: number;
    /**
     * 
     * @type {string}
     * @memberof EpisodeMetadata
     */
    'episodeId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EpisodeMetadata
     */
    'human'?: boolean;
    /**
     * 
     * @type {NodeAction}
     * @memberof EpisodeMetadata
     */
    'nodeAction'?: NodeAction;
    /**
     * 
     * @type {boolean}
     * @memberof EpisodeMetadata
     */
    'validationStatus'?: boolean;
}
/**
 * 
 * @export
 * @interface EpisodeTracker
 */
export interface EpisodeTracker {
    /**
     * 
     * @type {boolean}
     * @memberof EpisodeTracker
     */
    'cancelled'?: boolean;
    /**
     * 
     * @type {Disposable}
     * @memberof EpisodeTracker
     */
    'disposable'?: Disposable;
    /**
     * 
     * @type {number}
     * @memberof EpisodeTracker
     */
    'episodeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EpisodeTracker
     */
    'episodeUpperLimit'?: number;
    /**
     * 
     * @type {object}
     * @memberof EpisodeTracker
     */
    'mono'?: object;
    /**
     * 
     * @type {string}
     * @memberof EpisodeTracker
     */
    'statusMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof EpisodeTracker
     */
    'waterwayId'?: number;
}
/**
 * 
 * @export
 * @interface ErrorHandlingRequest
 */
export interface ErrorHandlingRequest {
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'errorCategoryCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorHandlingRequest
     */
    'errorCategoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'errorCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorHandlingRequest
     */
    'errorCodeLUTId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'errorCodeStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'errorDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'errorShortDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'errorSubCategoryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'loggingFlag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'moduleCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'originalErrorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingRequest
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ErrorHandlingResponse
 */
export interface ErrorHandlingResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'errorCategoryCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorHandlingResponse
     */
    'errorCategoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorHandlingResponse
     */
    'errorCodeLUTId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'errorCodeStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'errorDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'errorHandlingFailure'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'errorShortDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'errorSubCategoryCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorHandlingResponse
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'loggingFlag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'moduleCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'originalErrorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorHandlingResponse
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface ErrorNumberRequestDto
 */
export interface ErrorNumberRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorNumberRequestDto
     */
    'categoryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorNumberRequestDto
     */
    'designArea'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorNumberRequestDto
     */
    'errorCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorNumberRequestDto
     */
    'moduleCode'?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'urlPath'?: string;
}
/**
 * 
 * @export
 * @interface ErrorSummaryResponse
 */
export interface ErrorSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof ErrorSummaryResponse
     */
    'comment'?: string;
    /**
     * 
     * @type {number}
     * @memberof ErrorSummaryResponse
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorSummaryResponse
     */
    'originalErrorCode'?: string;
}
/**
 * 
 * @export
 * @interface ExportStakeOutPointsRequest
 */
export interface ExportStakeOutPointsRequest {
    /**
     * 
     * @type {number}
     * @memberof ExportStakeOutPointsRequest
     */
    'structureDesignElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportStakeOutPointsRequest
     */
    'surfaceDesignElementId'?: number;
}
/**
 * 
 * @export
 * @interface ExportSurvToCSVRequest
 */
export interface ExportSurvToCSVRequest {
    /**
     * 
     * @type {Array<SurveyExportRequest>}
     * @memberof ExportSurvToCSVRequest
     */
    'exportSurveysJson'?: Array<SurveyExportRequest>;
}
/**
 * 
 * @export
 * @interface FileSystemResource
 */
export interface FileSystemResource {
    /**
     * 
     * @type {string}
     * @memberof FileSystemResource
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof FileSystemResource
     */
    'file'?: any;
    /**
     * 
     * @type {string}
     * @memberof FileSystemResource
     */
    'filename'?: string;
    /**
     * 
     * @type {object}
     * @memberof FileSystemResource
     */
    'inputStream'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemResource
     */
    'open'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof FileSystemResource
     */
    'outputStream'?: object;
    /**
     * 
     * @type {string}
     * @memberof FileSystemResource
     */
    'path'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemResource
     */
    'readable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileSystemResource
     */
    'uri'?: string;
    /**
     * 
     * @type {URL}
     * @memberof FileSystemResource
     */
    'url'?: URL;
    /**
     * 
     * @type {boolean}
     * @memberof FileSystemResource
     */
    'writable'?: boolean;
}
/**
 * 
 * @export
 * @interface FlagUpToDateDto
 */
export interface FlagUpToDateDto {
    /**
     * 
     * @type {number}
     * @memberof FlagUpToDateDto
     */
    'designElementJsonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlagUpToDateDto
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FlagUpToDateDto
     */
    'flagUpToDate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FlagUpToDateDto
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlagUpToDateDto
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof FlagUpToDateDto
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface FlowPathSegment
 */
export interface FlowPathSegment {
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'crossSectionalFlowArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'flowTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'manningn'?: number;
    /**
     * 
     * @type {string}
     * @memberof FlowPathSegment
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'segmentLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'segmentSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'separatorX'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'separatorY'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'subTimeOfConcentration'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'surfaceManning'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'velocity'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowPathSegment
     */
    'wettedPerimeter'?: number;
}
/**
 * 
 * @export
 * @interface FrustrumPyramidRequestDto
 */
export interface FrustrumPyramidRequestDto {
    /**
     * 
     * @type {number}
     * @memberof FrustrumPyramidRequestDto
     */
    'a'?: number;
    /**
     * 
     * @type {number}
     * @memberof FrustrumPyramidRequestDto
     */
    'b'?: number;
    /**
     * 
     * @type {number}
     * @memberof FrustrumPyramidRequestDto
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof FrustrumPyramidRequestDto
     */
    'nOfSides'?: number;
}
/**
 * 
 * @export
 * @interface FrustrumPyramidResponseDto
 */
export interface FrustrumPyramidResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FrustrumPyramidResponseDto
     */
    'area1'?: string;
    /**
     * 
     * @type {string}
     * @memberof FrustrumPyramidResponseDto
     */
    'area2'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof FrustrumPyramidResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof FrustrumPyramidResponseDto
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FrustrumPyramidResponseDto
     */
    'volume'?: string;
}
/**
 * 
 * @export
 * @interface GenerateAlternativeQuestionsDTO
 */
export interface GenerateAlternativeQuestionsDTO {
    /**
     * 
     * @type {number}
     * @memberof GenerateAlternativeQuestionsDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GenerateAlternativeQuestionsDTO
     */
    'analysisSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateAlternativeQuestionsDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof GenerateAlternativeQuestionsDTO
     */
    'status'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenerateAlternativeQuestionsDTO
     */
    'suggestedQuestions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GenerateEpisodeJsonRequestDto
 */
export interface GenerateEpisodeJsonRequestDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof GenerateEpisodeJsonRequestDto
     */
    'alignedElementIdList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof GenerateEpisodeJsonRequestDto
     */
    'generationComment'?: string;
}
/**
 * 
 * @export
 * @interface GenerateLandXMLRequest
 */
export interface GenerateLandXMLRequest {
    /**
     * 
     * @type {number}
     * @memberof GenerateLandXMLRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateLandXMLRequest
     */
    'designElementType'?: number;
}
/**
 * 
 * @export
 * @interface GenerateLandXMLResponse
 */
export interface GenerateLandXMLResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof GenerateLandXMLResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof GenerateLandXMLResponse
     */
    'landXMLFileName'?: string;
}
/**
 * 
 * @export
 * @interface Geometry
 */
export interface Geometry {
    /**
     * 
     * @type {number}
     * @memberof Geometry
     */
    'area'?: number;
    /**
     * 
     * @type {Geometry}
     * @memberof Geometry
     */
    'boundary'?: Geometry;
    /**
     * 
     * @type {number}
     * @memberof Geometry
     */
    'boundaryDimension'?: number;
    /**
     * 
     * @type {Point}
     * @memberof Geometry
     */
    'centroid'?: Point;
    /**
     * 
     * @type {Coordinate}
     * @memberof Geometry
     */
    'coordinate'?: Coordinate;
    /**
     * 
     * @type {Array<Coordinate>}
     * @memberof Geometry
     */
    'coordinates'?: Array<Coordinate>;
    /**
     * 
     * @type {number}
     * @memberof Geometry
     */
    'dimension'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Geometry
     */
    'empty'?: boolean;
    /**
     * 
     * @type {Geometry}
     * @memberof Geometry
     */
    'envelope'?: Geometry;
    /**
     * 
     * @type {Envelope}
     * @memberof Geometry
     */
    'envelopeInternal'?: Envelope;
    /**
     * 
     * @type {GeometryFactory}
     * @memberof Geometry
     */
    'factory'?: GeometryFactory;
    /**
     * 
     * @type {string}
     * @memberof Geometry
     */
    'geometryType'?: string;
    /**
     * 
     * @type {Point}
     * @memberof Geometry
     */
    'interiorPoint'?: Point;
    /**
     * 
     * @type {number}
     * @memberof Geometry
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof Geometry
     */
    'numGeometries'?: number;
    /**
     * 
     * @type {number}
     * @memberof Geometry
     */
    'numPoints'?: number;
    /**
     * 
     * @type {PrecisionModel}
     * @memberof Geometry
     */
    'precisionModel'?: PrecisionModel;
    /**
     * 
     * @type {boolean}
     * @memberof Geometry
     */
    'rectangle'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Geometry
     */
    'simple'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Geometry
     */
    'srid'?: number;
    /**
     * 
     * @type {object}
     * @memberof Geometry
     */
    'userData'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Geometry
     */
    'valid'?: boolean;
}
/**
 * 
 * @export
 * @interface GeometryFactory
 */
export interface GeometryFactory {
    /**
     * 
     * @type {object}
     * @memberof GeometryFactory
     */
    'coordinateSequenceFactory'?: object;
    /**
     * 
     * @type {PrecisionModel}
     * @memberof GeometryFactory
     */
    'precisionModel'?: PrecisionModel;
    /**
     * 
     * @type {number}
     * @memberof GeometryFactory
     */
    'srid'?: number;
}
/**
 * 
 * @export
 * @interface GrassedSoilVegInfoDTO
 */
export interface GrassedSoilVegInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof GrassedSoilVegInfoDTO
     */
    'allowableStress'?: number;
    /**
     * 
     * @type {string}
     * @memberof GrassedSoilVegInfoDTO
     */
    'capacity'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrassedSoilVegInfoDTO
     */
    'endStation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrassedSoilVegInfoDTO
     */
    'soilGrainRoughness'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrassedSoilVegInfoDTO
     */
    'stability'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrassedSoilVegInfoDTO
     */
    'startStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof GrassedSoilVegInfoDTO
     */
    'vegetalCoverFactor'?: number;
    /**
     * 
     * @type {string}
     * @memberof GrassedSoilVegInfoDTO
     */
    'vegetalCoverType'?: string;
    /**
     * 
     * @type {number}
     * @memberof GrassedSoilVegInfoDTO
     */
    'velocityCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof GrassedSoilVegInfoDTO
     */
    'velocityStability'?: number;
}
/**
 * 
 * @export
 * @interface GroundElevationRequestDTO
 */
export interface GroundElevationRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof GroundElevationRequestDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroundElevationRequestDTO
     */
    'reachStationDistance'?: number;
}
/**
 * 
 * @export
 * @interface GroundElevationResponseDTO
 */
export interface GroundElevationResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof GroundElevationResponseDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroundElevationResponseDTO
     */
    'groundElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroundElevationResponseDTO
     */
    'reachStationDistance'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroundElevationResponseDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface HeadDto
 */
export interface HeadDto {
    /**
     * 
     * @type {number}
     * @memberof HeadDto
     */
    'bendLossCoeff'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeadDto
     */
    'entranceLossCoeff'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeadDto
     */
    'headOnPipe'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeadDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeadDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeadDto
     */
    'pipeLength'?: number;
}
/**
 * 
 * @export
 * @interface HoodedInletElevationDto
 */
export interface HoodedInletElevationDto {
    /**
     * 
     * @type {number}
     * @memberof HoodedInletElevationDto
     */
    'auxSpillwayElev'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HoodedInletElevationDto
     */
    'enableTailWater'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletElevationDto
     */
    'inletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletElevationDto
     */
    'outletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletElevationDto
     */
    'tailwaterElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletElevationDto
     */
    'toeElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletElevationDto
     */
    'topElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletElevationDto
     */
    'waterElev'?: number;
}
/**
 * 
 * @export
 * @interface HoodedInletRequestDto
 */
export interface HoodedInletRequestDto {
    /**
     * 
     * @type {CommonPipeDto}
     * @memberof HoodedInletRequestDto
     */
    'commonPipeDto'?: CommonPipeDto;
    /**
     * 
     * @type {CommonSideSlopeDto}
     * @memberof HoodedInletRequestDto
     */
    'commonSideSlopeDto'?: CommonSideSlopeDto;
    /**
     * 
     * @type {EarthWorksDto}
     * @memberof HoodedInletRequestDto
     */
    'earthWorksDto'?: EarthWorksDto;
    /**
     * 
     * @type {HoodedInletElevationDto}
     * @memberof HoodedInletRequestDto
     */
    'hoodedInletElevationDto'?: HoodedInletElevationDto;
}
/**
 * 
 * @export
 * @interface HoodedInletResponseDto
 */
export interface HoodedInletResponseDto {
    /**
     * 
     * @type {number}
     * @memberof HoodedInletResponseDto
     */
    'capacity'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof HoodedInletResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletResponseDto
     */
    'lengthOfPipe'?: number;
    /**
     * 
     * @type {string}
     * @memberof HoodedInletResponseDto
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof HoodedInletResponseDto
     */
    'seepagePath'?: number;
    /**
     * 
     * @type {Array<StageDischargeDto>}
     * @memberof HoodedInletResponseDto
     */
    'stageDischargeList'?: Array<StageDischargeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof HoodedInletResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface HydraulicFormulaDefaultRequestDto
 */
export interface HydraulicFormulaDefaultRequestDto {
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'defaultValueJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'deleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'helpUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'hydraulicFormulaCategory'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'hydraulicFormulaDefaultId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'hydraulicFormulaDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'hydraulicFormulaId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'hydraulicFormulaImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'hydraulicFormulaName'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulaDefaultRequestDto
     */
    'lastChangedBy'?: string;
}
/**
 * 
 * @export
 * @interface HydraulicFormulasDefaultResponseDto
 */
export interface HydraulicFormulasDefaultResponseDto {
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'defaultValueJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'deleted'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'helpUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'hydraulicFormulaCategory'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'hydraulicFormulaDefaultId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'hydraulicFormulaDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'hydraulicFormulaId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'hydraulicFormulaImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'hydraulicFormulaImageDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'hydraulicFormulaName'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydraulicFormulasDefaultResponseDto
     */
    'lastChangedBy'?: string;
}
/**
 * 
 * @export
 * @interface HydroByAlignmentAOIRequestDTO
 */
export interface HydroByAlignmentAOIRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof HydroByAlignmentAOIRequestDTO
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroByAlignmentAOIRequestDTO
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface HydroByAlignmentAOIResponseDTO
 */
export interface HydroByAlignmentAOIResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof HydroByAlignmentAOIResponseDTO
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroByAlignmentAOIResponseDTO
     */
    'projectTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroByAlignmentAOIResponseDTO
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface HydroDesignElementJsonDto
 */
export interface HydroDesignElementJsonDto {
    /**
     * 
     * @type {string}
     * @memberof HydroDesignElementJsonDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroDesignElementJsonDto
     */
    'creationDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroDesignElementJsonDto
     */
    'designElementId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroDesignElementJsonDto
     */
    'designElementName'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroDesignElementJsonDto
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroDesignElementJsonDto
     */
    'designObjectNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroDesignElementJsonDto
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroDesignElementJsonDto
     */
    'eftVersion'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HydroDesignElementJsonDto
     */
    'flagUpToDate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HydroDesignElementJsonDto
     */
    'json'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroDesignElementJsonDto
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroDesignElementJsonDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroDesignElementJsonDto
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface HydroParamsDTO
 */
export interface HydroParamsDTO {
    /**
     * 
     * @type {string}
     * @memberof HydroParamsDTO
     */
    'county'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'initialQPercent'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'peakFlowQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroParamsDTO
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroParamsDTO
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'stormFrequency'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'timeOfConcentration'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'totalRunoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'unitPeakDischarge'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'watershedSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroParamsDTO
     */
    'weightedCurveNumber'?: number;
}
/**
 * 
 * @export
 * @interface HydroResponseDto
 */
export interface HydroResponseDto {
    /**
     * 
     * @type {number}
     * @memberof HydroResponseDto
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'basinCharacteristicsJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'basinName'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroResponseDto
     */
    'basinTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof HydroResponseDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HydroResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HydroResponseDto
     */
    'designElementJsonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroResponseDto
     */
    'hydroParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HydroResponseDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'runoffSedimentStorageJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'soilParametersDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'terraceVegetalParametersDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof HydroResponseDto
     */
    'userDefinedBasinJson'?: string;
}
/**
 * 
 * @export
 * @interface ImageZipDownloadDto
 */
export interface ImageZipDownloadDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ImageZipDownloadDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof ImageZipDownloadDto
     */
    'zipFileName'?: string;
}
/**
 * 
 * @export
 * @interface InletProfileRowDTO
 */
export interface InletProfileRowDTO {
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'baseOrElbowElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'channelBottomElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'channelCut'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InletProfileRowDTO
     */
    'empty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InletProfileRowDTO
     */
    'guard'?: string;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'holesPerFoot'?: number;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'inletDiameter'?: number;
    /**
     * 
     * @type {string}
     * @memberof InletProfileRowDTO
     */
    'inletId'?: string;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'offsetPipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'offsetPipeLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'orificeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'orificeElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof InletProfileRowDTO
     */
    'perforationLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof InletProfileRowDTO
     */
    'perforationSize'?: string;
}
/**
 * 
 * @export
 * @interface InlineWaterControlElevationDto
 */
export interface InlineWaterControlElevationDto {
    /**
     * 
     * @type {number}
     * @memberof InlineWaterControlElevationDto
     */
    'maxPoolElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineWaterControlElevationDto
     */
    'pipeInletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineWaterControlElevationDto
     */
    'pipeOutletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineWaterControlElevationDto
     */
    'structureInvertElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineWaterControlElevationDto
     */
    'tailwaterElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineWaterControlElevationDto
     */
    'weirElev'?: number;
}
/**
 * 
 * @export
 * @interface InlineWaterControlRecordDto
 */
export interface InlineWaterControlRecordDto {
    /**
     * 
     * @type {string}
     * @memberof InlineWaterControlRecordDto
     */
    'discharge'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineWaterControlRecordDto
     */
    'downStreamElevation'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineWaterControlRecordDto
     */
    'poolElevation'?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineWaterControlRecordDto
     */
    'weirStageElevation'?: string;
}
/**
 * 
 * @export
 * @interface InlineWaterControlRequestDto
 */
export interface InlineWaterControlRequestDto {
    /**
     * 
     * @type {CommonInletDto}
     * @memberof InlineWaterControlRequestDto
     */
    'commonInletDto'?: CommonInletDto;
    /**
     * 
     * @type {CommonOutletDto}
     * @memberof InlineWaterControlRequestDto
     */
    'commonOutletDto'?: CommonOutletDto;
    /**
     * 
     * @type {InlineWaterControlElevationDto}
     * @memberof InlineWaterControlRequestDto
     */
    'inlineWaterControlElevationDto'?: InlineWaterControlElevationDto;
    /**
     * 
     * @type {number}
     * @memberof InlineWaterControlRequestDto
     */
    'weirLength'?: number;
}
/**
 * 
 * @export
 * @interface InlineWaterControlResponseDto
 */
export interface InlineWaterControlResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof InlineWaterControlResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<InlineWaterControlRecordDto>}
     * @memberof InlineWaterControlResponseDto
     */
    'inlineWaterControlRecordList'?: Array<InlineWaterControlRecordDto>;
    /**
     * 
     * @type {boolean}
     * @memberof InlineWaterControlResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface InputPoint
 */
export interface InputPoint {
    /**
     * 
     * @type {number}
     * @memberof InputPoint
     */
    'cutOrFill'?: number;
    /**
     * 
     * @type {string}
     * @memberof InputPoint
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof InputPoint
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InputPoint
     */
    'keyString'?: string;
    /**
     * 
     * @type {string}
     * @memberof InputPoint
     */
    'objectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InputPoint
     */
    'pointName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InputPoint
     */
    'tinnable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InputPoint
     */
    'visiable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InputPoint
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof InputPoint
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof InputPoint
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface InputStreamResource
 */
export interface InputStreamResource {
    /**
     * 
     * @type {string}
     * @memberof InputStreamResource
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof InputStreamResource
     */
    'file'?: any;
    /**
     * 
     * @type {string}
     * @memberof InputStreamResource
     */
    'filename'?: string;
    /**
     * 
     * @type {object}
     * @memberof InputStreamResource
     */
    'inputStream'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof InputStreamResource
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InputStreamResource
     */
    'readable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputStreamResource
     */
    'uri'?: string;
    /**
     * 
     * @type {URL}
     * @memberof InputStreamResource
     */
    'url'?: URL;
}
/**
 * 
 * @export
 * @interface InputXYZPoints
 */
export interface InputXYZPoints {
    /**
     * 
     * @type {string}
     * @memberof InputXYZPoints
     */
    'projectid'?: string;
    /**
     * 
     * @type {string}
     * @memberof InputXYZPoints
     */
    'sessionid'?: string;
    /**
     * 
     * @type {string}
     * @memberof InputXYZPoints
     */
    'surveyid'?: string;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof InputXYZPoints
     */
    'xyzarray'?: Array<InputPoint>;
}
/**
 * 
 * @export
 * @interface IntersectingTerraceDTO
 */
export interface IntersectingTerraceDTO {
    /**
     * 
     * @type {number}
     * @memberof IntersectingTerraceDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntersectingTerraceDTO
     */
    'alignedFeatureName'?: string;
    /**
     * 
     * @type {TerraceStructureShapeDTO}
     * @memberof IntersectingTerraceDTO
     */
    'terraceStructureShapeDTO'?: TerraceStructureShapeDTO;
}
/**
 * 
 * @export
 * @interface LandLevelingBestFitResponse
 */
export interface LandLevelingBestFitResponse {
    /**
     * 
     * @type {InputPoint}
     * @memberof LandLevelingBestFitResponse
     */
    'basePoint'?: InputPoint;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingBestFitResponse
     */
    'bestFit'?: boolean;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof LandLevelingBestFitResponse
     */
    'boundaryPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingBestFitResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingBestFitResponse
     */
    'useWholeField'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingBestFitResponse
     */
    'xslope'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingBestFitResponse
     */
    'yslope'?: number;
}
/**
 * 
 * @export
 * @interface LandLevelingCentroidResponse
 */
export interface LandLevelingCentroidResponse {
    /**
     * 
     * @type {InputPoint}
     * @memberof LandLevelingCentroidResponse
     */
    'basePoint'?: InputPoint;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof LandLevelingCentroidResponse
     */
    'boundaryPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingCentroidResponse
     */
    'centroid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingCentroidResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingCentroidResponse
     */
    'useWholeField'?: boolean;
}
/**
 * 
 * @export
 * @interface LandLevelingRequest
 */
export interface LandLevelingRequest {
    /**
     * 
     * @type {InputPoint}
     * @memberof LandLevelingRequest
     */
    'basePoint'?: InputPoint;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingRequest
     */
    'bestFit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'borrow'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof LandLevelingRequest
     */
    'boundaryPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'bufferSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingRequest
     */
    'centroid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingRequest
     */
    'includeDesignSurface'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'llStakeoutGrid'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandLevelingRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LandLevelingRequest
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingRequest
     */
    'useWholeField'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'waste'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'xslope'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingRequest
     */
    'yslope'?: number;
}
/**
 * 
 * @export
 * @interface LandLevelingResponse
 */
export interface LandLevelingResponse {
    /**
     * 
     * @type {InputPoint}
     * @memberof LandLevelingResponse
     */
    'basePoint'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'borrow'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof LandLevelingResponse
     */
    'boundaryPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'bufferArea'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof LandLevelingResponse
     */
    'bufferBorder'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<XyzPoint>}
     * @memberof LandLevelingResponse
     */
    'bufferPoints'?: Array<XyzPoint>;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'bufferSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'cellHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'cellSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'cellWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'cutRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'cutVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof LandLevelingResponse
     */
    'designedContours'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof LandLevelingResponse
     */
    'designedTinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'fieldArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'fillVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'llStakeoutGrid'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof LandLevelingResponse
     */
    'modifiedPlanePoints'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof LandLevelingResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'numOfX'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'numOfY'?: number;
    /**
     * 
     * @type {{ [key: string]: XyzPoint; }}
     * @memberof LandLevelingResponse
     */
    'planePoints'?: { [key: string]: XyzPoint; };
    /**
     * 
     * @type {Array<LineSegmentDto>}
     * @memberof LandLevelingResponse
     */
    'slopeArrows'?: Array<LineSegmentDto>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof LandLevelingResponse
     */
    'stakeOutPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'totalBufferCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'totalBufferFill'?: number;
    /**
     * 
     * @type {string}
     * @memberof LandLevelingResponse
     */
    'type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LandLevelingResponse
     */
    'useWholeField'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'waste'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'xmin'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'xslope'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'ymin'?: number;
    /**
     * 
     * @type {number}
     * @memberof LandLevelingResponse
     */
    'yslope'?: number;
}
/**
 * 
 * @export
 * @interface LineSegmentDto
 */
export interface LineSegmentDto {
    /**
     * 
     * @type {PointDto}
     * @memberof LineSegmentDto
     */
    'endPoint'?: PointDto;
    /**
     * 
     * @type {boolean}
     * @memberof LineSegmentDto
     */
    'hasZ'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LineSegmentDto
     */
    'srid'?: number;
    /**
     * 
     * @type {PointDto}
     * @memberof LineSegmentDto
     */
    'startPoint'?: PointDto;
}
/**
 * 
 * @export
 * @interface LinedSoilVegInfoDTO
 */
export interface LinedSoilVegInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof LinedSoilVegInfoDTO
     */
    'endStation'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinedSoilVegInfoDTO
     */
    'liningMaterial'?: string;
    /**
     * 
     * @type {number}
     * @memberof LinedSoilVegInfoDTO
     */
    'manningsN'?: number;
    /**
     * 
     * @type {string}
     * @memberof LinedSoilVegInfoDTO
     */
    'startStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof LinedSoilVegInfoDTO
     */
    'thickness'?: number;
    /**
     * 
     * @type {number}
     * @memberof LinedSoilVegInfoDTO
     */
    'velocity'?: number;
}
/**
 * 
 * @export
 * @interface LiningMaterialPatchRequest
 */
export interface LiningMaterialPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof LiningMaterialPatchRequest
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof LiningMaterialPatchRequest
     */
    'liningMaterials'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiningMaterialPatchRequest
     */
    'reachIdList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface LiningMaterialPatchResponse
 */
export interface LiningMaterialPatchResponse {
    /**
     * 
     * @type {number}
     * @memberof LiningMaterialPatchResponse
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof LiningMaterialPatchResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof LiningMaterialPatchResponse
     */
    'patchingStatus'?: string;
    /**
     * 
     * @type {{ [key: string]: LocalReachLiningMaterialDTO; }}
     * @memberof LiningMaterialPatchResponse
     */
    'reachLiningMaterialsPatchMap'?: { [key: string]: LocalReachLiningMaterialDTO; };
    /**
     * 
     * @type {string}
     * @memberof LiningMaterialPatchResponse
     */
    'waterwayGlobalLiningMaterials'?: string;
}
/**
 * 
 * @export
 * @interface LoadFlowPathSegmentsRespDTO
 */
export interface LoadFlowPathSegmentsRespDTO {
    /**
     * 
     * @type {number}
     * @memberof LoadFlowPathSegmentsRespDTO
     */
    'averageVelocity'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadFlowPathSegmentsRespDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {Array<FlowPathSegment>}
     * @memberof LoadFlowPathSegmentsRespDTO
     */
    'flowPathSegments'?: Array<FlowPathSegment>;
    /**
     * 
     * @type {number}
     * @memberof LoadFlowPathSegmentsRespDTO
     */
    'rainfallDistribution'?: number;
    /**
     * 
     * @type {string}
     * @memberof LoadFlowPathSegmentsRespDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoadFlowPathSegmentsRespDTO
     */
    'timeOfConcentration'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadFlowPathSegmentsRespDTO
     */
    'totalLength'?: number;
}
/**
 * 
 * @export
 * @interface LoadTerraceHydroParamsResponseDTO
 */
export interface LoadTerraceHydroParamsResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {BasinCharacteristicsDTO}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'basinCharacteristics'?: BasinCharacteristicsDTO;
    /**
     * 
     * @type {number}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'basinTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {RunoffSedimentStorageDTO}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'runoffSedimentStorage'?: RunoffSedimentStorageDTO;
    /**
     * 
     * @type {SoilParametersDTO}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'soilParameters'?: SoilParametersDTO;
    /**
     * 
     * @type {TerraceVegetalParametersDTO}
     * @memberof LoadTerraceHydroParamsResponseDTO
     */
    'terraceVegetalParameters'?: TerraceVegetalParametersDTO;
}
/**
 * 
 * @export
 * @interface LocalReachLiningMaterialDTO
 */
export interface LocalReachLiningMaterialDTO {
    /**
     * 
     * @type {string}
     * @memberof LocalReachLiningMaterialDTO
     */
    'capacity'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalReachLiningMaterialDTO
     */
    'stability'?: string;
}
/**
 * 
 * @export
 * @interface ManufacturedRiserTypeRequestDTO
 */
export interface ManufacturedRiserTypeRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'diameterIn'?: number;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'guard'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'heightIn'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'heightOfPerforationsFt'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'holeDiameterIn'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'holeWidthIn'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'holesPerFoot'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'ke'?: number;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'material'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'perforationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'riserTypeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeRequestDTO
     */
    'topOpeningDiameterIn'?: number;
}
/**
 * 
 * @export
 * @interface ManufacturedRiserTypeResponseDTO
 */
export interface ManufacturedRiserTypeResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'diameterIn'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'guard'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'heightIn'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'heightOfPerforationsFt'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'holeDiameterIn'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'holeWidthIn'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'holesPerFoot'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'ke'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'material'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'perforationType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'riserTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'riserTypeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManufacturedRiserTypeResponseDTO
     */
    'topOpeningDiameterIn'?: number;
}
/**
 * 
 * @export
 * @interface MatchVertex
 */
export interface MatchVertex {
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'alignedElementParamId'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'channelElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchVertex
     */
    'channelName'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'distance'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchVertex
     */
    'matchedReachStationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'sourceAlignmentDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'sourceAlignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchVertex
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'targetAlignmentId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MatchVertex
     */
    'theSameAlignmentId'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MatchVertex
     */
    'vertexDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchVertex
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface MiniHydroToolRequestDTO
 */
export interface MiniHydroToolRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof MiniHydroToolRequestDTO
     */
    'basinName'?: string;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolRequestDTO
     */
    'precipitation'?: number;
    /**
     * 
     * @type {string}
     * @memberof MiniHydroToolRequestDTO
     */
    'stormType'?: string;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolRequestDTO
     */
    'watershedArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolRequestDTO
     */
    'watershedCN'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolRequestDTO
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolRequestDTO
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface MiniHydroToolResponseDTO
 */
export interface MiniHydroToolResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof MiniHydroToolResponseDTO
     */
    'basinName'?: string;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'peakFlow'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'precipitation'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'qu'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'runoffQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof MiniHydroToolResponseDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof MiniHydroToolResponseDTO
     */
    'stormType'?: string;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'totalRunOff'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'watershedArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'watershedCN'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniHydroToolResponseDTO
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'absolute'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'absoluteFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'absolutePath'?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'canonicalFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'canonicalPath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'directory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'file'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'freeSpace'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelFile
     */
    'hidden'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'parent'?: string;
    /**
     * 
     * @type {any}
     * @memberof ModelFile
     */
    'parentFile'?: any;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'totalSpace'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    'usableSpace'?: number;
}
/**
 * 
 * @export
 * @interface NetsDefaultParametersResponseDTO
 */
export interface NetsDefaultParametersResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof NetsDefaultParametersResponseDTO
     */
    'defaultItemName'?: string;
    /**
     * 
     * @type {string}
     * @memberof NetsDefaultParametersResponseDTO
     */
    'errorResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof NetsDefaultParametersResponseDTO
     */
    'parametersJson'?: string;
}
/**
 * 
 * @export
 * @interface NextErrorCodeResponseDto
 */
export interface NextErrorCodeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof NextErrorCodeResponseDto
     */
    'errorCodePrefix'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof NextErrorCodeResponseDto
     */
    'errorResp'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof NextErrorCodeResponseDto
     */
    'nextErrorCodeNum'?: string;
}
/**
 * 
 * @export
 * @interface NodeAction
 */
export interface NodeAction {
    /**
     * 
     * @type {number}
     * @memberof NodeAction
     */
    'distanceAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodeAction
     */
    'elevationAdjustment'?: number;
    /**
     * 
     * @type {number}
     * @memberof NodeAction
     */
    'nodeId'?: number;
}
/**
 * 
 * @export
 * @interface OTriangleRequestDto
 */
export interface OTriangleRequestDto {
    /**
     * 
     * @type {number}
     * @memberof OTriangleRequestDto
     */
    'a'?: number;
    /**
     * 
     * @type {number}
     * @memberof OTriangleRequestDto
     */
    'b'?: number;
    /**
     * 
     * @type {number}
     * @memberof OTriangleRequestDto
     */
    'c'?: number;
}
/**
 * 
 * @export
 * @interface OTriangleResponseDto
 */
export interface OTriangleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof OTriangleResponseDto
     */
    'angleA'?: number;
    /**
     * 
     * @type {number}
     * @memberof OTriangleResponseDto
     */
    'angleB'?: number;
    /**
     * 
     * @type {number}
     * @memberof OTriangleResponseDto
     */
    'angleC'?: number;
    /**
     * 
     * @type {number}
     * @memberof OTriangleResponseDto
     */
    'area'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof OTriangleResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof OTriangleResponseDto
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof OTriangleResponseDto
     */
    'r'?: number;
    /**
     * 
     * @type {number}
     * @memberof OTriangleResponseDto
     */
    's'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OTriangleResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface OffsetStationDTO
 */
export interface OffsetStationDTO {
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationDTO
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationDTO
     */
    'entryMode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationDTO
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'hiElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'offsetStationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OffsetStationDTO
     */
    'offsetType'?: string;
    /**
     * 
     * @type {Array<SurveyEngineeringProjectDTO>}
     * @memberof OffsetStationDTO
     */
    'offsets'?: Array<SurveyEngineeringProjectDTO>;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'stationStep'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'tangentAzimuth'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationDTO
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface OffsetStationLineResponse
 */
export interface OffsetStationLineResponse {
    /**
     * 
     * @type {number}
     * @memberof OffsetStationLineResponse
     */
    'offsetStationLineEndPointId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetStationLineResponse
     */
    'offsetStationLineStartPointId'?: number;
}
/**
 * 
 * @export
 * @interface OrientationDTO
 */
export interface OrientationDTO {
    /**
     * 
     * @type {string}
     * @memberof OrientationDTO
     */
    'flagLineLocation'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrientationDTO
     */
    'flagLineLocationOption'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrientationDTO
     */
    'offsetFromAlignment'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrientationDTO
     */
    'uphillDirection'?: string;
}
/**
 * 
 * @export
 * @interface OrificeFlowRequestDTO
 */
export interface OrificeFlowRequestDTO {
    /**
     * 
     * @type {boolean}
     * @memberof OrificeFlowRequestDTO
     */
    'calDiameter'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrificeFlowRequestDTO
     */
    'head'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrificeFlowRequestDTO
     */
    'orificeArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrificeFlowRequestDTO
     */
    'orificeCoefficient'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrificeFlowRequestDTO
     */
    'orificeDiameter'?: number;
}
/**
 * 
 * @export
 * @interface OrificeFlowResponseDTO
 */
export interface OrificeFlowResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof OrificeFlowResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof OrificeFlowResponseDTO
     */
    'q'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrificeFlowResponseDTO
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface OutletProfileRowDTO
 */
export interface OutletProfileRowDTO {
    /**
     * 
     * @type {boolean}
     * @memberof OutletProfileRowDTO
     */
    'empty'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutletProfileRowDTO
     */
    'guard'?: string;
    /**
     * 
     * @type {number}
     * @memberof OutletProfileRowDTO
     */
    'holesPerFoot'?: number;
    /**
     * 
     * @type {string}
     * @memberof OutletProfileRowDTO
     */
    'inletId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OutletProfileRowDTO
     */
    'material'?: string;
    /**
     * 
     * @type {number}
     * @memberof OutletProfileRowDTO
     */
    'outletDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof OutletProfileRowDTO
     */
    'outletElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof OutletProfileRowDTO
     */
    'outletLengthOrHeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof OutletProfileRowDTO
     */
    'outletType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OutletProfileRowDTO
     */
    'perforationSize'?: string;
}
/**
 * 
 * @export
 * @interface PadRequest
 */
export interface PadRequest {
    /**
     * 
     * @type {InputPoint}
     * @memberof PadRequest
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {Array<number>}
     * @memberof PadRequest
     */
    'cutSlopes'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PadRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PadRequest
     */
    'equalCutSlopes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PadRequest
     */
    'equalFillSlopes'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PadRequest
     */
    'fillSlopes'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PadRequest
     */
    'includeDesignSurface'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PadRequest
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof PadRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PadRequest
     */
    'orienAzimuth'?: number;
    /**
     * 
     * @type {string}
     * @memberof PadRequest
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PadRequest
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface PadResponse
 */
export interface PadResponse {
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof PadResponse
     */
    'borders'?: Array<InputPoint>;
    /**
     * 
     * @type {InputPoint}
     * @memberof PadResponse
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PadResponse
     */
    'cutSlopes'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'cutVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof PadResponse
     */
    'designedContours'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof PadResponse
     */
    'designedTinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof PadResponse
     */
    'edgeBreaklines'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {boolean}
     * @memberof PadResponse
     */
    'equalCutSlopes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PadResponse
     */
    'equalFillSlopes'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PadResponse
     */
    'fillSlopes'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'fillVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof PadResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'orienAzimuth'?: number;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof PadResponse
     */
    'rays'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<LineSegmentDto>}
     * @memberof PadResponse
     */
    'slopeArrows'?: Array<LineSegmentDto>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof PadResponse
     */
    'stakeoutPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof PadResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PadResponse
     */
    'url'?: string;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof PadResponse
     */
    'vertices'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof PadResponse
     */
    'warningMsg'?: string;
    /**
     * 
     * @type {number}
     * @memberof PadResponse
     */
    'width'?: number;
    /**
     * 
     * @type {string}
     * @memberof PadResponse
     */
    'wkid'?: string;
}
/**
 * 
 * @export
 * @interface ParabolaRequestDto
 */
export interface ParabolaRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ParabolaRequestDto
     */
    'dep'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParabolaRequestDto
     */
    'topW'?: number;
}
/**
 * 
 * @export
 * @interface ParabolaResponseDto
 */
export interface ParabolaResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ParabolaResponseDto
     */
    'area'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ParabolaResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof ParabolaResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface ParabolicChannelRequestDto
 */
export interface ParabolicChannelRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ParabolicChannelRequestDto
     */
    'bedSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParabolicChannelRequestDto
     */
    'depth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParabolicChannelRequestDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParabolicChannelRequestDto
     */
    'topWidth'?: number;
}
/**
 * 
 * @export
 * @interface ParabolicChannelResponseDto
 */
export interface ParabolicChannelResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ParabolicChannelResponseDto
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParabolicChannelResponseDto
     */
    'capacity'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParabolicChannelResponseDto
     */
    'criticalDepth'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ParabolicChannelResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof ParabolicChannelResponseDto
     */
    'hydraulicRadius'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParabolicChannelResponseDto
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParabolicChannelResponseDto
     */
    'velocity'?: string;
}
/**
 * 
 * @export
 * @interface ParallelogramRequestDto
 */
export interface ParallelogramRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ParallelogramRequestDto
     */
    'a'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParallelogramRequestDto
     */
    'b'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParallelogramRequestDto
     */
    'height'?: number;
}
/**
 * 
 * @export
 * @interface ParallelogramResponseDto
 */
export interface ParallelogramResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ParallelogramResponseDto
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParallelogramResponseDto
     */
    'd1'?: number;
    /**
     * 
     * @type {number}
     * @memberof ParallelogramResponseDto
     */
    'd2'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof ParallelogramResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof ParallelogramResponseDto
     */
    'theta'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ParallelogramResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface PipeDropElevationDto
 */
export interface PipeDropElevationDto {
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'auxSpillwayElev'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PipeDropElevationDto
     */
    'enableTailwater'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'inletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'outletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'riserDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'riserLengthBelowInlet'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'riserTopElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'tailwaterElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'topElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeDropElevationDto
     */
    'waterElev'?: number;
}
/**
 * 
 * @export
 * @interface PipeDropRequestDto
 */
export interface PipeDropRequestDto {
    /**
     * 
     * @type {CommonPipeDto}
     * @memberof PipeDropRequestDto
     */
    'commonPipeDto'?: CommonPipeDto;
    /**
     * 
     * @type {CommonSideSlopeDto}
     * @memberof PipeDropRequestDto
     */
    'commonSideSlopeDto'?: CommonSideSlopeDto;
    /**
     * 
     * @type {EarthWorksDto}
     * @memberof PipeDropRequestDto
     */
    'earthWorksDto'?: EarthWorksDto;
    /**
     * 
     * @type {PipeDropElevationDto}
     * @memberof PipeDropRequestDto
     */
    'pipeDropElevationDto'?: PipeDropElevationDto;
}
/**
 * 
 * @export
 * @interface PipeDropResponseDTO
 */
export interface PipeDropResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof PipeDropResponseDTO
     */
    'capacity'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof PipeDropResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof PipeDropResponseDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PipeDropResponseDTO
     */
    'pipeLength'?: string;
    /**
     * 
     * @type {string}
     * @memberof PipeDropResponseDTO
     */
    'riserHeight'?: string;
    /**
     * 
     * @type {string}
     * @memberof PipeDropResponseDTO
     */
    'seepagePath'?: string;
    /**
     * 
     * @type {Array<StageDischargeDto>}
     * @memberof PipeDropResponseDTO
     */
    'stageDischargeList'?: Array<StageDischargeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PipeDropResponseDTO
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface PipeNetworkSimulationAndValidationRequestDto
 */
export interface PipeNetworkSimulationAndValidationRequestDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof PipeNetworkSimulationAndValidationRequestDto
     */
    'pipeIdList'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PipeNetworkSimulationAndValidationRequestDto
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface PipeNetworkSimulationResponseDto
 */
export interface PipeNetworkSimulationResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof PipeNetworkSimulationResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<PipeReachNetworkSimulationResult>}
     * @memberof PipeNetworkSimulationResponseDto
     */
    'pipeNetworkSimulationResult'?: Array<PipeReachNetworkSimulationResult>;
    /**
     * 
     * @type {string}
     * @memberof PipeNetworkSimulationResponseDto
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PipeNetworkSimulationResponseDto
     */
    'successful'?: boolean;
}
/**
 * 
 * @export
 * @interface PipeReachNetworkSimulationResult
 */
export interface PipeReachNetworkSimulationResult {
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'actualQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'capacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'capacityUtilization'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'diameter'?: number;
    /**
     * 
     * @type {string}
     * @memberof PipeReachNetworkSimulationResult
     */
    'drainStationId'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof PipeReachNetworkSimulationResult
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof PipeReachNetworkSimulationResult
     */
    'material'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PipeReachNetworkSimulationResult
     */
    'onPressure'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PipeReachNetworkSimulationResult
     */
    'passed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'pipeAlignedElementParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'pipeGrade'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'pipeLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof PipeReachNetworkSimulationResult
     */
    'pipelineName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PipeReachNetworkSimulationResult
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'requiredQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof PipeReachNetworkSimulationResult
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'terraceAlignedElementParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PipeReachNetworkSimulationResult
     */
    'terraceName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PipeReachNetworkSimulationResult
     */
    'velocity'?: number;
}
/**
 * 
 * @export
 * @interface PipelineDto
 */
export interface PipelineDto {
    /**
     * 
     * @type {number}
     * @memberof PipelineDto
     */
    'hazenWilliamsCoeff'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineDto
     */
    'numberOf45Elbows'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineDto
     */
    'numberOf90Elbows'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineDto
     */
    'totalPipeLength'?: number;
}
/**
 * 
 * @export
 * @interface PipelineModel
 */
export interface PipelineModel {
    /**
     * 
     * @type {number}
     * @memberof PipelineModel
     */
    'acres'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineModel
     */
    'acresAvail'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineModel
     */
    'diameter'?: number;
    /**
     * 
     * @type {string}
     * @memberof PipelineModel
     */
    'pipelineName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PipelineModel
     */
    'qavail'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineModel
     */
    'qreq'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineModel
     */
    'slope'?: number;
    /**
     * 
     * @type {number}
     * @memberof PipelineModel
     */
    'velocity'?: number;
}
/**
 * 
 * @export
 * @interface PitPadRequest
 */
export interface PitPadRequest {
    /**
     * 
     * @type {number}
     * @memberof PitPadRequest
     */
    'designElementId'?: number;
}
/**
 * 
 * @export
 * @interface PlungePoolElevationsDto
 */
export interface PlungePoolElevationsDto {
    /**
     * 
     * @type {number}
     * @memberof PlungePoolElevationsDto
     */
    'channelBottomElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlungePoolElevationsDto
     */
    'channelFlowElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlungePoolElevationsDto
     */
    'pipeOutletElev'?: number;
}
/**
 * 
 * @export
 * @interface PlungePoolPipeDto
 */
export interface PlungePoolPipeDto {
    /**
     * 
     * @type {number}
     * @memberof PlungePoolPipeDto
     */
    'maxPipeQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlungePoolPipeDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof PlungePoolPipeDto
     */
    'pipeSlope'?: number;
}
/**
 * 
 * @export
 * @interface PlungePoolRequestDto
 */
export interface PlungePoolRequestDto {
    /**
     * 
     * @type {PlungePoolElevationsDto}
     * @memberof PlungePoolRequestDto
     */
    'plungePoolElevationsDto'?: PlungePoolElevationsDto;
    /**
     * 
     * @type {PlungePoolPipeDto}
     * @memberof PlungePoolRequestDto
     */
    'plungePoolPipeDto'?: PlungePoolPipeDto;
    /**
     * 
     * @type {PoolShapeDto}
     * @memberof PlungePoolRequestDto
     */
    'poolShapeDto'?: PoolShapeDto;
}
/**
 * 
 * @export
 * @interface PlungePoolResponseDTO
 */
export interface PlungePoolResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'acrossFlow'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'atBottom'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'atSurface'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'bottomElevation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'distToCenterline'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof PlungePoolResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'filterVolume'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'geotextileArea'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'ripRapMaterial'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'ripRapThickness'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlungePoolResponseDTO
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PlungePoolResponseDTO
     */
    'withFlow'?: string;
}
/**
 * 
 * @export
 * @interface Point
 */
export interface Point {
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'area'?: number;
    /**
     * 
     * @type {Geometry}
     * @memberof Point
     */
    'boundary'?: Geometry;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'boundaryDimension'?: number;
    /**
     * 
     * @type {Point}
     * @memberof Point
     */
    'centroid'?: Point;
    /**
     * 
     * @type {Coordinate}
     * @memberof Point
     */
    'coordinate'?: Coordinate;
    /**
     * 
     * @type {CoordinateSequence}
     * @memberof Point
     */
    'coordinateSequence'?: CoordinateSequence;
    /**
     * 
     * @type {Array<Coordinate>}
     * @memberof Point
     */
    'coordinates'?: Array<Coordinate>;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'dimension'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Point
     */
    'empty'?: boolean;
    /**
     * 
     * @type {Geometry}
     * @memberof Point
     */
    'envelope'?: Geometry;
    /**
     * 
     * @type {Envelope}
     * @memberof Point
     */
    'envelopeInternal'?: Envelope;
    /**
     * 
     * @type {GeometryFactory}
     * @memberof Point
     */
    'factory'?: GeometryFactory;
    /**
     * 
     * @type {string}
     * @memberof Point
     */
    'geometryType'?: string;
    /**
     * 
     * @type {Point}
     * @memberof Point
     */
    'interiorPoint'?: Point;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'numGeometries'?: number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'numPoints'?: number;
    /**
     * 
     * @type {PrecisionModel}
     * @memberof Point
     */
    'precisionModel'?: PrecisionModel;
    /**
     * 
     * @type {boolean}
     * @memberof Point
     */
    'rectangle'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Point
     */
    'simple'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'srid'?: number;
    /**
     * 
     * @type {object}
     * @memberof Point
     */
    'userData'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Point
     */
    'valid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof Point
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface PointDto
 */
export interface PointDto {
    /**
     * 
     * @type {boolean}
     * @memberof PointDto
     */
    'hasZ'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PointDto
     */
    'srid'?: number;
    /**
     * 
     * @type {number}
     * @memberof PointDto
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof PointDto
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof PointDto
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface Polygon
 */
export interface Polygon {
    /**
     * 
     * @type {number}
     * @memberof Polygon
     */
    'area'?: number;
    /**
     * 
     * @type {number}
     * @memberof Polygon
     */
    'maxX'?: number;
    /**
     * 
     * @type {number}
     * @memberof Polygon
     */
    'maxY'?: number;
    /**
     * 
     * @type {number}
     * @memberof Polygon
     */
    'minX'?: number;
    /**
     * 
     * @type {number}
     * @memberof Polygon
     */
    'minY'?: number;
    /**
     * 
     * @type {Array<Point>}
     * @memberof Polygon
     */
    'pointList'?: Array<Point>;
    /**
     * 
     * @type {number}
     * @memberof Polygon
     */
    'signedArea'?: number;
}
/**
 * 
 * @export
 * @interface PoolShapeDto
 */
export interface PoolShapeDto {
    /**
     * 
     * @type {number}
     * @memberof PoolShapeDto
     */
    'acrossFlow'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolShapeDto
     */
    'aveRockSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PoolShapeDto
     */
    'filterThickness'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PoolShapeDto
     */
    'geotextileFilter'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PoolShapeDto
     */
    'overrideSideSlopes'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PoolShapeDto
     */
    'poolShape'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PoolShapeDto
     */
    'withFlow'?: number;
}
/**
 * 
 * @export
 * @interface PrecisionModel
 */
export interface PrecisionModel {
    /**
     * 
     * @type {boolean}
     * @memberof PrecisionModel
     */
    'floating'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PrecisionModel
     */
    'maximumSignificantDigits'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecisionModel
     */
    'offsetX'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecisionModel
     */
    'offsetY'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrecisionModel
     */
    'scale'?: number;
    /**
     * 
     * @type {object}
     * @memberof PrecisionModel
     */
    'type'?: object;
}
/**
 * 
 * @export
 * @interface PressureFlowPipeRequestDto
 */
export interface PressureFlowPipeRequestDto {
    /**
     * 
     * @type {ElevationDto}
     * @memberof PressureFlowPipeRequestDto
     */
    'elevationDto'?: ElevationDto;
    /**
     * 
     * @type {HeadDto}
     * @memberof PressureFlowPipeRequestDto
     */
    'headDto'?: HeadDto;
    /**
     * 
     * @type {boolean}
     * @memberof PressureFlowPipeRequestDto
     */
    'specify'?: boolean;
}
/**
 * 
 * @export
 * @interface PressureFlowPipeResponseDto
 */
export interface PressureFlowPipeResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof PressureFlowPipeResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof PressureFlowPipeResponseDto
     */
    'flowQ'?: string;
    /**
     * 
     * @type {string}
     * @memberof PressureFlowPipeResponseDto
     */
    'kp'?: string;
    /**
     * 
     * @type {string}
     * @memberof PressureFlowPipeResponseDto
     */
    'maxFall'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PressureFlowPipeResponseDto
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PressureFlowPipeResponseDto
     */
    'velocity'?: string;
}
/**
 * 
 * @export
 * @interface ProfileDTO
 */
export interface ProfileDTO {
    /**
     * 
     * @type {Array<StationDTO>}
     * @memberof ProfileDTO
     */
    'stationDTOList'?: Array<StationDTO>;
}
/**
 * 
 * @export
 * @interface ProfileRequestDTO
 */
export interface ProfileRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof ProfileRequestDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileRequestDTO
     */
    'lowBank'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProfileRequestDTO
     */
    'offsetValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileRequestDTO
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileRequestDTO
     */
    'verticalInterval'?: number;
}
/**
 * 
 * @export
 * @interface ProfileResponseDTO
 */
export interface ProfileResponseDTO {
    /**
     * 
     * @type {Array<ProfileDTO>}
     * @memberof ProfileResponseDTO
     */
    'bankProfileList'?: Array<ProfileDTO>;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof ProfileResponseDTO
     */
    'centerlineProfile'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface ProjectInfoDTO
 */
export interface ProjectInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof ProjectInfoDTO
     */
    'approvedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInfoDTO
     */
    'checkedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInfoDTO
     */
    'designedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInfoDTO
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInfoDTO
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectInfoDTO
     */
    'projectStatus'?: string;
}
/**
 * 
 * @export
 * @interface ProjectLandXMLRequest
 */
export interface ProjectLandXMLRequest {
    /**
     * 
     * @type {Array<GenerateLandXMLRequest>}
     * @memberof ProjectLandXMLRequest
     */
    'landXmlRequestList'?: Array<GenerateLandXMLRequest>;
    /**
     * 
     * @type {string}
     * @memberof ProjectLandXMLRequest
     */
    'projectUuid'?: string;
}
/**
 * 
 * @export
 * @interface PumpDrainageElevationDto
 */
export interface PumpDrainageElevationDto {
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageElevationDto
     */
    'inletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageElevationDto
     */
    'outletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageElevationDto
     */
    'startLevel'?: number;
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageElevationDto
     */
    'stopLevel'?: number;
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageElevationDto
     */
    'sumpArea'?: number;
}
/**
 * 
 * @export
 * @interface PumpDrainageRequestDto
 */
export interface PumpDrainageRequestDto {
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageRequestDto
     */
    'drainageCoeffs'?: number;
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageRequestDto
     */
    'drainedArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageRequestDto
     */
    'pumpCyclesPerHours'?: number;
    /**
     * 
     * @type {PumpDrainageElevationDto}
     * @memberof PumpDrainageRequestDto
     */
    'pumpDrainageElevationDto'?: PumpDrainageElevationDto;
    /**
     * 
     * @type {number}
     * @memberof PumpDrainageRequestDto
     */
    'saftyFactors'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PumpDrainageRequestDto
     */
    'solveFor'?: boolean;
}
/**
 * 
 * @export
 * @interface PumpDrainageResponseDTO
 */
export interface PumpDrainageResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof PumpDrainageResponseDTO
     */
    'dimensions'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof PumpDrainageResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof PumpDrainageResponseDTO
     */
    'flowQ'?: string;
    /**
     * 
     * @type {string}
     * @memberof PumpDrainageResponseDTO
     */
    'stopLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof PumpDrainageResponseDTO
     */
    'sumpArea'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PumpDrainageResponseDTO
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface ReDistributeRunoffDTO
 */
export interface ReDistributeRunoffDTO {
    /**
     * 
     * @type {number}
     * @memberof ReDistributeRunoffDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {Array<ReachParametersDTO>}
     * @memberof ReDistributeRunoffDTO
     */
    'reachParams'?: Array<ReachParametersDTO>;
}
/**
 * 
 * @export
 * @interface ReachFixedWidthDepthDTO
 */
export interface ReachFixedWidthDepthDTO {
    /**
     * 
     * @type {number}
     * @memberof ReachFixedWidthDepthDTO
     */
    'depth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReachFixedWidthDepthDTO
     */
    'depthEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReachFixedWidthDepthDTO
     */
    'simDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachFixedWidthDepthDTO
     */
    'simWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachFixedWidthDepthDTO
     */
    'width'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReachFixedWidthDepthDTO
     */
    'widthEdited'?: boolean;
}
/**
 * 
 * @export
 * @interface ReachFixedWidthDepthRequest
 */
export interface ReachFixedWidthDepthRequest {
    /**
     * 
     * @type {number}
     * @memberof ReachFixedWidthDepthRequest
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachFixedWidthDepthRequest
     */
    'fixedValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachFixedWidthDepthRequest
     */
    'fixedValueTypeId'?: number;
}
/**
 * 
 * @export
 * @interface ReachFixedWidthDepthResponse
 */
export interface ReachFixedWidthDepthResponse {
    /**
     * 
     * @type {{ [key: string]: ReachFixedWidthDepthDTO; }}
     * @memberof ReachFixedWidthDepthResponse
     */
    'updatedReachParametersMap'?: { [key: string]: ReachFixedWidthDepthDTO; };
}
/**
 * 
 * @export
 * @interface ReachGroupDTO
 */
export interface ReachGroupDTO {
    /**
     * 
     * @type {number}
     * @memberof ReachGroupDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {{ [key: string]: UgoVertexParamsDTO; }}
     * @memberof ReachGroupDTO
     */
    'ugoVertexParamsDTOMap'?: { [key: string]: UgoVertexParamsDTO; };
    /**
     * 
     * @type {{ [key: string]: WaterwayVertexParamDTO; }}
     * @memberof ReachGroupDTO
     */
    'waterWayVertextParamDTOMap'?: { [key: string]: WaterwayVertexParamDTO; };
}
/**
 * 
 * @export
 * @interface ReachInfoDTO
 */
export interface ReachInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachInfoDTO
     */
    'endStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'flowDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'flowTopWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'leftSS'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'limitingSlope'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachInfoDTO
     */
    'liningMaterial'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'offset1'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'offset2'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'offset3'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachInfoDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'rightSS'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'slope'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachInfoDTO
     */
    'startStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'thickness'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachInfoDTO
     */
    'volumeOfLiner'?: number;
}
/**
 * 
 * @export
 * @interface ReachJson
 */
export interface ReachJson {
    /**
     * 
     * @type {number}
     * @memberof ReachJson
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJson
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachJson
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReachJson
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReachJson
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJson
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJson
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachJson
     */
    'reachJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJson
     */
    'reachStationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJson
     */
    'waterwaySizingResponseDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJson
     */
    'waterwayVertexJson'?: string;
}
/**
 * 
 * @export
 * @interface ReachJsonRequestDto
 */
export interface ReachJsonRequestDto {
    /**
     * 
     * @type {number}
     * @memberof ReachJsonRequestDto
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonRequestDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonRequestDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonRequestDto
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachJsonRequestDto
     */
    'reachJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonRequestDto
     */
    'reachStationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonRequestDto
     */
    'waterwaySizingResponseDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonRequestDto
     */
    'waterwayVertexJson'?: string;
}
/**
 * 
 * @export
 * @interface ReachJsonResponseDto
 */
export interface ReachJsonResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ReachJsonResponseDto
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachJsonResponseDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReachJsonResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReachJsonResponseDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonResponseDto
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachJsonResponseDto
     */
    'reachJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonResponseDto
     */
    'reachStationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonResponseDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonResponseDto
     */
    'waterwaySizingResponseDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachJsonResponseDto
     */
    'waterwayVertexJson'?: string;
}
/**
 * 
 * @export
 * @interface ReachParametersDTO
 */
export interface ReachParametersDTO {
    /**
     * 
     * @type {number}
     * @memberof ReachParametersDTO
     */
    'addedQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachParametersDTO
     */
    'channelElev'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReachParametersDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReachParametersDTO
     */
    'runoffQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachParametersDTO
     */
    'stationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachParametersDTO
     */
    'totalQ'?: number;
}
/**
 * 
 * @export
 * @interface ReachStationAdjustmentDTO
 */
export interface ReachStationAdjustmentDTO {
    /**
     * 
     * @type {InputPoint}
     * @memberof ReachStationAdjustmentDTO
     */
    'coordinate'?: InputPoint;
    /**
     * 
     * @type {string}
     * @memberof ReachStationAdjustmentDTO
     */
    'newReachName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachStationAdjustmentDTO
     */
    'oldReachName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReachStationAdjustmentDTO
     */
    'reachId'?: string;
}
/**
 * 
 * @export
 * @interface ReachStationAdjustmentRequest
 */
export interface ReachStationAdjustmentRequest {
    /**
     * 
     * @type {number}
     * @memberof ReachStationAdjustmentRequest
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {AlignmentDTO}
     * @memberof ReachStationAdjustmentRequest
     */
    'alignmentDTO'?: AlignmentDTO;
}
/**
 * 
 * @export
 * @interface ReachStationAdjustmentResponse
 */
export interface ReachStationAdjustmentResponse {
    /**
     * 
     * @type {number}
     * @memberof ReachStationAdjustmentResponse
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReachStationAdjustmentResponse
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {Array<ReachStationAdjustmentDTO>}
     * @memberof ReachStationAdjustmentResponse
     */
    'reachStationAdjustmentDTOList'?: Array<ReachStationAdjustmentDTO>;
}
/**
 * 
 * @export
 * @interface ReachesUpdateEditRequest
 */
export interface ReachesUpdateEditRequest {
    /**
     * 
     * @type {number}
     * @memberof ReachesUpdateEditRequest
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ReachesUpdateEditRequest
     */
    'stationVertices'?: { [key: string]: number; };
    /**
     * 
     * @type {Array<WaterwayVertexParamDTO>}
     * @memberof ReachesUpdateEditRequest
     */
    'waterwayVertexParamDTO'?: Array<WaterwayVertexParamDTO>;
}
/**
 * 
 * @export
 * @interface RecRiserDropPipeDto
 */
export interface RecRiserDropPipeDto {
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropPipeDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropPipeDto
     */
    'pipeDiameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropPipeDto
     */
    'pipeLength'?: number;
}
/**
 * 
 * @export
 * @interface RecRiserDropStructureElevationDto
 */
export interface RecRiserDropStructureElevationDto {
    /**
     * 
     * @type {boolean}
     * @memberof RecRiserDropStructureElevationDto
     */
    'enableTailWater'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropStructureElevationDto
     */
    'inletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropStructureElevationDto
     */
    'maxPoolElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropStructureElevationDto
     */
    'outletElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropStructureElevationDto
     */
    'tailWaterElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropStructureElevationDto
     */
    'weirElev'?: number;
}
/**
 * 
 * @export
 * @interface RecRiserDropStructureRequestDto
 */
export interface RecRiserDropStructureRequestDto {
    /**
     * 
     * @type {RecRiserDropPipeDto}
     * @memberof RecRiserDropStructureRequestDto
     */
    'recRiserDropPipeDto'?: RecRiserDropPipeDto;
    /**
     * 
     * @type {RecRiserDropStructureElevationDto}
     * @memberof RecRiserDropStructureRequestDto
     */
    'recRiserDropStructureElevationDto'?: RecRiserDropStructureElevationDto;
    /**
     * 
     * @type {RiserDto}
     * @memberof RecRiserDropStructureRequestDto
     */
    'riserDto'?: RiserDto;
}
/**
 * 
 * @export
 * @interface RecRiserDropStructureResponseDto
 */
export interface RecRiserDropStructureResponseDto {
    /**
     * 
     * @type {number}
     * @memberof RecRiserDropStructureResponseDto
     */
    'capacity'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof RecRiserDropStructureResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof RecRiserDropStructureResponseDto
     */
    'message'?: string;
    /**
     * 
     * @type {Array<StageDischargeDto>}
     * @memberof RecRiserDropStructureResponseDto
     */
    'stageDischargeList'?: Array<StageDischargeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RecRiserDropStructureResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface RectangularPitRequest
 */
export interface RectangularPitRequest {
    /**
     * 
     * @type {InputPoint}
     * @memberof RectangularPitRequest
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RectangularPitRequest
     */
    'equalSlopes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RectangularPitRequest
     */
    'includeDesignSurface'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitRequest
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof RectangularPitRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitRequest
     */
    'orienAzimuth'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof RectangularPitRequest
     */
    'slopes'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof RectangularPitRequest
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitRequest
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface RectangularPitResponse
 */
export interface RectangularPitResponse {
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof RectangularPitResponse
     */
    'borders'?: Array<InputPoint>;
    /**
     * 
     * @type {InputPoint}
     * @memberof RectangularPitResponse
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitResponse
     */
    'cutVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof RectangularPitResponse
     */
    'designedContours'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof RectangularPitResponse
     */
    'designedTinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {boolean}
     * @memberof RectangularPitResponse
     */
    'equalSlopes'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitResponse
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof RectangularPitResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitResponse
     */
    'orienAzimuth'?: number;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof RectangularPitResponse
     */
    'rays'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<LineSegmentDto>}
     * @memberof RectangularPitResponse
     */
    'slopeArrows'?: Array<LineSegmentDto>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RectangularPitResponse
     */
    'slopes'?: Array<number>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof RectangularPitResponse
     */
    'stakeoutPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitResponse
     */
    'storageDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitResponse
     */
    'storageVolume'?: number;
    /**
     * 
     * @type {string}
     * @memberof RectangularPitResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RectangularPitResponse
     */
    'url'?: string;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof RectangularPitResponse
     */
    'vertices'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof RectangularPitResponse
     */
    'warningMsg'?: string;
    /**
     * 
     * @type {number}
     * @memberof RectangularPitResponse
     */
    'width'?: number;
    /**
     * 
     * @type {string}
     * @memberof RectangularPitResponse
     */
    'wkid'?: string;
}
/**
 * 
 * @export
 * @interface RectangularRequestDto
 */
export interface RectangularRequestDto {
    /**
     * 
     * @type {number}
     * @memberof RectangularRequestDto
     */
    'a'?: number;
    /**
     * 
     * @type {number}
     * @memberof RectangularRequestDto
     */
    'b'?: number;
    /**
     * 
     * @type {number}
     * @memberof RectangularRequestDto
     */
    'diagonal'?: number;
}
/**
 * 
 * @export
 * @interface RectangularResponseDto
 */
export interface RectangularResponseDto {
    /**
     * 
     * @type {number}
     * @memberof RectangularResponseDto
     */
    'area'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof RectangularResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof RectangularResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface ResetWaterwayProfileResponse
 */
export interface ResetWaterwayProfileResponse {
    /**
     * 
     * @type {number}
     * @memberof ResetWaterwayProfileResponse
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResetWaterwayProfileResponse
     */
    'reachesChange'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResetWaterwayProfileResponse
     */
    'removedReachIds'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ResetWaterwayProfileResponse
     */
    'removedStructureProfilesMap'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'description'?: string;
    /**
     * 
     * @type {any}
     * @memberof Resource
     */
    'file'?: any;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'filename'?: string;
    /**
     * 
     * @type {object}
     * @memberof Resource
     */
    'inputStream'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    'readable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    'uri'?: string;
    /**
     * 
     * @type {URL}
     * @memberof Resource
     */
    'url'?: URL;
}
/**
 * 
 * @export
 * @interface RiserDto
 */
export interface RiserDto {
    /**
     * 
     * @type {number}
     * @memberof RiserDto
     */
    'riserLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof RiserDto
     */
    'riserWidth'?: number;
}
/**
 * 
 * @export
 * @interface RoundPitRequest
 */
export interface RoundPitRequest {
    /**
     * 
     * @type {InputPoint}
     * @memberof RoundPitRequest
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof RoundPitRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RoundPitRequest
     */
    'includeDesignSurface'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoundPitRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RoundPitRequest
     */
    'radius'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoundPitRequest
     */
    'slope'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoundPitRequest
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface RoundPitResponse
 */
export interface RoundPitResponse {
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof RoundPitResponse
     */
    'borders'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof RoundPitResponse
     */
    'breaklines'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {InputPoint}
     * @memberof RoundPitResponse
     */
    'center'?: InputPoint;
    /**
     * 
     * @type {number}
     * @memberof RoundPitResponse
     */
    'cutVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoundPitResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof RoundPitResponse
     */
    'designedContours'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof RoundPitResponse
     */
    'designedTinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {string}
     * @memberof RoundPitResponse
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RoundPitResponse
     */
    'radius'?: number;
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof RoundPitResponse
     */
    'rays'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {number}
     * @memberof RoundPitResponse
     */
    'slope'?: number;
    /**
     * 
     * @type {Array<LineSegmentDto>}
     * @memberof RoundPitResponse
     */
    'slopeArrows'?: Array<LineSegmentDto>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof RoundPitResponse
     */
    'stakeoutPoints'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof RoundPitResponse
     */
    'storageDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoundPitResponse
     */
    'storageVolume'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoundPitResponse
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoundPitResponse
     */
    'url'?: string;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof RoundPitResponse
     */
    'vertices'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof RoundPitResponse
     */
    'warningMsg'?: string;
}
/**
 * 
 * @export
 * @interface RunoffSedimentStorageCalReqDTO
 */
export interface RunoffSedimentStorageCalReqDTO {
    /**
     * 
     * @type {TerraceHydroParamsDTO}
     * @memberof RunoffSedimentStorageCalReqDTO
     */
    'terraceHydroParams'?: TerraceHydroParamsDTO;
    /**
     * 
     * @type {string}
     * @memberof RunoffSedimentStorageCalReqDTO
     */
    'terraceName'?: string;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageCalReqDTO
     */
    'terraceTypeId'?: number;
}
/**
 * 
 * @export
 * @interface RunoffSedimentStorageDTO
 */
export interface RunoffSedimentStorageDTO {
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'designLife'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'equivalentRunoffDepthForRunoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'equivalentRunoffDepthForSediment'?: number;
    /**
     * 
     * @type {string}
     * @memberof RunoffSedimentStorageDTO
     */
    'erosionModel'?: string;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'erosionRate'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof RunoffSedimentStorageDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'floodDuration'?: number;
    /**
     * 
     * @type {string}
     * @memberof RunoffSedimentStorageDTO
     */
    'floodRoutingModel'?: string;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'percentageStored'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'requiredDischarge'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'runoffStorage'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'sedimentDensity'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'sedimentStorage'?: number;
    /**
     * 
     * @type {number}
     * @memberof RunoffSedimentStorageDTO
     */
    'trapEfficiency'?: number;
}
/**
 * 
 * @export
 * @interface SOSurveyCrossSlopeInputParm
 */
export interface SOSurveyCrossSlopeInputParm {
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'alignmentApplyCurves'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'alignmentAutoCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'alignmentAutoGrow'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'alignmentEntryMethod'?: SOSurveyCrossSlopeInputParmAlignmentEntryMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'alignmentIncreasing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {Array<AlignmentStationDTO>}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'alignmentStations'?: Array<AlignmentStationDTO>;
    /**
     * 
     * @type {number}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'beginningX'?: number;
    /**
     * 
     * @type {number}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'beginningY'?: number;
    /**
     * 
     * @type {Array<CrossSlopeStations>}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'crossSlopeStations'?: Array<CrossSlopeStations>;
    /**
     * 
     * @type {number}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'surveyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyCrossSlopeInputParm
     */
    'surveyName'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SOSurveyCrossSlopeInputParmAlignmentEntryMethodEnum {
    AngleDistance = 'AngleDistance',
    Coordinates = 'Coordinates'
}

/**
 * 
 * @export
 * @interface SOSurveyInputParm
 */
export interface SOSurveyInputParm {
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'alignmentApplyCurves'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'alignmentAutoCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'alignmentAutoGrow'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'alignmentEntryMethod'?: SOSurveyInputParmAlignmentEntryMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'alignmentIncreasing'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {Array<AlignmentStationDTO>}
     * @memberof SOSurveyInputParm
     */
    'alignmentStations'?: Array<AlignmentStationDTO>;
    /**
     * 
     * @type {number}
     * @memberof SOSurveyInputParm
     */
    'beginningX'?: number;
    /**
     * 
     * @type {number}
     * @memberof SOSurveyInputParm
     */
    'beginningY'?: number;
    /**
     * 
     * @type {Array<OffsetStationDTO>}
     * @memberof SOSurveyInputParm
     */
    'offsetStations'?: Array<OffsetStationDTO>;
    /**
     * 
     * @type {number}
     * @memberof SOSurveyInputParm
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'surveyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SOSurveyInputParm
     */
    'surveyName'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum SOSurveyInputParmAlignmentEntryMethodEnum {
    AngleDistance = 'AngleDistance',
    Coordinates = 'Coordinates'
}

/**
 * 
 * @export
 * @interface SavePipeNetworkSimulationRequestDto
 */
export interface SavePipeNetworkSimulationRequestDto {
    /**
     * 
     * @type {Array<PipeReachNetworkSimulationResult>}
     * @memberof SavePipeNetworkSimulationRequestDto
     */
    'pipeNetworkSimulationResult'?: Array<PipeReachNetworkSimulationResult>;
    /**
     * 
     * @type {string}
     * @memberof SavePipeNetworkSimulationRequestDto
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface SaveReachEditsRequestDTO
 */
export interface SaveReachEditsRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof SaveReachEditsRequestDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SaveReachEditsRequestDTO
     */
    'isCollectedTrainingSample'?: boolean;
    /**
     * 
     * @type {Array<ReachGroupDTO>}
     * @memberof SaveReachEditsRequestDTO
     */
    'reachGroupList'?: Array<ReachGroupDTO>;
}
/**
 * 
 * @export
 * @interface SaveSOSurveyCrossSlopeResponse
 */
export interface SaveSOSurveyCrossSlopeResponse {
    /**
     * 
     * @type {AlignmentDTO}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'alignment'?: AlignmentDTO;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'alignmentApplyCurves'?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'alignmentDesignElement'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {Array<AlignmentStationDTO>}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'alignmentStations'?: Array<AlignmentStationDTO>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'alignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'contourLines'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'curvedAlignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<OffsetStationLineResponse>}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'offsetStationLine'?: Array<OffsetStationLineResponse>;
    /**
     * 
     * @type {Array<StationOffsetResponse>}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'projectPoints'?: Array<StationOffsetResponse>;
    /**
     * 
     * @type {number}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {SurveyResponse}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'surveyId'?: SurveyResponse;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'surveyName'?: string;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof SaveSOSurveyCrossSlopeResponse
     */
    'tinTriangles'?: Array<TinTriangle>;
}
/**
 * 
 * @export
 * @interface SaveSOSurveySpreadsheetResponse
 */
export interface SaveSOSurveySpreadsheetResponse {
    /**
     * 
     * @type {AlignmentDTO}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'alignment'?: AlignmentDTO;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'alignmentApplyCurves'?: string;
    /**
     * 
     * @type {number}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'alignmentDesignElement'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {Array<AlignmentStationDTO>}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'alignmentStations'?: Array<AlignmentStationDTO>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'alignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'contourLines'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'curvedAlignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<OffsetStationLineResponse>}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'offsetStationLine'?: Array<OffsetStationLineResponse>;
    /**
     * 
     * @type {Array<StationOffsetResponse>}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'projectPoints'?: Array<StationOffsetResponse>;
    /**
     * 
     * @type {number}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {SurveyResponse}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'surveyId'?: SurveyResponse;
    /**
     * 
     * @type {string}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'surveyName'?: string;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof SaveSOSurveySpreadsheetResponse
     */
    'tinTriangles'?: Array<TinTriangle>;
}
/**
 * 
 * @export
 * @interface SaveTerraceReachEditsDTO
 */
export interface SaveTerraceReachEditsDTO {
    /**
     * 
     * @type {number}
     * @memberof SaveTerraceReachEditsDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {Array<TerraceReachGroupDTO>}
     * @memberof SaveTerraceReachEditsDTO
     */
    'terraceReachGroupList'?: Array<TerraceReachGroupDTO>;
}
/**
 * 
 * @export
 * @interface SaveTerraceReachEditsResponseDTO
 */
export interface SaveTerraceReachEditsResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SaveTerraceReachEditsResponseDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SaveTerraceReachEditsResponseDTO
     */
    'errorResponse'?: ErrorResponse;
}
/**
 * 
 * @export
 * @interface SaveUgoReachEditsRequestDTO
 */
export interface SaveUgoReachEditsRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof SaveUgoReachEditsRequestDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SaveUgoReachEditsRequestDTO
     */
    'isCollectedTrainingSample'?: boolean;
    /**
     * 
     * @type {Array<ReachGroupDTO>}
     * @memberof SaveUgoReachEditsRequestDTO
     */
    'reachGroupList'?: Array<ReachGroupDTO>;
}
/**
 * 
 * @export
 * @interface SaveUgoReachEditsResponseDTO
 */
export interface SaveUgoReachEditsResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SaveUgoReachEditsResponseDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SaveUgoReachEditsResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof SaveUgoReachEditsResponseDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface SelectedImageResponse
 */
export interface SelectedImageResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SelectedImageResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof SelectedImageResponse
     */
    'imageTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SelectedImageResponse
     */
    'stationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SelectedImageResponse
     */
    'structureProfileId'?: number;
}
/**
 * 
 * @export
 * @interface ShapeControlDTO
 */
export interface ShapeControlDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ShapeControlDTO
     */
    'backCutEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShapeControlDTO
     */
    'backCutSlopeGrade'?: number;
    /**
     * 
     * @type {TerraceSlopeAndLimits}
     * @memberof ShapeControlDTO
     */
    'bankEndSlope'?: TerraceSlopeAndLimits;
    /**
     * 
     * @type {TerraceSlopeAndLimits}
     * @memberof ShapeControlDTO
     */
    'bankStartSlope'?: TerraceSlopeAndLimits;
    /**
     * 
     * @type {number}
     * @memberof ShapeControlDTO
     */
    'freeboard'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShapeControlDTO
     */
    'freeboardMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShapeControlDTO
     */
    'minSlopeWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShapeControlDTO
     */
    'overFillAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShapeControlDTO
     */
    'overFillMode'?: string;
}
/**
 * 
 * @export
 * @interface ShiftWaterwayElevationResponse
 */
export interface ShiftWaterwayElevationResponse {
    /**
     * 
     * @type {number}
     * @memberof ShiftWaterwayElevationResponse
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShiftWaterwayElevationResponse
     */
    'deltaElevation'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShiftWaterwayElevationResponse
     */
    'reachElevationMap'?: { [key: string]: number; };
    /**
     * 
     * @type {WaterwaySummaryResultDTO}
     * @memberof ShiftWaterwayElevationResponse
     */
    'waterwaySummaryResultDTO'?: WaterwaySummaryResultDTO;
}
/**
 * 
 * @export
 * @interface Soil
 */
export interface Soil {
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'areaName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'areaSymbol'?: string;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'componentAcres'?: string;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'componentNameandPhase'?: string;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'componentPercentage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'coverageYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'hydrologicSoilGroup'?: string;
    /**
     * 
     * @type {number}
     * @memberof Soil
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'mapUnitName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'mapUnitSymol'?: string;
    /**
     * 
     * @type {number}
     * @memberof Soil
     */
    'mukey'?: number;
    /**
     * 
     * @type {string}
     * @memberof Soil
     */
    'state'?: string;
}
/**
 * 
 * @export
 * @interface SoilParametersDTO
 */
export interface SoilParametersDTO {
    /**
     * 
     * @type {number}
     * @memberof SoilParametersDTO
     */
    'allowableStress'?: number;
    /**
     * 
     * @type {number}
     * @memberof SoilParametersDTO
     */
    'd75'?: number;
    /**
     * 
     * @type {string}
     * @memberof SoilParametersDTO
     */
    'inputModeStr'?: string;
    /**
     * 
     * @type {number}
     * @memberof SoilParametersDTO
     */
    'plasticityIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof SoilParametersDTO
     */
    'soilGrainRoughness'?: number;
    /**
     * 
     * @type {string}
     * @memberof SoilParametersDTO
     */
    'soilTypeStr'?: string;
    /**
     * 
     * @type {string}
     * @memberof SoilParametersDTO
     */
    'stressFactorStr'?: string;
    /**
     * 
     * @type {number}
     * @memberof SoilParametersDTO
     */
    'voidRatio'?: number;
}
/**
 * 
 * @export
 * @interface SoilRoughnessCalRequestDTO
 */
export interface SoilRoughnessCalRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof SoilRoughnessCalRequestDTO
     */
    'd75'?: number;
    /**
     * 
     * @type {string}
     * @memberof SoilRoughnessCalRequestDTO
     */
    'soilType'?: string;
}
/**
 * 
 * @export
 * @interface SoilRoughnessCalResponseDTO
 */
export interface SoilRoughnessCalResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SoilRoughnessCalResponseDTO
     */
    'd75'?: number;
    /**
     * 
     * @type {number}
     * @memberof SoilRoughnessCalResponseDTO
     */
    'soilGrainRoughness'?: number;
    /**
     * 
     * @type {string}
     * @memberof SoilRoughnessCalResponseDTO
     */
    'soilType'?: string;
}
/**
 * 
 * @export
 * @interface SoilStressCalRequestDTO
 */
export interface SoilStressCalRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof SoilStressCalRequestDTO
     */
    'd75'?: number;
    /**
     * 
     * @type {number}
     * @memberof SoilStressCalRequestDTO
     */
    'plasticity'?: number;
    /**
     * 
     * @type {string}
     * @memberof SoilStressCalRequestDTO
     */
    'soilType'?: string;
    /**
     * 
     * @type {number}
     * @memberof SoilStressCalRequestDTO
     */
    'voidRatio'?: number;
}
/**
 * 
 * @export
 * @interface SoilStressCalResponseDTO
 */
export interface SoilStressCalResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SoilStressCalResponseDTO
     */
    'allowableStress'?: number;
    /**
     * 
     * @type {number}
     * @memberof SoilStressCalResponseDTO
     */
    'd75'?: number;
    /**
     * 
     * @type {number}
     * @memberof SoilStressCalResponseDTO
     */
    'plasticity'?: number;
    /**
     * 
     * @type {string}
     * @memberof SoilStressCalResponseDTO
     */
    'soilType'?: string;
    /**
     * 
     * @type {number}
     * @memberof SoilStressCalResponseDTO
     */
    'voidRatio'?: number;
}
/**
 * 
 * @export
 * @interface SoilTypeResponse
 */
export interface SoilTypeResponse {
    /**
     * 
     * @type {Array<Soil>}
     * @memberof SoilTypeResponse
     */
    'soilType'?: Array<Soil>;
    /**
     * 
     * @type {string}
     * @memberof SoilTypeResponse
     */
    'warning'?: string;
}
/**
 * 
 * @export
 * @interface SolidConeRequestDto
 */
export interface SolidConeRequestDto {
    /**
     * 
     * @type {number}
     * @memberof SolidConeRequestDto
     */
    'diameter1'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolidConeRequestDto
     */
    'diameter2'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolidConeRequestDto
     */
    'h'?: number;
}
/**
 * 
 * @export
 * @interface SolidConeResponseDto
 */
export interface SolidConeResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SolidConeResponseDto
     */
    'area1'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolidConeResponseDto
     */
    'area2'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SolidConeResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof SolidConeResponseDto
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SolidConeResponseDto
     */
    'volume'?: number;
}
/**
 * 
 * @export
 * @interface SolidPrismatoidRequestDto
 */
export interface SolidPrismatoidRequestDto {
    /**
     * 
     * @type {number}
     * @memberof SolidPrismatoidRequestDto
     */
    'area1'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolidPrismatoidRequestDto
     */
    'area2'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolidPrismatoidRequestDto
     */
    'areaMid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SolidPrismatoidRequestDto
     */
    'height'?: number;
}
/**
 * 
 * @export
 * @interface SolidPrismatoidResponseDto
 */
export interface SolidPrismatoidResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SolidPrismatoidResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {boolean}
     * @memberof SolidPrismatoidResponseDto
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SolidPrismatoidResponseDto
     */
    'volume'?: number;
}
/**
 * 
 * @export
 * @interface SplitFlowSegmentDto
 */
export interface SplitFlowSegmentDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SplitFlowSegmentDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof SplitFlowSegmentDto
     */
    'flowPath'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof SplitFlowSegmentDto
     */
    'flowTypeName'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SplitFlowSegmentDto
     */
    'segmentLength'?: Array<number>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof SplitFlowSegmentDto
     */
    'separators'?: Array<InputPoint>;
    /**
     * 
     * @type {string}
     * @memberof SplitFlowSegmentDto
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SplitFlowSegmentDto
     */
    'slopes'?: Array<number>;
}
/**
 * 
 * @export
 * @interface SplitTerraceRequest
 */
export interface SplitTerraceRequest {
    /**
     * 
     * @type {string}
     * @memberof SplitTerraceRequest
     */
    'reachIdAsSplittingLocation'?: string;
    /**
     * 
     * @type {number}
     * @memberof SplitTerraceRequest
     */
    'terraceAlignedElementId'?: number;
}
/**
 * 
 * @export
 * @interface SplitTerraceResponse
 */
export interface SplitTerraceResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SplitTerraceResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof SplitTerraceResponse
     */
    'leadingTerraceAlignedElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SplitTerraceResponse
     */
    'leadingTerraceHydroParamsId'?: number;
    /**
     * 
     * @type {Array<ReachJson>}
     * @memberof SplitTerraceResponse
     */
    'leadingTerraceReachJsons'?: Array<ReachJson>;
    /**
     * 
     * @type {number}
     * @memberof SplitTerraceResponse
     */
    'leadingTerraceSessionUiSateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SplitTerraceResponse
     */
    'trailingTerraceAlignedElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SplitTerraceResponse
     */
    'trailingTerraceHydroParamsId'?: number;
    /**
     * 
     * @type {Array<ReachJson>}
     * @memberof SplitTerraceResponse
     */
    'trailingTerraceReachJsons'?: Array<ReachJson>;
    /**
     * 
     * @type {number}
     * @memberof SplitTerraceResponse
     */
    'trailingTerraceSessionUiSateId'?: number;
}
/**
 * 
 * @export
 * @interface StageDischargeDto
 */
export interface StageDischargeDto {
    /**
     * 
     * @type {number}
     * @memberof StageDischargeDto
     */
    'discharge'?: number;
    /**
     * 
     * @type {number}
     * @memberof StageDischargeDto
     */
    'stage'?: number;
}
/**
 * 
 * @export
 * @interface StationDTO
 */
export interface StationDTO {
    /**
     * 
     * @type {number}
     * @memberof StationDTO
     */
    'distance'?: number;
    /**
     * 
     * @type {InputPoint}
     * @memberof StationDTO
     */
    'inputPoint'?: InputPoint;
}
/**
 * 
 * @export
 * @interface StationOffsetResponse
 */
export interface StationOffsetResponse {
    /**
     * 
     * @type {string}
     * @memberof StationOffsetResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof StationOffsetResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StationOffsetResponse
     */
    'pointName'?: string;
    /**
     * 
     * @type {number}
     * @memberof StationOffsetResponse
     */
    'tinable'?: number;
    /**
     * 
     * @type {number}
     * @memberof StationOffsetResponse
     */
    'visible'?: number;
    /**
     * 
     * @type {number}
     * @memberof StationOffsetResponse
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof StationOffsetResponse
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof StationOffsetResponse
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface StationOffsetSpreadsheetDTO
 */
export interface StationOffsetSpreadsheetDTO {
    /**
     * 
     * @type {AlignmentDTO}
     * @memberof StationOffsetSpreadsheetDTO
     */
    'alignment'?: AlignmentDTO;
    /**
     * 
     * @type {Array<OffsetStationDTO>}
     * @memberof StationOffsetSpreadsheetDTO
     */
    'offsetStations'?: Array<OffsetStationDTO>;
}
/**
 * 
 * @export
 * @interface StationOffsetSurveyResponse
 */
export interface StationOffsetSurveyResponse {
    /**
     * 
     * @type {string}
     * @memberof StationOffsetSurveyResponse
     */
    'alignmentApplyCurves'?: string;
    /**
     * 
     * @type {string}
     * @memberof StationOffsetSurveyResponse
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {Array<AlignmentStationDTO>}
     * @memberof StationOffsetSurveyResponse
     */
    'alignmentStations'?: Array<AlignmentStationDTO>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof StationOffsetSurveyResponse
     */
    'alignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof StationOffsetSurveyResponse
     */
    'contourLines'?: Array<ContourLineData>;
    /**
     * 
     * @type {Array<AlignmentResponse>}
     * @memberof StationOffsetSurveyResponse
     */
    'curvedAlignmentXY'?: Array<AlignmentResponse>;
    /**
     * 
     * @type {Array<OffsetStationLineResponse>}
     * @memberof StationOffsetSurveyResponse
     */
    'offsetStationLine'?: Array<OffsetStationLineResponse>;
    /**
     * 
     * @type {Array<StationOffsetResponse>}
     * @memberof StationOffsetSurveyResponse
     */
    'projectPoints'?: Array<StationOffsetResponse>;
    /**
     * 
     * @type {number}
     * @memberof StationOffsetSurveyResponse
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StationOffsetSurveyResponse
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof StationOffsetSurveyResponse
     */
    'tinTriangles'?: Array<TinTriangle>;
}
/**
 * 
 * @export
 * @interface StorageCaculationResponseDto
 */
export interface StorageCaculationResponseDto {
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'computedStorage'?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof StorageCaculationResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'floodArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'requiredStorage'?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'strippingVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'totalFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof StorageCaculationResponseDto
     */
    'waterElevation'?: number;
}
/**
 * 
 * @export
 * @interface StraightDropInletRequestDto
 */
export interface StraightDropInletRequestDto {
    /**
     * 
     * @type {number}
     * @memberof StraightDropInletRequestDto
     */
    'headAboveWeir'?: number;
    /**
     * 
     * @type {number}
     * @memberof StraightDropInletRequestDto
     */
    'sillElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof StraightDropInletRequestDto
     */
    'weirElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof StraightDropInletRequestDto
     */
    'weirLength'?: number;
}
/**
 * 
 * @export
 * @interface StraightDropResponseDto
 */
export interface StraightDropResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof StraightDropResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof StraightDropResponseDto
     */
    'flowQ'?: number;
    /**
     * 
     * @type {Array<StageDischargeDto>}
     * @memberof StraightDropResponseDto
     */
    'stageDischargeList'?: Array<StageDischargeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof StraightDropResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface StructureCrossSectionAdhocRequest
 */
export interface StructureCrossSectionAdhocRequest {
    /**
     * 
     * @type {number}
     * @memberof StructureCrossSectionAdhocRequest
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof StructureCrossSectionAdhocRequest
     */
    'crossSectionLine'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof StructureCrossSectionAdhocRequest
     */
    'crossSectionTotalWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureCrossSectionAdhocRequest
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureCrossSectionAdhocRequest
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface StructureCrossSectionRequest
 */
export interface StructureCrossSectionRequest {
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof StructureCrossSectionRequest
     */
    'crossSectionLine'?: Array<InputPoint>;
    /**
     * 
     * @type {number}
     * @memberof StructureCrossSectionRequest
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureCrossSectionRequest
     */
    'json'?: string;
    /**
     * 
     * @type {number}
     * @memberof StructureCrossSectionRequest
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureCrossSectionRequest
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof StructureCrossSectionRequest
     */
    'structureElementId'?: number;
}
/**
 * 
 * @export
 * @interface StructureCrossSectionResponse
 */
export interface StructureCrossSectionResponse {
    /**
     * 
     * @type {ProfileDTO}
     * @memberof StructureCrossSectionResponse
     */
    'designProfile'?: ProfileDTO;
    /**
     * 
     * @type {string}
     * @memberof StructureCrossSectionResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StructureCrossSectionResponse
     */
    'errorValues'?: Array<string>;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof StructureCrossSectionResponse
     */
    'originalProfile'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface StructureDesignElementUpdateRequest
 */
export interface StructureDesignElementUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof StructureDesignElementUpdateRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureDesignElementUpdateRequest
     */
    'designElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureDesignElementUpdateRequest
     */
    'designElementName'?: string;
    /**
     * 
     * @type {number}
     * @memberof StructureDesignElementUpdateRequest
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureDesignElementUpdateRequest
     */
    'json'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureDesignElementUpdateRequest
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureDesignElementUpdateRequest
     */
    'sessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureDesignElementUpdateRequest
     */
    'surveyprjId'?: string;
}
/**
 * 
 * @export
 * @interface StructureProfileRequest
 */
export interface StructureProfileRequest {
    /**
     * 
     * @type {number}
     * @memberof StructureProfileRequest
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileRequest
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileRequest
     */
    'imageTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileRequest
     */
    'profileImageBase64String'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileRequest
     */
    'profileOrCrossSection'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileRequest
     */
    'stationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileRequest
     */
    'structureMapImageBase64String'?: string;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileRequest
     */
    'structureProfilesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileRequest
     */
    'twoDimensionalGeometryJson'?: string;
}
/**
 * 
 * @export
 * @interface StructureProfileResponse
 */
export interface StructureProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'creationDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileResponse
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileResponse
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileResponse
     */
    'imageTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'lastChangeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'profileOrCrossSection'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'stationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileResponse
     */
    'structureProfilesId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StructureProfileResponse
     */
    'twoDimensionalGeometryJson'?: string;
}
/**
 * 
 * @export
 * @interface StructureProfileSummaryDTO
 */
export interface StructureProfileSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof StructureProfileSummaryDTO
     */
    'designElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileSummaryDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileSummaryDTO
     */
    'imageTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof StructureProfileSummaryDTO
     */
    'structureProfilesId'?: number;
}
/**
 * 
 * @export
 * @interface SubBasinRequest
 */
export interface SubBasinRequest {
    /**
     * 
     * @type {number}
     * @memberof SubBasinRequest
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubBasinRequest
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubBasinRequest
     */
    'peakFlow'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubBasinRequest
     */
    'runoffQ'?: number;
}
/**
 * 
 * @export
 * @interface SubBasinResponse
 */
export interface SubBasinResponse {
    /**
     * 
     * @type {number}
     * @memberof SubBasinResponse
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {BasinCharacteristicsDTO}
     * @memberof SubBasinResponse
     */
    'basinCharacteristicsDTO'?: BasinCharacteristicsDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SubBasinResponse
     */
    'errorResponse'?: ErrorResponse;
}
/**
 * 
 * @export
 * @interface SubsurfaceDrainRequestDTO
 */
export interface SubsurfaceDrainRequestDTO {
    /**
     * 
     * @type {Array<number>}
     * @memberof SubsurfaceDrainRequestDTO
     */
    'areaList'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof SubsurfaceDrainRequestDTO
     */
    'drainageCoefficient'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubsurfaceDrainRequestDTO
     */
    'manningsN'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SubsurfaceDrainRequestDTO
     */
    'slopeList'?: Array<number>;
}
/**
 * 
 * @export
 * @interface SubsurfaceDrainResponseDTO
 */
export interface SubsurfaceDrainResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SubsurfaceDrainResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<PipelineModel>}
     * @memberof SubsurfaceDrainResponseDTO
     */
    'pipelines'?: Array<PipelineModel>;
    /**
     * 
     * @type {boolean}
     * @memberof SubsurfaceDrainResponseDTO
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface SurfaceDTO
 */
export interface SurfaceDTO {
    /**
     * 
     * @type {BorderDTO}
     * @memberof SurfaceDTO
     */
    'border'?: BorderDTO;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceDTO
     */
    'borderRebuild'?: boolean;
    /**
     * 
     * @type {BreaklineRequestDTO}
     * @memberof SurfaceDTO
     */
    'breaklineData'?: BreaklineRequestDTO;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDTO
     */
    'contourInterval'?: number;
    /**
     * 
     * @type {DrawingDesign}
     * @memberof SurfaceDTO
     */
    'drawingDesign'?: DrawingDesign;
    /**
     * 
     * @type {Array<SurveyInputPoint>}
     * @memberof SurfaceDTO
     */
    'points'?: Array<SurveyInputPoint>;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDTO
     */
    'surfaceDefId'?: number;
}
/**
 * 
 * @export
 * @interface SurfaceDefDTO
 */
export interface SurfaceDefDTO {
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefDTO
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefDTO
     */
    'sessionResourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefDTO
     */
    'surfaceDefClassId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefDTO
     */
    'surfaceDefClassName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefDTO
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefDTO
     */
    'surfaceDefTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefDTO
     */
    'surfaceDefTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefDTO
     */
    'surfaceDefTypeName'?: string;
}
/**
 * 
 * @export
 * @interface SurfaceDefRequest
 */
export interface SurfaceDefRequest {
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefRequest
     */
    'borderJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefRequest
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'deleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefRequest
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'sessionResourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefRequest
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefRequest
     */
    'shape'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'srid'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'surfaceDefClassId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefRequest
     */
    'surfaceDefTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'surfaceDefTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefRequest
     */
    'surfaceJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'xMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'xMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'yMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'yMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefRequest
     */
    'zUnits'?: number;
}
/**
 * 
 * @export
 * @interface SurfaceDefResponse
 */
export interface SurfaceDefResponse {
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefResponse
     */
    'createdDate'?: string;
    /**
     * 
     * @type {Array<DEMSurfaceResponse>}
     * @memberof SurfaceDefResponse
     */
    'demSurfaceMetadata'?: Array<DEMSurfaceResponse>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefResponse
     */
    'surfaceDefClassId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefResponse
     */
    'surfaceDefClassName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefResponse
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefResponse
     */
    'surfaceDefTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceDefResponse
     */
    'surfaceDefTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefResponse
     */
    'surfaceDefTypeName'?: string;
    /**
     * 
     * @type {Array<SurveyMetadata>}
     * @memberof SurfaceDefResponse
     */
    'surveyMetadata'?: Array<SurveyMetadata>;
}
/**
 * 
 * @export
 * @interface SurfaceDefSurfaceNameDTO
 */
export interface SurfaceDefSurfaceNameDTO {
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefSurfaceNameDTO
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefSurfaceNameDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceDefSurfaceNameDTO
     */
    'surfaceName'?: string;
}
/**
 * 
 * @export
 * @interface SurfaceInletRequestDTO
 */
export interface SurfaceInletRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletRequestDTO
     */
    'drainageCoeff'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'elbowElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'holePerFt'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletRequestDTO
     */
    'inletTopGuard'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'mainLineDia'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'mainLineElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'offsetLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletRequestDTO
     */
    'offsetMaterial'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'offsetPerforated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'offsetPipe'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'offsetPipeManningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'offsetPipeSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'offsetPressurizable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'orifice'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'orificeDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'orificeDiam'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'perfDiam'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'perfFraction'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'perfH'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'perfwidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'plugedFraction'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'rectangularPerf'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'riserHeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletRequestDTO
     */
    'riserMaterial'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'riserPerforated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'riserPipeManningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'riserPipeSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'riserPressurizable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceInletRequestDTO
     */
    'roundPerf'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'soilElevAtRiser'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'topOpening'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceInletRequestDTO
     */
    'waterElev'?: number;
}
/**
 * 
 * @export
 * @interface SurfaceInletResponseDTO
 */
export interface SurfaceInletResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'actualQ'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'averageFlowQ'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SurfaceInletResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'offsetQ'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'orificeQ'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'outputInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'perfQ'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'requiredQ'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceInletResponseDTO
     */
    'topQ'?: string;
}
/**
 * 
 * @export
 * @interface Survey2CSVRequest
 */
export interface Survey2CSVRequest {
    /**
     * 
     * @type {string}
     * @memberof Survey2CSVRequest
     */
    'surveyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Survey2CSVRequest
     */
    'surveyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Survey2CSVRequest
     */
    'surveyType'?: number;
}
/**
 * 
 * @export
 * @interface SurveyDataWithinDefinedUTMandCountyRequest
 */
export interface SurveyDataWithinDefinedUTMandCountyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyRequest
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyRequest
     */
    'definedUTM'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyRequest
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyRequest
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyDataWithinDefinedUTMandCountyRequest
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyDataWithinDefinedUTMandCountyRequest
     */
    'y'?: number;
}
/**
 * 
 * @export
 * @interface SurveyDataWithinDefinedUTMandCountyResponse
 */
export interface SurveyDataWithinDefinedUTMandCountyResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyResponse
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyResponse
     */
    'definedUTM'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SurveyDataWithinDefinedUTMandCountyResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyResponse
     */
    'projectUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyResponse
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDataWithinDefinedUTMandCountyResponse
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyDataWithinDefinedUTMandCountyResponse
     */
    'withinDefinedUTMAndCounty'?: boolean;
}
/**
 * 
 * @export
 * @interface SurveyEngineeringProjectDTO
 */
export interface SurveyEngineeringProjectDTO {
    /**
     * 
     * @type {number}
     * @memberof SurveyEngineeringProjectDTO
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyEngineeringProjectDTO
     */
    'editingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyEngineeringProjectDTO
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyEngineeringProjectDTO
     */
    'offsetDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyEngineeringProjectDTO
     */
    'offsetId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyEngineeringProjectDTO
     */
    'offsetStationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyEngineeringProjectDTO
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyEngineeringProjectDTO
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyEngineeringProjectDTO
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface SurveyExportRequest
 */
export interface SurveyExportRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyExportRequest
     */
    'surveyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyExportRequest
     */
    'surveyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyExportRequest
     */
    'surveyType'?: number;
}
/**
 * 
 * @export
 * @interface SurveyInputPoint
 */
export interface SurveyInputPoint {
    /**
     * 
     * @type {string}
     * @memberof SurveyInputPoint
     */
    'editing_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInputPoint
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInputPoint
     */
    'featureDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInputPoint
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInputPoint
     */
    'keyString'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInputPoint
     */
    'objectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInputPoint
     */
    'pointName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyInputPoint
     */
    'tinable'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyInputPoint
     */
    'visible'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyInputPoint
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyInputPoint
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyInputPoint
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface SurveyMetadata
 */
export interface SurveyMetadata {
    /**
     * 
     * @type {number}
     * @memberof SurveyMetadata
     */
    'pointsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyMetadata
     */
    'surveyCoordinateSystem'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyMetadata
     */
    'surveyDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyMetadata
     */
    'surveyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyMetadata
     */
    'surveyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyMetadata
     */
    'surveyType'?: number;
}
/**
 * 
 * @export
 * @interface SurveyMetadataResponse
 */
export interface SurveyMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveyMetadataResponse
     */
    'deleteStatus'?: string;
}
/**
 * 
 * @export
 * @interface SurveyPoints
 */
export interface SurveyPoints {
    /**
     * 
     * @type {string}
     * @memberof SurveyPoints
     */
    'sessionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyPoints
     */
    'surfaceDefId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyPoints
     */
    'surveyCoordinateSystem'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyPoints
     */
    'surveyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyPoints
     */
    'surveyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyPoints
     */
    'surveyTypeId'?: number;
    /**
     * 
     * @type {Array<SurveyInputPoint>}
     * @memberof SurveyPoints
     */
    'xyzArray'?: Array<SurveyInputPoint>;
}
/**
 * 
 * @export
 * @interface SurveyResponse
 */
export interface SurveyResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveyResponse
     */
    'breaklineFeatureId'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof SurveyResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<SurveyInputPoint>}
     * @memberof SurveyResponse
     */
    'outsidePoints'?: Array<SurveyInputPoint>;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponse
     */
    'surveyId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponse
     */
    'utmGeometryId'?: number;
}
/**
 * 
 * @export
 * @interface SurveyTypeDTO
 */
export interface SurveyTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveyTypeDTO
     */
    'surveyTypeDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyTypeDTO
     */
    'surveyTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyTypeDTO
     */
    'surveyTypeName'?: string;
}
/**
 * 
 * @export
 * @interface TerracConstructionReportReqDTO
 */
export interface TerracConstructionReportReqDTO {
    /**
     * 
     * @type {number}
     * @memberof TerracConstructionReportReqDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerracConstructionReportReqDTO
     */
    'backsight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerracConstructionReportReqDTO
     */
    'foresight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerracConstructionReportReqDTO
     */
    'heightOfInstrument'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerracConstructionReportReqDTO
     */
    'other'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerracConstructionReportReqDTO
     */
    'sessionuuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TerracConstructionReportReqDTO
     */
    'stationIdListForThreeXsection'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TerraceAlignElementResponseDto
 */
export interface TerraceAlignElementResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TerraceAlignElementResponseDto
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceAlignElementResponseDto
     */
    'errorResponse'?: ErrorResponse;
}
/**
 * 
 * @export
 * @interface TerraceBasicInfoDTO
 */
export interface TerraceBasicInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceBasicInfoDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceBasicInfoDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceBasicInfoDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceBasicInfoDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof TerraceBasicInfoDTO
     */
    'terraceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceBasicInfoDTO
     */
    'terraceType'?: string;
}
/**
 * 
 * @export
 * @interface TerraceChannelTemplateDTO
 */
export interface TerraceChannelTemplateDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'backSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'backSlopeMode'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'cutSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'cutSlopeMode'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'frontHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'frontSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'frontSlopeMode'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateDTO
     */
    'slopeLimitsJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateDTO
     */
    'templateGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateDTO
     */
    'templateName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'terraceChannelTemplateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateDTO
     */
    'topWidth'?: number;
}
/**
 * 
 * @export
 * @interface TerraceChannelTemplateResponseDto
 */
export interface TerraceChannelTemplateResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'backSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'backSlopeMode'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'cutSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'cutSlopeMode'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'frontHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'frontSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'frontSlopeMode'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'slopeLimitsJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'templateGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'templateName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'terraceChannelTemplateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceChannelTemplateResponseDto
     */
    'topWidth'?: number;
}
/**
 * 
 * @export
 * @interface TerraceConstructionReportRespDTO
 */
export interface TerraceConstructionReportRespDTO {
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'additionalInformation'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'backsight'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'benchmarkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'benchmarkElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'clearing'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'constructBenchmark'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'designWaterElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'designedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'flatLineLoc'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'foresight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'heightOfInstrument'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'image811'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'locationMapImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'onCallNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'other'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'projectCounty'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'projectDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'projectState'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TerraceConstructionReportRespDTO
     */
    'stationIdXsectionMap'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'strippingDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'strippingVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'terraceLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'terraceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'terracePlanViewImage'?: string;
    /**
     * 
     * @type {Array<TerraceProfileDTO>}
     * @memberof TerraceConstructionReportRespDTO
     */
    'terraceProfileList'?: Array<TerraceProfileDTO>;
    /**
     * 
     * @type {Array<TerraceSummaryInfoDTO>}
     * @memberof TerraceConstructionReportRespDTO
     */
    'terraceSummaryInfoList'?: Array<TerraceSummaryInfoDTO>;
    /**
     * 
     * @type {string}
     * @memberof TerraceConstructionReportRespDTO
     */
    'terraceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceConstructionReportRespDTO
     */
    'totalFill'?: number;
}
/**
 * 
 * @export
 * @interface TerraceCrossSectionProfileDTO
 */
export interface TerraceCrossSectionProfileDTO {
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceCrossSectionProfileDTO
     */
    'crossSectionProfile'?: ProfileDTO;
    /**
     * 
     * @type {StationDTO}
     * @memberof TerraceCrossSectionProfileDTO
     */
    'drainStation'?: StationDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceCrossSectionProfileDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof TerraceCrossSectionProfileDTO
     */
    'terraceAlignedElementId'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceCrossSectionProfileDTO
     */
    'waterLevelProfile'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface TerraceCrossSectionResponse
 */
export interface TerraceCrossSectionResponse {
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceCrossSectionResponse
     */
    'crossSectionProfile'?: ProfileDTO;
    /**
     * 
     * @type {StationDTO}
     * @memberof TerraceCrossSectionResponse
     */
    'drainStation'?: StationDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceCrossSectionResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceCrossSectionResponse
     */
    'groundProfile'?: ProfileDTO;
    /**
     * 
     * @type {number}
     * @memberof TerraceCrossSectionResponse
     */
    'station'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceCrossSectionResponse
     */
    'terraceAlignedElementId'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceCrossSectionResponse
     */
    'waterLevelProfile'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface TerraceDefaultReachRequest
 */
export interface TerraceDefaultReachRequest {
    /**
     * 
     * @type {number}
     * @memberof TerraceDefaultReachRequest
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TerraceDefaultReachRequest
     */
    'stationVertices'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface TerraceDefaultReachResponseDTO
 */
export interface TerraceDefaultReachResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'channel'?: ProfileDTO;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'constructedTerrace'?: ProfileDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'reachProfile'?: ProfileDTO;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'settledTerrace'?: ProfileDTO;
    /**
     * 
     * @type {Array<TerraceVertexParamsDTO>}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'terraceVertexDTOList'?: Array<TerraceVertexParamsDTO>;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDefaultReachResponseDTO
     */
    'waterLevel'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface TerraceDesignControlDTO
 */
export interface TerraceDesignControlDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignControlDTO
     */
    'isUserDefinedTemplate'?: number;
    /**
     * 
     * @type {OrientationDTO}
     * @memberof TerraceDesignControlDTO
     */
    'orientationDTO'?: OrientationDTO;
    /**
     * 
     * @type {ShapeControlDTO}
     * @memberof TerraceDesignControlDTO
     */
    'shapeControlDTO'?: ShapeControlDTO;
    /**
     * 
     * @type {Array<TerraceSlopeAndLimits>}
     * @memberof TerraceDesignControlDTO
     */
    'slopeLimits'?: Array<TerraceSlopeAndLimits>;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignControlDTO
     */
    'terraceChannelTemplateJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignControlDTO
     */
    'terraceTemplateId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignControlDTO
     */
    'terraceTypeId'?: number;
}
/**
 * 
 * @export
 * @interface TerraceDesignControlResponseDTO
 */
export interface TerraceDesignControlResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceDesignControlResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {TerraceDesignControlDTO}
     * @memberof TerraceDesignControlResponseDTO
     */
    'terraceDesignControlDTO'?: TerraceDesignControlDTO;
}
/**
 * 
 * @export
 * @interface TerraceDesignReportDTO
 */
export interface TerraceDesignReportDTO {
    /**
     * 
     * @type {TerraceDesignReportStatisticsDTO}
     * @memberof TerraceDesignReportDTO
     */
    'designStatistics'?: TerraceDesignReportStatisticsDTO;
    /**
     * 
     * @type {TerraceDesignReportSummaryDTO}
     * @memberof TerraceDesignReportDTO
     */
    'designSummary'?: TerraceDesignReportSummaryDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceDesignReportDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {TerraceDesignReportHydrologySectionDTO}
     * @memberof TerraceDesignReportDTO
     */
    'hydrologySection'?: TerraceDesignReportHydrologySectionDTO;
    /**
     * 
     * @type {TerraceDesignReportInputsDTO}
     * @memberof TerraceDesignReportDTO
     */
    'inputs'?: TerraceDesignReportInputsDTO;
    /**
     * 
     * @type {ProjectInfoDTO}
     * @memberof TerraceDesignReportDTO
     */
    'projectInfo'?: ProjectInfoDTO;
    /**
     * 
     * @type {Array<TerraceDesignReportStationTableDTO>}
     * @memberof TerraceDesignReportDTO
     */
    'stationsTable'?: Array<TerraceDesignReportStationTableDTO>;
    /**
     * 
     * @type {TerraceDesignReportTemplateDTO}
     * @memberof TerraceDesignReportDTO
     */
    'template'?: TerraceDesignReportTemplateDTO;
}
/**
 * 
 * @export
 * @interface TerraceDesignReportHydrologySectionDTO
 */
export interface TerraceDesignReportHydrologySectionDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportHydrologySectionDTO
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportHydrologySectionDTO
     */
    'peakFlowQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportHydrologySectionDTO
     */
    'runoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportHydrologySectionDTO
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportHydrologySectionDTO
     */
    'watershedSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportHydrologySectionDTO
     */
    'weightedCurveNumber'?: number;
}
/**
 * 
 * @export
 * @interface TerraceDesignReportInputsDTO
 */
export interface TerraceDesignReportInputsDTO {
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'alignment'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'curveNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'designLife'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'dimensionlessUnitHydrograph'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'drainageArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'erodibility'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'erosionRate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'floodDuration'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'floodRoutingModel'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'frequency'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'percentageStored'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'retardanceClassCapacity'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'retardanceClassStability'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'sedimentDensity'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'strippingDepth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'subbasin'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'terraceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'terraceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'trapEfficiency'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportInputsDTO
     */
    'vegetalCoverType'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'watershedLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportInputsDTO
     */
    'watershedSlope'?: number;
}
/**
 * 
 * @export
 * @interface TerraceDesignReportStationTableDTO
 */
export interface TerraceDesignReportStationTableDTO {
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'block'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'channelZ'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'cutFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'designHeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'drain'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'errorCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'flowQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'frontHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'groundZ'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'slope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'stabilityVelocity'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'station'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStationTableDTO
     */
    'velocityFlowDepth'?: number;
}
/**
 * 
 * @export
 * @interface TerraceDesignReportStatisticsDTO
 */
export interface TerraceDesignReportStatisticsDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'floodArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'floodDuration'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'floodRoutingModel'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'requiredStorage'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'terraceLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportStatisticsDTO
     */
    'waterElevation'?: number;
}
/**
 * 
 * @export
 * @interface TerraceDesignReportSummaryDTO
 */
export interface TerraceDesignReportSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportSummaryDTO
     */
    'designSurfaceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportSummaryDTO
     */
    'terraceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportSummaryDTO
     */
    'terraceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportSummaryDTO
     */
    'undergroundOutletDrainFraction'?: number;
}
/**
 * 
 * @export
 * @interface TerraceDesignReportTemplateDTO
 */
export interface TerraceDesignReportTemplateDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'backSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'backSlopeMode'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'cutSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'cutSlopeMode'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'embankmentStartSlopeLimit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'embankmentStartSlopeMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'embankmentStartSlopeValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'flagLineLocation'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'freeboard'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'freeboardMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'frontHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'frontSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'frontSlopeMode'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'offsetFromAlignment'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'overfillAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'overfillMode'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'topWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignReportTemplateDTO
     */
    'uphillDirection'?: string;
}
/**
 * 
 * @export
 * @interface TerraceDesignShapeResponseDTO
 */
export interface TerraceDesignShapeResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'channel'?: ProfileDTO;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'computedStorage'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'constructedTerrace'?: ProfileDTO;
    /**
     * 
     * @type {Array<ContourLineData>}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'contourLines'?: Array<ContourLineData>;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'createBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {Array<{ [key: string]: XyzPoint; }>}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'crossSectionGeometries'?: Array<{ [key: string]: XyzPoint; }>;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'drainageBasinArea'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'floodedAcres'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'lastChangeDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'maxCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'maxFill'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'reachProfile'?: ProfileDTO;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'seedingArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'settledTerrace'?: ProfileDTO;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'strippingVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'terraceLength'?: number;
    /**
     * 
     * @type {TerraceStructureShapeDTO}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'terraceStructureShapeDTO'?: TerraceStructureShapeDTO;
    /**
     * 
     * @type {Array<TinTriangle>}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'tinTriangles'?: Array<TinTriangle>;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'totalFieldArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'totalStorageVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'totalThicknessCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'waterElevation'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceDesignShapeResponseDTO
     */
    'waterLevel'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface TerraceDesignSummariesResponseDto
 */
export interface TerraceDesignSummariesResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'actions'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'createdDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'defaultTemplate'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'maxHeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'terraceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummariesResponseDto
     */
    'warnings'?: string;
}
/**
 * 
 * @export
 * @interface TerraceDesignSummaryDto
 */
export interface TerraceDesignSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummaryDto
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'designElementJsonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'frequency'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'hydrology'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'lastUpdate'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'maxTopWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummaryDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'peakFlowQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'reachCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceDesignSummaryDto
     */
    'surface'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceDesignSummaryDto
     */
    'terraceTypeId'?: number;
}
/**
 * 
 * @export
 * @interface TerraceHydroParamsDTO
 */
export interface TerraceHydroParamsDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceHydroParamsDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceHydroParamsDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceHydroParamsDTO
     */
    'basinCharacteristicsJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceHydroParamsDTO
     */
    'basinName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceHydroParamsDTO
     */
    'basinTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceHydroParamsDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceHydroParamsDTO
     */
    'hydroParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceHydroParamsDTO
     */
    'inputSaveIndicator'?: number;
    /**
     * 
     * @type {BasinCharacteristicsDTO}
     * @memberof TerraceHydroParamsDTO
     */
    'requiredbasinCharacteristicsDTO'?: BasinCharacteristicsDTO;
    /**
     * 
     * @type {string}
     * @memberof TerraceHydroParamsDTO
     */
    'runoffSedimentStorageJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceHydroParamsDTO
     */
    'soilParametersJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceHydroParamsDTO
     */
    'strippingDepth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceHydroParamsDTO
     */
    'terraceVegetalParametersJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceHydroParamsDTO
     */
    'userDefinedBasinJson'?: string;
}
/**
 * 
 * @export
 * @interface TerraceHydroParamsResponseDTO
 */
export interface TerraceHydroParamsResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceHydroParamsResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof TerraceHydroParamsResponseDTO
     */
    'terraceHydroParamsId'?: number;
}
/**
 * 
 * @export
 * @interface TerraceInputsDTO
 */
export interface TerraceInputsDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceInputsDTO
     */
    'alignedElementParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceInputsDTO
     */
    'alignmentJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceInputsDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceInputsDTO
     */
    'benchMarkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceInputsDTO
     */
    'benchmarkMarkElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceInputsDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceInputsDTO
     */
    'sessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceInputsDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceInputsDTO
     */
    'terraceName'?: string;
}
/**
 * 
 * @export
 * @interface TerraceProfileDTO
 */
export interface TerraceProfileDTO {
    /**
     * 
     * @type {string}
     * @memberof TerraceProfileDTO
     */
    'blockId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileDTO
     */
    'channelElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileDTO
     */
    'cutFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileDTO
     */
    'designHeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceProfileDTO
     */
    'drainId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileDTO
     */
    'groundElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileDTO
     */
    'planRidgeHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileDTO
     */
    'referenceElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileDTO
     */
    'ridgeElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceProfileDTO
     */
    'stationId'?: string;
}
/**
 * 
 * @export
 * @interface TerraceProfileRequestDTO
 */
export interface TerraceProfileRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileRequestDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileRequestDTO
     */
    'sampleInterval'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileRequestDTO
     */
    'verticalInterval'?: number;
}
/**
 * 
 * @export
 * @interface TerraceProfileResponseDTO
 */
export interface TerraceProfileResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceProfileResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceProfileResponseDTO
     */
    'channel'?: ProfileDTO;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceProfileResponseDTO
     */
    'constructedTerrace'?: ProfileDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceProfileResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceProfileResponseDTO
     */
    'groundSurface'?: ProfileDTO;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceProfileResponseDTO
     */
    'settledTerrace'?: ProfileDTO;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceProfileResponseDTO
     */
    'waterLevel'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface TerraceReachDTO
 */
export interface TerraceReachDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceReachDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceReachDTO
     */
    'reachJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachDTO
     */
    'reachStationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachDTO
     */
    'waterwaySizingResponseDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachDTO
     */
    'waterwayVertexJson'?: string;
}
/**
 * 
 * @export
 * @interface TerraceReachGroupDTO
 */
export interface TerraceReachGroupDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceReachGroupDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {{ [key: string]: TerraceVertexParamsDTO; }}
     * @memberof TerraceReachGroupDTO
     */
    'terraceVertexParamsDTOMap'?: { [key: string]: TerraceVertexParamsDTO; };
}
/**
 * 
 * @export
 * @interface TerraceReachResponseDTO
 */
export interface TerraceReachResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceReachResponseDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachResponseDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceReachResponseDTO
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TerraceReachResponseDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TerraceReachResponseDTO
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachResponseDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachResponseDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceReachResponseDTO
     */
    'reachJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachResponseDTO
     */
    'reachStationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachResponseDTO
     */
    'waterwaySizingResponseDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceReachResponseDTO
     */
    'waterwayVertexJson'?: string;
}
/**
 * 
 * @export
 * @interface TerraceSimulationAndValidationRespDTO
 */
export interface TerraceSimulationAndValidationRespDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceSimulationAndValidationRespDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceSimulationAndValidationRespDTO
     */
    'constructedTerraceProfile'?: ProfileDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceSimulationAndValidationRespDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<TerraceVertexParamsDTO>}
     * @memberof TerraceSimulationAndValidationRespDTO
     */
    'terraceVertexDTOList'?: Array<TerraceVertexParamsDTO>;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof TerraceSimulationAndValidationRespDTO
     */
    'waterLevelProfile'?: ProfileDTO;
}
/**
 * 
 * @export
 * @interface TerraceSlopeAndLimits
 */
export interface TerraceSlopeAndLimits {
    /**
     * 
     * @type {number}
     * @memberof TerraceSlopeAndLimits
     */
    'isLimitEnforced'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSlopeAndLimits
     */
    'slopeLimit'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceSlopeAndLimits
     */
    'slopeMode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceSlopeAndLimits
     */
    'slopeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceSlopeAndLimits
     */
    'slopeValue'?: number;
}
/**
 * 
 * @export
 * @interface TerraceStructureShapeDTO
 */
export interface TerraceStructureShapeDTO {
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'backCutSlopePolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'backSlopePolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'blockStations'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'borderPolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'bottomCenterLine'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'bottomPolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {{ [key: string]: Array<BreaklineDTO>; }}
     * @memberof TerraceStructureShapeDTO
     */
    'breaklinesMap'?: { [key: string]: Array<BreaklineDTO>; };
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof TerraceStructureShapeDTO
     */
    'crossSectionLines'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'drainStations'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'frontCutSlopePolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'frontSlopePolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'ridgeTopPolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {{ [key: string]: Array<LineSegmentDto>; }}
     * @memberof TerraceStructureShapeDTO
     */
    'slopeArrowsMap'?: { [key: string]: Array<LineSegmentDto>; };
    /**
     * 
     * @type {Array<Array<InputPoint>>}
     * @memberof TerraceStructureShapeDTO
     */
    'subbasinPolygons'?: Array<Array<InputPoint>>;
    /**
     * 
     * @type {string}
     * @memberof TerraceStructureShapeDTO
     */
    'terraceType'?: string;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'waterLevelPolygon'?: Array<InputPoint>;
    /**
     * 
     * @type {{ [key: string]: Array<LineSegmentDto>; }}
     * @memberof TerraceStructureShapeDTO
     */
    'waterflowArrowsMap'?: { [key: string]: Array<LineSegmentDto>; };
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof TerraceStructureShapeDTO
     */
    'waterflowDirections'?: Array<InputPoint>;
}
/**
 * 
 * @export
 * @interface TerraceSummaryInfoDTO
 */
export interface TerraceSummaryInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'backSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'cutSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'excavationVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'fillVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'frontSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'layoutLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceSummaryInfoDTO
     */
    'terraceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceSummaryInfoDTO
     */
    'terraceTemplateName'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryInfoDTO
     */
    'topWidth'?: number;
}
/**
 * 
 * @export
 * @interface TerraceSummaryResultDTO
 */
export interface TerraceSummaryResultDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'computedStorage'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'drainageBasinArea'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceSummaryResultDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'floodArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'floodDuration'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceSummaryResultDTO
     */
    'floodRoutingModel'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'requiredStorage'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceSummaryResultDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'strippingVolume'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'terraceLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceSummaryResultDTO
     */
    'waterElevation'?: number;
}
/**
 * 
 * @export
 * @interface TerraceVegetalParametersDTO
 */
export interface TerraceVegetalParametersDTO {
    /**
     * 
     * @type {number}
     * @memberof TerraceVegetalParametersDTO
     */
    'strippingDepth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceVegetalParametersDTO
     */
    'vegetalCapacityOption'?: string;
    /**
     * 
     * @type {VegetalParametersDTO}
     * @memberof TerraceVegetalParametersDTO
     */
    'vegetalCapacityParams'?: VegetalParametersDTO;
    /**
     * 
     * @type {number}
     * @memberof TerraceVegetalParametersDTO
     */
    'vegetalCover'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceVegetalParametersDTO
     */
    'vegetalCoverDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceVegetalParametersDTO
     */
    'vegetalStabilityOption'?: string;
    /**
     * 
     * @type {VegetalParametersDTO}
     * @memberof TerraceVegetalParametersDTO
     */
    'vegetalStabilityParams'?: VegetalParametersDTO;
}
/**
 * 
 * @export
 * @interface TerraceVertexParamsDTO
 */
export interface TerraceVertexParamsDTO {
    /**
     * 
     * @type {boolean}
     * @memberof TerraceVertexParamsDTO
     */
    'blockStation'?: boolean;
    /**
     * 
     * @type {BlockStationDTO}
     * @memberof TerraceVertexParamsDTO
     */
    'blockStationDto'?: BlockStationDTO;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TerraceVertexParamsDTO
     */
    'bottomWidthEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'channelElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'cutFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'designHeight'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TerraceVertexParamsDTO
     */
    'drainStation'?: boolean;
    /**
     * 
     * @type {DrainStationDTO}
     * @memberof TerraceVertexParamsDTO
     */
    'drainStationDto'?: DrainStationDTO;
    /**
     * 
     * @type {string}
     * @memberof TerraceVertexParamsDTO
     */
    'endStation'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TerraceVertexParamsDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'estimatedCutSlopeRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'flowQ'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TerraceVertexParamsDTO
     */
    'flowQEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'flowVelocity'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'frontHeight'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TerraceVertexParamsDTO
     */
    'frontHeightEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'grade'?: number;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'groundElev'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceVertexParamsDTO
     */
    'liningMaterial'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'peakFlowDepth'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceVertexParamsDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'simWidth'?: number;
    /**
     * 
     * @type {Array<TerraceSlopeAndLimits>}
     * @memberof TerraceVertexParamsDTO
     */
    'slopeLimits'?: Array<TerraceSlopeAndLimits>;
    /**
     * 
     * @type {string}
     * @memberof TerraceVertexParamsDTO
     */
    'startStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof TerraceVertexParamsDTO
     */
    'stationDist'?: number;
    /**
     * 
     * @type {string}
     * @memberof TerraceVertexParamsDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof TerraceVertexParamsDTO
     */
    'templateName'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TerraceVertexParamsDTO
     */
    'templateParams'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface TinTriangle
 */
export interface TinTriangle {
    /**
     * 
     * @type {{ [key: string]: Point; }}
     * @memberof TinTriangle
     */
    'points'?: { [key: string]: Point; };
    /**
     * 
     * @type {TriPoint}
     * @memberof TinTriangle
     */
    'tin'?: TriPoint;
}
/**
 * 
 * @export
 * @interface TrapezoidalChannelRequestDto
 */
export interface TrapezoidalChannelRequestDto {
    /**
     * 
     * @type {number}
     * @memberof TrapezoidalChannelRequestDto
     */
    'bedSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrapezoidalChannelRequestDto
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrapezoidalChannelRequestDto
     */
    'depth'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrapezoidalChannelRequestDto
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrapezoidalChannelRequestDto
     */
    'sideSlopZ1'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrapezoidalChannelRequestDto
     */
    'sideSlopZ2'?: number;
}
/**
 * 
 * @export
 * @interface TrapezoidalChannelResponseDto
 */
export interface TrapezoidalChannelResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TrapezoidalChannelResponseDto
     */
    'area'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrapezoidalChannelResponseDto
     */
    'capacity'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrapezoidalChannelResponseDto
     */
    'criticalDepth'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof TrapezoidalChannelResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof TrapezoidalChannelResponseDto
     */
    'hydraulicRadius'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrapezoidalChannelResponseDto
     */
    'topWidth'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrapezoidalChannelResponseDto
     */
    'validationPass'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TrapezoidalChannelResponseDto
     */
    'valocity'?: string;
}
/**
 * 
 * @export
 * @interface TriPoint
 */
export interface TriPoint {
    /**
     * 
     * @type {number}
     * @memberof TriPoint
     */
    'ap1'?: number;
    /**
     * 
     * @type {number}
     * @memberof TriPoint
     */
    'ap2'?: number;
    /**
     * 
     * @type {number}
     * @memberof TriPoint
     */
    'ap3'?: number;
    /**
     * 
     * @type {number}
     * @memberof TriPoint
     */
    'p1'?: number;
    /**
     * 
     * @type {number}
     * @memberof TriPoint
     */
    'p2'?: number;
    /**
     * 
     * @type {number}
     * @memberof TriPoint
     */
    'p3'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TriPoint
     */
    'pointIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface URI
 */
export interface URI {
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    'absolute'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'authority'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'fragment'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'host'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof URI
     */
    'opaque'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof URI
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'query'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawAuthority'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawFragment'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawQuery'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawSchemeSpecificPart'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'rawUserInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'scheme'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'schemeSpecificPart'?: string;
    /**
     * 
     * @type {string}
     * @memberof URI
     */
    'userInfo'?: string;
}
/**
 * 
 * @export
 * @interface URL
 */
export interface URL {
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'authority'?: string;
    /**
     * 
     * @type {object}
     * @memberof URL
     */
    'content'?: object;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    'defaultPort'?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'file'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'host'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof URL
     */
    'port'?: number;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'protocol'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'query'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'ref'?: string;
    /**
     * 
     * @type {string}
     * @memberof URL
     */
    'userInfo'?: string;
}
/**
 * 
 * @export
 * @interface UgoAlignedElementDesignParamsRequestDTO
 */
export interface UgoAlignedElementDesignParamsRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'alignedFeatureName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'backFillSoilType'?: UgoAlignedElementDesignParamsRequestDTOBackFillSoilTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'benchmarkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'benchmarkElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'benchmarkName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'constructBenchmark'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {UgoPipeSpecification}
     * @memberof UgoAlignedElementDesignParamsRequestDTO
     */
    'ugoPipeSpecification'?: UgoPipeSpecification;
}

/**
    * @export
    * @enum {string}
    */
export enum UgoAlignedElementDesignParamsRequestDTOBackFillSoilTypeEnum {
    SiltyClayLoam = 'SILTY_CLAY_LOAM',
    SandOrSandyLoam = 'SAND_OR_SANDY_LOAM',
    SiltOrSiltLoam = 'SILT_OR_SILT_LOAM',
    ClayOrClayLoam = 'CLAY_OR_CLAY_LOAM',
    CoarseSandOrGravel = 'COARSE_SAND_OR_GRAVEL'
}

/**
 * 
 * @export
 * @interface UgoAlignedElementShapeResponseDTO
 */
export interface UgoAlignedElementShapeResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoAlignedElementShapeResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<IntersectingTerraceDTO>}
     * @memberof UgoAlignedElementShapeResponseDTO
     */
    'terracesIntersectingWithUgo'?: Array<IntersectingTerraceDTO>;
    /**
     * 
     * @type {Array<InputPoint>}
     * @memberof UgoAlignedElementShapeResponseDTO
     */
    'ugoAlignmentCoordinates'?: Array<InputPoint>;
}
/**
 * 
 * @export
 * @interface UgoConstructionReportDTO
 */
export interface UgoConstructionReportDTO {
    /**
     * 
     * @type {Array<InletProfileRowDTO>}
     * @memberof UgoConstructionReportDTO
     */
    'inletRows'?: Array<InletProfileRowDTO>;
    /**
     * 
     * @type {Array<OutletProfileRowDTO>}
     * @memberof UgoConstructionReportDTO
     */
    'outletRows'?: Array<OutletProfileRowDTO>;
    /**
     * 
     * @type {Array<UgoProfilePipeRowDTO>}
     * @memberof UgoConstructionReportDTO
     */
    'pipeRows'?: Array<UgoProfilePipeRowDTO>;
    /**
     * 
     * @type {Array<UgoProfileStationRowDTO>}
     * @memberof UgoConstructionReportDTO
     */
    'stationRows'?: Array<UgoProfileStationRowDTO>;
}
/**
 * 
 * @export
 * @interface UgoConstructionReportResponseDTO
 */
export interface UgoConstructionReportResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoConstructionReportResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof UgoConstructionReportResponseDTO
     */
    'locationMapImages'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UgoConstructionReportResponseDTO
     */
    'planMapImages'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UgoConstructionReportResponseDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {Array<UgoConstructionReportDTO>}
     * @memberof UgoConstructionReportResponseDTO
     */
    'ugoConstructionReportDTO'?: Array<UgoConstructionReportDTO>;
    /**
     * 
     * @type {UgoProjectSummary}
     * @memberof UgoConstructionReportResponseDTO
     */
    'ugoProjectSummary'?: UgoProjectSummary;
}
/**
 * 
 * @export
 * @interface UgoDefaultReachRequest
 */
export interface UgoDefaultReachRequest {
    /**
     * 
     * @type {number}
     * @memberof UgoDefaultReachRequest
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof UgoDefaultReachRequest
     */
    'stations'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface UgoDefaultReachResponse
 */
export interface UgoDefaultReachResponse {
    /**
     * 
     * @type {number}
     * @memberof UgoDefaultReachResponse
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoDefaultReachResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<UgoVertexParamsDTO>}
     * @memberof UgoDefaultReachResponse
     */
    'ugoVertexDTOList'?: Array<UgoVertexParamsDTO>;
}
/**
 * 
 * @export
 * @interface UgoFixtureRiserInletFlowQ
 */
export interface UgoFixtureRiserInletFlowQ {
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureRiserInletFlowQ
     */
    'averageFlowQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureRiserInletFlowQ
     */
    'qperf'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureRiserInletFlowQ
     */
    'qtop'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureRiserInletFlowQ
     */
    'releaseTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureRiserInletFlowQ
     */
    'ugoSizingFlow'?: number;
}
/**
 * 
 * @export
 * @interface UgoFixtureRiserInletQCalculationRequest
 */
export interface UgoFixtureRiserInletQCalculationRequest {
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureRiserInletQCalculationRequest
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureRiserInletQCalculationRequest
     */
    'ugoRiserInletJson'?: string;
}
/**
 * 
 * @export
 * @interface UgoFixtureRiserInletQCalculationResponse
 */
export interface UgoFixtureRiserInletQCalculationResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoFixtureRiserInletQCalculationResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {UgoFixtureRiserInletFlowQ}
     * @memberof UgoFixtureRiserInletQCalculationResponse
     */
    'ugoFixtureRiserInletFlowQ'?: UgoFixtureRiserInletFlowQ;
}
/**
 * 
 * @export
 * @interface UgoFixtureTypeRequestDTO
 */
export interface UgoFixtureTypeRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeRequestDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UgoFixtureTypeRequestDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeRequestDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeRequestDTO
     */
    'ugoFixtureTypeName'?: string;
}
/**
 * 
 * @export
 * @interface UgoFixtureTypeResponseDTO
 */
export interface UgoFixtureTypeResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'description'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'ugoFixtureTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoFixtureTypeResponseDTO
     */
    'ugoFixtureTypeName'?: string;
}
/**
 * 
 * @export
 * @interface UgoJunctionNamelListResponseDTO
 */
export interface UgoJunctionNamelListResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoJunctionNamelListResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof UgoJunctionNamelListResponseDTO
     */
    'junctionNameList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UgoJunctionNamelListResponseDTO
     */
    'sessionUuid'?: string;
}
/**
 * 
 * @export
 * @interface UgoPipeSpecification
 */
export interface UgoPipeSpecification {
    /**
     * 
     * @type {number}
     * @memberof UgoPipeSpecification
     */
    'elbowElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoPipeSpecification
     */
    'materialTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoPipeSpecification
     */
    'offsetDistance'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UgoPipeSpecification
     */
    'perforated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UgoPipeSpecification
     */
    'pipeManningn'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoPipeSpecification
     */
    'pipelineSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UgoPipeSpecification
     */
    'pressureFlow'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UgoPipeSpecification
     */
    'pressurizable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoPipeSpecification
     */
    'ugoMaterialDescription'?: string;
}
/**
 * 
 * @export
 * @interface UgoPipelineMaterialTypeRequestDTO
 */
export interface UgoPipelineMaterialTypeRequestDTO {
    /**
     * 
     * @type {boolean}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'canPressurizable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'manningsNJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'maxSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'minSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'pipeMaterialDefaultJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'pipelineMaterialName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeRequestDTO
     */
    'pipelineTypeId'?: number;
}
/**
 * 
 * @export
 * @interface UgoPipelineMaterialTypeResponseDTO
 */
export interface UgoPipelineMaterialTypeResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'canPressurizable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'createdBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'creationDateUtc'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'description'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'lastChangeDateUtc'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'lastChangedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'mannningsNJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'maxSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'minSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'pipeMaterialDefaultJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'pipelineMaterialName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'pipelineTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoPipelineMaterialTypeResponseDTO
     */
    'ugoPipelineMaterialTypeId'?: number;
}
/**
 * 
 * @export
 * @interface UgoProfilePipeRowDTO
 */
export interface UgoProfilePipeRowDTO {
    /**
     * 
     * @type {string}
     * @memberof UgoProfilePipeRowDTO
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoProfilePipeRowDTO
     */
    'diameter'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfilePipeRowDTO
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoProfilePipeRowDTO
     */
    'material'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoProfilePipeRowDTO
     */
    'pipeGradePercent'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoProfilePipeRowDTO
     */
    'pipeId'?: string;
}
/**
 * 
 * @export
 * @interface UgoProfileStationRowDTO
 */
export interface UgoProfileStationRowDTO {
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'asBuiltFlowlineRodElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'asBuiltOrificeRodElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'asBuiltPipeGrade'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'asBuiltRiserPerfRodElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoProfileStationRowDTO
     */
    'fixtureId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'hi'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'originalGroundElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'planCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'planFlowlineElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'planOrificeElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'planPipeGrade'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoProfileStationRowDTO
     */
    'planRiserPerfElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoProfileStationRowDTO
     */
    'stationId'?: string;
}
/**
 * 
 * @export
 * @interface UgoProjectSummary
 */
export interface UgoProjectSummary {
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'createdBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'designedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'projectCounty'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'projectDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoProjectSummary
     */
    'projectState'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UgoProjectSummary
     */
    'ugoNames'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UgoSummariesResponseDTO
 */
export interface UgoSummariesResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoSummariesResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<UgoSummaryDTO>}
     * @memberof UgoSummariesResponseDTO
     */
    'ugoSummaryDTOs'?: Array<UgoSummaryDTO>;
}
/**
 * 
 * @export
 * @interface UgoSummaryDTO
 */
export interface UgoSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof UgoSummaryDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoSummaryDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoSummaryDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UgoSummaryDTO
     */
    'connected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UgoSummaryDTO
     */
    'createdDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoSummaryDTO
     */
    'designElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoSummaryDTO
     */
    'errorResponse'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoSummaryDTO
     */
    'lastChangeDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoSummaryDTO
     */
    'numOfDrains'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoSummaryDTO
     */
    'ugoName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoSummaryDTO
     */
    'warnings'?: string;
}
/**
 * 
 * @export
 * @interface UgoTerraceCrossSectionProfileResponse
 */
export interface UgoTerraceCrossSectionProfileResponse {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoTerraceCrossSectionProfileResponse
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {ProfileDTO}
     * @memberof UgoTerraceCrossSectionProfileResponse
     */
    'groundProfile'?: ProfileDTO;
    /**
     * 
     * @type {Array<TerraceCrossSectionProfileDTO>}
     * @memberof UgoTerraceCrossSectionProfileResponse
     */
    'terraceProfileList'?: Array<TerraceCrossSectionProfileDTO>;
    /**
     * 
     * @type {number}
     * @memberof UgoTerraceCrossSectionProfileResponse
     */
    'ugoAlignedElementId'?: number;
}
/**
 * 
 * @export
 * @interface UgoVertexParamsDTO
 */
export interface UgoVertexParamsDTO {
    /**
     * 
     * @type {string}
     * @memberof UgoVertexParamsDTO
     */
    'endStation'?: string;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoVertexParamsDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof UgoVertexParamsDTO
     */
    'fixtureDtoJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoVertexParamsDTO
     */
    'fixtureName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'fixtureTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'grade'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'groundElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'pipeCoverDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'pipeFlowDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'pipeFlowElev'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UgoVertexParamsDTO
     */
    'pressureFlow'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UgoVertexParamsDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'runoffQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoVertexParamsDTO
     */
    'startStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoVertexParamsDTO
     */
    'stationDist'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoVertexParamsDTO
     */
    'status'?: string;
    /**
     * 
     * @type {UgoPipeSpecification}
     * @memberof UgoVertexParamsDTO
     */
    'ugoPipeSpecification'?: UgoPipeSpecification;
}
/**
 * 
 * @export
 * @interface UgoWaterResourceNameListResponseDTO
 */
export interface UgoWaterResourceNameListResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoWaterResourceNameListResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof UgoWaterResourceNameListResponseDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UgoWaterResourceNameListResponseDTO
     */
    'waterResourceNameList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UgoWaterResourceRequestDTO
 */
export interface UgoWaterResourceRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof UgoWaterResourceRequestDTO
     */
    'sessionUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UgoWaterResourceRequestDTO
     */
    'waterResourceName'?: string;
}
/**
 * 
 * @export
 * @interface UgoWaterResourceResponseDTO
 */
export interface UgoWaterResourceResponseDTO {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoWaterResourceResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {Array<UgoWaterSourceDTO>}
     * @memberof UgoWaterResourceResponseDTO
     */
    'waterSourceValueList'?: Array<UgoWaterSourceDTO>;
}
/**
 * 
 * @export
 * @interface UgoWaterSourceDTO
 */
export interface UgoWaterSourceDTO {
    /**
     * 
     * @type {number}
     * @memberof UgoWaterSourceDTO
     */
    'avgFloodDepthFactor'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoWaterSourceDTO
     */
    'channelElev'?: number;
    /**
     * 
     * @type {DrainStationDTO}
     * @memberof UgoWaterSourceDTO
     */
    'drainStationDTO'?: DrainStationDTO;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UgoWaterSourceDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof UgoWaterSourceDTO
     */
    'pipeDepthBelowChannel'?: number;
    /**
     * 
     * @type {string}
     * @memberof UgoWaterSourceDTO
     */
    'terraceAndOutlet'?: string;
    /**
     * 
     * @type {number}
     * @memberof UgoWaterSourceDTO
     */
    'terraceFloodElev'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoWaterSourceDTO
     */
    'terraceRequiredQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof UgoWaterSourceDTO
     */
    'ugoSizingFloodDepthFactor'?: number;
}
/**
 * 
 * @export
 * @interface UpdateSurfStakeOutGridRequest
 */
export interface UpdateSurfStakeOutGridRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateSurfStakeOutGridRequest
     */
    'cellHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSurfStakeOutGridRequest
     */
    'cellWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSurfStakeOutGridRequest
     */
    'surfaceDesignElementId'?: number;
}
/**
 * 
 * @export
 * @interface UpdateTerraceDesignControlDTO
 */
export interface UpdateTerraceDesignControlDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateTerraceDesignControlDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTerraceDesignControlDTO
     */
    'inputSaveIndicator'?: number;
    /**
     * 
     * @type {TerraceDesignControlDTO}
     * @memberof UpdateTerraceDesignControlDTO
     */
    'terraceDesignControl'?: TerraceDesignControlDTO;
}
/**
 * 
 * @export
 * @interface UpdateTerraceDesignControlResponseDTO
 */
export interface UpdateTerraceDesignControlResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof UpdateTerraceDesignControlResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof UpdateTerraceDesignControlResponseDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof UpdateTerraceDesignControlResponseDTO
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface UserDefinedImages
 */
export interface UserDefinedImages {
    /**
     * 
     * @type {string}
     * @memberof UserDefinedImages
     */
    'imageName'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDefinedImages
     */
    'imageTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDefinedImages
     */
    'images'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDefinedImages
     */
    'lastChangeDate'?: number;
}
/**
 * 
 * @export
 * @interface VNotchWeirRequestDto
 */
export interface VNotchWeirRequestDto {
    /**
     * 
     * @type {number}
     * @memberof VNotchWeirRequestDto
     */
    'headOnWeir'?: number;
}
/**
 * 
 * @export
 * @interface VNotchWeirResponseDto
 */
export interface VNotchWeirResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof VNotchWeirResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {string}
     * @memberof VNotchWeirResponseDto
     */
    'q'?: string;
}
/**
 * 
 * @export
 * @interface VegetalCoverStabilityRCICalReqDTO
 */
export interface VegetalCoverStabilityRCICalReqDTO {
    /**
     * 
     * @type {number}
     * @memberof VegetalCoverStabilityRCICalReqDTO
     */
    'stabStemDensity'?: number;
    /**
     * 
     * @type {number}
     * @memberof VegetalCoverStabilityRCICalReqDTO
     */
    'stabStemLength'?: number;
}
/**
 * 
 * @export
 * @interface VegetalCoverStabilityRCICalRespDTO
 */
export interface VegetalCoverStabilityRCICalRespDTO {
    /**
     * 
     * @type {number}
     * @memberof VegetalCoverStabilityRCICalRespDTO
     */
    'stabStemDensity'?: number;
    /**
     * 
     * @type {number}
     * @memberof VegetalCoverStabilityRCICalRespDTO
     */
    'stabStemLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof VegetalCoverStabilityRCICalRespDTO
     */
    'stabilityRCI'?: number;
}
/**
 * 
 * @export
 * @interface VegetalParametersDTO
 */
export interface VegetalParametersDTO {
    /**
     * 
     * @type {number}
     * @memberof VegetalParametersDTO
     */
    'manningsN'?: number;
    /**
     * 
     * @type {number}
     * @memberof VegetalParametersDTO
     */
    'rci'?: number;
    /**
     * 
     * @type {string}
     * @memberof VegetalParametersDTO
     */
    'retClassStr'?: string;
    /**
     * 
     * @type {number}
     * @memberof VegetalParametersDTO
     */
    'stemDensity'?: number;
    /**
     * 
     * @type {number}
     * @memberof VegetalParametersDTO
     */
    'stemLength'?: number;
}
/**
 * 
 * @export
 * @interface WWDesignReachInfoDTO
 */
export interface WWDesignReachInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'addedQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'bottomWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'channelZ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'cutFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'flowDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'flowTopWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'groundZ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'leftSS'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'limitSlope'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'offset1'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'offset2'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'offset3'?: number;
    /**
     * 
     * @type {string}
     * @memberof WWDesignReachInfoDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'rightSS'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'runoffQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'slope'?: number;
    /**
     * 
     * @type {string}
     * @memberof WWDesignReachInfoDTO
     */
    'station'?: string;
    /**
     * 
     * @type {string}
     * @memberof WWDesignReachInfoDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof WWDesignReachInfoDTO
     */
    'totalQ'?: number;
}
/**
 * 
 * @export
 * @interface WaterWayProfileDTO
 */
export interface WaterWayProfileDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'channelElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'cutFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'designBottomWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'designDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'designTopWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'grade'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'offset50Elevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterWayProfileDTO
     */
    'stationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'subgrade'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterWayProfileDTO
     */
    'thickness'?: number;
}
/**
 * 
 * @export
 * @interface WaterwayActionRequestDTO
 */
export interface WaterwayActionRequestDTO {
    /**
     * 
     * @type {{ [key: string]: InputPoint; }}
     * @memberof WaterwayActionRequestDTO
     */
    'actionRequestMap'?: { [key: string]: InputPoint; };
    /**
     * 
     * @type {number}
     * @memberof WaterwayActionRequestDTO
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayActionRequestDTO
     */
    'designStage'?: boolean;
}
/**
 * 
 * @export
 * @interface WaterwayAssessmentAndRecommendationDTO
 */
export interface WaterwayAssessmentAndRecommendationDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayAssessmentAndRecommendationDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayAssessmentAndRecommendationDTO
     */
    'assessmentSummary'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayAssessmentAndRecommendationDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayAssessmentAndRecommendationDTO
     */
    'status'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WaterwayAssessmentAndRecommendationDTO
     */
    'suggestions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WaterwayConstructionReportReqDTO
 */
export interface WaterwayConstructionReportReqDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportReqDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportReqDTO
     */
    'backsight'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportReqDTO
     */
    'foresight'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportReqDTO
     */
    'heightOfInstrument'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportReqDTO
     */
    'other'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportReqDTO
     */
    'sessionuuid'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WaterwayConstructionReportReqDTO
     */
    'stationIdListForThreeXsection'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WaterwayConstructionReportRespDTO
 */
export interface WaterwayConstructionReportRespDTO {
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'additionalInformation'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'backsight'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'benchmarkDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'benchmarkElevation'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'channelType'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'clearing'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'constructBenchmark'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'designedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'foresight'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'heightOfInstrument'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'locationMapImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'onCallNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'other'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'projectCounty'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'projectDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'projectState'?: string;
    /**
     * 
     * @type {Array<ReachInfoDTO>}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'reachInfoList'?: Array<ReachInfoDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'seedingArea'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'spoilDisposal'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'stationIdXsectionMap'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {Array<WaterWayProfileDTO>}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'waterWayProfileList'?: Array<WaterWayProfileDTO>;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'waterWayType'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'waterwayArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'waterwayLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'waterwayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'waterwayPlanViewImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayConstructionReportRespDTO
     */
    'xsectionImage'?: string;
}
/**
 * 
 * @export
 * @interface WaterwayDTO
 */
export interface WaterwayDTO {
    /**
     * 
     * @type {string}
     * @memberof WaterwayDTO
     */
    'alignmentBindingName'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDTO
     */
    'alignmentJsonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDTO
     */
    'benchMark'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDTO
     */
    'benchmarkName'?: string;
    /**
     * 
     * @type {DesignControlDTO}
     * @memberof WaterwayDTO
     */
    'designControlDto'?: DesignControlDTO;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDTO
     */
    'designElementTypeId'?: number;
    /**
     * 
     * @type {HydroParamsDTO}
     * @memberof WaterwayDTO
     */
    'hydroParamsDto'?: HydroParamsDTO;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDTO
     */
    'materialManningN'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDTO
     */
    'objectName'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDTO
     */
    'seedWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDTO
     */
    'sessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDTO
     */
    'waterwayMiscDTO'?: string;
    /**
     * 
     * @type {Array<WaterwaySizingResponseDTO>}
     * @memberof WaterwayDTO
     */
    'waterwaySizingResponseDTOs'?: Array<WaterwaySizingResponseDTO>;
    /**
     * 
     * @type {Array<WaterwayVertexParamDTO>}
     * @memberof WaterwayDTO
     */
    'waterwayVertexParams'?: Array<WaterwayVertexParamDTO>;
}
/**
 * 
 * @export
 * @interface WaterwayDesignAIAssistanceRequestDTO
 */
export interface WaterwayDesignAIAssistanceRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignAIAssistanceRequestDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignAIAssistanceRequestDTO
     */
    'userRequest'?: string;
}
/**
 * 
 * @export
 * @interface WaterwayDesignQueryResponseDTO
 */
export interface WaterwayDesignQueryResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignQueryResponseDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignQueryResponseDTO
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignQueryResponseDTO
     */
    'queryResponse'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignQueryResponseDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignQueryResponseDTO
     */
    'userRequest'?: string;
}
/**
 * 
 * @export
 * @interface WaterwayDesignSummaryDto
 */
export interface WaterwayDesignSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'alignmentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignSummaryDto
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignSummaryDto
     */
    'channelType'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'designElementJsonId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'frequency'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'hydrology'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'lastUpdate'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'maxTopWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignSummaryDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'peakFlowQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDesignSummaryDto
     */
    'reachCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignSummaryDto
     */
    'surface'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDesignSummaryDto
     */
    'waterwayType'?: string;
}
/**
 * 
 * @export
 * @interface WaterwayDrlInput
 */
export interface WaterwayDrlInput {
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'absoluteReachStationChannelElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'adjustmentOfReachStationChannelElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'adjustmentOfReachStationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'channelSlope'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayDrlInput
     */
    'channelSlopeValidationStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayDrlInput
     */
    'depthValidationStatus'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'materialManning'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'previousStationDistance'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayDrlInput
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'relativeReachStationChannelElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'relativeReachStationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'simDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'simWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayDrlInput
     */
    'velocity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayDrlInput
     */
    'velocityValidationStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayDrlInput
     */
    'widthValidationStatus'?: boolean;
}
/**
 * 
 * @export
 * @interface WaterwayEnvResponseDto
 */
export interface WaterwayEnvResponseDto {
    /**
     * 
     * @type {number}
     * @memberof WaterwayEnvResponseDto
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof WaterwayEnvResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof WaterwayEnvResponseDto
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayEnvResponseDto
     */
    'totalFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayEnvResponseDto
     */
    'totalLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayEnvResponseDto
     */
    'totalThicknessCut'?: number;
    /**
     * 
     * @type {{ [key: string]: WaterwayDrlInput; }}
     * @memberof WaterwayEnvResponseDto
     */
    'waterwayDrlInputMap'?: { [key: string]: WaterwayDrlInput; };
}
/**
 * 
 * @export
 * @interface WaterwayEpisodeBatchProcessRequest
 */
export interface WaterwayEpisodeBatchProcessRequest {
    /**
     * 
     * @type {number}
     * @memberof WaterwayEpisodeBatchProcessRequest
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayEpisodeBatchProcessRequest
     */
    'episodeUpperLimit'?: number;
}
/**
 * 
 * @export
 * @interface WaterwayExportDTO
 */
export interface WaterwayExportDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayExportDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayExportDTO
     */
    'crossSectionInterval'?: number;
}
/**
 * 
 * @export
 * @interface WaterwayHumanFeedbackRequestDto
 */
export interface WaterwayHumanFeedbackRequestDto {
    /**
     * 
     * @type {number}
     * @memberof WaterwayHumanFeedbackRequestDto
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayHumanFeedbackRequestDto
     */
    'human'?: boolean;
    /**
     * 
     * @type {Array<NodeAction>}
     * @memberof WaterwayHumanFeedbackRequestDto
     */
    'nodeActions'?: Array<NodeAction>;
}
/**
 * 
 * @export
 * @interface WaterwayInputChangeDto
 */
export interface WaterwayInputChangeDto {
    /**
     * 
     * @type {number}
     * @memberof WaterwayInputChangeDto
     */
    'alignedElementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayInputChangeDto
     */
    'alignedFeatureSCChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayInputChangeDto
     */
    'alignmentChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayInputChangeDto
     */
    'hydroChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayInputChangeDto
     */
    'reachesChange'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayInputChangeDto
     */
    'surfaceChange'?: number;
}
/**
 * 
 * @export
 * @interface WaterwayObservationDTO
 */
export interface WaterwayObservationDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayObservationDTO
     */
    'alignedElementDesignParamsId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayObservationDTO
     */
    'channelSlopeValidationStatus'?: boolean;
    /**
     * 
     * @type {ErrorResponse}
     * @memberof WaterwayObservationDTO
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof WaterwayObservationDTO
     */
    'reachId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayObservationDTO
     */
    'reachStationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayObservationDTO
     */
    'relativeReachStationChannelElevation'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayObservationDTO
     */
    'relativeReachStationDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayObservationDTO
     */
    'simDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayObservationDTO
     */
    'simWidth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayObservationDTO
     */
    'validationStatusDepth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayObservationDTO
     */
    'validationStatusVelocity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayObservationDTO
     */
    'validationStatusWidth'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WaterwayObservationDTO
     */
    'velocity'?: number;
}
/**
 * 
 * @export
 * @interface WaterwaySizingParamsDTO
 */
export interface WaterwaySizingParamsDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwaySizingParamsDTO
     */
    'alignmentStation'?: number;
    /**
     * 
     * @type {ChannelParametersDTO}
     * @memberof WaterwaySizingParamsDTO
     */
    'channelParams'?: ChannelParametersDTO;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySizingParamsDTO
     */
    'channelSlope'?: number;
    /**
     * 
     * @type {WaterwayVertexDTO}
     * @memberof WaterwaySizingParamsDTO
     */
    'dataVertex'?: WaterwayVertexDTO;
    /**
     * 
     * @type {SoilParametersDTO}
     * @memberof WaterwaySizingParamsDTO
     */
    'soilParameters'?: SoilParametersDTO;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingParamsDTO
     */
    'vcDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySizingParamsDTO
     */
    'vcffactor'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingParamsDTO
     */
    'vegetalCapacityOption'?: string;
    /**
     * 
     * @type {VegetalParametersDTO}
     * @memberof WaterwaySizingParamsDTO
     */
    'vegetalCapacityParams'?: VegetalParametersDTO;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingParamsDTO
     */
    'vegetalStabilityOption'?: string;
    /**
     * 
     * @type {VegetalParametersDTO}
     * @memberof WaterwaySizingParamsDTO
     */
    'vegetalStabilityParams'?: VegetalParametersDTO;
}
/**
 * 
 * @export
 * @interface WaterwaySizingRequestReachDTO
 */
export interface WaterwaySizingRequestReachDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwaySizingRequestReachDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WaterwaySizingRequestReachDTO
     */
    'reachIds'?: Array<string>;
    /**
     * 
     * @type {WaterwaySizingResponseDTO}
     * @memberof WaterwaySizingRequestReachDTO
     */
    'waterWaySizingResponseParamDto'?: WaterwaySizingResponseDTO;
}
/**
 * 
 * @export
 * @interface WaterwaySizingResponseDTO
 */
export interface WaterwaySizingResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwaySizingResponseDTO
     */
    'alignmentStation'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capBankSlopeString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capBedWidthString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capFlowDepthString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capFlowWidthString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capFlowWidthWFBString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capHydRadiusString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capNString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capSoilStressString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capVString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'capXSectAreaString'?: string;
    /**
     * 
     * @type {ChannelParametersDTO}
     * @memberof WaterwaySizingResponseDTO
     */
    'channelParams'?: ChannelParametersDTO;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySizingResponseDTO
     */
    'channelSlope'?: number;
    /**
     * 
     * @type {WaterwayVertexDTO}
     * @memberof WaterwaySizingResponseDTO
     */
    'dataVertex'?: WaterwayVertexDTO;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'endStation'?: string;
    /**
     * 
     * @type {SoilParametersDTO}
     * @memberof WaterwaySizingResponseDTO
     */
    'soilParameters'?: SoilParametersDTO;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabBankSlopeString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabBedWidthString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabFlowDepthString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabFlowWidthString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabFlowWidthWFBString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabHydRadiusString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabNString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabSoilStressString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabVString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'stabXSectAreaString'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'startStation'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'vcDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySizingResponseDTO
     */
    'vcffactor'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'vegetalCapacityOption'?: string;
    /**
     * 
     * @type {VegetalParametersDTO}
     * @memberof WaterwaySizingResponseDTO
     */
    'vegetalCapacityParams'?: VegetalParametersDTO;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySizingResponseDTO
     */
    'vegetalStabilityOption'?: string;
    /**
     * 
     * @type {VegetalParametersDTO}
     * @memberof WaterwaySizingResponseDTO
     */
    'vegetalStabilityParams'?: VegetalParametersDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof WaterwaySizingResponseDTO
     */
    'warningMsgs'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WaterwaySummaryReportDTO
 */
export interface WaterwaySummaryReportDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'additionalSeedingArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'channelShape'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'initialQFraction'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'peakFlowQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'projectCounty'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'projectDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'projectState'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'projectStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'totalArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'totalDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'waterWayType'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportDTO
     */
    'waterwayName'?: string;
    /**
     * 
     * @type {Array<WaterwayVertexParamDTO>}
     * @memberof WaterwaySummaryReportDTO
     */
    'waterwayVertexParamList'?: Array<WaterwayVertexParamDTO>;
}
/**
 * 
 * @export
 * @interface WaterwaySummaryReportRespDTO
 */
export interface WaterwaySummaryReportRespDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'additionalSeedingArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'alignmentDesignElementJsonId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'channelShape'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {Array<GrassedSoilVegInfoDTO>}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'grassedSoilVegInfoList'?: Array<GrassedSoilVegInfoDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'initialQFraction'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'length'?: number;
    /**
     * 
     * @type {Array<LinedSoilVegInfoDTO>}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'linedSoilVegInfoList'?: Array<LinedSoilVegInfoDTO>;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'peakFlowQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'practice'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'projectCounty'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'projectDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'projectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'projectOwner'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'projectState'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'projectStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'totalArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'totalDistance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {Array<WWDesignReachInfoDTO>}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'waterWayDesignReachInfoList'?: Array<WWDesignReachInfoDTO>;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'waterWayType'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryReportRespDTO
     */
    'waterwayName'?: string;
}
/**
 * 
 * @export
 * @interface WaterwaySummaryResultDTO
 */
export interface WaterwaySummaryResultDTO {
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryResultDTO
     */
    'alignmentName'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryResultDTO
     */
    'cutFillBalance'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryResultDTO
     */
    'cutFillRatio'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryResultDTO
     */
    'designedBy'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryResultDTO
     */
    'length'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryResultDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryResultDTO
     */
    'totalArea'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryResultDTO
     */
    'totalCut'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwaySummaryResultDTO
     */
    'totalFill'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryResultDTO
     */
    'waterWayType'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwaySummaryResultDTO
     */
    'waterwayName'?: string;
}
/**
 * 
 * @export
 * @interface WaterwayVertexDTO
 */
export interface WaterwayVertexDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'addedQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'bedWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'depth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexDTO
     */
    'depthEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'flowQ'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexDTO
     */
    'flowQEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'simDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'simFlowQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'simWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'totalQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexDTO
     */
    'width'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexDTO
     */
    'widthEdited'?: boolean;
}
/**
 * 
 * @export
 * @interface WaterwayVertexParamDTO
 */
export interface WaterwayVertexParamDTO {
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'addedQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'btmWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'capaVelocity'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'capacity'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'channelElev'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WaterwayVertexParamDTO
     */
    'channelParams'?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'channelShapeType'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'cutFill'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'depth'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexParamDTO
     */
    'depthEdited'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'endStation'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'errorCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexParamDTO
     */
    'firstReach'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexParamDTO
     */
    'flowQEdited'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'grade'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'groundElev'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexParamDTO
     */
    'lastReach'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'leftSS'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'rightSS'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'simDepth'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'simFlowQ'?: number;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'simWidth'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'soilStrength'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'stabVelocity'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'stability'?: string;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'startStation'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'stationDist'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'totalQ'?: number;
    /**
     * 
     * @type {string}
     * @memberof WaterwayVertexParamDTO
     */
    'vegetalCover'?: string;
    /**
     * 
     * @type {number}
     * @memberof WaterwayVertexParamDTO
     */
    'width'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WaterwayVertexParamDTO
     */
    'widthEdited'?: boolean;
}
/**
 * 
 * @export
 * @interface WdtReachesRequestDTO
 */
export interface WdtReachesRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof WdtReachesRequestDTO
     */
    'alignedElementDesignParametersId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WdtReachesRequestDTO
     */
    'reachId'?: string;
    /**
     * 
     * @type {{ [key: string]: WaterwayVertexParamDTO; }}
     * @memberof WdtReachesRequestDTO
     */
    'waterWayVertexParamDTOMap'?: { [key: string]: WaterwayVertexParamDTO; };
    /**
     * 
     * @type {{ [key: string]: WaterwayVertexParamDTO; }}
     * @memberof WdtReachesRequestDTO
     */
    'waterWayVertextParamDTOMap'?: { [key: string]: WaterwayVertexParamDTO; };
}
/**
 * 
 * @export
 * @interface WdtSimulationResponseDTO
 */
export interface WdtSimulationResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof WdtSimulationResponseDTO
     */
    'errCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof WdtSimulationResponseDTO
     */
    'errMessage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WdtSimulationResponseDTO
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface WeirFlowRequest
 */
export interface WeirFlowRequest {
    /**
     * 
     * @type {number}
     * @memberof WeirFlowRequest
     */
    'headOfWeir'?: number;
    /**
     * 
     * @type {number}
     * @memberof WeirFlowRequest
     */
    'lengthOfWeir'?: number;
    /**
     * 
     * @type {string}
     * @memberof WeirFlowRequest
     */
    'weirCoefficient'?: string;
}
/**
 * 
 * @export
 * @interface WeirFlowResponseDto
 */
export interface WeirFlowResponseDto {
    /**
     * 
     * @type {ErrorResponse}
     * @memberof WeirFlowResponseDto
     */
    'errorResponse'?: ErrorResponse;
    /**
     * 
     * @type {number}
     * @memberof WeirFlowResponseDto
     */
    'q'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WeirFlowResponseDto
     */
    'validationPass'?: boolean;
}
/**
 * 
 * @export
 * @interface XyzPoint
 */
export interface XyzPoint {
    /**
     * 
     * @type {string}
     * @memberof XyzPoint
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'delta'?: number;
    /**
     * 
     * @type {string}
     * @memberof XyzPoint
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'id'?: number;
    /**
     * 
     * @type {Point}
     * @memberof XyzPoint
     */
    'jtsPoint'?: Point;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'm'?: number;
    /**
     * 
     * @type {string}
     * @memberof XyzPoint
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'permanentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof XyzPoint
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof XyzPoint
     */
    'surveyName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof XyzPoint
     */
    'tinable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof XyzPoint
     */
    'visible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'xinMeters'?: number;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'yinMeters'?: number;
    /**
     * 
     * @type {number}
     * @memberof XyzPoint
     */
    'z'?: number;
}
/**
 * 
 * @export
 * @interface Xyzarray
 */
export interface Xyzarray {
    /**
     * 
     * @type {number}
     * @memberof Xyzarray
     */
    'x'?: number;
    /**
     * 
     * @type {number}
     * @memberof Xyzarray
     */
    'y'?: number;
    /**
     * 
     * @type {number}
     * @memberof Xyzarray
     */
    'z'?: number;
}

/**
 * ActivityLogControllerApi - axios parameter creator
 * @export
 */
export const ActivityLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createActivityLogForErrorHandling
         * @param {string} originalErrorCode originalErrorCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLogForErrorHandlingUsingPOST: async (originalErrorCode: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'originalErrorCode' is not null or undefined
            assertParamExists('createActivityLogForErrorHandlingUsingPOST', 'originalErrorCode', originalErrorCode)
            const localVarPath = `/activityLog/createActivityLogForErrorHandling/{originalErrorCode}`
                .replace(`{${"originalErrorCode"}}`, encodeURIComponent(String(originalErrorCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createActivityLogForWithoutProject
         * @param {ActivityLogRequest} activityLogRequest activityLogRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLogForWithoutProjectUsingPOST: async (activityLogRequest: ActivityLogRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityLogRequest' is not null or undefined
            assertParamExists('createActivityLogForWithoutProjectUsingPOST', 'activityLogRequest', activityLogRequest)
            const localVarPath = `/activityLog/createActivityLogForWithoutProject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityLogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createActivityLog
         * @param {ActivityLogRequest} activityLogRequest activityLogRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLogUsingPOST: async (activityLogRequest: ActivityLogRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityLogRequest' is not null or undefined
            assertParamExists('createActivityLogUsingPOST', 'activityLogRequest', activityLogRequest)
            const localVarPath = `/activityLog/createActivityLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityLogRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateErrorSummaryReport
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateErrorSummaryReportUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/activityLog/generateErrorSummaryReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getActivitySummaryByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitySummaryByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getActivitySummaryByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/activityLog/getActivitySummaryByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllActivityLogByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getAllActivityLogByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/activityLog/getAllActivityLogByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllActivityLogBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogBySessionUuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getAllActivityLogBySessionUuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/activityLog/getAllActivityLogBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllActivityLogByUserName
         * @param {string} userName userName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogByUserNameUsingGET: async (userName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('getAllActivityLogByUserNameUsingGET', 'userName', userName)
            const localVarPath = `/activityLog/getAllActivityLogByUserName/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllActivityLogs
         * @param {string} all all
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogsUsingGET: async (all: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'all' is not null or undefined
            assertParamExists('getAllActivityLogsUsingGET', 'all', all)
            const localVarPath = `/activityLog/getAllActivityLogs/{all}`
                .replace(`{${"all"}}`, encodeURIComponent(String(all)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityLogControllerApi - functional programming interface
 * @export
 */
export const ActivityLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createActivityLogForErrorHandling
         * @param {string} originalErrorCode originalErrorCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivityLogForErrorHandlingUsingPOST(originalErrorCode: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivityLogForErrorHandlingUsingPOST(originalErrorCode, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createActivityLogForWithoutProject
         * @param {ActivityLogRequest} activityLogRequest activityLogRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivityLogForWithoutProjectUsingPOST(activityLogRequest: ActivityLogRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivityLogForWithoutProjectUsingPOST(activityLogRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createActivityLog
         * @param {ActivityLogRequest} activityLogRequest activityLogRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivityLogUsingPOST(activityLogRequest: ActivityLogRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivityLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivityLogUsingPOST(activityLogRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateErrorSummaryReport
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateErrorSummaryReportUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ErrorSummaryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateErrorSummaryReportUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getActivitySummaryByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivitySummaryByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActivitySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivitySummaryByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllActivityLogByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActivityLogByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActivityLogByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllActivityLogBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActivityLogBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActivityLogBySessionUuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllActivityLogByUserName
         * @param {string} userName userName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActivityLogByUserNameUsingGET(userName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActivityLogByUserNameUsingGET(userName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllActivityLogs
         * @param {string} all all
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllActivityLogsUsingGET(all: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActivityLogResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllActivityLogsUsingGET(all, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ActivityLogControllerApi - factory interface
 * @export
 */
export const ActivityLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createActivityLogForErrorHandling
         * @param {string} originalErrorCode originalErrorCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLogForErrorHandlingUsingPOST(originalErrorCode: string, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.createActivityLogForErrorHandlingUsingPOST(originalErrorCode, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createActivityLogForWithoutProject
         * @param {ActivityLogRequest} activityLogRequest activityLogRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLogForWithoutProjectUsingPOST(activityLogRequest: ActivityLogRequest, authorization?: string, options?: any): AxiosPromise<ActivityLogResponse> {
            return localVarFp.createActivityLogForWithoutProjectUsingPOST(activityLogRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createActivityLog
         * @param {ActivityLogRequest} activityLogRequest activityLogRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLogUsingPOST(activityLogRequest: ActivityLogRequest, authorization?: string, options?: any): AxiosPromise<ActivityLogResponse> {
            return localVarFp.createActivityLogUsingPOST(activityLogRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateErrorSummaryReport
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateErrorSummaryReportUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ErrorSummaryResponse>> {
            return localVarFp.generateErrorSummaryReportUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getActivitySummaryByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivitySummaryByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<ActivitySummaryResponse> {
            return localVarFp.getActivitySummaryByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllActivityLogByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<ActivityLogResponse>> {
            return localVarFp.getAllActivityLogByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllActivityLogBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<Array<ActivityLogResponse>> {
            return localVarFp.getAllActivityLogBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllActivityLogByUserName
         * @param {string} userName userName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogByUserNameUsingGET(userName: string, authorization?: string, options?: any): AxiosPromise<Array<ActivityLogResponse>> {
            return localVarFp.getAllActivityLogByUserNameUsingGET(userName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllActivityLogs
         * @param {string} all all
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllActivityLogsUsingGET(all: string, authorization?: string, options?: any): AxiosPromise<Array<ActivityLogResponse>> {
            return localVarFp.getAllActivityLogsUsingGET(all, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityLogControllerApi - object-oriented interface
 * @export
 * @class ActivityLogControllerApi
 * @extends {BaseAPI}
 */
export class ActivityLogControllerApi extends BaseAPI {
    /**
     * 
     * @summary createActivityLogForErrorHandling
     * @param {string} originalErrorCode originalErrorCode
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public createActivityLogForErrorHandlingUsingPOST(originalErrorCode: string, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).createActivityLogForErrorHandlingUsingPOST(originalErrorCode, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createActivityLogForWithoutProject
     * @param {ActivityLogRequest} activityLogRequest activityLogRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public createActivityLogForWithoutProjectUsingPOST(activityLogRequest: ActivityLogRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).createActivityLogForWithoutProjectUsingPOST(activityLogRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createActivityLog
     * @param {ActivityLogRequest} activityLogRequest activityLogRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public createActivityLogUsingPOST(activityLogRequest: ActivityLogRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).createActivityLogUsingPOST(activityLogRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateErrorSummaryReport
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public generateErrorSummaryReportUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).generateErrorSummaryReportUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getActivitySummaryByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public getActivitySummaryByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).getActivitySummaryByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllActivityLogByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public getAllActivityLogByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).getAllActivityLogByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllActivityLogBySessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public getAllActivityLogBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).getAllActivityLogBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllActivityLogByUserName
     * @param {string} userName userName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public getAllActivityLogByUserNameUsingGET(userName: string, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).getAllActivityLogByUserNameUsingGET(userName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllActivityLogs
     * @param {string} all all
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogControllerApi
     */
    public getAllActivityLogsUsingGET(all: string, authorization?: string, options?: AxiosRequestConfig) {
        return ActivityLogControllerApiFp(this.configuration).getAllActivityLogsUsingGET(all, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AiLogControllerApi - axios parameter creator
 * @export
 */
export const AiLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createOrUpdateAILog
         * @param {AILogRequestDTO} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateAILogUsingPOST: async (request: AILogRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('createOrUpdateAILogUsingPOST', 'request', request)
            const localVarPath = `/ai-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteAILog
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAILogUsingDELETE: async (alignedElementDesignParametersId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('deleteAILogUsingDELETE', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/ai-logs/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAILogByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAILogByAlignedElementDesignParametersIdUsingGET: async (alignedElementDesignParametersId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getAILogByAlignedElementDesignParametersIdUsingGET', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/ai-logs/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllAILogs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAILogsUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiLogControllerApi - functional programming interface
 * @export
 */
export const AiLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createOrUpdateAILog
         * @param {AILogRequestDTO} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateAILogUsingPOST(request: AILogRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AILog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateAILogUsingPOST(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteAILog
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAILogUsingDELETE(alignedElementDesignParametersId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAILogUsingDELETE(alignedElementDesignParametersId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAILogByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAILogByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AILog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAILogByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllAILogs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAILogsUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AILog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAILogsUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AiLogControllerApi - factory interface
 * @export
 */
export const AiLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createOrUpdateAILog
         * @param {AILogRequestDTO} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateAILogUsingPOST(request: AILogRequestDTO, options?: any): AxiosPromise<AILog> {
            return localVarFp.createOrUpdateAILogUsingPOST(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteAILog
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAILogUsingDELETE(alignedElementDesignParametersId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAILogUsingDELETE(alignedElementDesignParametersId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAILogByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAILogByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, options?: any): AxiosPromise<AILog> {
            return localVarFp.getAILogByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllAILogs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAILogsUsingGET(options?: any): AxiosPromise<Array<AILog>> {
            return localVarFp.getAllAILogsUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiLogControllerApi - object-oriented interface
 * @export
 * @class AiLogControllerApi
 * @extends {BaseAPI}
 */
export class AiLogControllerApi extends BaseAPI {
    /**
     * 
     * @summary createOrUpdateAILog
     * @param {AILogRequestDTO} request request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiLogControllerApi
     */
    public createOrUpdateAILogUsingPOST(request: AILogRequestDTO, options?: AxiosRequestConfig) {
        return AiLogControllerApiFp(this.configuration).createOrUpdateAILogUsingPOST(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteAILog
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiLogControllerApi
     */
    public deleteAILogUsingDELETE(alignedElementDesignParametersId: number, options?: AxiosRequestConfig) {
        return AiLogControllerApiFp(this.configuration).deleteAILogUsingDELETE(alignedElementDesignParametersId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAILogByAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiLogControllerApi
     */
    public getAILogByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, options?: AxiosRequestConfig) {
        return AiLogControllerApiFp(this.configuration).getAILogByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllAILogs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiLogControllerApi
     */
    public getAllAILogsUsingGET(options?: AxiosRequestConfig) {
        return AiLogControllerApiFp(this.configuration).getAllAILogsUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AlignmentAoiControllerApi - axios parameter creator
 * @export
 */
export const AlignmentAoiControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary updateProjectAlignmentAOI
         * @param {AlignmentAOIRequest} alignmentAOIJson alignmentAOIJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectAlignmentAOIUsingPOST: async (alignmentAOIJson: AlignmentAOIRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentAOIJson' is not null or undefined
            assertParamExists('updateProjectAlignmentAOIUsingPOST', 'alignmentAOIJson', alignmentAOIJson)
            const localVarPath = `/alignmentAOI/updateShape`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentAOIJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlignmentAoiControllerApi - functional programming interface
 * @export
 */
export const AlignmentAoiControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlignmentAoiControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary updateProjectAlignmentAOI
         * @param {AlignmentAOIRequest} alignmentAOIJson alignmentAOIJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectAlignmentAOIUsingPOST(alignmentAOIJson: AlignmentAOIRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentAOIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectAlignmentAOIUsingPOST(alignmentAOIJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AlignmentAoiControllerApi - factory interface
 * @export
 */
export const AlignmentAoiControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlignmentAoiControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary updateProjectAlignmentAOI
         * @param {AlignmentAOIRequest} alignmentAOIJson alignmentAOIJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectAlignmentAOIUsingPOST(alignmentAOIJson: AlignmentAOIRequest, authorization?: string, options?: any): AxiosPromise<AlignmentAOIResponse> {
            return localVarFp.updateProjectAlignmentAOIUsingPOST(alignmentAOIJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlignmentAoiControllerApi - object-oriented interface
 * @export
 * @class AlignmentAoiControllerApi
 * @extends {BaseAPI}
 */
export class AlignmentAoiControllerApi extends BaseAPI {
    /**
     * 
     * @summary updateProjectAlignmentAOI
     * @param {AlignmentAOIRequest} alignmentAOIJson alignmentAOIJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentAoiControllerApi
     */
    public updateProjectAlignmentAOIUsingPOST(alignmentAOIJson: AlignmentAOIRequest, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentAoiControllerApiFp(this.configuration).updateProjectAlignmentAOIUsingPOST(alignmentAOIJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AlignmentControllerApi - axios parameter creator
 * @export
 */
export const AlignmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary addDesignElementJsonForAlignment
         * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDesignElementJsonForAlignmentUsingPOST: async (createAlignmentJson: AlignmentDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAlignmentJson' is not null or undefined
            assertParamExists('addDesignElementJsonForAlignmentUsingPOST', 'createAlignmentJson', createAlignmentJson)
            const localVarPath = `/alignment/addDesignElementJsonForAlignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAlignmentJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary applyDefaultCurvesToAlignment
         * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDefaultCurvesToAlignmentUsingPOST: async (createAlignmentJson: AlignmentDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAlignmentJson' is not null or undefined
            assertParamExists('applyDefaultCurvesToAlignmentUsingPOST', 'createAlignmentJson', createAlignmentJson)
            const localVarPath = `/alignment/applyDefaultCurvesToAlignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAlignmentJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary duplicateAlignments
         * @param {AlignmentCopyParmDTO} duplicateAlignmentJson duplicateAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateAlignmentsUsingPOST: async (duplicateAlignmentJson: AlignmentCopyParmDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duplicateAlignmentJson' is not null or undefined
            assertParamExists('duplicateAlignmentsUsingPOST', 'duplicateAlignmentJson', duplicateAlignmentJson)
            const localVarPath = `/alignment/duplicateAlignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicateAlignmentJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary exportAlignmentsToCSV
         * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAlignmentsToCSVUsingPOST: async (exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportAlignmentsJson' is not null or undefined
            assertParamExists('exportAlignmentsToCSVUsingPOST', 'exportAlignmentsJson', exportAlignmentsJson)
            const localVarPath = `/alignment/exportAlignmentsToCSV`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportAlignmentsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary exportAlignmentsToCSV_v2
         * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAlignmentsToCSVV2UsingPOST: async (exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportAlignmentsJson' is not null or undefined
            assertParamExists('exportAlignmentsToCSVV2UsingPOST', 'exportAlignmentsJson', exportAlignmentsJson)
            const localVarPath = `/alignment/exportAlignmentsToCSV/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportAlignmentsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getXYByAlignmentAndStationName
         * @param {AlignmentCoordinateRequest} alignmentCoordinateRequest alignmentCoordinateRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXYByAlignmentAndStationNameUsingPOST: async (alignmentCoordinateRequest: AlignmentCoordinateRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentCoordinateRequest' is not null or undefined
            assertParamExists('getXYByAlignmentAndStationNameUsingPOST', 'alignmentCoordinateRequest', alignmentCoordinateRequest)
            const localVarPath = `/alignment/getXYByAlignmentAndStationName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentCoordinateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary renameAlignmentName
         * @param {AlignmentRenameRequest} renameAlignmentNameJson renameAlignmentNameJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameAlignmentNameUsingPOST: async (renameAlignmentNameJson: AlignmentRenameRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'renameAlignmentNameJson' is not null or undefined
            assertParamExists('renameAlignmentNameUsingPOST', 'renameAlignmentNameJson', renameAlignmentNameJson)
            const localVarPath = `/alignment/renameAlignmentName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameAlignmentNameJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlignmentControllerApi - functional programming interface
 * @export
 */
export const AlignmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlignmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary addDesignElementJsonForAlignment
         * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDesignElementJsonForAlignmentUsingPOST(createAlignmentJson: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDesignElementJsonForAlignmentUsingPOST(createAlignmentJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary applyDefaultCurvesToAlignment
         * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyDefaultCurvesToAlignmentUsingPOST(createAlignmentJson: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyDefaultCurvesToAlignmentUsingPOST(createAlignmentJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary duplicateAlignments
         * @param {AlignmentCopyParmDTO} duplicateAlignmentJson duplicateAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateAlignmentsUsingPOST(duplicateAlignmentJson: AlignmentCopyParmDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateAlignmentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateAlignmentsUsingPOST(duplicateAlignmentJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary exportAlignmentsToCSV
         * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAlignmentsToCSVUsingPOST(exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAlignmentsToCSVUsingPOST(exportAlignmentsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary exportAlignmentsToCSV_v2
         * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAlignmentsToCSVV2UsingPOST(exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentsToCSVResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAlignmentsToCSVV2UsingPOST(exportAlignmentsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getXYByAlignmentAndStationName
         * @param {AlignmentCoordinateRequest} alignmentCoordinateRequest alignmentCoordinateRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getXYByAlignmentAndStationNameUsingPOST(alignmentCoordinateRequest: AlignmentCoordinateRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentCoordinateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getXYByAlignmentAndStationNameUsingPOST(alignmentCoordinateRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary renameAlignmentName
         * @param {AlignmentRenameRequest} renameAlignmentNameJson renameAlignmentNameJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameAlignmentNameUsingPOST(renameAlignmentNameJson: AlignmentRenameRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentRenameRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameAlignmentNameUsingPOST(renameAlignmentNameJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AlignmentControllerApi - factory interface
 * @export
 */
export const AlignmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlignmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary addDesignElementJsonForAlignment
         * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDesignElementJsonForAlignmentUsingPOST(createAlignmentJson: AlignmentDTO, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.addDesignElementJsonForAlignmentUsingPOST(createAlignmentJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary applyDefaultCurvesToAlignment
         * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyDefaultCurvesToAlignmentUsingPOST(createAlignmentJson: AlignmentDTO, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.applyDefaultCurvesToAlignmentUsingPOST(createAlignmentJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary duplicateAlignments
         * @param {AlignmentCopyParmDTO} duplicateAlignmentJson duplicateAlignmentJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateAlignmentsUsingPOST(duplicateAlignmentJson: AlignmentCopyParmDTO, authorization?: string, options?: any): AxiosPromise<DuplicateAlignmentsResponse> {
            return localVarFp.duplicateAlignmentsUsingPOST(duplicateAlignmentJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary exportAlignmentsToCSV
         * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAlignmentsToCSVUsingPOST(exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportAlignmentsToCSVUsingPOST(exportAlignmentsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary exportAlignmentsToCSV_v2
         * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAlignmentsToCSVV2UsingPOST(exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options?: any): AxiosPromise<AlignmentsToCSVResponse> {
            return localVarFp.exportAlignmentsToCSVV2UsingPOST(exportAlignmentsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getXYByAlignmentAndStationName
         * @param {AlignmentCoordinateRequest} alignmentCoordinateRequest alignmentCoordinateRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getXYByAlignmentAndStationNameUsingPOST(alignmentCoordinateRequest: AlignmentCoordinateRequest, authorization?: string, options?: any): AxiosPromise<AlignmentCoordinateResponse> {
            return localVarFp.getXYByAlignmentAndStationNameUsingPOST(alignmentCoordinateRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary renameAlignmentName
         * @param {AlignmentRenameRequest} renameAlignmentNameJson renameAlignmentNameJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameAlignmentNameUsingPOST(renameAlignmentNameJson: AlignmentRenameRequest, authorization?: string, options?: any): AxiosPromise<AlignmentRenameRequest> {
            return localVarFp.renameAlignmentNameUsingPOST(renameAlignmentNameJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlignmentControllerApi - object-oriented interface
 * @export
 * @class AlignmentControllerApi
 * @extends {BaseAPI}
 */
export class AlignmentControllerApi extends BaseAPI {
    /**
     * 
     * @summary addDesignElementJsonForAlignment
     * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentControllerApi
     */
    public addDesignElementJsonForAlignmentUsingPOST(createAlignmentJson: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentControllerApiFp(this.configuration).addDesignElementJsonForAlignmentUsingPOST(createAlignmentJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary applyDefaultCurvesToAlignment
     * @param {AlignmentDTO} createAlignmentJson createAlignmentJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentControllerApi
     */
    public applyDefaultCurvesToAlignmentUsingPOST(createAlignmentJson: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentControllerApiFp(this.configuration).applyDefaultCurvesToAlignmentUsingPOST(createAlignmentJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary duplicateAlignments
     * @param {AlignmentCopyParmDTO} duplicateAlignmentJson duplicateAlignmentJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentControllerApi
     */
    public duplicateAlignmentsUsingPOST(duplicateAlignmentJson: AlignmentCopyParmDTO, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentControllerApiFp(this.configuration).duplicateAlignmentsUsingPOST(duplicateAlignmentJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary exportAlignmentsToCSV
     * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentControllerApi
     */
    public exportAlignmentsToCSVUsingPOST(exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentControllerApiFp(this.configuration).exportAlignmentsToCSVUsingPOST(exportAlignmentsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary exportAlignmentsToCSV_v2
     * @param {Array<AlignmentExportRequest>} exportAlignmentsJson exportAlignmentsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentControllerApi
     */
    public exportAlignmentsToCSVV2UsingPOST(exportAlignmentsJson: Array<AlignmentExportRequest>, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentControllerApiFp(this.configuration).exportAlignmentsToCSVV2UsingPOST(exportAlignmentsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getXYByAlignmentAndStationName
     * @param {AlignmentCoordinateRequest} alignmentCoordinateRequest alignmentCoordinateRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentControllerApi
     */
    public getXYByAlignmentAndStationNameUsingPOST(alignmentCoordinateRequest: AlignmentCoordinateRequest, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentControllerApiFp(this.configuration).getXYByAlignmentAndStationNameUsingPOST(alignmentCoordinateRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary renameAlignmentName
     * @param {AlignmentRenameRequest} renameAlignmentNameJson renameAlignmentNameJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlignmentControllerApi
     */
    public renameAlignmentNameUsingPOST(renameAlignmentNameJson: AlignmentRenameRequest, authorization?: string, options?: AxiosRequestConfig) {
        return AlignmentControllerApiFp(this.configuration).renameAlignmentNameUsingPOST(renameAlignmentNameJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiBatchTaskControllerApi - axios parameter creator
 * @export
 */
export const ApiBatchTaskControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel the random episodes generating process for a given waterway
         * @param {number} waterwayId waterwayId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelUsingPOST: async (waterwayId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwayId' is not null or undefined
            assertParamExists('cancelUsingPOST', 'waterwayId', waterwayId)
            const localVarPath = `/batch-api/cancel/{waterwayId}`
                .replace(`{${"waterwayId"}}`, encodeURIComponent(String(waterwayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Monitoring the episode generation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayloadTrackersUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/batch-api/episodeTrackers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resume the random episodes generating process for a given waterway
         * @param {number} waterwayId waterwayId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeUsingPOST: async (waterwayId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwayId' is not null or undefined
            assertParamExists('resumeUsingPOST', 'waterwayId', waterwayId)
            const localVarPath = `/batch-api/resume/{waterwayId}`
                .replace(`{${"waterwayId"}}`, encodeURIComponent(String(waterwayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate random episodes provided a list of waterway\'s aligned element ids
         * @param {Array<WaterwayEpisodeBatchProcessRequest>} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startBatchUsingPOST: async (request: Array<WaterwayEpisodeBatchProcessRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('startBatchUsingPOST', 'request', request)
            const localVarPath = `/batch-api/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiBatchTaskControllerApi - functional programming interface
 * @export
 */
export const ApiBatchTaskControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiBatchTaskControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel the random episodes generating process for a given waterway
         * @param {number} waterwayId waterwayId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelUsingPOST(waterwayId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelUsingPOST(waterwayId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Monitoring the episode generation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllPayloadTrackersUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EpisodeTracker>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllPayloadTrackersUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resume the random episodes generating process for a given waterway
         * @param {number} waterwayId waterwayId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeUsingPOST(waterwayId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeUsingPOST(waterwayId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate random episodes provided a list of waterway\'s aligned element ids
         * @param {Array<WaterwayEpisodeBatchProcessRequest>} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startBatchUsingPOST(request: Array<WaterwayEpisodeBatchProcessRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startBatchUsingPOST(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiBatchTaskControllerApi - factory interface
 * @export
 */
export const ApiBatchTaskControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiBatchTaskControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel the random episodes generating process for a given waterway
         * @param {number} waterwayId waterwayId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelUsingPOST(waterwayId: number, options?: any): AxiosPromise<string> {
            return localVarFp.cancelUsingPOST(waterwayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Monitoring the episode generation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllPayloadTrackersUsingGET(options?: any): AxiosPromise<Array<EpisodeTracker>> {
            return localVarFp.getAllPayloadTrackersUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resume the random episodes generating process for a given waterway
         * @param {number} waterwayId waterwayId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeUsingPOST(waterwayId: number, options?: any): AxiosPromise<string> {
            return localVarFp.resumeUsingPOST(waterwayId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate random episodes provided a list of waterway\'s aligned element ids
         * @param {Array<WaterwayEpisodeBatchProcessRequest>} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startBatchUsingPOST(request: Array<WaterwayEpisodeBatchProcessRequest>, options?: any): AxiosPromise<string> {
            return localVarFp.startBatchUsingPOST(request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiBatchTaskControllerApi - object-oriented interface
 * @export
 * @class ApiBatchTaskControllerApi
 * @extends {BaseAPI}
 */
export class ApiBatchTaskControllerApi extends BaseAPI {
    /**
     * 
     * @summary Cancel the random episodes generating process for a given waterway
     * @param {number} waterwayId waterwayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiBatchTaskControllerApi
     */
    public cancelUsingPOST(waterwayId: number, options?: AxiosRequestConfig) {
        return ApiBatchTaskControllerApiFp(this.configuration).cancelUsingPOST(waterwayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Monitoring the episode generation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiBatchTaskControllerApi
     */
    public getAllPayloadTrackersUsingGET(options?: AxiosRequestConfig) {
        return ApiBatchTaskControllerApiFp(this.configuration).getAllPayloadTrackersUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resume the random episodes generating process for a given waterway
     * @param {number} waterwayId waterwayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiBatchTaskControllerApi
     */
    public resumeUsingPOST(waterwayId: number, options?: AxiosRequestConfig) {
        return ApiBatchTaskControllerApiFp(this.configuration).resumeUsingPOST(waterwayId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate random episodes provided a list of waterway\'s aligned element ids
     * @param {Array<WaterwayEpisodeBatchProcessRequest>} request request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiBatchTaskControllerApi
     */
    public startBatchUsingPOST(request: Array<WaterwayEpisodeBatchProcessRequest>, options?: AxiosRequestConfig) {
        return ApiBatchTaskControllerApiFp(this.configuration).startBatchUsingPOST(request, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BaseControllerApi - axios parameter creator
 * @export
 */
export const BaseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BaseControllerApi - functional programming interface
 * @export
 */
export const BaseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BaseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async baseSvcUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.baseSvcUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BaseControllerApi - factory interface
 * @export
 */
export const BaseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BaseControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary baseSvc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        baseSvcUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.baseSvcUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BaseControllerApi - object-oriented interface
 * @export
 * @class BaseControllerApi
 * @extends {BaseAPI}
 */
export class BaseControllerApi extends BaseAPI {
    /**
     * 
     * @summary baseSvc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BaseControllerApi
     */
    public baseSvcUsingGET(options?: AxiosRequestConfig) {
        return BaseControllerApiFp(this.configuration).baseSvcUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BreaklineControllerApi - axios parameter creator
 * @export
 */
export const BreaklineControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createBreakLine
         * @param {BreaklineRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBreakLineUsingPOST: async (request: BreaklineRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('createBreakLineUsingPOST', 'request', request)
            const localVarPath = `/surface/createBreakLine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteBreakline
         * @param {string} breaklineId breaklineId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBreaklineUsingPOST: async (breaklineId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'breaklineId' is not null or undefined
            assertParamExists('deleteBreaklineUsingPOST', 'breaklineId', breaklineId)
            const localVarPath = `/surface/deleteBreakline/{breaklineId}`
                .replace(`{${"breaklineId"}}`, encodeURIComponent(String(breaklineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary findAllBreaklineBySurfaceDefId
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBreaklineBySurfaceDefIdUsingGET: async (surfaceDefId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceDefId' is not null or undefined
            assertParamExists('findAllBreaklineBySurfaceDefIdUsingGET', 'surfaceDefId', surfaceDefId)
            const localVarPath = `/surface/findAllBreaklineBySurfaceDefId/{surfaceDefId}`
                .replace(`{${"surfaceDefId"}}`, encodeURIComponent(String(surfaceDefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BreaklineControllerApi - functional programming interface
 * @export
 */
export const BreaklineControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BreaklineControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createBreakLine
         * @param {BreaklineRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBreakLineUsingPOST(request: BreaklineRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreaklineResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBreakLineUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteBreakline
         * @param {string} breaklineId breaklineId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBreaklineUsingPOST(breaklineId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreaklineResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBreaklineUsingPOST(breaklineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary findAllBreaklineBySurfaceDefId
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllBreaklineBySurfaceDefIdUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreaklineResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllBreaklineBySurfaceDefIdUsingGET(surfaceDefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BreaklineControllerApi - factory interface
 * @export
 */
export const BreaklineControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BreaklineControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createBreakLine
         * @param {BreaklineRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBreakLineUsingPOST(request: BreaklineRequestDTO, authorization?: string, options?: any): AxiosPromise<BreaklineResponseDTO> {
            return localVarFp.createBreakLineUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteBreakline
         * @param {string} breaklineId breaklineId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBreaklineUsingPOST(breaklineId: string, authorization?: string, options?: any): AxiosPromise<BreaklineResponse> {
            return localVarFp.deleteBreaklineUsingPOST(breaklineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary findAllBreaklineBySurfaceDefId
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllBreaklineBySurfaceDefIdUsingGET(surfaceDefId: number, authorization?: string, options?: any): AxiosPromise<BreaklineResponseDTO> {
            return localVarFp.findAllBreaklineBySurfaceDefIdUsingGET(surfaceDefId, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BreaklineControllerApi - object-oriented interface
 * @export
 * @class BreaklineControllerApi
 * @extends {BaseAPI}
 */
export class BreaklineControllerApi extends BaseAPI {
    /**
     * 
     * @summary createBreakLine
     * @param {BreaklineRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BreaklineControllerApi
     */
    public createBreakLineUsingPOST(request: BreaklineRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return BreaklineControllerApiFp(this.configuration).createBreakLineUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteBreakline
     * @param {string} breaklineId breaklineId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BreaklineControllerApi
     */
    public deleteBreaklineUsingPOST(breaklineId: string, authorization?: string, options?: AxiosRequestConfig) {
        return BreaklineControllerApiFp(this.configuration).deleteBreaklineUsingPOST(breaklineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary findAllBreaklineBySurfaceDefId
     * @param {number} surfaceDefId surfaceDefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BreaklineControllerApi
     */
    public findAllBreaklineBySurfaceDefIdUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig) {
        return BreaklineControllerApiFp(this.configuration).findAllBreaklineBySurfaceDefIdUsingGET(surfaceDefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CrossSlopeCrudControllerApi - axios parameter creator
 * @export
 */
export const CrossSlopeCrudControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createCrossSlopeStations
         * @param {Array<CrossSlopeStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopeStationsUsingPOST: async (input: Array<CrossSlopeStationDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('createCrossSlopeStationsUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/createCrossSlopeStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createCrossSlopes
         * @param {Array<CrossSlopeDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopesUsingPOST: async (input: Array<CrossSlopeDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('createCrossSlopesUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/createCrossSlopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteCrossSlopeStationsByCrossSlopeId
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeStationsByCrossSlopeIdUsingPOST: async (crossSlopeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeId' is not null or undefined
            assertParamExists('deleteCrossSlopeStationsByCrossSlopeIdUsingPOST', 'crossSlopeId', crossSlopeId)
            const localVarPath = `/stationOffset/deleteCrossSlopeStationsByCrossSlopeId/{crossSlopeId}`
                .replace(`{${"crossSlopeId"}}`, encodeURIComponent(String(crossSlopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteCrossSlopeStationsByIds
         * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeStationsByIdsUsingPOST: async (crossSlopeStationIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeStationIds' is not null or undefined
            assertParamExists('deleteCrossSlopeStationsByIdsUsingPOST', 'crossSlopeStationIds', crossSlopeStationIds)
            const localVarPath = `/stationOffset/deleteCrossSlopeStationsByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeStationIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteCrossSlopesByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopesByAlignmentIdUsingPOST: async (alignmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentId' is not null or undefined
            assertParamExists('deleteCrossSlopesByAlignmentIdUsingPOST', 'alignmentId', alignmentId)
            const localVarPath = `/stationOffset/deleteCrossSlopesByAlignmentId/{alignmentId}`
                .replace(`{${"alignmentId"}}`, encodeURIComponent(String(alignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteCrossSlopesByIds
         * @param {Array<number>} crossSlopeIds crossSlopeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopesByIdsUsingPOST: async (crossSlopeIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeIds' is not null or undefined
            assertParamExists('deleteCrossSlopesByIdsUsingPOST', 'crossSlopeIds', crossSlopeIds)
            const localVarPath = `/stationOffset/deleteCrossSlopesByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getClossSlopesByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClossSlopesByAlignmentIdUsingGET: async (alignmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentId' is not null or undefined
            assertParamExists('getClossSlopesByAlignmentIdUsingGET', 'alignmentId', alignmentId)
            const localVarPath = `/stationOffset/getCrossSlopesByAlignmentId/{alignmentId}`
                .replace(`{${"alignmentId"}}`, encodeURIComponent(String(alignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getClossSlopesByIds
         * @param {Array<number>} crossSlopeIds crossSlopeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClossSlopesByIdsUsingGET: async (crossSlopeIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeIds' is not null or undefined
            assertParamExists('getClossSlopesByIdsUsingGET', 'crossSlopeIds', crossSlopeIds)
            const localVarPath = `/stationOffset/getCrossSlopesByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCrossSlopeStationsByCrossSlopeId
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeStationsByCrossSlopeIdUsingGET: async (crossSlopeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeId' is not null or undefined
            assertParamExists('getCrossSlopeStationsByCrossSlopeIdUsingGET', 'crossSlopeId', crossSlopeId)
            const localVarPath = `/stationOffset/getCrossSlopeStationsByCrossSlopeId/{crossSlopeId}`
                .replace(`{${"crossSlopeId"}}`, encodeURIComponent(String(crossSlopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCrossSlopeStationsByIds
         * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeStationsByIdsUsingGET: async (crossSlopeStationIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeStationIds' is not null or undefined
            assertParamExists('getCrossSlopeStationsByIdsUsingGET', 'crossSlopeStationIds', crossSlopeStationIds)
            const localVarPath = `/stationOffset/getCrossSlopeStationsByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeStationIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateCrossSlopeStation
         * @param {Array<CrossSlopeStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopeStationUsingPOST: async (input: Array<CrossSlopeStationDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('updateCrossSlopeStationUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/updateCrossSlopeStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateCrossSlopes
         * @param {Array<CrossSlopeDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopesUsingPOST: async (input: Array<CrossSlopeDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('updateCrossSlopesUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/updateCrossSlopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CrossSlopeCrudControllerApi - functional programming interface
 * @export
 */
export const CrossSlopeCrudControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CrossSlopeCrudControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createCrossSlopeStations
         * @param {Array<CrossSlopeStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCrossSlopeStationsUsingPOST(input: Array<CrossSlopeStationDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCrossSlopeStationsUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createCrossSlopes
         * @param {Array<CrossSlopeDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCrossSlopesUsingPOST(input: Array<CrossSlopeDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCrossSlopesUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteCrossSlopeStationsByCrossSlopeId
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCrossSlopeStationsByCrossSlopeIdUsingPOST(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCrossSlopeStationsByCrossSlopeIdUsingPOST(crossSlopeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteCrossSlopeStationsByIds
         * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCrossSlopeStationsByIdsUsingPOST(crossSlopeStationIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCrossSlopeStationsByIdsUsingPOST(crossSlopeStationIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteCrossSlopesByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCrossSlopesByAlignmentIdUsingPOST(alignmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCrossSlopesByAlignmentIdUsingPOST(alignmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteCrossSlopesByIds
         * @param {Array<number>} crossSlopeIds crossSlopeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCrossSlopesByIdsUsingPOST(crossSlopeIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCrossSlopesByIdsUsingPOST(crossSlopeIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getClossSlopesByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClossSlopesByAlignmentIdUsingGET(alignmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClossSlopesByAlignmentIdUsingGET(alignmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getClossSlopesByIds
         * @param {Array<number>} crossSlopeIds crossSlopeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClossSlopesByIdsUsingGET(crossSlopeIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClossSlopesByIdsUsingGET(crossSlopeIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getCrossSlopeStationsByCrossSlopeId
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrossSlopeStationsByCrossSlopeIdUsingGET(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrossSlopeStationsByCrossSlopeIdUsingGET(crossSlopeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getCrossSlopeStationsByIds
         * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrossSlopeStationsByIdsUsingGET(crossSlopeStationIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrossSlopeStationsByIdsUsingGET(crossSlopeStationIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateCrossSlopeStation
         * @param {Array<CrossSlopeStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCrossSlopeStationUsingPOST(input: Array<CrossSlopeStationDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCrossSlopeStationUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateCrossSlopes
         * @param {Array<CrossSlopeDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCrossSlopesUsingPOST(input: Array<CrossSlopeDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSlopeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCrossSlopesUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CrossSlopeCrudControllerApi - factory interface
 * @export
 */
export const CrossSlopeCrudControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CrossSlopeCrudControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createCrossSlopeStations
         * @param {Array<CrossSlopeStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopeStationsUsingPOST(input: Array<CrossSlopeStationDTO>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeStationDTO>> {
            return localVarFp.createCrossSlopeStationsUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createCrossSlopes
         * @param {Array<CrossSlopeDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopesUsingPOST(input: Array<CrossSlopeDTO>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeDTO>> {
            return localVarFp.createCrossSlopesUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteCrossSlopeStationsByCrossSlopeId
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeStationsByCrossSlopeIdUsingPOST(crossSlopeId: number, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeStationDTO>> {
            return localVarFp.deleteCrossSlopeStationsByCrossSlopeIdUsingPOST(crossSlopeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteCrossSlopeStationsByIds
         * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeStationsByIdsUsingPOST(crossSlopeStationIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeStationDTO>> {
            return localVarFp.deleteCrossSlopeStationsByIdsUsingPOST(crossSlopeStationIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteCrossSlopesByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopesByAlignmentIdUsingPOST(alignmentId: number, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeDTO>> {
            return localVarFp.deleteCrossSlopesByAlignmentIdUsingPOST(alignmentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteCrossSlopesByIds
         * @param {Array<number>} crossSlopeIds crossSlopeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopesByIdsUsingPOST(crossSlopeIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeDTO>> {
            return localVarFp.deleteCrossSlopesByIdsUsingPOST(crossSlopeIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getClossSlopesByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClossSlopesByAlignmentIdUsingGET(alignmentId: number, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeDTO>> {
            return localVarFp.getClossSlopesByAlignmentIdUsingGET(alignmentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getClossSlopesByIds
         * @param {Array<number>} crossSlopeIds crossSlopeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClossSlopesByIdsUsingGET(crossSlopeIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeDTO>> {
            return localVarFp.getClossSlopesByIdsUsingGET(crossSlopeIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCrossSlopeStationsByCrossSlopeId
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeStationsByCrossSlopeIdUsingGET(crossSlopeId: number, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeStationDTO>> {
            return localVarFp.getCrossSlopeStationsByCrossSlopeIdUsingGET(crossSlopeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCrossSlopeStationsByIds
         * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeStationsByIdsUsingGET(crossSlopeStationIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeStationDTO>> {
            return localVarFp.getCrossSlopeStationsByIdsUsingGET(crossSlopeStationIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateCrossSlopeStation
         * @param {Array<CrossSlopeStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopeStationUsingPOST(input: Array<CrossSlopeStationDTO>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeStationDTO>> {
            return localVarFp.updateCrossSlopeStationUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateCrossSlopes
         * @param {Array<CrossSlopeDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopesUsingPOST(input: Array<CrossSlopeDTO>, authorization?: string, options?: any): AxiosPromise<Array<CrossSlopeDTO>> {
            return localVarFp.updateCrossSlopesUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CrossSlopeCrudControllerApi - object-oriented interface
 * @export
 * @class CrossSlopeCrudControllerApi
 * @extends {BaseAPI}
 */
export class CrossSlopeCrudControllerApi extends BaseAPI {
    /**
     * 
     * @summary createCrossSlopeStations
     * @param {Array<CrossSlopeStationDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public createCrossSlopeStationsUsingPOST(input: Array<CrossSlopeStationDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).createCrossSlopeStationsUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createCrossSlopes
     * @param {Array<CrossSlopeDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public createCrossSlopesUsingPOST(input: Array<CrossSlopeDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).createCrossSlopesUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteCrossSlopeStationsByCrossSlopeId
     * @param {number} crossSlopeId crossSlopeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public deleteCrossSlopeStationsByCrossSlopeIdUsingPOST(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).deleteCrossSlopeStationsByCrossSlopeIdUsingPOST(crossSlopeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteCrossSlopeStationsByIds
     * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public deleteCrossSlopeStationsByIdsUsingPOST(crossSlopeStationIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).deleteCrossSlopeStationsByIdsUsingPOST(crossSlopeStationIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteCrossSlopesByAlignmentId
     * @param {number} alignmentId alignmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public deleteCrossSlopesByAlignmentIdUsingPOST(alignmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).deleteCrossSlopesByAlignmentIdUsingPOST(alignmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteCrossSlopesByIds
     * @param {Array<number>} crossSlopeIds crossSlopeIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public deleteCrossSlopesByIdsUsingPOST(crossSlopeIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).deleteCrossSlopesByIdsUsingPOST(crossSlopeIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getClossSlopesByAlignmentId
     * @param {number} alignmentId alignmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public getClossSlopesByAlignmentIdUsingGET(alignmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).getClossSlopesByAlignmentIdUsingGET(alignmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getClossSlopesByIds
     * @param {Array<number>} crossSlopeIds crossSlopeIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public getClossSlopesByIdsUsingGET(crossSlopeIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).getClossSlopesByIdsUsingGET(crossSlopeIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCrossSlopeStationsByCrossSlopeId
     * @param {number} crossSlopeId crossSlopeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public getCrossSlopeStationsByCrossSlopeIdUsingGET(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).getCrossSlopeStationsByCrossSlopeIdUsingGET(crossSlopeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCrossSlopeStationsByIds
     * @param {Array<number>} crossSlopeStationIds crossSlopeStationIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public getCrossSlopeStationsByIdsUsingGET(crossSlopeStationIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).getCrossSlopeStationsByIdsUsingGET(crossSlopeStationIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateCrossSlopeStation
     * @param {Array<CrossSlopeStationDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public updateCrossSlopeStationUsingPOST(input: Array<CrossSlopeStationDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).updateCrossSlopeStationUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateCrossSlopes
     * @param {Array<CrossSlopeDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossSlopeCrudControllerApi
     */
    public updateCrossSlopesUsingPOST(input: Array<CrossSlopeDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return CrossSlopeCrudControllerApiFp(this.configuration).updateCrossSlopesUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DemResourcesControllerApi - axios parameter creator
 * @export
 */
export const DemResourcesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createDEMResource
         * @param {DemResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDEMResourceUsingPUT: async (request: DemResourceRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('createDEMResourceUsingPUT', 'request', request)
            const localVarPath = `/demResources/createDEMResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteDEMResource
         * @param {number} demResourceId demResourceId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDEMResourceUsingDELETE: async (demResourceId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'demResourceId' is not null or undefined
            assertParamExists('deleteDEMResourceUsingDELETE', 'demResourceId', demResourceId)
            const localVarPath = `/demResources/deleteDEMResource/{demResourceId}`
                .replace(`{${"demResourceId"}}`, encodeURIComponent(String(demResourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllDEMResources
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDEMResourcesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/demResources/getAllDEMResources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDEMResource
         * @param {number} demResourceId demResourceId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDEMResourceUsingGET: async (demResourceId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'demResourceId' is not null or undefined
            assertParamExists('getDEMResourceUsingGET', 'demResourceId', demResourceId)
            const localVarPath = `/demResources/getDEMResource/{demResourceId}`
                .replace(`{${"demResourceId"}}`, encodeURIComponent(String(demResourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateDEMResource
         * @param {number} demResourceId demResourceId
         * @param {DemResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMResourceUsingPOST: async (demResourceId: number, request: DemResourceRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'demResourceId' is not null or undefined
            assertParamExists('updateDEMResourceUsingPOST', 'demResourceId', demResourceId)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('updateDEMResourceUsingPOST', 'request', request)
            const localVarPath = `/demResources/updateDEMResource/{demResourceId}`
                .replace(`{${"demResourceId"}}`, encodeURIComponent(String(demResourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemResourcesControllerApi - functional programming interface
 * @export
 */
export const DemResourcesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemResourcesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createDEMResource
         * @param {DemResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDEMResourceUsingPUT(request: DemResourceRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDEMResourceUsingPUT(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteDEMResource
         * @param {number} demResourceId demResourceId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDEMResourceUsingDELETE(demResourceId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDEMResourceUsingDELETE(demResourceId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllDEMResources
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDEMResourcesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DEMResourceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDEMResourcesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDEMResource
         * @param {number} demResourceId demResourceId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDEMResourceUsingGET(demResourceId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDEMResourceUsingGET(demResourceId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateDEMResource
         * @param {number} demResourceId demResourceId
         * @param {DemResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDEMResourceUsingPOST(demResourceId: number, request: DemResourceRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMResourceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDEMResourceUsingPOST(demResourceId, request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DemResourcesControllerApi - factory interface
 * @export
 */
export const DemResourcesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemResourcesControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createDEMResource
         * @param {DemResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDEMResourceUsingPUT(request: DemResourceRequestDTO, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.createDEMResourceUsingPUT(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteDEMResource
         * @param {number} demResourceId demResourceId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDEMResourceUsingDELETE(demResourceId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteDEMResourceUsingDELETE(demResourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllDEMResources
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDEMResourcesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<DEMResourceResponse>> {
            return localVarFp.getAllDEMResourcesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDEMResource
         * @param {number} demResourceId demResourceId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDEMResourceUsingGET(demResourceId: number, authorization?: string, options?: any): AxiosPromise<DEMResourceResponse> {
            return localVarFp.getDEMResourceUsingGET(demResourceId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateDEMResource
         * @param {number} demResourceId demResourceId
         * @param {DemResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMResourceUsingPOST(demResourceId: number, request: DemResourceRequestDTO, authorization?: string, options?: any): AxiosPromise<DEMResourceResponse> {
            return localVarFp.updateDEMResourceUsingPOST(demResourceId, request, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemResourcesControllerApi - object-oriented interface
 * @export
 * @class DemResourcesControllerApi
 * @extends {BaseAPI}
 */
export class DemResourcesControllerApi extends BaseAPI {
    /**
     * 
     * @summary createDEMResource
     * @param {DemResourceRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemResourcesControllerApi
     */
    public createDEMResourceUsingPUT(request: DemResourceRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return DemResourcesControllerApiFp(this.configuration).createDEMResourceUsingPUT(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteDEMResource
     * @param {number} demResourceId demResourceId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemResourcesControllerApi
     */
    public deleteDEMResourceUsingDELETE(demResourceId: number, authorization?: string, options?: AxiosRequestConfig) {
        return DemResourcesControllerApiFp(this.configuration).deleteDEMResourceUsingDELETE(demResourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllDEMResources
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemResourcesControllerApi
     */
    public getAllDEMResourcesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return DemResourcesControllerApiFp(this.configuration).getAllDEMResourcesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDEMResource
     * @param {number} demResourceId demResourceId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemResourcesControllerApi
     */
    public getDEMResourceUsingGET(demResourceId: number, authorization?: string, options?: AxiosRequestConfig) {
        return DemResourcesControllerApiFp(this.configuration).getDEMResourceUsingGET(demResourceId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateDEMResource
     * @param {number} demResourceId demResourceId
     * @param {DemResourceRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemResourcesControllerApi
     */
    public updateDEMResourceUsingPOST(demResourceId: number, request: DemResourceRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return DemResourcesControllerApiFp(this.configuration).updateDEMResourceUsingPOST(demResourceId, request, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DesignElementControllerApi - axios parameter creator
 * @export
 */
export const DesignElementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary addDesignElement
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDesignElementUsingPOST: async (request: DesignElementRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('addDesignElementUsingPOST', 'request', request)
            const localVarPath = `/survey/addDesignElement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createOrUpdateTimeOfConcentration
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTimeOfConcentrationUsingPOST: async (request: DesignElementRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('createOrUpdateTimeOfConcentrationUsingPOST', 'request', request)
            const localVarPath = `/survey/createOrUpdateTimeOfConcentration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteDemFileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemFileByProjectUuidUsingDELETE: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('deleteDemFileByProjectUuidUsingDELETE', 'projectUuid', projectUuid)
            const localVarPath = `/survey/deleteDEMByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteDesignElement
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesignElementUsingPOST: async (designElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('deleteDesignElementUsingPOST', 'designElementId', designElementId)
            const localVarPath = `/survey/deleteDesignElement/{designElementId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary demSurfaceResource
         * @param {string} filePath filePath
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demSurfaceResourceUsingGET: async (filePath: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('demSurfaceResourceUsingGET', 'filePath', filePath)
            const localVarPath = `/survey/demSurfaceResource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filePath !== undefined) {
                localVarQueryParameter['filePath'] = filePath;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadDEMAsPNG
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDEMAsPNGUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('downloadDEMAsPNGUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/survey/downloadDEMAsPNGByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadDEMFileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDEMFileByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('downloadDEMFileByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/survey/downloadDEMFileByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllDesignElementsBySessionAndType
         * @param {string} sessionUUID sessionUUID
         * @param {string} designElementTypeCSV designElementTypeCSV
         * @param {boolean} [addJson] addJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementsBySessionAndTypeUsingGET: async (sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUUID' is not null or undefined
            assertParamExists('getAllDesignElementsBySessionAndTypeUsingGET', 'sessionUUID', sessionUUID)
            // verify required parameter 'designElementTypeCSV' is not null or undefined
            assertParamExists('getAllDesignElementsBySessionAndTypeUsingGET', 'designElementTypeCSV', designElementTypeCSV)
            const localVarPath = `/survey/getAllDesignElementsBySessionAndType/{sessionUUID}/{designElementTypeCSV}`
                .replace(`{${"sessionUUID"}}`, encodeURIComponent(String(sessionUUID)))
                .replace(`{${"designElementTypeCSV"}}`, encodeURIComponent(String(designElementTypeCSV)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (addJson !== undefined) {
                localVarQueryParameter['addJson'] = addJson;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllDesignElementsBySession
         * @param {string} sessionUUIDs sessionUUIDs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementsBySessionUsingGET: async (sessionUUIDs: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUUIDs' is not null or undefined
            assertParamExists('getAllDesignElementsBySessionUsingGET', 'sessionUUIDs', sessionUUIDs)
            const localVarPath = `/survey/getAllDesignElementsBySession/{sessionUUIDs}`
                .replace(`{${"sessionUUIDs"}}`, encodeURIComponent(String(sessionUUIDs)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllSurveyDesignElementJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurveyDesignElementJsonUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey/getAllDesignElements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDEMMetadataByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDEMMetadataByProjectUuidUsingPOST: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getDEMMetadataByProjectUuidUsingPOST', 'projectUuid', projectUuid)
            const localVarPath = `/survey/getDEMMetadataByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDesignElementFlagUpToDateByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignElementFlagUpToDateByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getDesignElementFlagUpToDateByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/survey/getDesignElementFlagUpToDateByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDesignElementsBySessionAndType
         * @param {string} sessionUUID sessionUUID
         * @param {string} designElementTypeCSV designElementTypeCSV
         * @param {boolean} [addJson] addJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignElementsBySessionAndTypeUsingGET: async (sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUUID' is not null or undefined
            assertParamExists('getDesignElementsBySessionAndTypeUsingGET', 'sessionUUID', sessionUUID)
            // verify required parameter 'designElementTypeCSV' is not null or undefined
            assertParamExists('getDesignElementsBySessionAndTypeUsingGET', 'designElementTypeCSV', designElementTypeCSV)
            const localVarPath = `/survey/getDesignElementsBySessionAndType/{sessionUUID}/{designElementTypeCSV}`
                .replace(`{${"sessionUUID"}}`, encodeURIComponent(String(sessionUUID)))
                .replace(`{${"designElementTypeCSV"}}`, encodeURIComponent(String(designElementTypeCSV)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (addJson !== undefined) {
                localVarQueryParameter['addJson'] = addJson;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveOnlineDEMByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnlineDEMByProjectUuidUsingPOST: async (projectUuid: string, elevationUnit: string, demSurfaceName: string, url: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'elevationUnit' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidUsingPOST', 'elevationUnit', elevationUnit)
            // verify required parameter 'demSurfaceName' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidUsingPOST', 'demSurfaceName', demSurfaceName)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidUsingPOST', 'url', url)
            const localVarPath = `/survey/saveOnlineDEMByProjectUuid/{projectUuid}/{elevationUnit}/{demSurfaceName}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)))
                .replace(`{${"elevationUnit"}}`, encodeURIComponent(String(elevationUnit)))
                .replace(`{${"demSurfaceName"}}`, encodeURIComponent(String(demSurfaceName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveOnlineDEMByProjectUuidWithInterval
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {number} contourInterval contourInterval
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnlineDEMByProjectUuidWithIntervalUsingPOST: async (projectUuid: string, elevationUnit: string, demSurfaceName: string, contourInterval: number, url: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidWithIntervalUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'elevationUnit' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidWithIntervalUsingPOST', 'elevationUnit', elevationUnit)
            // verify required parameter 'demSurfaceName' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidWithIntervalUsingPOST', 'demSurfaceName', demSurfaceName)
            // verify required parameter 'contourInterval' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidWithIntervalUsingPOST', 'contourInterval', contourInterval)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('saveOnlineDEMByProjectUuidWithIntervalUsingPOST', 'url', url)
            const localVarPath = `/survey/saveOnlineDEMByProjectUuidWithInterval/{projectUuid}/{elevationUnit}/{demSurfaceName}/{contourInterval}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)))
                .replace(`{${"elevationUnit"}}`, encodeURIComponent(String(elevationUnit)))
                .replace(`{${"demSurfaceName"}}`, encodeURIComponent(String(demSurfaceName)))
                .replace(`{${"contourInterval"}}`, encodeURIComponent(String(contourInterval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary surveyDesignElementById
         * @param {string} designElementIds designElementIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyDesignElementByIdUsingGET: async (designElementIds: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementIds' is not null or undefined
            assertParamExists('surveyDesignElementByIdUsingGET', 'designElementIds', designElementIds)
            const localVarPath = `/survey/getDesignElement/{designElementIds}`
                .replace(`{${"designElementIds"}}`, encodeURIComponent(String(designElementIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateDEMNameByProjectUuidAndNewFileName
         * @param {string} projectUuid projectUuid
         * @param {string} newDemFileName newDemFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMNameByProjectUuidAndNewFileNameUsingPOST: async (projectUuid: string, newDemFileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('updateDEMNameByProjectUuidAndNewFileNameUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'newDemFileName' is not null or undefined
            assertParamExists('updateDEMNameByProjectUuidAndNewFileNameUsingPOST', 'newDemFileName', newDemFileName)
            const localVarPath = `/survey/updateDEMNameByProjectUuidAndNewFileName/{projectUuid}/{newDemFileName}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)))
                .replace(`{${"newDemFileName"}}`, encodeURIComponent(String(newDemFileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateDEMSurfaceByProjectUuidAndNewInterval
         * @param {string} projectUuid projectUuid
         * @param {number} contourInterval contourInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST: async (projectUuid: string, contourInterval: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'contourInterval' is not null or undefined
            assertParamExists('updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST', 'contourInterval', contourInterval)
            const localVarPath = `/survey/updateDEMSurfaceByProjectUuidAndNewInterval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (projectUuid !== undefined) {
                localVarQueryParameter['projectUuid'] = projectUuid;
            }

            if (contourInterval !== undefined) {
                localVarQueryParameter['contourInterval'] = contourInterval;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceName
         * @param {string} projectUuid projectUuid
         * @param {string} newDEMSurfaceName newDEMSurfaceName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST: async (projectUuid: string, newDEMSurfaceName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'newDEMSurfaceName' is not null or undefined
            assertParamExists('updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST', 'newDEMSurfaceName', newDEMSurfaceName)
            const localVarPath = `/survey/updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceName/{projectUuid}/{newDEMSurfaceName}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)))
                .replace(`{${"newDEMSurfaceName"}}`, encodeURIComponent(String(newDEMSurfaceName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateDesignElement
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDesignElementUsingPOST: async (request: DesignElementRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('updateDesignElementUsingPOST', 'request', request)
            const localVarPath = `/survey/updateDesignElement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateStructureDesignElement
         * @param {StructureDesignElementUpdateRequest} updateRequest updateRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStructureDesignElementUsingPOST: async (updateRequest: StructureDesignElementUpdateRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateRequest' is not null or undefined
            assertParamExists('updateStructureDesignElementUsingPOST', 'updateRequest', updateRequest)
            const localVarPath = `/survey/updateStructureDesignElement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSurfaceStakeOutGrid
         * @param {UpdateSurfStakeOutGridRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurfaceStakeOutGridUsingPOST: async (req: UpdateSurfStakeOutGridRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateSurfaceStakeOutGridUsingPOST', 'req', req)
            const localVarPath = `/survey/updateStakeOutGrid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploadDEMByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {number} interval interval
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDEMByProjectUuidUsingPOST: async (projectUuid: string, elevationUnit: string, demSurfaceName: string, interval: number, image: any, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('uploadDEMByProjectUuidUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'elevationUnit' is not null or undefined
            assertParamExists('uploadDEMByProjectUuidUsingPOST', 'elevationUnit', elevationUnit)
            // verify required parameter 'demSurfaceName' is not null or undefined
            assertParamExists('uploadDEMByProjectUuidUsingPOST', 'demSurfaceName', demSurfaceName)
            // verify required parameter 'interval' is not null or undefined
            assertParamExists('uploadDEMByProjectUuidUsingPOST', 'interval', interval)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('uploadDEMByProjectUuidUsingPOST', 'image', image)
            const localVarPath = `/survey/uploadDEMByProjectUuid/{projectUuid}/{elevationUnit}/{interval}/{demSurfaceName}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)))
                .replace(`{${"elevationUnit"}}`, encodeURIComponent(String(elevationUnit)))
                .replace(`{${"demSurfaceName"}}`, encodeURIComponent(String(demSurfaceName)))
                .replace(`{${"interval"}}`, encodeURIComponent(String(interval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validateDEMCRSByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDEMCRSByProjectUuidUsingPOST: async (projectUuid: string, image: any, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('validateDEMCRSByProjectUuidUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('validateDEMCRSByProjectUuidUsingPOST', 'image', image)
            const localVarPath = `/survey/validateDEMCRSByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validateOnlineDEMCRSByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOnlineDEMCRSByProjectUuidUsingPOST: async (projectUuid: string, url: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('validateOnlineDEMCRSByProjectUuidUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('validateOnlineDEMCRSByProjectUuidUsingPOST', 'url', url)
            const localVarPath = `/survey/validateOnlineDEMCRSByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesignElementControllerApi - functional programming interface
 * @export
 */
export const DesignElementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DesignElementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary addDesignElement
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDesignElementUsingPOST(request: DesignElementRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDesignElementUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createOrUpdateTimeOfConcentration
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateTimeOfConcentrationUsingPOST(request: DesignElementRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateTimeOfConcentrationUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteDemFileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDemFileByProjectUuidUsingDELETE(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDemFileByProjectUuidUsingDELETE(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteDesignElement
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDesignElementUsingPOST(designElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDesignElementUsingPOST(designElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary demSurfaceResource
         * @param {string} filePath filePath
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async demSurfaceResourceUsingGET(filePath: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.demSurfaceResourceUsingGET(filePath, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadDEMAsPNG
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDEMAsPNGUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDEMAsPNGUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadDEMFileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDEMFileByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDEMFileByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllDesignElementsBySessionAndType
         * @param {string} sessionUUID sessionUUID
         * @param {string} designElementTypeCSV designElementTypeCSV
         * @param {boolean} [addJson] addJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDesignElementsBySessionAndTypeUsingGET(sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignElementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDesignElementsBySessionAndTypeUsingGET(sessionUUID, designElementTypeCSV, addJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllDesignElementsBySession
         * @param {string} sessionUUIDs sessionUUIDs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDesignElementsBySessionUsingGET(sessionUUIDs: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignElementProjectResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDesignElementsBySessionUsingGET(sessionUUIDs, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllSurveyDesignElementJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSurveyDesignElementJsonUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignElementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSurveyDesignElementJsonUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDEMMetadataByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDEMMetadataByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDEMMetadataByProjectUuidUsingPOST(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDesignElementFlagUpToDateByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignElementFlagUpToDateByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FlagUpToDateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignElementFlagUpToDateByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDesignElementsBySessionAndType
         * @param {string} sessionUUID sessionUUID
         * @param {string} designElementTypeCSV designElementTypeCSV
         * @param {boolean} [addJson] addJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignElementsBySessionAndTypeUsingGET(sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignElementsBySessionAndTypeUsingGET(sessionUUID, designElementTypeCSV, addJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveOnlineDEMByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOnlineDEMByProjectUuidUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, url: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOnlineDEMByProjectUuidUsingPOST(projectUuid, elevationUnit, demSurfaceName, url, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveOnlineDEMByProjectUuidWithInterval
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {number} contourInterval contourInterval
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOnlineDEMByProjectUuidWithIntervalUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, contourInterval: number, url: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOnlineDEMByProjectUuidWithIntervalUsingPOST(projectUuid, elevationUnit, demSurfaceName, contourInterval, url, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary surveyDesignElementById
         * @param {string} designElementIds designElementIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async surveyDesignElementByIdUsingGET(designElementIds: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignElementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.surveyDesignElementByIdUsingGET(designElementIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateDEMNameByProjectUuidAndNewFileName
         * @param {string} projectUuid projectUuid
         * @param {string} newDemFileName newDemFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDEMNameByProjectUuidAndNewFileNameUsingPOST(projectUuid: string, newDemFileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDEMNameByProjectUuidAndNewFileNameUsingPOST(projectUuid, newDemFileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateDEMSurfaceByProjectUuidAndNewInterval
         * @param {string} projectUuid projectUuid
         * @param {number} contourInterval contourInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST(projectUuid: string, contourInterval: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST(projectUuid, contourInterval, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceName
         * @param {string} projectUuid projectUuid
         * @param {string} newDEMSurfaceName newDEMSurfaceName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST(projectUuid: string, newDEMSurfaceName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST(projectUuid, newDEMSurfaceName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateDesignElement
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDesignElementUsingPOST(request: DesignElementRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDesignElementUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateStructureDesignElement
         * @param {StructureDesignElementUpdateRequest} updateRequest updateRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStructureDesignElementUsingPOST(updateRequest: StructureDesignElementUpdateRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStructureDesignElementUsingPOST(updateRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSurfaceStakeOutGrid
         * @param {UpdateSurfStakeOutGridRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurfaceStakeOutGridUsingPOST(req: UpdateSurfStakeOutGridRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurfaceStakeOutGridUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary uploadDEMByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {number} interval interval
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDEMByProjectUuidUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, interval: number, image: any, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDEMByProjectUuidUsingPOST(projectUuid, elevationUnit, demSurfaceName, interval, image, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary validateDEMCRSByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateDEMCRSByProjectUuidUsingPOST(projectUuid: string, image: any, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMCRSResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateDEMCRSByProjectUuidUsingPOST(projectUuid, image, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary validateOnlineDEMCRSByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateOnlineDEMCRSByProjectUuidUsingPOST(projectUuid: string, url: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMCRSResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateOnlineDEMCRSByProjectUuidUsingPOST(projectUuid, url, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DesignElementControllerApi - factory interface
 * @export
 */
export const DesignElementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DesignElementControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary addDesignElement
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDesignElementUsingPOST(request: DesignElementRequest, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.addDesignElementUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createOrUpdateTimeOfConcentration
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTimeOfConcentrationUsingPOST(request: DesignElementRequest, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.createOrUpdateTimeOfConcentrationUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteDemFileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemFileByProjectUuidUsingDELETE(projectUuid: string, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.deleteDemFileByProjectUuidUsingDELETE(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteDesignElement
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesignElementUsingPOST(designElementId: number, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.deleteDesignElementUsingPOST(designElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary demSurfaceResource
         * @param {string} filePath filePath
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demSurfaceResourceUsingGET(filePath: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.demSurfaceResourceUsingGET(filePath, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadDEMAsPNG
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDEMAsPNGUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadDEMAsPNGUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadDEMFileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDEMFileByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadDEMFileByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllDesignElementsBySessionAndType
         * @param {string} sessionUUID sessionUUID
         * @param {string} designElementTypeCSV designElementTypeCSV
         * @param {boolean} [addJson] addJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementsBySessionAndTypeUsingGET(sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options?: any): AxiosPromise<Array<DesignElementResponse>> {
            return localVarFp.getAllDesignElementsBySessionAndTypeUsingGET(sessionUUID, designElementTypeCSV, addJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllDesignElementsBySession
         * @param {string} sessionUUIDs sessionUUIDs
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementsBySessionUsingGET(sessionUUIDs: string, authorization?: string, options?: any): AxiosPromise<Array<DesignElementProjectResponse>> {
            return localVarFp.getAllDesignElementsBySessionUsingGET(sessionUUIDs, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllSurveyDesignElementJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurveyDesignElementJsonUsingGET(authorization?: string, options?: any): AxiosPromise<Array<DesignElementResponse>> {
            return localVarFp.getAllSurveyDesignElementJsonUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDEMMetadataByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDEMMetadataByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.getDEMMetadataByProjectUuidUsingPOST(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDesignElementFlagUpToDateByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignElementFlagUpToDateByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<FlagUpToDateDto>> {
            return localVarFp.getDesignElementFlagUpToDateByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDesignElementsBySessionAndType
         * @param {string} sessionUUID sessionUUID
         * @param {string} designElementTypeCSV designElementTypeCSV
         * @param {boolean} [addJson] addJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignElementsBySessionAndTypeUsingGET(sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options?: any): AxiosPromise<DesignElementResponseDto> {
            return localVarFp.getDesignElementsBySessionAndTypeUsingGET(sessionUUID, designElementTypeCSV, addJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveOnlineDEMByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnlineDEMByProjectUuidUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, url: string, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.saveOnlineDEMByProjectUuidUsingPOST(projectUuid, elevationUnit, demSurfaceName, url, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveOnlineDEMByProjectUuidWithInterval
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {number} contourInterval contourInterval
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnlineDEMByProjectUuidWithIntervalUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, contourInterval: number, url: string, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.saveOnlineDEMByProjectUuidWithIntervalUsingPOST(projectUuid, elevationUnit, demSurfaceName, contourInterval, url, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary surveyDesignElementById
         * @param {string} designElementIds designElementIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        surveyDesignElementByIdUsingGET(designElementIds: string, authorization?: string, options?: any): AxiosPromise<Array<DesignElementResponse>> {
            return localVarFp.surveyDesignElementByIdUsingGET(designElementIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateDEMNameByProjectUuidAndNewFileName
         * @param {string} projectUuid projectUuid
         * @param {string} newDemFileName newDemFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMNameByProjectUuidAndNewFileNameUsingPOST(projectUuid: string, newDemFileName: string, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.updateDEMNameByProjectUuidAndNewFileNameUsingPOST(projectUuid, newDemFileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateDEMSurfaceByProjectUuidAndNewInterval
         * @param {string} projectUuid projectUuid
         * @param {number} contourInterval contourInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST(projectUuid: string, contourInterval: number, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST(projectUuid, contourInterval, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceName
         * @param {string} projectUuid projectUuid
         * @param {string} newDEMSurfaceName newDEMSurfaceName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST(projectUuid: string, newDEMSurfaceName: string, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST(projectUuid, newDEMSurfaceName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateDesignElement
         * @param {DesignElementRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDesignElementUsingPOST(request: DesignElementRequest, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.updateDesignElementUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateStructureDesignElement
         * @param {StructureDesignElementUpdateRequest} updateRequest updateRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStructureDesignElementUsingPOST(updateRequest: StructureDesignElementUpdateRequest, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.updateStructureDesignElementUsingPOST(updateRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSurfaceStakeOutGrid
         * @param {UpdateSurfStakeOutGridRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurfaceStakeOutGridUsingPOST(req: UpdateSurfStakeOutGridRequest, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateSurfaceStakeOutGridUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploadDEMByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} elevationUnit elevationUnit
         * @param {string} demSurfaceName demSurfaceName
         * @param {number} interval interval
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDEMByProjectUuidUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, interval: number, image: any, authorization?: string, options?: any): AxiosPromise<DEMSurfaceResponse> {
            return localVarFp.uploadDEMByProjectUuidUsingPOST(projectUuid, elevationUnit, demSurfaceName, interval, image, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary validateDEMCRSByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {any} image image
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateDEMCRSByProjectUuidUsingPOST(projectUuid: string, image: any, authorization?: string, options?: any): AxiosPromise<DEMCRSResponse> {
            return localVarFp.validateDEMCRSByProjectUuidUsingPOST(projectUuid, image, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary validateOnlineDEMCRSByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} url url
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateOnlineDEMCRSByProjectUuidUsingPOST(projectUuid: string, url: string, authorization?: string, options?: any): AxiosPromise<DEMCRSResponse> {
            return localVarFp.validateOnlineDEMCRSByProjectUuidUsingPOST(projectUuid, url, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DesignElementControllerApi - object-oriented interface
 * @export
 * @class DesignElementControllerApi
 * @extends {BaseAPI}
 */
export class DesignElementControllerApi extends BaseAPI {
    /**
     * 
     * @summary addDesignElement
     * @param {DesignElementRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public addDesignElementUsingPOST(request: DesignElementRequest, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).addDesignElementUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createOrUpdateTimeOfConcentration
     * @param {DesignElementRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public createOrUpdateTimeOfConcentrationUsingPOST(request: DesignElementRequest, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).createOrUpdateTimeOfConcentrationUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteDemFileByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public deleteDemFileByProjectUuidUsingDELETE(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).deleteDemFileByProjectUuidUsingDELETE(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteDesignElement
     * @param {number} designElementId designElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public deleteDesignElementUsingPOST(designElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).deleteDesignElementUsingPOST(designElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary demSurfaceResource
     * @param {string} filePath filePath
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public demSurfaceResourceUsingGET(filePath: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).demSurfaceResourceUsingGET(filePath, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadDEMAsPNG
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public downloadDEMAsPNGUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).downloadDEMAsPNGUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadDEMFileByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public downloadDEMFileByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).downloadDEMFileByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllDesignElementsBySessionAndType
     * @param {string} sessionUUID sessionUUID
     * @param {string} designElementTypeCSV designElementTypeCSV
     * @param {boolean} [addJson] addJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public getAllDesignElementsBySessionAndTypeUsingGET(sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).getAllDesignElementsBySessionAndTypeUsingGET(sessionUUID, designElementTypeCSV, addJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllDesignElementsBySession
     * @param {string} sessionUUIDs sessionUUIDs
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public getAllDesignElementsBySessionUsingGET(sessionUUIDs: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).getAllDesignElementsBySessionUsingGET(sessionUUIDs, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllSurveyDesignElementJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public getAllSurveyDesignElementJsonUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).getAllSurveyDesignElementJsonUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDEMMetadataByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public getDEMMetadataByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).getDEMMetadataByProjectUuidUsingPOST(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDesignElementFlagUpToDateByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public getDesignElementFlagUpToDateByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).getDesignElementFlagUpToDateByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDesignElementsBySessionAndType
     * @param {string} sessionUUID sessionUUID
     * @param {string} designElementTypeCSV designElementTypeCSV
     * @param {boolean} [addJson] addJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public getDesignElementsBySessionAndTypeUsingGET(sessionUUID: string, designElementTypeCSV: string, addJson?: boolean, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).getDesignElementsBySessionAndTypeUsingGET(sessionUUID, designElementTypeCSV, addJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveOnlineDEMByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} elevationUnit elevationUnit
     * @param {string} demSurfaceName demSurfaceName
     * @param {string} url url
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public saveOnlineDEMByProjectUuidUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, url: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).saveOnlineDEMByProjectUuidUsingPOST(projectUuid, elevationUnit, demSurfaceName, url, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveOnlineDEMByProjectUuidWithInterval
     * @param {string} projectUuid projectUuid
     * @param {string} elevationUnit elevationUnit
     * @param {string} demSurfaceName demSurfaceName
     * @param {number} contourInterval contourInterval
     * @param {string} url url
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public saveOnlineDEMByProjectUuidWithIntervalUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, contourInterval: number, url: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).saveOnlineDEMByProjectUuidWithIntervalUsingPOST(projectUuid, elevationUnit, demSurfaceName, contourInterval, url, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary surveyDesignElementById
     * @param {string} designElementIds designElementIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public surveyDesignElementByIdUsingGET(designElementIds: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).surveyDesignElementByIdUsingGET(designElementIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateDEMNameByProjectUuidAndNewFileName
     * @param {string} projectUuid projectUuid
     * @param {string} newDemFileName newDemFileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public updateDEMNameByProjectUuidAndNewFileNameUsingPOST(projectUuid: string, newDemFileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).updateDEMNameByProjectUuidAndNewFileNameUsingPOST(projectUuid, newDemFileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateDEMSurfaceByProjectUuidAndNewInterval
     * @param {string} projectUuid projectUuid
     * @param {number} contourInterval contourInterval
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST(projectUuid: string, contourInterval: number, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).updateDEMSurfaceByProjectUuidAndNewIntervalUsingPOST(projectUuid, contourInterval, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceName
     * @param {string} projectUuid projectUuid
     * @param {string} newDEMSurfaceName newDEMSurfaceName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST(projectUuid: string, newDEMSurfaceName: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).updateDEMSurfaceNameByProjectUuidAndNewDEMSurfaceNameUsingPOST(projectUuid, newDEMSurfaceName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateDesignElement
     * @param {DesignElementRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public updateDesignElementUsingPOST(request: DesignElementRequest, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).updateDesignElementUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateStructureDesignElement
     * @param {StructureDesignElementUpdateRequest} updateRequest updateRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public updateStructureDesignElementUsingPOST(updateRequest: StructureDesignElementUpdateRequest, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).updateStructureDesignElementUsingPOST(updateRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSurfaceStakeOutGrid
     * @param {UpdateSurfStakeOutGridRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public updateSurfaceStakeOutGridUsingPOST(req: UpdateSurfStakeOutGridRequest, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).updateSurfaceStakeOutGridUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploadDEMByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} elevationUnit elevationUnit
     * @param {string} demSurfaceName demSurfaceName
     * @param {number} interval interval
     * @param {any} image image
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public uploadDEMByProjectUuidUsingPOST(projectUuid: string, elevationUnit: string, demSurfaceName: string, interval: number, image: any, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).uploadDEMByProjectUuidUsingPOST(projectUuid, elevationUnit, demSurfaceName, interval, image, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary validateDEMCRSByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {any} image image
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public validateDEMCRSByProjectUuidUsingPOST(projectUuid: string, image: any, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).validateDEMCRSByProjectUuidUsingPOST(projectUuid, image, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary validateOnlineDEMCRSByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} url url
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementControllerApi
     */
    public validateOnlineDEMCRSByProjectUuidUsingPOST(projectUuid: string, url: string, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementControllerApiFp(this.configuration).validateOnlineDEMCRSByProjectUuidUsingPOST(projectUuid, url, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DesignElementExportControllerApi - axios parameter creator
 * @export
 */
export const DesignElementExportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllDesignElementExportablesBySession
         * @param {string} sessionUuid sessionUuid
         * @param {number} [surfaceDefId] surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementExportablesBySessionUsingGET: async (sessionUuid: string, surfaceDefId?: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getAllDesignElementExportablesBySessionUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/exporter/getAllDesignElementExportablesBySession/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surfaceDefId !== undefined) {
                localVarQueryParameter['surfaceDefId'] = surfaceDefId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary submitDownloadForAllDesignElementsCSV
         * @param {string} projectUuid projectUuid
         * @param {string} projectName projectName
         * @param {boolean} createCombinedWaterwayCSVFile createCombinedWaterwayCSVFile
         * @param {DesignElementDownloadDTO} designElementDownloadDTO designElementDownloadDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDownloadForAllDesignElementsCSVUsingPOST: async (projectUuid: string, projectName: string, createCombinedWaterwayCSVFile: boolean, designElementDownloadDTO: DesignElementDownloadDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('submitDownloadForAllDesignElementsCSVUsingPOST', 'projectUuid', projectUuid)
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('submitDownloadForAllDesignElementsCSVUsingPOST', 'projectName', projectName)
            // verify required parameter 'createCombinedWaterwayCSVFile' is not null or undefined
            assertParamExists('submitDownloadForAllDesignElementsCSVUsingPOST', 'createCombinedWaterwayCSVFile', createCombinedWaterwayCSVFile)
            // verify required parameter 'designElementDownloadDTO' is not null or undefined
            assertParamExists('submitDownloadForAllDesignElementsCSVUsingPOST', 'designElementDownloadDTO', designElementDownloadDTO)
            const localVarPath = `/exporter/submitDownloadForAllDesignElementsCSV`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (projectUuid !== undefined) {
                localVarQueryParameter['projectUuid'] = projectUuid;
            }

            if (projectName !== undefined) {
                localVarQueryParameter['projectName'] = projectName;
            }

            if (createCombinedWaterwayCSVFile !== undefined) {
                localVarQueryParameter['createCombinedWaterwayCSVFile'] = createCombinedWaterwayCSVFile;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(designElementDownloadDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesignElementExportControllerApi - functional programming interface
 * @export
 */
export const DesignElementExportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DesignElementExportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllDesignElementExportablesBySession
         * @param {string} sessionUuid sessionUuid
         * @param {number} [surfaceDefId] surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDesignElementExportablesBySessionUsingGET(sessionUuid: string, surfaceDefId?: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementExportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDesignElementExportablesBySessionUsingGET(sessionUuid, surfaceDefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary submitDownloadForAllDesignElementsCSV
         * @param {string} projectUuid projectUuid
         * @param {string} projectName projectName
         * @param {boolean} createCombinedWaterwayCSVFile createCombinedWaterwayCSVFile
         * @param {DesignElementDownloadDTO} designElementDownloadDTO designElementDownloadDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitDownloadForAllDesignElementsCSVUsingPOST(projectUuid: string, projectName: string, createCombinedWaterwayCSVFile: boolean, designElementDownloadDTO: DesignElementDownloadDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitDownloadForAllDesignElementsCSVUsingPOST(projectUuid, projectName, createCombinedWaterwayCSVFile, designElementDownloadDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DesignElementExportControllerApi - factory interface
 * @export
 */
export const DesignElementExportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DesignElementExportControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllDesignElementExportablesBySession
         * @param {string} sessionUuid sessionUuid
         * @param {number} [surfaceDefId] surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDesignElementExportablesBySessionUsingGET(sessionUuid: string, surfaceDefId?: number, authorization?: string, options?: any): AxiosPromise<DesignElementExportDTO> {
            return localVarFp.getAllDesignElementExportablesBySessionUsingGET(sessionUuid, surfaceDefId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary submitDownloadForAllDesignElementsCSV
         * @param {string} projectUuid projectUuid
         * @param {string} projectName projectName
         * @param {boolean} createCombinedWaterwayCSVFile createCombinedWaterwayCSVFile
         * @param {DesignElementDownloadDTO} designElementDownloadDTO designElementDownloadDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDownloadForAllDesignElementsCSVUsingPOST(projectUuid: string, projectName: string, createCombinedWaterwayCSVFile: boolean, designElementDownloadDTO: DesignElementDownloadDTO, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.submitDownloadForAllDesignElementsCSVUsingPOST(projectUuid, projectName, createCombinedWaterwayCSVFile, designElementDownloadDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DesignElementExportControllerApi - object-oriented interface
 * @export
 * @class DesignElementExportControllerApi
 * @extends {BaseAPI}
 */
export class DesignElementExportControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllDesignElementExportablesBySession
     * @param {string} sessionUuid sessionUuid
     * @param {number} [surfaceDefId] surfaceDefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementExportControllerApi
     */
    public getAllDesignElementExportablesBySessionUsingGET(sessionUuid: string, surfaceDefId?: number, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementExportControllerApiFp(this.configuration).getAllDesignElementExportablesBySessionUsingGET(sessionUuid, surfaceDefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary submitDownloadForAllDesignElementsCSV
     * @param {string} projectUuid projectUuid
     * @param {string} projectName projectName
     * @param {boolean} createCombinedWaterwayCSVFile createCombinedWaterwayCSVFile
     * @param {DesignElementDownloadDTO} designElementDownloadDTO designElementDownloadDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignElementExportControllerApi
     */
    public submitDownloadForAllDesignElementsCSVUsingPOST(projectUuid: string, projectName: string, createCombinedWaterwayCSVFile: boolean, designElementDownloadDTO: DesignElementDownloadDTO, authorization?: string, options?: AxiosRequestConfig) {
        return DesignElementExportControllerApiFp(this.configuration).submitDownloadForAllDesignElementsCSVUsingPOST(projectUuid, projectName, createCombinedWaterwayCSVFile, designElementDownloadDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ErrorHandlingControllerApi - axios parameter creator
 * @export
 */
export const ErrorHandlingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary combineErrorResponses
         * @param {CombineErrorResponsesRequest} combineErrorResponsesRequest combineErrorResponsesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        combineErrorResponsesUsingGET: async (combineErrorResponsesRequest: CombineErrorResponsesRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'combineErrorResponsesRequest' is not null or undefined
            assertParamExists('combineErrorResponsesUsingGET', 'combineErrorResponsesRequest', combineErrorResponsesRequest)
            const localVarPath = `/survey/errorHandling/combineErrorResponses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(combineErrorResponsesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createErrorHandlingLUT
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createErrorHandlingLUTUsingPOST: async (req: ErrorHandlingRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('createErrorHandlingLUTUsingPOST', 'req', req)
            const localVarPath = `/survey/errorHandling/createErrorHandlingLUT`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteErrorHandlingByErrorCodeLUTId
         * @param {number} errorCodeLUTId errorCodeLUTId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteErrorHandlingByErrorCodeLUTIdUsingPOST: async (errorCodeLUTId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'errorCodeLUTId' is not null or undefined
            assertParamExists('deleteErrorHandlingByErrorCodeLUTIdUsingPOST', 'errorCodeLUTId', errorCodeLUTId)
            const localVarPath = `/survey/errorHandling/deleteErrorHandlingByErrorCodeLUTId/{errorCodeLUTId}`
                .replace(`{${"errorCodeLUTId"}}`, encodeURIComponent(String(errorCodeLUTId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllErrorHandlingsByErrorCodeLUTIds
         * @param {string} errorCodeLUTIds errorCodeLUTIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllErrorHandlingsByErrorCodeLUTIdsUsingGET: async (errorCodeLUTIds: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'errorCodeLUTIds' is not null or undefined
            assertParamExists('getAllErrorHandlingsByErrorCodeLUTIdsUsingGET', 'errorCodeLUTIds', errorCodeLUTIds)
            const localVarPath = `/survey/errorHandling/getAllErrorHandlingsByErrorCodeLUTIds/{errorCodeLUTIds}`
                .replace(`{${"errorCodeLUTIds"}}`, encodeURIComponent(String(errorCodeLUTIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllErrorHandlings
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllErrorHandlingsUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey/errorHandling/getAllErrorHandlings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getErrorHandlingByModuleCode
         * @param {string} moduleCode moduleCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorHandlingByModuleCodeUsingGET: async (moduleCode: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleCode' is not null or undefined
            assertParamExists('getErrorHandlingByModuleCodeUsingGET', 'moduleCode', moduleCode)
            const localVarPath = `/survey/errorHandling/getErrorHandlingByModuleCode/{moduleCode}`
                .replace(`{${"moduleCode"}}`, encodeURIComponent(String(moduleCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getErrorHandlingByOriginalErrorCode
         * @param {string} originalErrorCode originalErrorCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorHandlingByOriginalErrorCodeUsingGET: async (originalErrorCode: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'originalErrorCode' is not null or undefined
            assertParamExists('getErrorHandlingByOriginalErrorCodeUsingGET', 'originalErrorCode', originalErrorCode)
            const localVarPath = `/survey/errorHandling/getErrorHandlingByOriginalErrorCode/{originalErrorCode}`
                .replace(`{${"originalErrorCode"}}`, encodeURIComponent(String(originalErrorCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getErrorHandlingByOriginalErrorCodes
         * @param {string} codes codes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorHandlingByOriginalErrorCodesUsingGET: async (codes: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codes' is not null or undefined
            assertParamExists('getErrorHandlingByOriginalErrorCodesUsingGET', 'codes', codes)
            const localVarPath = `/survey/errorHandling/getByOriginalErrorCodes/{codes}`
                .replace(`{${"codes"}}`, encodeURIComponent(String(codes)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getErrorResponse
         * @param {CreateErrorResponseRequest} errorRequest errorRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorResponseUsingGET: async (errorRequest: CreateErrorResponseRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'errorRequest' is not null or undefined
            assertParamExists('getErrorResponseUsingGET', 'errorRequest', errorRequest)
            const localVarPath = `/survey/errorHandling/errorResponse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(errorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getNextErrorCodeNumber
         * @param {ErrorNumberRequestDto} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextErrorCodeNumberUsingPOST: async (req: ErrorNumberRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getNextErrorCodeNumberUsingPOST', 'req', req)
            const localVarPath = `/survey/errorHandling/getNextErrorCodeNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateErrorHandlingByOriginalErrorCode
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateErrorHandlingByOriginalErrorCodeUsingPOST: async (req: ErrorHandlingRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateErrorHandlingByOriginalErrorCodeUsingPOST', 'req', req)
            const localVarPath = `/survey/errorHandling/updateErrorHandlingByOriginalErrorCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateErrorHandling
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateErrorHandlingUsingPOST: async (req: ErrorHandlingRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateErrorHandlingUsingPOST', 'req', req)
            const localVarPath = `/survey/errorHandling/updateErrorHandlingByErrorCodeLUTId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ErrorHandlingControllerApi - functional programming interface
 * @export
 */
export const ErrorHandlingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ErrorHandlingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary combineErrorResponses
         * @param {CombineErrorResponsesRequest} combineErrorResponsesRequest combineErrorResponsesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async combineErrorResponsesUsingGET(combineErrorResponsesRequest: CombineErrorResponsesRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.combineErrorResponsesUsingGET(combineErrorResponsesRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createErrorHandlingLUT
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createErrorHandlingLUTUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorHandlingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createErrorHandlingLUTUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteErrorHandlingByErrorCodeLUTId
         * @param {number} errorCodeLUTId errorCodeLUTId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteErrorHandlingByErrorCodeLUTIdUsingPOST(errorCodeLUTId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorHandlingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteErrorHandlingByErrorCodeLUTIdUsingPOST(errorCodeLUTId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllErrorHandlingsByErrorCodeLUTIds
         * @param {string} errorCodeLUTIds errorCodeLUTIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllErrorHandlingsByErrorCodeLUTIdsUsingGET(errorCodeLUTIds: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ErrorHandlingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllErrorHandlingsByErrorCodeLUTIdsUsingGET(errorCodeLUTIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllErrorHandlings
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllErrorHandlingsUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ErrorHandlingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllErrorHandlingsUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getErrorHandlingByModuleCode
         * @param {string} moduleCode moduleCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorHandlingByModuleCodeUsingGET(moduleCode: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ErrorHandlingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorHandlingByModuleCodeUsingGET(moduleCode, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getErrorHandlingByOriginalErrorCode
         * @param {string} originalErrorCode originalErrorCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorHandlingByOriginalErrorCodeUsingGET(originalErrorCode: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ErrorHandlingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorHandlingByOriginalErrorCodeUsingGET(originalErrorCode, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getErrorHandlingByOriginalErrorCodes
         * @param {string} codes codes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorHandlingByOriginalErrorCodesUsingGET(codes: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ErrorHandlingResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorHandlingByOriginalErrorCodesUsingGET(codes, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getErrorResponse
         * @param {CreateErrorResponseRequest} errorRequest errorRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getErrorResponseUsingGET(errorRequest: CreateErrorResponseRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getErrorResponseUsingGET(errorRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getNextErrorCodeNumber
         * @param {ErrorNumberRequestDto} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextErrorCodeNumberUsingPOST(req: ErrorNumberRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextErrorCodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextErrorCodeNumberUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateErrorHandlingByOriginalErrorCode
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateErrorHandlingByOriginalErrorCodeUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorHandlingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateErrorHandlingByOriginalErrorCodeUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateErrorHandling
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateErrorHandlingUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorHandlingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateErrorHandlingUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ErrorHandlingControllerApi - factory interface
 * @export
 */
export const ErrorHandlingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ErrorHandlingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary combineErrorResponses
         * @param {CombineErrorResponsesRequest} combineErrorResponsesRequest combineErrorResponsesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        combineErrorResponsesUsingGET(combineErrorResponsesRequest: CombineErrorResponsesRequest, authorization?: string, options?: any): AxiosPromise<ErrorResponse> {
            return localVarFp.combineErrorResponsesUsingGET(combineErrorResponsesRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createErrorHandlingLUT
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createErrorHandlingLUTUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: any): AxiosPromise<ErrorHandlingResponse> {
            return localVarFp.createErrorHandlingLUTUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteErrorHandlingByErrorCodeLUTId
         * @param {number} errorCodeLUTId errorCodeLUTId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteErrorHandlingByErrorCodeLUTIdUsingPOST(errorCodeLUTId: number, authorization?: string, options?: any): AxiosPromise<ErrorHandlingResponse> {
            return localVarFp.deleteErrorHandlingByErrorCodeLUTIdUsingPOST(errorCodeLUTId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllErrorHandlingsByErrorCodeLUTIds
         * @param {string} errorCodeLUTIds errorCodeLUTIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllErrorHandlingsByErrorCodeLUTIdsUsingGET(errorCodeLUTIds: string, authorization?: string, options?: any): AxiosPromise<Array<ErrorHandlingResponse>> {
            return localVarFp.getAllErrorHandlingsByErrorCodeLUTIdsUsingGET(errorCodeLUTIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllErrorHandlings
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllErrorHandlingsUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ErrorHandlingResponse>> {
            return localVarFp.getAllErrorHandlingsUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getErrorHandlingByModuleCode
         * @param {string} moduleCode moduleCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorHandlingByModuleCodeUsingGET(moduleCode: string, authorization?: string, options?: any): AxiosPromise<Array<ErrorHandlingResponse>> {
            return localVarFp.getErrorHandlingByModuleCodeUsingGET(moduleCode, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getErrorHandlingByOriginalErrorCode
         * @param {string} originalErrorCode originalErrorCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorHandlingByOriginalErrorCodeUsingGET(originalErrorCode: string, authorization?: string, options?: any): AxiosPromise<Array<ErrorHandlingResponse>> {
            return localVarFp.getErrorHandlingByOriginalErrorCodeUsingGET(originalErrorCode, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getErrorHandlingByOriginalErrorCodes
         * @param {string} codes codes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorHandlingByOriginalErrorCodesUsingGET(codes: string, authorization?: string, options?: any): AxiosPromise<Array<ErrorHandlingResponse>> {
            return localVarFp.getErrorHandlingByOriginalErrorCodesUsingGET(codes, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getErrorResponse
         * @param {CreateErrorResponseRequest} errorRequest errorRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getErrorResponseUsingGET(errorRequest: CreateErrorResponseRequest, authorization?: string, options?: any): AxiosPromise<ErrorResponse> {
            return localVarFp.getErrorResponseUsingGET(errorRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getNextErrorCodeNumber
         * @param {ErrorNumberRequestDto} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextErrorCodeNumberUsingPOST(req: ErrorNumberRequestDto, authorization?: string, options?: any): AxiosPromise<NextErrorCodeResponseDto> {
            return localVarFp.getNextErrorCodeNumberUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateErrorHandlingByOriginalErrorCode
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateErrorHandlingByOriginalErrorCodeUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: any): AxiosPromise<ErrorHandlingResponse> {
            return localVarFp.updateErrorHandlingByOriginalErrorCodeUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateErrorHandling
         * @param {ErrorHandlingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateErrorHandlingUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: any): AxiosPromise<ErrorHandlingResponse> {
            return localVarFp.updateErrorHandlingUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ErrorHandlingControllerApi - object-oriented interface
 * @export
 * @class ErrorHandlingControllerApi
 * @extends {BaseAPI}
 */
export class ErrorHandlingControllerApi extends BaseAPI {
    /**
     * 
     * @summary combineErrorResponses
     * @param {CombineErrorResponsesRequest} combineErrorResponsesRequest combineErrorResponsesRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public combineErrorResponsesUsingGET(combineErrorResponsesRequest: CombineErrorResponsesRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).combineErrorResponsesUsingGET(combineErrorResponsesRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createErrorHandlingLUT
     * @param {ErrorHandlingRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public createErrorHandlingLUTUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).createErrorHandlingLUTUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteErrorHandlingByErrorCodeLUTId
     * @param {number} errorCodeLUTId errorCodeLUTId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public deleteErrorHandlingByErrorCodeLUTIdUsingPOST(errorCodeLUTId: number, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).deleteErrorHandlingByErrorCodeLUTIdUsingPOST(errorCodeLUTId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllErrorHandlingsByErrorCodeLUTIds
     * @param {string} errorCodeLUTIds errorCodeLUTIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public getAllErrorHandlingsByErrorCodeLUTIdsUsingGET(errorCodeLUTIds: string, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).getAllErrorHandlingsByErrorCodeLUTIdsUsingGET(errorCodeLUTIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllErrorHandlings
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public getAllErrorHandlingsUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).getAllErrorHandlingsUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getErrorHandlingByModuleCode
     * @param {string} moduleCode moduleCode
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public getErrorHandlingByModuleCodeUsingGET(moduleCode: string, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).getErrorHandlingByModuleCodeUsingGET(moduleCode, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getErrorHandlingByOriginalErrorCode
     * @param {string} originalErrorCode originalErrorCode
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public getErrorHandlingByOriginalErrorCodeUsingGET(originalErrorCode: string, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).getErrorHandlingByOriginalErrorCodeUsingGET(originalErrorCode, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getErrorHandlingByOriginalErrorCodes
     * @param {string} codes codes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public getErrorHandlingByOriginalErrorCodesUsingGET(codes: string, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).getErrorHandlingByOriginalErrorCodesUsingGET(codes, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getErrorResponse
     * @param {CreateErrorResponseRequest} errorRequest errorRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public getErrorResponseUsingGET(errorRequest: CreateErrorResponseRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).getErrorResponseUsingGET(errorRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getNextErrorCodeNumber
     * @param {ErrorNumberRequestDto} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public getNextErrorCodeNumberUsingPOST(req: ErrorNumberRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).getNextErrorCodeNumberUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateErrorHandlingByOriginalErrorCode
     * @param {ErrorHandlingRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public updateErrorHandlingByOriginalErrorCodeUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).updateErrorHandlingByOriginalErrorCodeUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateErrorHandling
     * @param {ErrorHandlingRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorHandlingControllerApi
     */
    public updateErrorHandlingUsingPOST(req: ErrorHandlingRequest, authorization?: string, options?: AxiosRequestConfig) {
        return ErrorHandlingControllerApiFp(this.configuration).updateErrorHandlingUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HydraulicFormulaControllerApi - axios parameter creator
 * @export
 */
export const HydraulicFormulaControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API Calculates Gravity Flow in circular Section, takes  CircularSectionRequestDto  as input parameters  and responds back with calculated values
         * @param {CircularSectionRequestDto} circularSectionRequestDto circularSectionRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calGravityFlowInCircularSectionUsingPOST: async (circularSectionRequestDto: CircularSectionRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'circularSectionRequestDto' is not null or undefined
            assertParamExists('calGravityFlowInCircularSectionUsingPOST', 'circularSectionRequestDto', circularSectionRequestDto)
            const localVarPath = `/hydraulicFormula/calGravityFlowInCircularSection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(circularSectionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for VNotch Weir Flow, takes VNotchWeirRequestDto as input parameters and responds back with calculated values
         * @param {VNotchWeirRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calVNotchWeirFlowUsingPOST: async (request: VNotchWeirRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calVNotchWeirFlowUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calVNotchWeirFlow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Box Drop Inlet, takes  BoxDropInletDTO  as input parameters  and responds back with calculated values
         * @param {BoxDropInletDto} boxDropInletParams boxDropInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateBoxDropInletUsingPOST: async (boxDropInletParams: BoxDropInletDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boxDropInletParams' is not null or undefined
            assertParamExists('calculateBoxDropInletUsingPOST', 'boxDropInletParams', boxDropInletParams)
            const localVarPath = `/hydraulicFormula/calBoxDropInlet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boxDropInletParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Circle, takes CircleRequestDto as input parameters and responds back with calculated values
         * @param {CircleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCircleUsingPOST: async (request: CircleRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateCircleUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calCircle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SolidConeRequestDto} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateConeUsingPOST: async (surfaceInletParams: SolidConeRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceInletParams' is not null or undefined
            assertParamExists('calculateConeUsingPOST', 'surfaceInletParams', surfaceInletParams)
            const localVarPath = `/hydraulicFormula/calCone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surfaceInletParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Dry Hydrant, takes  DryHydrantRequestDto  as input parameters  and responds back with calculated values
         * @param {DryHydrantRequestDto} dryHydrantParams dryHydrantParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDryHydrantUsingPOST: async (dryHydrantParams: DryHydrantRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dryHydrantParams' is not null or undefined
            assertParamExists('calculateDryHydrantUsingPOST', 'dryHydrantParams', dryHydrantParams)
            const localVarPath = `/hydraulicFormula/calDryHydrant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dryHydrantParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for ETriangle, takes ETriangleRequestDto as input parameters and responds back with calculated values
         * @param {ETriangleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateETriangleUsingPOST: async (request: ETriangleRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateETriangleUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calETriangle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Frustrum of Pyramid, takes  frustrumPyramidRequestDto  as input parameters  and responds back with calculated values
         * @param {FrustrumPyramidRequestDto} frustrumPyramidParams frustrumPyramidParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateFrustrumPyramidUsingPOST: async (frustrumPyramidParams: FrustrumPyramidRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'frustrumPyramidParams' is not null or undefined
            assertParamExists('calculateFrustrumPyramidUsingPOST', 'frustrumPyramidParams', frustrumPyramidParams)
            const localVarPath = `/hydraulicFormula/calFrustrumPyramid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(frustrumPyramidParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Hooded Inlet, takes  HoodedInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {HoodedInletRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateHoodedInletResultsUsingPOST: async (request: HoodedInletRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateHoodedInletResultsUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calculateResultsForHoodedInlet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
         * @param {InlineWaterControlRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateInlineWaterUsingPOST: async (request: InlineWaterControlRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateInlineWaterUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calInlineWater`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for OTriangle, takes OTriangleRequestDto as input parameters and responds back with calculated values
         * @param {OTriangleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOTriangleUsingPOST: async (request: OTriangleRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateOTriangleUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calOTriangle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
         * @param {OrificeFlowRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrificeFlowUsingPOST: async (request: OrificeFlowRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateOrificeFlowUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calOrificeFlow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Parabola, takes ParabolaRequestDto as input parameters and responds back with calculated values
         * @param {ParabolaRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateParabolaUsingPOST: async (request: ParabolaRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateParabolaUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calParabola`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Parabolic Channel, takes  ParabolicChannelRequestDto  as input parameters  and responds back with calculated values
         * @param {ParabolicChannelRequestDto} parabolicChannelParams parabolicChannelParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateParabolicChannelUsingPOST: async (parabolicChannelParams: ParabolicChannelRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parabolicChannelParams' is not null or undefined
            assertParamExists('calculateParabolicChannelUsingPOST', 'parabolicChannelParams', parabolicChannelParams)
            const localVarPath = `/hydraulicFormula/calParabolicChannel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(parabolicChannelParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Parallelogram, takes ParallelogramRequestDto as input parameters and responds back with calculated values
         * @param {ParallelogramRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateParallelogramUsingPOST: async (request: ParallelogramRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateParallelogramUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calParallelogram`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Pipe Drop, takes  PipeDropRequestDTO  as input parameters  and responds back with calculated values
         * @param {PipeDropRequestDto} pipeDropRequestDTO pipeDropRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePipeDropUsingPOST: async (pipeDropRequestDTO: PipeDropRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipeDropRequestDTO' is not null or undefined
            assertParamExists('calculatePipeDropUsingPOST', 'pipeDropRequestDTO', pipeDropRequestDTO)
            const localVarPath = `/hydraulicFormula/calPipeDrop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pipeDropRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Plune Pool, takes  PlungePoolRequestDTO  as input parameters  and responds back with calculated values
         * @param {PlungePoolRequestDto} plungePoolRequestDTO plungePoolRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePlungePoolUsingPOST: async (plungePoolRequestDTO: PlungePoolRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plungePoolRequestDTO' is not null or undefined
            assertParamExists('calculatePlungePoolUsingPOST', 'plungePoolRequestDTO', plungePoolRequestDTO)
            const localVarPath = `/hydraulicFormula/calPlungePool`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(plungePoolRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Pressure Flow, takes PressureFlowRequestDTO as input parameters and responds back with calculated values
         * @param {PressureFlowPipeRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePressureFlowPipeUsingPOST: async (request: PressureFlowPipeRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculatePressureFlowPipeUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calPressureFlowPipe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SolidPrismatoidRequestDto} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePrismatoidUsingPOST: async (surfaceInletParams: SolidPrismatoidRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceInletParams' is not null or undefined
            assertParamExists('calculatePrismatoidUsingPOST', 'surfaceInletParams', surfaceInletParams)
            const localVarPath = `/hydraulicFormula/calPrismatoid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surfaceInletParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Pump Drainage, takes PumpDrainageRequestDTO as input parameters and responds back with calculated values
         * @param {PumpDrainageRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePumpDrainageUsingPOST: async (request: PumpDrainageRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculatePumpDrainageUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calPumpDrainage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Rectangular Riser Drop, takes  RecRiserDropStructureRequestDto  as input parameters  and responds back with calculated values
         * @param {RecRiserDropStructureRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateRectRiserDropResultsUsingPOST: async (request: RecRiserDropStructureRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateRectRiserDropResultsUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calRectRiserDrop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Rectangular, takes RectangularRequestDto as input parameters and responds back with calculated values
         * @param {RectangularRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateRectangularUsingPOST: async (request: RectangularRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateRectangularUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calRectangular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
         * @param {StraightDropInletRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateStraightDropInletResultsUsingPOST: async (request: StraightDropInletRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateStraightDropInletResultsUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calStraightDropInlet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Subsurface Drainage, takes SubsurfaceDrainRequestDTO as input parameters and responds back with calculated values
         * @param {SubsurfaceDrainRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSubsurfaceDrainageUsingPOST: async (request: SubsurfaceDrainRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateSubsurfaceDrainageUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calSubsurfaceDrainage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet RequiredQ, takes  QRequiredRequestDTO  as input parameters  and responds back with calculated values
         * @param {number} opt opt
         * @param {string} inputParams inputParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSurfaceInletUsingPOST: async (opt: number, inputParams: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opt' is not null or undefined
            assertParamExists('calculateSurfaceInletUsingPOST', 'opt', opt)
            // verify required parameter 'inputParams' is not null or undefined
            assertParamExists('calculateSurfaceInletUsingPOST', 'inputParams', inputParams)
            const localVarPath = `/hydraulicFormula/calSurfaceInletStaging/{opt}`
                .replace(`{${"opt"}}`, encodeURIComponent(String(opt)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SurfaceInletRequestDTO} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSurfaceInletUsingPOST1: async (surfaceInletParams: SurfaceInletRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceInletParams' is not null or undefined
            assertParamExists('calculateSurfaceInletUsingPOST1', 'surfaceInletParams', surfaceInletParams)
            const localVarPath = `/hydraulicFormula/calSurfaceInlet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surfaceInletParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Trapezoidal Channel, takes  TrapezoidalChannelRequestDto  as input parameters  and responds back with calculated values
         * @param {TrapezoidalChannelRequestDto} trapezoidalChannelParams trapezoidalChannelParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTrapezoidalChannelUsingPOST: async (trapezoidalChannelParams: TrapezoidalChannelRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trapezoidalChannelParams' is not null or undefined
            assertParamExists('calculateTrapezoidalChannelUsingPOST', 'trapezoidalChannelParams', trapezoidalChannelParams)
            const localVarPath = `/hydraulicFormula/calTrapezoidalChannel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trapezoidalChannelParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
         * @param {WeirFlowRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateWeirFlowUsingPOST: async (request: WeirFlowRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateWeirFlowUsingPOST', 'request', request)
            const localVarPath = `/hydraulicFormula/calWeirFlow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getHydraulicDefaultFromula
         * @param {string} hydraulicFormulaId hydraulicFormulaId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydraulicDefaultFromulaUsingGET: async (hydraulicFormulaId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hydraulicFormulaId' is not null or undefined
            assertParamExists('getHydraulicDefaultFromulaUsingGET', 'hydraulicFormulaId', hydraulicFormulaId)
            const localVarPath = `/hydraulicFormula/getHydraulicFormulaByFormulaID/{hydraulicFormulaId}`
                .replace(`{${"hydraulicFormulaId"}}`, encodeURIComponent(String(hydraulicFormulaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateHydraulicDefaultFromula
         * @param {HydraulicFormulaDefaultRequestDto} hydraulicFormulaParams hydraulicFormulaParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHydraulicDefaultFromulaUsingPOST: async (hydraulicFormulaParams: HydraulicFormulaDefaultRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hydraulicFormulaParams' is not null or undefined
            assertParamExists('updateHydraulicDefaultFromulaUsingPOST', 'hydraulicFormulaParams', hydraulicFormulaParams)
            const localVarPath = `/hydraulicFormula/updateHydraulicFormulaByFormulaID`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hydraulicFormulaParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HydraulicFormulaControllerApi - functional programming interface
 * @export
 */
export const HydraulicFormulaControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HydraulicFormulaControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API Calculates Gravity Flow in circular Section, takes  CircularSectionRequestDto  as input parameters  and responds back with calculated values
         * @param {CircularSectionRequestDto} circularSectionRequestDto circularSectionRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calGravityFlowInCircularSectionUsingPOST(circularSectionRequestDto: CircularSectionRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CircularSectionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calGravityFlowInCircularSectionUsingPOST(circularSectionRequestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for VNotch Weir Flow, takes VNotchWeirRequestDto as input parameters and responds back with calculated values
         * @param {VNotchWeirRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calVNotchWeirFlowUsingPOST(request: VNotchWeirRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VNotchWeirResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calVNotchWeirFlowUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Box Drop Inlet, takes  BoxDropInletDTO  as input parameters  and responds back with calculated values
         * @param {BoxDropInletDto} boxDropInletParams boxDropInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateBoxDropInletUsingPOST(boxDropInletParams: BoxDropInletDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoxDropInletResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateBoxDropInletUsingPOST(boxDropInletParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Circle, takes CircleRequestDto as input parameters and responds back with calculated values
         * @param {CircleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateCircleUsingPOST(request: CircleRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CircleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateCircleUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SolidConeRequestDto} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateConeUsingPOST(surfaceInletParams: SolidConeRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolidConeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateConeUsingPOST(surfaceInletParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Dry Hydrant, takes  DryHydrantRequestDto  as input parameters  and responds back with calculated values
         * @param {DryHydrantRequestDto} dryHydrantParams dryHydrantParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateDryHydrantUsingPOST(dryHydrantParams: DryHydrantRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DryHydrantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateDryHydrantUsingPOST(dryHydrantParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for ETriangle, takes ETriangleRequestDto as input parameters and responds back with calculated values
         * @param {ETriangleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateETriangleUsingPOST(request: ETriangleRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ETriangleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateETriangleUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Frustrum of Pyramid, takes  frustrumPyramidRequestDto  as input parameters  and responds back with calculated values
         * @param {FrustrumPyramidRequestDto} frustrumPyramidParams frustrumPyramidParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateFrustrumPyramidUsingPOST(frustrumPyramidParams: FrustrumPyramidRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FrustrumPyramidResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateFrustrumPyramidUsingPOST(frustrumPyramidParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Hooded Inlet, takes  HoodedInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {HoodedInletRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateHoodedInletResultsUsingPOST(request: HoodedInletRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HoodedInletResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateHoodedInletResultsUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
         * @param {InlineWaterControlRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateInlineWaterUsingPOST(request: InlineWaterControlRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineWaterControlResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateInlineWaterUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for OTriangle, takes OTriangleRequestDto as input parameters and responds back with calculated values
         * @param {OTriangleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateOTriangleUsingPOST(request: OTriangleRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OTriangleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOTriangleUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
         * @param {OrificeFlowRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateOrificeFlowUsingPOST(request: OrificeFlowRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrificeFlowResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOrificeFlowUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Parabola, takes ParabolaRequestDto as input parameters and responds back with calculated values
         * @param {ParabolaRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateParabolaUsingPOST(request: ParabolaRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParabolaResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateParabolaUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Parabolic Channel, takes  ParabolicChannelRequestDto  as input parameters  and responds back with calculated values
         * @param {ParabolicChannelRequestDto} parabolicChannelParams parabolicChannelParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateParabolicChannelUsingPOST(parabolicChannelParams: ParabolicChannelRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParabolicChannelResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateParabolicChannelUsingPOST(parabolicChannelParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Parallelogram, takes ParallelogramRequestDto as input parameters and responds back with calculated values
         * @param {ParallelogramRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateParallelogramUsingPOST(request: ParallelogramRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParallelogramResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateParallelogramUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Pipe Drop, takes  PipeDropRequestDTO  as input parameters  and responds back with calculated values
         * @param {PipeDropRequestDto} pipeDropRequestDTO pipeDropRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePipeDropUsingPOST(pipeDropRequestDTO: PipeDropRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipeDropResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePipeDropUsingPOST(pipeDropRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Plune Pool, takes  PlungePoolRequestDTO  as input parameters  and responds back with calculated values
         * @param {PlungePoolRequestDto} plungePoolRequestDTO plungePoolRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePlungePoolUsingPOST(plungePoolRequestDTO: PlungePoolRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlungePoolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePlungePoolUsingPOST(plungePoolRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Pressure Flow, takes PressureFlowRequestDTO as input parameters and responds back with calculated values
         * @param {PressureFlowPipeRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePressureFlowPipeUsingPOST(request: PressureFlowPipeRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PressureFlowPipeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePressureFlowPipeUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SolidPrismatoidRequestDto} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePrismatoidUsingPOST(surfaceInletParams: SolidPrismatoidRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolidPrismatoidResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePrismatoidUsingPOST(surfaceInletParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Pump Drainage, takes PumpDrainageRequestDTO as input parameters and responds back with calculated values
         * @param {PumpDrainageRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePumpDrainageUsingPOST(request: PumpDrainageRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PumpDrainageResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePumpDrainageUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Rectangular Riser Drop, takes  RecRiserDropStructureRequestDto  as input parameters  and responds back with calculated values
         * @param {RecRiserDropStructureRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateRectRiserDropResultsUsingPOST(request: RecRiserDropStructureRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecRiserDropStructureResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateRectRiserDropResultsUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Rectangular, takes RectangularRequestDto as input parameters and responds back with calculated values
         * @param {RectangularRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateRectangularUsingPOST(request: RectangularRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RectangularResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateRectangularUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
         * @param {StraightDropInletRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateStraightDropInletResultsUsingPOST(request: StraightDropInletRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StraightDropResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateStraightDropInletResultsUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Subsurface Drainage, takes SubsurfaceDrainRequestDTO as input parameters and responds back with calculated values
         * @param {SubsurfaceDrainRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateSubsurfaceDrainageUsingPOST(request: SubsurfaceDrainRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubsurfaceDrainResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateSubsurfaceDrainageUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet RequiredQ, takes  QRequiredRequestDTO  as input parameters  and responds back with calculated values
         * @param {number} opt opt
         * @param {string} inputParams inputParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateSurfaceInletUsingPOST(opt: number, inputParams: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceInletResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateSurfaceInletUsingPOST(opt, inputParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SurfaceInletRequestDTO} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateSurfaceInletUsingPOST1(surfaceInletParams: SurfaceInletRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceInletResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateSurfaceInletUsingPOST1(surfaceInletParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Trapezoidal Channel, takes  TrapezoidalChannelRequestDto  as input parameters  and responds back with calculated values
         * @param {TrapezoidalChannelRequestDto} trapezoidalChannelParams trapezoidalChannelParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateTrapezoidalChannelUsingPOST(trapezoidalChannelParams: TrapezoidalChannelRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrapezoidalChannelResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateTrapezoidalChannelUsingPOST(trapezoidalChannelParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
         * @param {WeirFlowRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateWeirFlowUsingPOST(request: WeirFlowRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeirFlowResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateWeirFlowUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getHydraulicDefaultFromula
         * @param {string} hydraulicFormulaId hydraulicFormulaId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHydraulicDefaultFromulaUsingGET(hydraulicFormulaId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydraulicFormulasDefaultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHydraulicDefaultFromulaUsingGET(hydraulicFormulaId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateHydraulicDefaultFromula
         * @param {HydraulicFormulaDefaultRequestDto} hydraulicFormulaParams hydraulicFormulaParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHydraulicDefaultFromulaUsingPOST(hydraulicFormulaParams: HydraulicFormulaDefaultRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydraulicFormulasDefaultResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHydraulicDefaultFromulaUsingPOST(hydraulicFormulaParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HydraulicFormulaControllerApi - factory interface
 * @export
 */
export const HydraulicFormulaControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HydraulicFormulaControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API Calculates Gravity Flow in circular Section, takes  CircularSectionRequestDto  as input parameters  and responds back with calculated values
         * @param {CircularSectionRequestDto} circularSectionRequestDto circularSectionRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calGravityFlowInCircularSectionUsingPOST(circularSectionRequestDto: CircularSectionRequestDto, authorization?: string, options?: any): AxiosPromise<CircularSectionResponseDto> {
            return localVarFp.calGravityFlowInCircularSectionUsingPOST(circularSectionRequestDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for VNotch Weir Flow, takes VNotchWeirRequestDto as input parameters and responds back with calculated values
         * @param {VNotchWeirRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calVNotchWeirFlowUsingPOST(request: VNotchWeirRequestDto, authorization?: string, options?: any): AxiosPromise<VNotchWeirResponseDto> {
            return localVarFp.calVNotchWeirFlowUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Box Drop Inlet, takes  BoxDropInletDTO  as input parameters  and responds back with calculated values
         * @param {BoxDropInletDto} boxDropInletParams boxDropInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateBoxDropInletUsingPOST(boxDropInletParams: BoxDropInletDto, authorization?: string, options?: any): AxiosPromise<BoxDropInletResponseDTO> {
            return localVarFp.calculateBoxDropInletUsingPOST(boxDropInletParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Circle, takes CircleRequestDto as input parameters and responds back with calculated values
         * @param {CircleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateCircleUsingPOST(request: CircleRequestDto, authorization?: string, options?: any): AxiosPromise<CircleResponseDto> {
            return localVarFp.calculateCircleUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SolidConeRequestDto} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateConeUsingPOST(surfaceInletParams: SolidConeRequestDto, authorization?: string, options?: any): AxiosPromise<SolidConeResponseDto> {
            return localVarFp.calculateConeUsingPOST(surfaceInletParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Dry Hydrant, takes  DryHydrantRequestDto  as input parameters  and responds back with calculated values
         * @param {DryHydrantRequestDto} dryHydrantParams dryHydrantParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateDryHydrantUsingPOST(dryHydrantParams: DryHydrantRequestDto, authorization?: string, options?: any): AxiosPromise<DryHydrantResponseDto> {
            return localVarFp.calculateDryHydrantUsingPOST(dryHydrantParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for ETriangle, takes ETriangleRequestDto as input parameters and responds back with calculated values
         * @param {ETriangleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateETriangleUsingPOST(request: ETriangleRequestDto, authorization?: string, options?: any): AxiosPromise<ETriangleResponseDto> {
            return localVarFp.calculateETriangleUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Frustrum of Pyramid, takes  frustrumPyramidRequestDto  as input parameters  and responds back with calculated values
         * @param {FrustrumPyramidRequestDto} frustrumPyramidParams frustrumPyramidParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateFrustrumPyramidUsingPOST(frustrumPyramidParams: FrustrumPyramidRequestDto, authorization?: string, options?: any): AxiosPromise<FrustrumPyramidResponseDto> {
            return localVarFp.calculateFrustrumPyramidUsingPOST(frustrumPyramidParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Hooded Inlet, takes  HoodedInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {HoodedInletRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateHoodedInletResultsUsingPOST(request: HoodedInletRequestDto, authorization?: string, options?: any): AxiosPromise<HoodedInletResponseDto> {
            return localVarFp.calculateHoodedInletResultsUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
         * @param {InlineWaterControlRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateInlineWaterUsingPOST(request: InlineWaterControlRequestDto, authorization?: string, options?: any): AxiosPromise<InlineWaterControlResponseDto> {
            return localVarFp.calculateInlineWaterUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for OTriangle, takes OTriangleRequestDto as input parameters and responds back with calculated values
         * @param {OTriangleRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOTriangleUsingPOST(request: OTriangleRequestDto, authorization?: string, options?: any): AxiosPromise<OTriangleResponseDto> {
            return localVarFp.calculateOTriangleUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
         * @param {OrificeFlowRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrificeFlowUsingPOST(request: OrificeFlowRequestDTO, authorization?: string, options?: any): AxiosPromise<OrificeFlowResponseDTO> {
            return localVarFp.calculateOrificeFlowUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Parabola, takes ParabolaRequestDto as input parameters and responds back with calculated values
         * @param {ParabolaRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateParabolaUsingPOST(request: ParabolaRequestDto, authorization?: string, options?: any): AxiosPromise<ParabolaResponseDto> {
            return localVarFp.calculateParabolaUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Parabolic Channel, takes  ParabolicChannelRequestDto  as input parameters  and responds back with calculated values
         * @param {ParabolicChannelRequestDto} parabolicChannelParams parabolicChannelParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateParabolicChannelUsingPOST(parabolicChannelParams: ParabolicChannelRequestDto, authorization?: string, options?: any): AxiosPromise<ParabolicChannelResponseDto> {
            return localVarFp.calculateParabolicChannelUsingPOST(parabolicChannelParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Parallelogram, takes ParallelogramRequestDto as input parameters and responds back with calculated values
         * @param {ParallelogramRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateParallelogramUsingPOST(request: ParallelogramRequestDto, authorization?: string, options?: any): AxiosPromise<ParallelogramResponseDto> {
            return localVarFp.calculateParallelogramUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Pipe Drop, takes  PipeDropRequestDTO  as input parameters  and responds back with calculated values
         * @param {PipeDropRequestDto} pipeDropRequestDTO pipeDropRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePipeDropUsingPOST(pipeDropRequestDTO: PipeDropRequestDto, authorization?: string, options?: any): AxiosPromise<PipeDropResponseDTO> {
            return localVarFp.calculatePipeDropUsingPOST(pipeDropRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Plune Pool, takes  PlungePoolRequestDTO  as input parameters  and responds back with calculated values
         * @param {PlungePoolRequestDto} plungePoolRequestDTO plungePoolRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePlungePoolUsingPOST(plungePoolRequestDTO: PlungePoolRequestDto, authorization?: string, options?: any): AxiosPromise<PlungePoolResponseDTO> {
            return localVarFp.calculatePlungePoolUsingPOST(plungePoolRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Pressure Flow, takes PressureFlowRequestDTO as input parameters and responds back with calculated values
         * @param {PressureFlowPipeRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePressureFlowPipeUsingPOST(request: PressureFlowPipeRequestDto, authorization?: string, options?: any): AxiosPromise<PressureFlowPipeResponseDto> {
            return localVarFp.calculatePressureFlowPipeUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SolidPrismatoidRequestDto} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePrismatoidUsingPOST(surfaceInletParams: SolidPrismatoidRequestDto, authorization?: string, options?: any): AxiosPromise<SolidPrismatoidResponseDto> {
            return localVarFp.calculatePrismatoidUsingPOST(surfaceInletParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Pump Drainage, takes PumpDrainageRequestDTO as input parameters and responds back with calculated values
         * @param {PumpDrainageRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePumpDrainageUsingPOST(request: PumpDrainageRequestDto, authorization?: string, options?: any): AxiosPromise<PumpDrainageResponseDTO> {
            return localVarFp.calculatePumpDrainageUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Rectangular Riser Drop, takes  RecRiserDropStructureRequestDto  as input parameters  and responds back with calculated values
         * @param {RecRiserDropStructureRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateRectRiserDropResultsUsingPOST(request: RecRiserDropStructureRequestDto, authorization?: string, options?: any): AxiosPromise<RecRiserDropStructureResponseDto> {
            return localVarFp.calculateRectRiserDropResultsUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Rectangular, takes RectangularRequestDto as input parameters and responds back with calculated values
         * @param {RectangularRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateRectangularUsingPOST(request: RectangularRequestDto, authorization?: string, options?: any): AxiosPromise<RectangularResponseDto> {
            return localVarFp.calculateRectangularUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
         * @param {StraightDropInletRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateStraightDropInletResultsUsingPOST(request: StraightDropInletRequestDto, authorization?: string, options?: any): AxiosPromise<StraightDropResponseDto> {
            return localVarFp.calculateStraightDropInletResultsUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Subsurface Drainage, takes SubsurfaceDrainRequestDTO as input parameters and responds back with calculated values
         * @param {SubsurfaceDrainRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSubsurfaceDrainageUsingPOST(request: SubsurfaceDrainRequestDTO, authorization?: string, options?: any): AxiosPromise<SubsurfaceDrainResponseDTO> {
            return localVarFp.calculateSubsurfaceDrainageUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet RequiredQ, takes  QRequiredRequestDTO  as input parameters  and responds back with calculated values
         * @param {number} opt opt
         * @param {string} inputParams inputParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSurfaceInletUsingPOST(opt: number, inputParams: string, authorization?: string, options?: any): AxiosPromise<SurfaceInletResponseDTO> {
            return localVarFp.calculateSurfaceInletUsingPOST(opt, inputParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
         * @param {SurfaceInletRequestDTO} surfaceInletParams SurfaceInletParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSurfaceInletUsingPOST1(surfaceInletParams: SurfaceInletRequestDTO, authorization?: string, options?: any): AxiosPromise<SurfaceInletResponseDTO> {
            return localVarFp.calculateSurfaceInletUsingPOST1(surfaceInletParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Trapezoidal Channel, takes  TrapezoidalChannelRequestDto  as input parameters  and responds back with calculated values
         * @param {TrapezoidalChannelRequestDto} trapezoidalChannelParams trapezoidalChannelParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTrapezoidalChannelUsingPOST(trapezoidalChannelParams: TrapezoidalChannelRequestDto, authorization?: string, options?: any): AxiosPromise<TrapezoidalChannelResponseDto> {
            return localVarFp.calculateTrapezoidalChannelUsingPOST(trapezoidalChannelParams, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
         * @param {WeirFlowRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateWeirFlowUsingPOST(request: WeirFlowRequest, authorization?: string, options?: any): AxiosPromise<WeirFlowResponseDto> {
            return localVarFp.calculateWeirFlowUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getHydraulicDefaultFromula
         * @param {string} hydraulicFormulaId hydraulicFormulaId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydraulicDefaultFromulaUsingGET(hydraulicFormulaId: string, authorization?: string, options?: any): AxiosPromise<HydraulicFormulasDefaultResponseDto> {
            return localVarFp.getHydraulicDefaultFromulaUsingGET(hydraulicFormulaId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateHydraulicDefaultFromula
         * @param {HydraulicFormulaDefaultRequestDto} hydraulicFormulaParams hydraulicFormulaParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHydraulicDefaultFromulaUsingPOST(hydraulicFormulaParams: HydraulicFormulaDefaultRequestDto, authorization?: string, options?: any): AxiosPromise<HydraulicFormulasDefaultResponseDto> {
            return localVarFp.updateHydraulicDefaultFromulaUsingPOST(hydraulicFormulaParams, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HydraulicFormulaControllerApi - object-oriented interface
 * @export
 * @class HydraulicFormulaControllerApi
 * @extends {BaseAPI}
 */
export class HydraulicFormulaControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API Calculates Gravity Flow in circular Section, takes  CircularSectionRequestDto  as input parameters  and responds back with calculated values
     * @param {CircularSectionRequestDto} circularSectionRequestDto circularSectionRequestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calGravityFlowInCircularSectionUsingPOST(circularSectionRequestDto: CircularSectionRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calGravityFlowInCircularSectionUsingPOST(circularSectionRequestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for VNotch Weir Flow, takes VNotchWeirRequestDto as input parameters and responds back with calculated values
     * @param {VNotchWeirRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calVNotchWeirFlowUsingPOST(request: VNotchWeirRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calVNotchWeirFlowUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Box Drop Inlet, takes  BoxDropInletDTO  as input parameters  and responds back with calculated values
     * @param {BoxDropInletDto} boxDropInletParams boxDropInletParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateBoxDropInletUsingPOST(boxDropInletParams: BoxDropInletDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateBoxDropInletUsingPOST(boxDropInletParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Circle, takes CircleRequestDto as input parameters and responds back with calculated values
     * @param {CircleRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateCircleUsingPOST(request: CircleRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateCircleUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
     * @param {SolidConeRequestDto} surfaceInletParams SurfaceInletParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateConeUsingPOST(surfaceInletParams: SolidConeRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateConeUsingPOST(surfaceInletParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Dry Hydrant, takes  DryHydrantRequestDto  as input parameters  and responds back with calculated values
     * @param {DryHydrantRequestDto} dryHydrantParams dryHydrantParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateDryHydrantUsingPOST(dryHydrantParams: DryHydrantRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateDryHydrantUsingPOST(dryHydrantParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for ETriangle, takes ETriangleRequestDto as input parameters and responds back with calculated values
     * @param {ETriangleRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateETriangleUsingPOST(request: ETriangleRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateETriangleUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Frustrum of Pyramid, takes  frustrumPyramidRequestDto  as input parameters  and responds back with calculated values
     * @param {FrustrumPyramidRequestDto} frustrumPyramidParams frustrumPyramidParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateFrustrumPyramidUsingPOST(frustrumPyramidParams: FrustrumPyramidRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateFrustrumPyramidUsingPOST(frustrumPyramidParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Hooded Inlet, takes  HoodedInletRequestDTO  as input parameters  and responds back with calculated values
     * @param {HoodedInletRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateHoodedInletResultsUsingPOST(request: HoodedInletRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateHoodedInletResultsUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
     * @param {InlineWaterControlRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateInlineWaterUsingPOST(request: InlineWaterControlRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateInlineWaterUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for OTriangle, takes OTriangleRequestDto as input parameters and responds back with calculated values
     * @param {OTriangleRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateOTriangleUsingPOST(request: OTriangleRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateOTriangleUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
     * @param {OrificeFlowRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateOrificeFlowUsingPOST(request: OrificeFlowRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateOrificeFlowUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Parabola, takes ParabolaRequestDto as input parameters and responds back with calculated values
     * @param {ParabolaRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateParabolaUsingPOST(request: ParabolaRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateParabolaUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Parabolic Channel, takes  ParabolicChannelRequestDto  as input parameters  and responds back with calculated values
     * @param {ParabolicChannelRequestDto} parabolicChannelParams parabolicChannelParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateParabolicChannelUsingPOST(parabolicChannelParams: ParabolicChannelRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateParabolicChannelUsingPOST(parabolicChannelParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Parallelogram, takes ParallelogramRequestDto as input parameters and responds back with calculated values
     * @param {ParallelogramRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateParallelogramUsingPOST(request: ParallelogramRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateParallelogramUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Pipe Drop, takes  PipeDropRequestDTO  as input parameters  and responds back with calculated values
     * @param {PipeDropRequestDto} pipeDropRequestDTO pipeDropRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculatePipeDropUsingPOST(pipeDropRequestDTO: PipeDropRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculatePipeDropUsingPOST(pipeDropRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Plune Pool, takes  PlungePoolRequestDTO  as input parameters  and responds back with calculated values
     * @param {PlungePoolRequestDto} plungePoolRequestDTO plungePoolRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculatePlungePoolUsingPOST(plungePoolRequestDTO: PlungePoolRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculatePlungePoolUsingPOST(plungePoolRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Pressure Flow, takes PressureFlowRequestDTO as input parameters and responds back with calculated values
     * @param {PressureFlowPipeRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculatePressureFlowPipeUsingPOST(request: PressureFlowPipeRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculatePressureFlowPipeUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
     * @param {SolidPrismatoidRequestDto} surfaceInletParams SurfaceInletParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculatePrismatoidUsingPOST(surfaceInletParams: SolidPrismatoidRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculatePrismatoidUsingPOST(surfaceInletParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Pump Drainage, takes PumpDrainageRequestDTO as input parameters and responds back with calculated values
     * @param {PumpDrainageRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculatePumpDrainageUsingPOST(request: PumpDrainageRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculatePumpDrainageUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Rectangular Riser Drop, takes  RecRiserDropStructureRequestDto  as input parameters  and responds back with calculated values
     * @param {RecRiserDropStructureRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateRectRiserDropResultsUsingPOST(request: RecRiserDropStructureRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateRectRiserDropResultsUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Rectangular, takes RectangularRequestDto as input parameters and responds back with calculated values
     * @param {RectangularRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateRectangularUsingPOST(request: RectangularRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateRectangularUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Straight Drop Inlet, takes  StraightDropInletRequestDto  as input parameters  and responds back with calculated values
     * @param {StraightDropInletRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateStraightDropInletResultsUsingPOST(request: StraightDropInletRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateStraightDropInletResultsUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Subsurface Drainage, takes SubsurfaceDrainRequestDTO as input parameters and responds back with calculated values
     * @param {SubsurfaceDrainRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateSubsurfaceDrainageUsingPOST(request: SubsurfaceDrainRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateSubsurfaceDrainageUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Surface Inlet RequiredQ, takes  QRequiredRequestDTO  as input parameters  and responds back with calculated values
     * @param {number} opt opt
     * @param {string} inputParams inputParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateSurfaceInletUsingPOST(opt: number, inputParams: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateSurfaceInletUsingPOST(opt, inputParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Surface Inlet, takes  SurfaceInletRequestDTO  as input parameters  and responds back with calculated values
     * @param {SurfaceInletRequestDTO} surfaceInletParams SurfaceInletParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateSurfaceInletUsingPOST1(surfaceInletParams: SurfaceInletRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateSurfaceInletUsingPOST1(surfaceInletParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Trapezoidal Channel, takes  TrapezoidalChannelRequestDto  as input parameters  and responds back with calculated values
     * @param {TrapezoidalChannelRequestDto} trapezoidalChannelParams trapezoidalChannelParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateTrapezoidalChannelUsingPOST(trapezoidalChannelParams: TrapezoidalChannelRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateTrapezoidalChannelUsingPOST(trapezoidalChannelParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates results for Surface Inlet, takes StraightDropInletRequestDto as input parameters and responds back with calculated values
     * @param {WeirFlowRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public calculateWeirFlowUsingPOST(request: WeirFlowRequest, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).calculateWeirFlowUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getHydraulicDefaultFromula
     * @param {string} hydraulicFormulaId hydraulicFormulaId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public getHydraulicDefaultFromulaUsingGET(hydraulicFormulaId: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).getHydraulicDefaultFromulaUsingGET(hydraulicFormulaId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateHydraulicDefaultFromula
     * @param {HydraulicFormulaDefaultRequestDto} hydraulicFormulaParams hydraulicFormulaParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicFormulaControllerApi
     */
    public updateHydraulicDefaultFromulaUsingPOST(hydraulicFormulaParams: HydraulicFormulaDefaultRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydraulicFormulaControllerApiFp(this.configuration).updateHydraulicDefaultFromulaUsingPOST(hydraulicFormulaParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HydroByAlignmentAoiControllerApi - axios parameter creator
 * @export
 */
export const HydroByAlignmentAoiControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getHydrologyProjectsByAlignmentAOI
         * @param {HydroByAlignmentAOIRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydrologyProjectsByAlignmentAOIUsingPOST: async (request: HydroByAlignmentAOIRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('getHydrologyProjectsByAlignmentAOIUsingPOST', 'request', request)
            const localVarPath = `/hydrology/getHydrologyProjectsByAlignmentAOI`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get related Hydrology Projects by passing design project uuid
         * @param {string} projectUUID projectUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydrologyProjectsByDesignProjUUIDUsingGET: async (projectUUID: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUUID' is not null or undefined
            assertParamExists('getHydrologyProjectsByDesignProjUUIDUsingGET', 'projectUUID', projectUUID)
            const localVarPath = `/hydrology/getHydrologyProjectsByDesignProjUUID/{projectUUID}`
                .replace(`{${"projectUUID"}}`, encodeURIComponent(String(projectUUID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HydroByAlignmentAoiControllerApi - functional programming interface
 * @export
 */
export const HydroByAlignmentAoiControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HydroByAlignmentAoiControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getHydrologyProjectsByAlignmentAOI
         * @param {HydroByAlignmentAOIRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHydrologyProjectsByAlignmentAOIUsingPOST(request: HydroByAlignmentAOIRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HydroByAlignmentAOIResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHydrologyProjectsByAlignmentAOIUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get related Hydrology Projects by passing design project uuid
         * @param {string} projectUUID projectUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHydrologyProjectsByDesignProjUUIDUsingGET(projectUUID: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HydroByAlignmentAOIResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHydrologyProjectsByDesignProjUUIDUsingGET(projectUUID, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HydroByAlignmentAoiControllerApi - factory interface
 * @export
 */
export const HydroByAlignmentAoiControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HydroByAlignmentAoiControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getHydrologyProjectsByAlignmentAOI
         * @param {HydroByAlignmentAOIRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydrologyProjectsByAlignmentAOIUsingPOST(request: HydroByAlignmentAOIRequestDTO, authorization?: string, options?: any): AxiosPromise<Array<HydroByAlignmentAOIResponseDTO>> {
            return localVarFp.getHydrologyProjectsByAlignmentAOIUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get related Hydrology Projects by passing design project uuid
         * @param {string} projectUUID projectUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydrologyProjectsByDesignProjUUIDUsingGET(projectUUID: string, authorization?: string, options?: any): AxiosPromise<Array<HydroByAlignmentAOIResponseDTO>> {
            return localVarFp.getHydrologyProjectsByDesignProjUUIDUsingGET(projectUUID, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HydroByAlignmentAoiControllerApi - object-oriented interface
 * @export
 * @class HydroByAlignmentAoiControllerApi
 * @extends {BaseAPI}
 */
export class HydroByAlignmentAoiControllerApi extends BaseAPI {
    /**
     * 
     * @summary getHydrologyProjectsByAlignmentAOI
     * @param {HydroByAlignmentAOIRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroByAlignmentAoiControllerApi
     */
    public getHydrologyProjectsByAlignmentAOIUsingPOST(request: HydroByAlignmentAOIRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydroByAlignmentAoiControllerApiFp(this.configuration).getHydrologyProjectsByAlignmentAOIUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get related Hydrology Projects by passing design project uuid
     * @param {string} projectUUID projectUUID
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroByAlignmentAoiControllerApi
     */
    public getHydrologyProjectsByDesignProjUUIDUsingGET(projectUUID: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroByAlignmentAoiControllerApiFp(this.configuration).getHydrologyProjectsByDesignProjUUIDUsingGET(projectUUID, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HydroControllerApi - axios parameter creator
 * @export
 */
export const HydroControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createHydro
         * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHydroUsingPOST: async (hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hydroRequestDto' is not null or undefined
            assertParamExists('createHydroUsingPOST', 'hydroRequestDto', hydroRequestDto)
            const localVarPath = `/hydro/createTerraceHydroParams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hydroRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST: async (alignmentDesignElementJsonId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentDesignElementJsonId' is not null or undefined
            assertParamExists('deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST', 'alignmentDesignElementJsonId', alignmentDesignElementJsonId)
            const localVarPath = `/hydro/deleteTerraceHydroParamsByAlignmentDesignElementJsonId/{alignmentDesignElementJsonId}`
                .replace(`{${"alignmentDesignElementJsonId"}}`, encodeURIComponent(String(alignmentDesignElementJsonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getHydroById
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroByIdUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getHydroByIdUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/hydro/getHydroImageByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getTerraceHydroByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceHydroByAlignedElementDesignParametersIdUsingGET: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getTerraceHydroByAlignedElementDesignParametersIdUsingGET', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/hydro/getTerraceHydroParamsByAlignedElementDesignParametersId/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET: async (alignmentDesignElementJsonId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentDesignElementJsonId' is not null or undefined
            assertParamExists('getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET', 'alignmentDesignElementJsonId', alignmentDesignElementJsonId)
            const localVarPath = `/hydro/getTerraceHydroParamsByAlignmentDesignElementJsonId/{alignmentDesignElementJsonId}`
                .replace(`{${"alignmentDesignElementJsonId"}}`, encodeURIComponent(String(alignmentDesignElementJsonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary hydroModelSimulation
         * @param {MiniHydroToolRequestDTO} miniHydroToolRequestDTO miniHydroToolRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydroModelSimulationUsingPOST: async (miniHydroToolRequestDTO: MiniHydroToolRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'miniHydroToolRequestDTO' is not null or undefined
            assertParamExists('hydroModelSimulationUsingPOST', 'miniHydroToolRequestDTO', miniHydroToolRequestDTO)
            const localVarPath = `/hydro/miniHydroTool/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(miniHydroToolRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSubBasin
         * @param {SubBasinRequest} subBasinRequest subBasinRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubBasinUsingPOST: async (subBasinRequest: SubBasinRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subBasinRequest' is not null or undefined
            assertParamExists('updateSubBasinUsingPOST', 'subBasinRequest', subBasinRequest)
            const localVarPath = `/hydro/updateSubBasin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subBasinRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST: async (alignmentDesignElementJsonId: number, hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentDesignElementJsonId' is not null or undefined
            assertParamExists('updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST', 'alignmentDesignElementJsonId', alignmentDesignElementJsonId)
            // verify required parameter 'hydroRequestDto' is not null or undefined
            assertParamExists('updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST', 'hydroRequestDto', hydroRequestDto)
            const localVarPath = `/hydro/updateTerraceHydroParamsByAlignmentDesignElementJsonId/{alignmentDesignElementJsonId}`
                .replace(`{${"alignmentDesignElementJsonId"}}`, encodeURIComponent(String(alignmentDesignElementJsonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hydroRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HydroControllerApi - functional programming interface
 * @export
 */
export const HydroControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HydroControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createHydro
         * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHydroUsingPOST(hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceHydroParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHydroUsingPOST(hydroRequestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getHydroById
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHydroByIdUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHydroByIdUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getTerraceHydroByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceHydroByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceHydroByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET(alignmentDesignElementJsonId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary hydroModelSimulation
         * @param {MiniHydroToolRequestDTO} miniHydroToolRequestDTO miniHydroToolRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hydroModelSimulationUsingPOST(miniHydroToolRequestDTO: MiniHydroToolRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MiniHydroToolResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hydroModelSimulationUsingPOST(miniHydroToolRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSubBasin
         * @param {SubBasinRequest} subBasinRequest subBasinRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubBasinUsingPOST(subBasinRequest: SubBasinRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubBasinResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubBasinUsingPOST(subBasinRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId: number, hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId, hydroRequestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HydroControllerApi - factory interface
 * @export
 */
export const HydroControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HydroControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createHydro
         * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHydroUsingPOST(hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options?: any): AxiosPromise<TerraceHydroParamsResponseDTO> {
            return localVarFp.createHydroUsingPOST(hydroRequestDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId: number, authorization?: string, options?: any): AxiosPromise<HydroResponseDto> {
            return localVarFp.deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getHydroById
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroByIdUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getHydroByIdUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getTerraceHydroByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceHydroByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<HydroResponseDto> {
            return localVarFp.getTerraceHydroByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: any): AxiosPromise<HydroResponseDto> {
            return localVarFp.getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET(alignmentDesignElementJsonId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary hydroModelSimulation
         * @param {MiniHydroToolRequestDTO} miniHydroToolRequestDTO miniHydroToolRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydroModelSimulationUsingPOST(miniHydroToolRequestDTO: MiniHydroToolRequestDTO, authorization?: string, options?: any): AxiosPromise<MiniHydroToolResponseDTO> {
            return localVarFp.hydroModelSimulationUsingPOST(miniHydroToolRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSubBasin
         * @param {SubBasinRequest} subBasinRequest subBasinRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubBasinUsingPOST(subBasinRequest: SubBasinRequest, authorization?: string, options?: any): AxiosPromise<SubBasinResponse> {
            return localVarFp.updateSubBasinUsingPOST(subBasinRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateTerraceHydroParamsByAlignmentDesignElementJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId: number, hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options?: any): AxiosPromise<HydroResponseDto> {
            return localVarFp.updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId, hydroRequestDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HydroControllerApi - object-oriented interface
 * @export
 * @class HydroControllerApi
 * @extends {BaseAPI}
 */
export class HydroControllerApi extends BaseAPI {
    /**
     * 
     * @summary createHydro
     * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public createHydroUsingPOST(hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).createHydroUsingPOST(hydroRequestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteTerraceHydroParamsByAlignmentDesignElementJsonId
     * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).deleteTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getHydroById
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getHydroByIdUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getHydroByIdUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getTerraceHydroByAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getTerraceHydroByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getTerraceHydroByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getTerraceHydroParamsByAlignmentDesignElementJsonId
     * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).getTerraceHydroParamsByAlignmentDesignElementJsonIdUsingGET(alignmentDesignElementJsonId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary hydroModelSimulation
     * @param {MiniHydroToolRequestDTO} miniHydroToolRequestDTO miniHydroToolRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public hydroModelSimulationUsingPOST(miniHydroToolRequestDTO: MiniHydroToolRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).hydroModelSimulationUsingPOST(miniHydroToolRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSubBasin
     * @param {SubBasinRequest} subBasinRequest subBasinRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public updateSubBasinUsingPOST(subBasinRequest: SubBasinRequest, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).updateSubBasinUsingPOST(subBasinRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateTerraceHydroParamsByAlignmentDesignElementJsonId
     * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
     * @param {TerraceHydroParamsDTO} hydroRequestDto hydroRequestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroControllerApi
     */
    public updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId: number, hydroRequestDto: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return HydroControllerApiFp(this.configuration).updateTerraceHydroParamsByAlignmentDesignElementJsonIdUsingPOST(alignmentDesignElementJsonId, hydroRequestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HydroWatershedControllerApi - axios parameter creator
 * @export
 */
export const HydroWatershedControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to add or update design element json database record for Hydrology Watershed Design.
         * @param {string} sessionUuid sessionUuid
         * @param {DesignElementJsonKeyValueDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateHydroWatershedDesignUsingPOST: async (sessionUuid: string, requestDto: DesignElementJsonKeyValueDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('addOrUpdateHydroWatershedDesignUsingPOST', 'sessionUuid', sessionUuid)
            // verify required parameter 'requestDto' is not null or undefined
            assertParamExists('addOrUpdateHydroWatershedDesignUsingPOST', 'requestDto', requestDto)
            const localVarPath = `/hydro/dem/design/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve all design element json records by design element type code
         * @param {number} designElementTypeCode designElementTypeCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBySessionAndDesignTypeIdUsingGET: async (designElementTypeCode: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementTypeCode' is not null or undefined
            assertParamExists('getBySessionAndDesignTypeIdUsingGET', 'designElementTypeCode', designElementTypeCode)
            const localVarPath = `/hydro/dem/design/getByDesignType/{designElementTypeCode}`
                .replace(`{${"designElementTypeCode"}}`, encodeURIComponent(String(designElementTypeCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve a design element json record for hydrology watershed design by session uuid and design element type code 18.
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBySessionAndDesignTypeIdUsingGET1: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getBySessionAndDesignTypeIdUsingGET1', 'sessionUuid', sessionUuid)
            const localVarPath = `/hydro/dem/design/getHydroWatershedDesignBy/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to load flowpathsegments related to hydrology project
         * @param {string} sessionUUID sessionUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadFlowPathSegmentsUsingGET: async (sessionUUID: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUUID' is not null or undefined
            assertParamExists('loadFlowPathSegmentsUsingGET', 'sessionUUID', sessionUUID)
            const localVarPath = `/hydro/dem/loadFlowPathSegments/{sessionUUID}`
                .replace(`{${"sessionUUID"}}`, encodeURIComponent(String(sessionUUID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to split flow path and calculate each segment of slope and length.
         * @param {SplitFlowSegmentDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitSegmentBySeparatorsUsingPOST: async (request: SplitFlowSegmentDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('splitSegmentBySeparatorsUsingPOST', 'request', request)
            const localVarPath = `/hydro/dem/design/splitSegmentBySeparators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HydroWatershedControllerApi - functional programming interface
 * @export
 */
export const HydroWatershedControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HydroWatershedControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to add or update design element json database record for Hydrology Watershed Design.
         * @param {string} sessionUuid sessionUuid
         * @param {DesignElementJsonKeyValueDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrUpdateHydroWatershedDesignUsingPOST(sessionUuid: string, requestDto: DesignElementJsonKeyValueDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroDesignElementJsonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrUpdateHydroWatershedDesignUsingPOST(sessionUuid, requestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve all design element json records by design element type code
         * @param {number} designElementTypeCode designElementTypeCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBySessionAndDesignTypeIdUsingGET(designElementTypeCode: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HydroDesignElementJsonDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBySessionAndDesignTypeIdUsingGET(designElementTypeCode, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve a design element json record for hydrology watershed design by session uuid and design element type code 18.
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBySessionAndDesignTypeIdUsingGET1(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HydroDesignElementJsonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBySessionAndDesignTypeIdUsingGET1(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to load flowpathsegments related to hydrology project
         * @param {string} sessionUUID sessionUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadFlowPathSegmentsUsingGET(sessionUUID: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadFlowPathSegmentsRespDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadFlowPathSegmentsUsingGET(sessionUUID, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to split flow path and calculate each segment of slope and length.
         * @param {SplitFlowSegmentDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitSegmentBySeparatorsUsingPOST(request: SplitFlowSegmentDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SplitFlowSegmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitSegmentBySeparatorsUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HydroWatershedControllerApi - factory interface
 * @export
 */
export const HydroWatershedControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HydroWatershedControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to add or update design element json database record for Hydrology Watershed Design.
         * @param {string} sessionUuid sessionUuid
         * @param {DesignElementJsonKeyValueDto} requestDto requestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateHydroWatershedDesignUsingPOST(sessionUuid: string, requestDto: DesignElementJsonKeyValueDto, authorization?: string, options?: any): AxiosPromise<HydroDesignElementJsonDto> {
            return localVarFp.addOrUpdateHydroWatershedDesignUsingPOST(sessionUuid, requestDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve all design element json records by design element type code
         * @param {number} designElementTypeCode designElementTypeCode
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBySessionAndDesignTypeIdUsingGET(designElementTypeCode: number, authorization?: string, options?: any): AxiosPromise<Array<HydroDesignElementJsonDto>> {
            return localVarFp.getBySessionAndDesignTypeIdUsingGET(designElementTypeCode, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve a design element json record for hydrology watershed design by session uuid and design element type code 18.
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBySessionAndDesignTypeIdUsingGET1(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<HydroDesignElementJsonDto> {
            return localVarFp.getBySessionAndDesignTypeIdUsingGET1(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to load flowpathsegments related to hydrology project
         * @param {string} sessionUUID sessionUUID
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadFlowPathSegmentsUsingGET(sessionUUID: string, authorization?: string, options?: any): AxiosPromise<LoadFlowPathSegmentsRespDTO> {
            return localVarFp.loadFlowPathSegmentsUsingGET(sessionUUID, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to split flow path and calculate each segment of slope and length.
         * @param {SplitFlowSegmentDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitSegmentBySeparatorsUsingPOST(request: SplitFlowSegmentDto, authorization?: string, options?: any): AxiosPromise<SplitFlowSegmentDto> {
            return localVarFp.splitSegmentBySeparatorsUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HydroWatershedControllerApi - object-oriented interface
 * @export
 * @class HydroWatershedControllerApi
 * @extends {BaseAPI}
 */
export class HydroWatershedControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to add or update design element json database record for Hydrology Watershed Design.
     * @param {string} sessionUuid sessionUuid
     * @param {DesignElementJsonKeyValueDto} requestDto requestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroWatershedControllerApi
     */
    public addOrUpdateHydroWatershedDesignUsingPOST(sessionUuid: string, requestDto: DesignElementJsonKeyValueDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydroWatershedControllerApiFp(this.configuration).addOrUpdateHydroWatershedDesignUsingPOST(sessionUuid, requestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve all design element json records by design element type code
     * @param {number} designElementTypeCode designElementTypeCode
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroWatershedControllerApi
     */
    public getBySessionAndDesignTypeIdUsingGET(designElementTypeCode: number, authorization?: string, options?: AxiosRequestConfig) {
        return HydroWatershedControllerApiFp(this.configuration).getBySessionAndDesignTypeIdUsingGET(designElementTypeCode, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve a design element json record for hydrology watershed design by session uuid and design element type code 18.
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroWatershedControllerApi
     */
    public getBySessionAndDesignTypeIdUsingGET1(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroWatershedControllerApiFp(this.configuration).getBySessionAndDesignTypeIdUsingGET1(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to load flowpathsegments related to hydrology project
     * @param {string} sessionUUID sessionUUID
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroWatershedControllerApi
     */
    public loadFlowPathSegmentsUsingGET(sessionUUID: string, authorization?: string, options?: AxiosRequestConfig) {
        return HydroWatershedControllerApiFp(this.configuration).loadFlowPathSegmentsUsingGET(sessionUUID, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to split flow path and calculate each segment of slope and length.
     * @param {SplitFlowSegmentDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydroWatershedControllerApi
     */
    public splitSegmentBySeparatorsUsingPOST(request: SplitFlowSegmentDto, authorization?: string, options?: AxiosRequestConfig) {
        return HydroWatershedControllerApiFp(this.configuration).splitSegmentBySeparatorsUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MonitoringControllerApi - axios parameter creator
 * @export
 */
export const MonitoringControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/monitoring/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MonitoringControllerApi - functional programming interface
 * @export
 */
export const MonitoringControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MonitoringControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck2UsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck2UsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MonitoringControllerApi - factory interface
 * @export
 */
export const MonitoringControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MonitoringControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary healthCheck2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck2UsingGET(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.healthCheck2UsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MonitoringControllerApi - object-oriented interface
 * @export
 * @class MonitoringControllerApi
 * @extends {BaseAPI}
 */
export class MonitoringControllerApi extends BaseAPI {
    /**
     * 
     * @summary healthCheck2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitoringControllerApi
     */
    public healthCheck2UsingGET(options?: AxiosRequestConfig) {
        return MonitoringControllerApiFp(this.configuration).healthCheck2UsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NetsDefaultParametersControllerApi - axios parameter creator
 * @export
 */
export const NetsDefaultParametersControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getNetsDefaultParameterJsonByDefaultItemName
         * @param {string} netsDefaultItemName netsDefaultItemName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetsDefaultParameterJsonByDefaultItemNameUsingGET: async (netsDefaultItemName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'netsDefaultItemName' is not null or undefined
            assertParamExists('getNetsDefaultParameterJsonByDefaultItemNameUsingGET', 'netsDefaultItemName', netsDefaultItemName)
            const localVarPath = `/netsDefaultParameters/getNetsDefaultParameterJsonByDefaultItemName/{netsDefaultItemName}`
                .replace(`{${"netsDefaultItemName"}}`, encodeURIComponent(String(netsDefaultItemName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NetsDefaultParametersControllerApi - functional programming interface
 * @export
 */
export const NetsDefaultParametersControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NetsDefaultParametersControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getNetsDefaultParameterJsonByDefaultItemName
         * @param {string} netsDefaultItemName netsDefaultItemName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNetsDefaultParameterJsonByDefaultItemNameUsingGET(netsDefaultItemName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NetsDefaultParametersResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNetsDefaultParameterJsonByDefaultItemNameUsingGET(netsDefaultItemName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NetsDefaultParametersControllerApi - factory interface
 * @export
 */
export const NetsDefaultParametersControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NetsDefaultParametersControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getNetsDefaultParameterJsonByDefaultItemName
         * @param {string} netsDefaultItemName netsDefaultItemName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetsDefaultParameterJsonByDefaultItemNameUsingGET(netsDefaultItemName: string, authorization?: string, options?: any): AxiosPromise<Array<NetsDefaultParametersResponseDTO>> {
            return localVarFp.getNetsDefaultParameterJsonByDefaultItemNameUsingGET(netsDefaultItemName, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NetsDefaultParametersControllerApi - object-oriented interface
 * @export
 * @class NetsDefaultParametersControllerApi
 * @extends {BaseAPI}
 */
export class NetsDefaultParametersControllerApi extends BaseAPI {
    /**
     * 
     * @summary getNetsDefaultParameterJsonByDefaultItemName
     * @param {string} netsDefaultItemName netsDefaultItemName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetsDefaultParametersControllerApi
     */
    public getNetsDefaultParameterJsonByDefaultItemNameUsingGET(netsDefaultItemName: string, authorization?: string, options?: AxiosRequestConfig) {
        return NetsDefaultParametersControllerApiFp(this.configuration).getNetsDefaultParameterJsonByDefaultItemNameUsingGET(netsDefaultItemName, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProfileControllerApi - axios parameter creator
 * @export
 */
export const ProfileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary generateProfile
         * @param {ProfileRequestDTO} profileRequestDTO profileRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProfileUsingPOST: async (profileRequestDTO: ProfileRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileRequestDTO' is not null or undefined
            assertParamExists('generateProfileUsingPOST', 'profileRequestDTO', profileRequestDTO)
            const localVarPath = `/profile/generateProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getGroundElevationByReachStationDistanceFromAlignment
         * @param {GroundElevationRequestDTO} groundElevationRequestDTO groundElevationRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroundElevationByReachStationDistanceFromAlignmentUsingPOST: async (groundElevationRequestDTO: GroundElevationRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groundElevationRequestDTO' is not null or undefined
            assertParamExists('getGroundElevationByReachStationDistanceFromAlignmentUsingPOST', 'groundElevationRequestDTO', groundElevationRequestDTO)
            const localVarPath = `/profile/getGroundElevationByReachStationDistanceFromAlignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groundElevationRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileControllerApi - functional programming interface
 * @export
 */
export const ProfileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary generateProfile
         * @param {ProfileRequestDTO} profileRequestDTO profileRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateProfileUsingPOST(profileRequestDTO: ProfileRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateProfileUsingPOST(profileRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getGroundElevationByReachStationDistanceFromAlignment
         * @param {GroundElevationRequestDTO} groundElevationRequestDTO groundElevationRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(groundElevationRequestDTO: GroundElevationRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroundElevationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(groundElevationRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfileControllerApi - factory interface
 * @export
 */
export const ProfileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary generateProfile
         * @param {ProfileRequestDTO} profileRequestDTO profileRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProfileUsingPOST(profileRequestDTO: ProfileRequestDTO, authorization?: string, options?: any): AxiosPromise<ProfileResponseDTO> {
            return localVarFp.generateProfileUsingPOST(profileRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getGroundElevationByReachStationDistanceFromAlignment
         * @param {GroundElevationRequestDTO} groundElevationRequestDTO groundElevationRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(groundElevationRequestDTO: GroundElevationRequestDTO, authorization?: string, options?: any): AxiosPromise<GroundElevationResponseDTO> {
            return localVarFp.getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(groundElevationRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileControllerApi - object-oriented interface
 * @export
 * @class ProfileControllerApi
 * @extends {BaseAPI}
 */
export class ProfileControllerApi extends BaseAPI {
    /**
     * 
     * @summary generateProfile
     * @param {ProfileRequestDTO} profileRequestDTO profileRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public generateProfileUsingPOST(profileRequestDTO: ProfileRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).generateProfileUsingPOST(profileRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getGroundElevationByReachStationDistanceFromAlignment
     * @param {GroundElevationRequestDTO} groundElevationRequestDTO groundElevationRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(groundElevationRequestDTO: GroundElevationRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return ProfileControllerApiFp(this.configuration).getGroundElevationByReachStationDistanceFromAlignmentUsingPOST(groundElevationRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceStatusControllerApi - axios parameter creator
 * @export
 */
export const ServiceStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/entityCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/healthCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck_core`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck_framework
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckFrameworkUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck_framework`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/manifestCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/serviceStatus/profileCheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceStatusControllerApi - functional programming interface
 * @export
 */
export const ServiceStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckCoreUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckCoreUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck_framework
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckFrameworkUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckFrameworkUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manifestCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manifestCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileCheckUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileCheckUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceStatusControllerApi - factory interface
 * @export
 */
export const ServiceStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary entityCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.entityCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary healthCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.healthCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck_core
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckCoreUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckCoreUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck_framework
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckFrameworkUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckFrameworkUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary manifestCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manifestCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.manifestCheckUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary profileCheck
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileCheckUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.profileCheckUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceStatusControllerApi - object-oriented interface
 * @export
 * @class ServiceStatusControllerApi
 * @extends {BaseAPI}
 */
export class ServiceStatusControllerApi extends BaseAPI {
    /**
     * 
     * @summary entityCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public entityCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).entityCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary healthCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public healthCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).healthCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck_core
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckCoreUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckCoreUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck_framework
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckFrameworkUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckFrameworkUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary manifestCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public manifestCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).manifestCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary profileCheck
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceStatusControllerApi
     */
    public profileCheckUsingGET(options?: AxiosRequestConfig) {
        return ServiceStatusControllerApiFp(this.configuration).profileCheckUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SetSurveyControllerApi - axios parameter creator
 * @export
 */
export const SetSurveyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary deleteSurvey
         * @param {SurveyMetadata} surveyInfo surveyInfo
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyUsingPOST: async (surveyInfo: SurveyMetadata, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyInfo' is not null or undefined
            assertParamExists('deleteSurveyUsingPOST', 'surveyInfo', surveyInfo)
            const localVarPath = `/survey/deleteSurvey/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileUsingGET: async (fileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('downloadFileUsingGET', 'fileName', fileName)
            const localVarPath = `/survey/downloadLandXmlFile/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary editSurvey
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSurveyUsingPOST: async (inputpoints: SurveyPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('editSurveyUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/editSurvey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary exportSurveysToCSV
         * @param {ExportSurvToCSVRequest} cSVReq CSVReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSurveysToCSVUsingPOST: async (cSVReq: ExportSurvToCSVRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cSVReq' is not null or undefined
            assertParamExists('exportSurveysToCSVUsingPOST', 'cSVReq', cSVReq)
            const localVarPath = `/survey/exportSurveysToCSV`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cSVReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateBorder
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBorderUsingPOST: async (inputpoints: InputXYZPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('generateBorderUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/settools/genBorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateGeojsonContourLines
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGeojsonContourLinesUsingPOST: async (inputpoints: InputXYZPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('generateGeojsonContourLinesUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/settools/genContour`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateGeojson
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGeojsonUsingPOST: async (inputpoints: InputXYZPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('generateGeojsonUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/settools/genGeoJson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateLandxmlFromDB
         * @param {string} surveyprjId surveyprjId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLandxmlFromDBUsingGET: async (surveyprjId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyprjId' is not null or undefined
            assertParamExists('generateLandxmlFromDBUsingGET', 'surveyprjId', surveyprjId)
            const localVarPath = `/survey/genLandXml/{surveyprjId}`
                .replace(`{${"surveyprjId"}}`, encodeURIComponent(String(surveyprjId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateLandxml
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLandxmlUsingPOST: async (inputpoints: InputXYZPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('generateLandxmlUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/settools/genLandXml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateSurveyZip
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSurveyZipUsingPOST: async (inputpoints: InputXYZPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('generateSurveyZipUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/genSurveyZip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateTins
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTinsUsingPOST: async (inputpoints: InputXYZPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('generateTinsUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/settools/genTins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSurvey
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyUsingGET: async (surveyId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getSurveyUsingGET', 'surveyId', surveyId)
            const localVarPath = `/survey/getSurveyPoints/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSurveyZip
         * @param {string} zipFileName zipFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyZipUsingGET: async (zipFileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zipFileName' is not null or undefined
            assertParamExists('getSurveyZipUsingGET', 'zipFileName', zipFileName)
            const localVarPath = `/survey/downloadSurveyZip/{zipFileName}`
                .replace(`{${"zipFileName"}}`, encodeURIComponent(String(zipFileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary hardDeleteSurvey
         * @param {string} sessionId sessionId
         * @param {string} surveyIds surveyIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteSurveyUsingDELETE: async (sessionId: string, surveyIds: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('hardDeleteSurveyUsingDELETE', 'sessionId', sessionId)
            // verify required parameter 'surveyIds' is not null or undefined
            assertParamExists('hardDeleteSurveyUsingDELETE', 'surveyIds', surveyIds)
            const localVarPath = `/survey/delete/{sessionId}/{surveyIds}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"surveyIds"}}`, encodeURIComponent(String(surveyIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary loadSurveyNew
         * @param {number} interval interval
         * @param {SurveyPoints} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSurveyNewUsingPOST: async (interval: number, inputPoints: SurveyPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interval' is not null or undefined
            assertParamExists('loadSurveyNewUsingPOST', 'interval', interval)
            // verify required parameter 'inputPoints' is not null or undefined
            assertParamExists('loadSurveyNewUsingPOST', 'inputPoints', inputPoints)
            const localVarPath = `/survey/loadSurvey/{interval}`
                .replace(`{${"interval"}}`, encodeURIComponent(String(interval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputPoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary loadSurveyNew
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loadSurveyNewUsingPOST1: async (inputpoints: SurveyPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('loadSurveyNewUsingPOST1', 'inputpoints', inputpoints)
            const localVarPath = `/survey/loadSurveyNew`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary loadSurvey
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loadSurveyUsingPOST: async (inputpoints: SurveyPoints, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputpoints' is not null or undefined
            assertParamExists('loadSurveyUsingPOST', 'inputpoints', inputpoints)
            const localVarPath = `/survey/loadSurvey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputpoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testUsingGET: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey/settools`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validateSurveyDataWithinDefinedUTMandCounty
         * @param {SurveyDataWithinDefinedUTMandCountyRequest} sddUTMCtyreq sddUTMCtyreq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSurveyDataWithinDefinedUTMandCountyUsingPOST: async (sddUTMCtyreq: SurveyDataWithinDefinedUTMandCountyRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sddUTMCtyreq' is not null or undefined
            assertParamExists('validateSurveyDataWithinDefinedUTMandCountyUsingPOST', 'sddUTMCtyreq', sddUTMCtyreq)
            const localVarPath = `/survey/validateSurveyDataWithinDefinedUTMandCounty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sddUTMCtyreq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SetSurveyControllerApi - functional programming interface
 * @export
 */
export const SetSurveyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SetSurveyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary deleteSurvey
         * @param {SurveyMetadata} surveyInfo surveyInfo
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurveyUsingPOST(surveyInfo: SurveyMetadata, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurveyUsingPOST(surveyInfo, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileUsingGET(fileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileUsingGET(fileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary editSurvey
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editSurveyUsingPOST(inputpoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSurveyUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary exportSurveysToCSV
         * @param {ExportSurvToCSVRequest} cSVReq CSVReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSurveysToCSVUsingPOST(cSVReq: ExportSurvToCSVRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSurveysToCSVUsingPOST(cSVReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateBorder
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateBorderUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateBorderUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateGeojsonContourLines
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateGeojsonContourLinesUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateGeojsonContourLinesUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateGeojson
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateGeojsonUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateGeojsonUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateLandxmlFromDB
         * @param {string} surveyprjId surveyprjId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLandxmlFromDBUsingGET(surveyprjId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLandxmlFromDBUsingGET(surveyprjId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateLandxml
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLandxmlUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLandxmlUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateSurveyZip
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSurveyZipUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSurveyZipUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateTins
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTinsUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTinsUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSurvey
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyUsingGET(surveyId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyPoints>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyUsingGET(surveyId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSurveyZip
         * @param {string} zipFileName zipFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyZipUsingGET(zipFileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyZipUsingGET(zipFileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary hardDeleteSurvey
         * @param {string} sessionId sessionId
         * @param {string} surveyIds surveyIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hardDeleteSurveyUsingDELETE(sessionId: string, surveyIds: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hardDeleteSurveyUsingDELETE(sessionId, surveyIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary loadSurveyNew
         * @param {number} interval interval
         * @param {SurveyPoints} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadSurveyNewUsingPOST(interval: number, inputPoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadSurveyNewUsingPOST(interval, inputPoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary loadSurveyNew
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async loadSurveyNewUsingPOST1(inputpoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadSurveyNewUsingPOST1(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary loadSurvey
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async loadSurveyUsingPOST(inputpoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadSurveyUsingPOST(inputpoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testUsingGET(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary validateSurveyDataWithinDefinedUTMandCounty
         * @param {SurveyDataWithinDefinedUTMandCountyRequest} sddUTMCtyreq sddUTMCtyreq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSurveyDataWithinDefinedUTMandCountyUsingPOST(sddUTMCtyreq: SurveyDataWithinDefinedUTMandCountyRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDataWithinDefinedUTMandCountyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSurveyDataWithinDefinedUTMandCountyUsingPOST(sddUTMCtyreq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SetSurveyControllerApi - factory interface
 * @export
 */
export const SetSurveyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SetSurveyControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary deleteSurvey
         * @param {SurveyMetadata} surveyInfo surveyInfo
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyUsingPOST(surveyInfo: SurveyMetadata, authorization?: string, options?: any): AxiosPromise<SurveyMetadataResponse> {
            return localVarFp.deleteSurveyUsingPOST(surveyInfo, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileUsingGET(fileName: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadFileUsingGET(fileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary editSurvey
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSurveyUsingPOST(inputpoints: SurveyPoints, authorization?: string, options?: any): AxiosPromise<SurveyResponse> {
            return localVarFp.editSurveyUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary exportSurveysToCSV
         * @param {ExportSurvToCSVRequest} cSVReq CSVReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSurveysToCSVUsingPOST(cSVReq: ExportSurvToCSVRequest, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportSurveysToCSVUsingPOST(cSVReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateBorder
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBorderUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateBorderUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateGeojsonContourLines
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGeojsonContourLinesUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateGeojsonContourLinesUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateGeojson
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGeojsonUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateGeojsonUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateLandxmlFromDB
         * @param {string} surveyprjId surveyprjId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLandxmlFromDBUsingGET(surveyprjId: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateLandxmlFromDBUsingGET(surveyprjId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateLandxml
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLandxmlUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateLandxmlUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateSurveyZip
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSurveyZipUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateSurveyZipUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateTins
         * @param {InputXYZPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTinsUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.generateTinsUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSurvey
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyUsingGET(surveyId: string, authorization?: string, options?: any): AxiosPromise<SurveyPoints> {
            return localVarFp.getSurveyUsingGET(surveyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSurveyZip
         * @param {string} zipFileName zipFileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyZipUsingGET(zipFileName: string, authorization?: string, options?: any): AxiosPromise<Resource> {
            return localVarFp.getSurveyZipUsingGET(zipFileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary hardDeleteSurvey
         * @param {string} sessionId sessionId
         * @param {string} surveyIds surveyIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hardDeleteSurveyUsingDELETE(sessionId: string, surveyIds: string, authorization?: string, options?: any): AxiosPromise<DeleteSurveyResponse> {
            return localVarFp.hardDeleteSurveyUsingDELETE(sessionId, surveyIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary loadSurveyNew
         * @param {number} interval interval
         * @param {SurveyPoints} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSurveyNewUsingPOST(interval: number, inputPoints: SurveyPoints, authorization?: string, options?: any): AxiosPromise<SurveyResponse> {
            return localVarFp.loadSurveyNewUsingPOST(interval, inputPoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary loadSurveyNew
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loadSurveyNewUsingPOST1(inputpoints: SurveyPoints, authorization?: string, options?: any): AxiosPromise<SurveyResponse> {
            return localVarFp.loadSurveyNewUsingPOST1(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary loadSurvey
         * @param {SurveyPoints} inputpoints inputpoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        loadSurveyUsingPOST(inputpoints: SurveyPoints, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.loadSurveyUsingPOST(inputpoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary test
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.testUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary validateSurveyDataWithinDefinedUTMandCounty
         * @param {SurveyDataWithinDefinedUTMandCountyRequest} sddUTMCtyreq sddUTMCtyreq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSurveyDataWithinDefinedUTMandCountyUsingPOST(sddUTMCtyreq: SurveyDataWithinDefinedUTMandCountyRequest, authorization?: string, options?: any): AxiosPromise<SurveyDataWithinDefinedUTMandCountyResponse> {
            return localVarFp.validateSurveyDataWithinDefinedUTMandCountyUsingPOST(sddUTMCtyreq, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SetSurveyControllerApi - object-oriented interface
 * @export
 * @class SetSurveyControllerApi
 * @extends {BaseAPI}
 */
export class SetSurveyControllerApi extends BaseAPI {
    /**
     * 
     * @summary deleteSurvey
     * @param {SurveyMetadata} surveyInfo surveyInfo
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public deleteSurveyUsingPOST(surveyInfo: SurveyMetadata, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).deleteSurveyUsingPOST(surveyInfo, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadFile
     * @param {string} fileName fileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public downloadFileUsingGET(fileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).downloadFileUsingGET(fileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary editSurvey
     * @param {SurveyPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public editSurveyUsingPOST(inputpoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).editSurveyUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary exportSurveysToCSV
     * @param {ExportSurvToCSVRequest} cSVReq CSVReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public exportSurveysToCSVUsingPOST(cSVReq: ExportSurvToCSVRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).exportSurveysToCSVUsingPOST(cSVReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateBorder
     * @param {InputXYZPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public generateBorderUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).generateBorderUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateGeojsonContourLines
     * @param {InputXYZPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public generateGeojsonContourLinesUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).generateGeojsonContourLinesUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateGeojson
     * @param {InputXYZPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public generateGeojsonUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).generateGeojsonUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateLandxmlFromDB
     * @param {string} surveyprjId surveyprjId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public generateLandxmlFromDBUsingGET(surveyprjId: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).generateLandxmlFromDBUsingGET(surveyprjId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateLandxml
     * @param {InputXYZPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public generateLandxmlUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).generateLandxmlUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateSurveyZip
     * @param {InputXYZPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public generateSurveyZipUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).generateSurveyZipUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateTins
     * @param {InputXYZPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public generateTinsUsingPOST(inputpoints: InputXYZPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).generateTinsUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSurvey
     * @param {string} surveyId surveyId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public getSurveyUsingGET(surveyId: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).getSurveyUsingGET(surveyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSurveyZip
     * @param {string} zipFileName zipFileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public getSurveyZipUsingGET(zipFileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).getSurveyZipUsingGET(zipFileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary hardDeleteSurvey
     * @param {string} sessionId sessionId
     * @param {string} surveyIds surveyIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public hardDeleteSurveyUsingDELETE(sessionId: string, surveyIds: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).hardDeleteSurveyUsingDELETE(sessionId, surveyIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary loadSurveyNew
     * @param {number} interval interval
     * @param {SurveyPoints} inputPoints inputPoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public loadSurveyNewUsingPOST(interval: number, inputPoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).loadSurveyNewUsingPOST(interval, inputPoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary loadSurveyNew
     * @param {SurveyPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public loadSurveyNewUsingPOST1(inputpoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).loadSurveyNewUsingPOST1(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary loadSurvey
     * @param {SurveyPoints} inputpoints inputpoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public loadSurveyUsingPOST(inputpoints: SurveyPoints, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).loadSurveyUsingPOST(inputpoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary test
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public testUsingGET(options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).testUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary validateSurveyDataWithinDefinedUTMandCounty
     * @param {SurveyDataWithinDefinedUTMandCountyRequest} sddUTMCtyreq sddUTMCtyreq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyControllerApi
     */
    public validateSurveyDataWithinDefinedUTMandCountyUsingPOST(sddUTMCtyreq: SurveyDataWithinDefinedUTMandCountyRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyControllerApiFp(this.configuration).validateSurveyDataWithinDefinedUTMandCountyUsingPOST(sddUTMCtyreq, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SetSurveyStationOffsetControllerApi - axios parameter creator
 * @export
 */
export const SetSurveyStationOffsetControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createAlignmentStation
         * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlignmentStationUsingPOST: async (alignmentStationDTO: AlignmentStationDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentStationDTO' is not null or undefined
            assertParamExists('createAlignmentStationUsingPOST', 'alignmentStationDTO', alignmentStationDTO)
            const localVarPath = `/stationOffset/createAlignmentStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentStationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createAlignment
         * @param {AlignmentDTO} alignmentDTO alignmentDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlignmentUsingPOST: async (alignmentDTO: AlignmentDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentDTO' is not null or undefined
            assertParamExists('createAlignmentUsingPOST', 'alignmentDTO', alignmentDTO)
            const localVarPath = `/stationOffset/createAlignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createCrossSlopeStation
         * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopeStationUsingPOST: async (crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeStationDTO' is not null or undefined
            assertParamExists('createCrossSlopeStationUsingPOST', 'crossSlopeStationDTO', crossSlopeStationDTO)
            const localVarPath = `/stationOffset/createCrossSlopeStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeStationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createCrossSlope
         * @param {CrossSlopeDTO} crossSlopeDTO crossSlopeDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopeUsingPOST: async (crossSlopeDTO: CrossSlopeDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeDTO' is not null or undefined
            assertParamExists('createCrossSlopeUsingPOST', 'crossSlopeDTO', crossSlopeDTO)
            const localVarPath = `/stationOffset/createCrossSlope`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createOffsetStationInput
         * @param {OffsetStationDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationInputUsingPOST: async (inputPoints: OffsetStationDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputPoints' is not null or undefined
            assertParamExists('createOffsetStationInputUsingPOST', 'inputPoints', inputPoints)
            const localVarPath = `/stationOffset/createOffsetStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputPoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createOffsetStationOffset
         * @param {SurveyEngineeringProjectDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationOffsetUsingPOST: async (inputPoints: SurveyEngineeringProjectDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputPoints' is not null or undefined
            assertParamExists('createOffsetStationOffsetUsingPOST', 'inputPoints', inputPoints)
            const localVarPath = `/stationOffset/createOffsetStationOffset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputPoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteAlignmentStation
         * @param {number} alignmentStationId alignmentStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignmentStationUsingPOST: async (alignmentStationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentStationId' is not null or undefined
            assertParamExists('deleteAlignmentStationUsingPOST', 'alignmentStationId', alignmentStationId)
            const localVarPath = `/stationOffset/deleteAlignmentStation/{alignmentStationId}`
                .replace(`{${"alignmentStationId"}}`, encodeURIComponent(String(alignmentStationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteAlignment
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignmentUsingPOST: async (alignmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentId' is not null or undefined
            assertParamExists('deleteAlignmentUsingPOST', 'alignmentId', alignmentId)
            const localVarPath = `/stationOffset/deleteAlignment/{alignmentId}`
                .replace(`{${"alignmentId"}}`, encodeURIComponent(String(alignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteCrossSlopeStation
         * @param {number} crossSlopeStationId crossSlopeStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeStationUsingPOST: async (crossSlopeStationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeStationId' is not null or undefined
            assertParamExists('deleteCrossSlopeStationUsingPOST', 'crossSlopeStationId', crossSlopeStationId)
            const localVarPath = `/stationOffset/deleteCrossSlopeStation/{crossSlopeStationId}`
                .replace(`{${"crossSlopeStationId"}}`, encodeURIComponent(String(crossSlopeStationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteCrossSlope
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeUsingPOST: async (crossSlopeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeId' is not null or undefined
            assertParamExists('deleteCrossSlopeUsingPOST', 'crossSlopeId', crossSlopeId)
            const localVarPath = `/stationOffset/deleteCrossSlope/{crossSlopeId}`
                .replace(`{${"crossSlopeId"}}`, encodeURIComponent(String(crossSlopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteOffsetStationOffset
         * @param {number} offsetStationOffsetId offsetStationOffsetId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationOffsetUsingPOST: async (offsetStationOffsetId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetStationOffsetId' is not null or undefined
            assertParamExists('deleteOffsetStationOffsetUsingPOST', 'offsetStationOffsetId', offsetStationOffsetId)
            const localVarPath = `/stationOffset/deleteOffsetStationOffset/{offsetStationOffsetId}`
                .replace(`{${"offsetStationOffsetId"}}`, encodeURIComponent(String(offsetStationOffsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteOffsetStation
         * @param {number} offsetStationId offsetStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationUsingPOST: async (offsetStationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetStationId' is not null or undefined
            assertParamExists('deleteOffsetStationUsingPOST', 'offsetStationId', offsetStationId)
            const localVarPath = `/stationOffset/deleteOffsetStation/{offsetStationId}`
                .replace(`{${"offsetStationId"}}`, encodeURIComponent(String(offsetStationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteStationOffsetCrossSlope
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStationOffsetCrossSlopeUsingPOST: async (surveyId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('deleteStationOffsetCrossSlopeUsingPOST', 'surveyId', surveyId)
            const localVarPath = `/stationOffset/deleteStationOffsetCrossSlope/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteStationOffsetSpreadsheet
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStationOffsetSpreadsheetUsingPOST: async (surveyId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('deleteStationOffsetSpreadsheetUsingPOST', 'surveyId', surveyId)
            const localVarPath = `/stationOffset/deleteStationOffsetSpreadsheet/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateSOSurveyXYZPointsFromCrossSlope
         * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSOSurveyXYZPointsFromCrossSlopeUsingPOST: async (aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aliStationsJson' is not null or undefined
            assertParamExists('generateSOSurveyXYZPointsFromCrossSlopeUsingPOST', 'aliStationsJson', aliStationsJson)
            const localVarPath = `/stationOffset/generateSOSurveyXYZPointsForCrossSlope`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aliStationsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateSOSurveyXYZPoints
         * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSOSurveyXYZPointsUsingPOST: async (aliStationsJson: SOSurveyInputParm, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aliStationsJson' is not null or undefined
            assertParamExists('generateSOSurveyXYZPointsUsingPOST', 'aliStationsJson', aliStationsJson)
            const localVarPath = `/stationOffset/generateSOSurveyXYZPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aliStationsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignmentBySurveyIds
         * @param {AlignmentBySurveyIdsRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentBySurveyIdsUsingGET: async (req: AlignmentBySurveyIdsRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getAlignmentBySurveyIdsUsingGET', 'req', req)
            const localVarPath = `/stationOffset/getAlignmentBySurveyIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignmentStation
         * @param {number} alignmentStationId alignmentStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentStationUsingGET: async (alignmentStationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentStationId' is not null or undefined
            assertParamExists('getAlignmentStationUsingGET', 'alignmentStationId', alignmentStationId)
            const localVarPath = `/stationOffset/getAlignmentStation/{alignmentStationId}`
                .replace(`{${"alignmentStationId"}}`, encodeURIComponent(String(alignmentStationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignment
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentUsingGET: async (alignmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentId' is not null or undefined
            assertParamExists('getAlignmentUsingGET', 'alignmentId', alignmentId)
            const localVarPath = `/stationOffset/getAlignment/{alignmentId}`
                .replace(`{${"alignmentId"}}`, encodeURIComponent(String(alignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignmentsMetadata
         * @param {AlignmentMetadataRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentsMetadataUsingPOST: async (req: AlignmentMetadataRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getAlignmentsMetadataUsingPOST', 'req', req)
            const localVarPath = `/stationOffset/getAlignmentsMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getClossSlope
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClossSlopeUsingGET: async (crossSlopeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeId' is not null or undefined
            assertParamExists('getClossSlopeUsingGET', 'crossSlopeId', crossSlopeId)
            const localVarPath = `/stationOffset/getCrossSlope/{crossSlopeId}`
                .replace(`{${"crossSlopeId"}}`, encodeURIComponent(String(crossSlopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCrossSlopeStation
         * @param {number} crossSlopeStationId crossSlopeStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeStationUsingGET: async (crossSlopeStationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeStationId' is not null or undefined
            assertParamExists('getCrossSlopeStationUsingGET', 'crossSlopeStationId', crossSlopeStationId)
            const localVarPath = `/stationOffset/getCrossSlopeStation/{crossSlopeStationId}`
                .replace(`{${"crossSlopeStationId"}}`, encodeURIComponent(String(crossSlopeStationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCrossSlopeSurveyById
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeSurveyByIdUsingGET: async (surveyId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getCrossSlopeSurveyByIdUsingGET', 'surveyId', surveyId)
            const localVarPath = `/stationOffset/getCrossSlopeSurvey/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getOffsetStationOffset
         * @param {number} offsetStationOffsetId offsetStationOffsetId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationOffsetUsingGET: async (offsetStationOffsetId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetStationOffsetId' is not null or undefined
            assertParamExists('getOffsetStationOffsetUsingGET', 'offsetStationOffsetId', offsetStationOffsetId)
            const localVarPath = `/stationOffset/getOffsetStationOffset/{offsetStationOffsetId}`
                .replace(`{${"offsetStationOffsetId"}}`, encodeURIComponent(String(offsetStationOffsetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getOffsetStation
         * @param {number} offsetStationId offsetStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationUsingGET: async (offsetStationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetStationId' is not null or undefined
            assertParamExists('getOffsetStationUsingGET', 'offsetStationId', offsetStationId)
            const localVarPath = `/stationOffset/getOffsetStation/{offsetStationId}`
                .replace(`{${"offsetStationId"}}`, encodeURIComponent(String(offsetStationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getStationOffsetSpreadsheet
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationOffsetSpreadsheetUsingGET: async (surveyId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyId' is not null or undefined
            assertParamExists('getStationOffsetSpreadsheetUsingGET', 'surveyId', surveyId)
            const localVarPath = `/stationOffset/getStationOffsetSpreadsheet/{surveyId}`
                .replace(`{${"surveyId"}}`, encodeURIComponent(String(surveyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveSOSurveyCrossSlope
         * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSOSurveyCrossSlopeUsingPOST: async (aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aliStationsJson' is not null or undefined
            assertParamExists('saveSOSurveyCrossSlopeUsingPOST', 'aliStationsJson', aliStationsJson)
            const localVarPath = `/stationOffset/saveSOSurveyCrossSlope`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aliStationsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveSOSurvey
         * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSOSurveyUsingPOST: async (aliStationsJson: SOSurveyInputParm, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aliStationsJson' is not null or undefined
            assertParamExists('saveSOSurveyUsingPOST', 'aliStationsJson', aliStationsJson)
            const localVarPath = `/stationOffset/saveSOSurveySpreadsheet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aliStationsJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateAlignmentStation
         * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlignmentStationUsingPOST: async (alignmentStationDTO: AlignmentStationDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentStationDTO' is not null or undefined
            assertParamExists('updateAlignmentStationUsingPOST', 'alignmentStationDTO', alignmentStationDTO)
            const localVarPath = `/stationOffset/updateAlignmentStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentStationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateAlignment
         * @param {AlignmentDTO} alignmentDto alignmentDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlignmentUsingPOST: async (alignmentDto: AlignmentDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentDto' is not null or undefined
            assertParamExists('updateAlignmentUsingPOST', 'alignmentDto', alignmentDto)
            const localVarPath = `/stationOffset/updateAlignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateCrossSlopeStation
         * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopeStationUsingPOST1: async (crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeStationDTO' is not null or undefined
            assertParamExists('updateCrossSlopeStationUsingPOST1', 'crossSlopeStationDTO', crossSlopeStationDTO)
            const localVarPath = `/stationOffset/updateCrossSlopeStation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeStationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateCrossSlope
         * @param {CrossSlopeDTO} crossSlopeDto crossSlopeDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopeUsingPOST: async (crossSlopeDto: CrossSlopeDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSlopeDto' is not null or undefined
            assertParamExists('updateCrossSlopeUsingPOST', 'crossSlopeDto', crossSlopeDto)
            const localVarPath = `/stationOffset/updateCrossSlope`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSlopeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateOffsetStationOffset
         * @param {SurveyEngineeringProjectDTO} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationOffsetUsingPOST: async (input: SurveyEngineeringProjectDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('updateOffsetStationOffsetUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/updateOffsetStationOffset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateOffsetStation
         * @param {OffsetStationDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationUsingPOST: async (inputPoints: OffsetStationDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inputPoints' is not null or undefined
            assertParamExists('updateOffsetStationUsingPOST', 'inputPoints', inputPoints)
            const localVarPath = `/stationOffset/updateOffsetStation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputPoints, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SetSurveyStationOffsetControllerApi - functional programming interface
 * @export
 */
export const SetSurveyStationOffsetControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SetSurveyStationOffsetControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createAlignmentStation
         * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAlignmentStationUsingPOST(alignmentStationDTO: AlignmentStationDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAlignmentStationUsingPOST(alignmentStationDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createAlignment
         * @param {AlignmentDTO} alignmentDTO alignmentDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAlignmentUsingPOST(alignmentDTO: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAlignmentUsingPOST(alignmentDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createCrossSlopeStation
         * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCrossSlopeStationUsingPOST(crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCrossSlopeStationUsingPOST(crossSlopeStationDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createCrossSlope
         * @param {CrossSlopeDTO} crossSlopeDTO crossSlopeDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCrossSlopeUsingPOST(crossSlopeDTO: CrossSlopeDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCrossSlopeUsingPOST(crossSlopeDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createOffsetStationInput
         * @param {OffsetStationDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOffsetStationInputUsingPOST(inputPoints: OffsetStationDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffsetStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOffsetStationInputUsingPOST(inputPoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createOffsetStationOffset
         * @param {SurveyEngineeringProjectDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOffsetStationOffsetUsingPOST(inputPoints: SurveyEngineeringProjectDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyEngineeringProjectDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOffsetStationOffsetUsingPOST(inputPoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteAlignmentStation
         * @param {number} alignmentStationId alignmentStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlignmentStationUsingPOST(alignmentStationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlignmentStationUsingPOST(alignmentStationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteAlignment
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlignmentUsingPOST(alignmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlignmentUsingPOST(alignmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteCrossSlopeStation
         * @param {number} crossSlopeStationId crossSlopeStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCrossSlopeStationUsingPOST(crossSlopeStationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCrossSlopeStationUsingPOST(crossSlopeStationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteCrossSlope
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCrossSlopeUsingPOST(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCrossSlopeUsingPOST(crossSlopeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteOffsetStationOffset
         * @param {number} offsetStationOffsetId offsetStationOffsetId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffsetStationOffsetUsingPOST(offsetStationOffsetId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyEngineeringProjectDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffsetStationOffsetUsingPOST(offsetStationOffsetId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteOffsetStation
         * @param {number} offsetStationId offsetStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffsetStationUsingPOST(offsetStationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffsetStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffsetStationUsingPOST(offsetStationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteStationOffsetCrossSlope
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStationOffsetCrossSlopeUsingPOST(surveyId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStationOffsetCrossSlopeUsingPOST(surveyId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteStationOffsetSpreadsheet
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStationOffsetSpreadsheetUsingPOST(surveyId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStationOffsetSpreadsheetUsingPOST(surveyId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateSOSurveyXYZPointsFromCrossSlope
         * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSOSurveyXYZPointsFromCrossSlopeUsingPOST(aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSOSurveyXYZPointsFromCrossSlopeUsingPOST(aliStationsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateSOSurveyXYZPoints
         * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSOSurveyXYZPointsUsingPOST(aliStationsJson: SOSurveyInputParm, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationOffsetSurveyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSOSurveyXYZPointsUsingPOST(aliStationsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignmentBySurveyIds
         * @param {AlignmentBySurveyIdsRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignmentBySurveyIdsUsingGET(req: AlignmentBySurveyIdsRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlignmentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignmentBySurveyIdsUsingGET(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignmentStation
         * @param {number} alignmentStationId alignmentStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignmentStationUsingGET(alignmentStationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignmentStationUsingGET(alignmentStationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignment
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignmentUsingGET(alignmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignmentUsingGET(alignmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignmentsMetadata
         * @param {AlignmentMetadataRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignmentsMetadataUsingPOST(req: AlignmentMetadataRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlignmentMetadataResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignmentsMetadataUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getClossSlope
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClossSlopeUsingGET(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClossSlopeUsingGET(crossSlopeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getCrossSlopeStation
         * @param {number} crossSlopeStationId crossSlopeStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrossSlopeStationUsingGET(crossSlopeStationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrossSlopeStationUsingGET(crossSlopeStationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getCrossSlopeSurveyById
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrossSlopeSurveyByIdUsingGET(surveyId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeSurvey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrossSlopeSurveyByIdUsingGET(surveyId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getOffsetStationOffset
         * @param {number} offsetStationOffsetId offsetStationOffsetId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffsetStationOffsetUsingGET(offsetStationOffsetId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyEngineeringProjectDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffsetStationOffsetUsingGET(offsetStationOffsetId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getOffsetStation
         * @param {number} offsetStationId offsetStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffsetStationUsingGET(offsetStationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffsetStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffsetStationUsingGET(offsetStationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getStationOffsetSpreadsheet
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStationOffsetSpreadsheetUsingGET(surveyId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StationOffsetSpreadsheetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStationOffsetSpreadsheetUsingGET(surveyId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveSOSurveyCrossSlope
         * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSOSurveyCrossSlopeUsingPOST(aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveSOSurveyCrossSlopeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSOSurveyCrossSlopeUsingPOST(aliStationsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveSOSurvey
         * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSOSurveyUsingPOST(aliStationsJson: SOSurveyInputParm, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveSOSurveySpreadsheetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSOSurveyUsingPOST(aliStationsJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateAlignmentStation
         * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAlignmentStationUsingPOST(alignmentStationDTO: AlignmentStationDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAlignmentStationUsingPOST(alignmentStationDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateAlignment
         * @param {AlignmentDTO} alignmentDto alignmentDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAlignmentUsingPOST(alignmentDto: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAlignmentUsingPOST(alignmentDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateCrossSlopeStation
         * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCrossSlopeStationUsingPOST1(crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCrossSlopeStationUsingPOST1(crossSlopeStationDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateCrossSlope
         * @param {CrossSlopeDTO} crossSlopeDto crossSlopeDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCrossSlopeUsingPOST(crossSlopeDto: CrossSlopeDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CrossSlopeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCrossSlopeUsingPOST(crossSlopeDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateOffsetStationOffset
         * @param {SurveyEngineeringProjectDTO} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOffsetStationOffsetUsingPOST(input: SurveyEngineeringProjectDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyEngineeringProjectDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOffsetStationOffsetUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateOffsetStation
         * @param {OffsetStationDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOffsetStationUsingPOST(inputPoints: OffsetStationDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffsetStationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOffsetStationUsingPOST(inputPoints, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SetSurveyStationOffsetControllerApi - factory interface
 * @export
 */
export const SetSurveyStationOffsetControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SetSurveyStationOffsetControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createAlignmentStation
         * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlignmentStationUsingPOST(alignmentStationDTO: AlignmentStationDTO, authorization?: string, options?: any): AxiosPromise<AlignmentStationDTO> {
            return localVarFp.createAlignmentStationUsingPOST(alignmentStationDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createAlignment
         * @param {AlignmentDTO} alignmentDTO alignmentDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlignmentUsingPOST(alignmentDTO: AlignmentDTO, authorization?: string, options?: any): AxiosPromise<AlignmentDTO> {
            return localVarFp.createAlignmentUsingPOST(alignmentDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createCrossSlopeStation
         * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopeStationUsingPOST(crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options?: any): AxiosPromise<CrossSlopeStationDTO> {
            return localVarFp.createCrossSlopeStationUsingPOST(crossSlopeStationDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createCrossSlope
         * @param {CrossSlopeDTO} crossSlopeDTO crossSlopeDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCrossSlopeUsingPOST(crossSlopeDTO: CrossSlopeDTO, authorization?: string, options?: any): AxiosPromise<CrossSlopeDTO> {
            return localVarFp.createCrossSlopeUsingPOST(crossSlopeDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createOffsetStationInput
         * @param {OffsetStationDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationInputUsingPOST(inputPoints: OffsetStationDTO, authorization?: string, options?: any): AxiosPromise<OffsetStationDTO> {
            return localVarFp.createOffsetStationInputUsingPOST(inputPoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createOffsetStationOffset
         * @param {SurveyEngineeringProjectDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationOffsetUsingPOST(inputPoints: SurveyEngineeringProjectDTO, authorization?: string, options?: any): AxiosPromise<SurveyEngineeringProjectDTO> {
            return localVarFp.createOffsetStationOffsetUsingPOST(inputPoints, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteAlignmentStation
         * @param {number} alignmentStationId alignmentStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignmentStationUsingPOST(alignmentStationId: number, authorization?: string, options?: any): AxiosPromise<AlignmentStationDTO> {
            return localVarFp.deleteAlignmentStationUsingPOST(alignmentStationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteAlignment
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignmentUsingPOST(alignmentId: number, authorization?: string, options?: any): AxiosPromise<AlignmentDTO> {
            return localVarFp.deleteAlignmentUsingPOST(alignmentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteCrossSlopeStation
         * @param {number} crossSlopeStationId crossSlopeStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeStationUsingPOST(crossSlopeStationId: number, authorization?: string, options?: any): AxiosPromise<CrossSlopeStationDTO> {
            return localVarFp.deleteCrossSlopeStationUsingPOST(crossSlopeStationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteCrossSlope
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCrossSlopeUsingPOST(crossSlopeId: number, authorization?: string, options?: any): AxiosPromise<CrossSlopeDTO> {
            return localVarFp.deleteCrossSlopeUsingPOST(crossSlopeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteOffsetStationOffset
         * @param {number} offsetStationOffsetId offsetStationOffsetId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationOffsetUsingPOST(offsetStationOffsetId: number, authorization?: string, options?: any): AxiosPromise<SurveyEngineeringProjectDTO> {
            return localVarFp.deleteOffsetStationOffsetUsingPOST(offsetStationOffsetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteOffsetStation
         * @param {number} offsetStationId offsetStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationUsingPOST(offsetStationId: number, authorization?: string, options?: any): AxiosPromise<OffsetStationDTO> {
            return localVarFp.deleteOffsetStationUsingPOST(offsetStationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteStationOffsetCrossSlope
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStationOffsetCrossSlopeUsingPOST(surveyId: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteStationOffsetCrossSlopeUsingPOST(surveyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteStationOffsetSpreadsheet
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStationOffsetSpreadsheetUsingPOST(surveyId: string, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteStationOffsetSpreadsheetUsingPOST(surveyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateSOSurveyXYZPointsFromCrossSlope
         * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSOSurveyXYZPointsFromCrossSlopeUsingPOST(aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options?: any): AxiosPromise<CrossSlopeSurveyResponse> {
            return localVarFp.generateSOSurveyXYZPointsFromCrossSlopeUsingPOST(aliStationsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateSOSurveyXYZPoints
         * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSOSurveyXYZPointsUsingPOST(aliStationsJson: SOSurveyInputParm, authorization?: string, options?: any): AxiosPromise<StationOffsetSurveyResponse> {
            return localVarFp.generateSOSurveyXYZPointsUsingPOST(aliStationsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignmentBySurveyIds
         * @param {AlignmentBySurveyIdsRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentBySurveyIdsUsingGET(req: AlignmentBySurveyIdsRequest, authorization?: string, options?: any): AxiosPromise<Array<AlignmentDTO>> {
            return localVarFp.getAlignmentBySurveyIdsUsingGET(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignmentStation
         * @param {number} alignmentStationId alignmentStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentStationUsingGET(alignmentStationId: number, authorization?: string, options?: any): AxiosPromise<AlignmentStationDTO> {
            return localVarFp.getAlignmentStationUsingGET(alignmentStationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignment
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentUsingGET(alignmentId: number, authorization?: string, options?: any): AxiosPromise<AlignmentDTO> {
            return localVarFp.getAlignmentUsingGET(alignmentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignmentsMetadata
         * @param {AlignmentMetadataRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentsMetadataUsingPOST(req: AlignmentMetadataRequest, authorization?: string, options?: any): AxiosPromise<Array<AlignmentMetadataResponse>> {
            return localVarFp.getAlignmentsMetadataUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getClossSlope
         * @param {number} crossSlopeId crossSlopeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClossSlopeUsingGET(crossSlopeId: number, authorization?: string, options?: any): AxiosPromise<CrossSlopeDTO> {
            return localVarFp.getClossSlopeUsingGET(crossSlopeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCrossSlopeStation
         * @param {number} crossSlopeStationId crossSlopeStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeStationUsingGET(crossSlopeStationId: number, authorization?: string, options?: any): AxiosPromise<CrossSlopeStationDTO> {
            return localVarFp.getCrossSlopeStationUsingGET(crossSlopeStationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCrossSlopeSurveyById
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSlopeSurveyByIdUsingGET(surveyId: string, authorization?: string, options?: any): AxiosPromise<CrossSlopeSurvey> {
            return localVarFp.getCrossSlopeSurveyByIdUsingGET(surveyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getOffsetStationOffset
         * @param {number} offsetStationOffsetId offsetStationOffsetId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationOffsetUsingGET(offsetStationOffsetId: number, authorization?: string, options?: any): AxiosPromise<SurveyEngineeringProjectDTO> {
            return localVarFp.getOffsetStationOffsetUsingGET(offsetStationOffsetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getOffsetStation
         * @param {number} offsetStationId offsetStationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationUsingGET(offsetStationId: number, authorization?: string, options?: any): AxiosPromise<OffsetStationDTO> {
            return localVarFp.getOffsetStationUsingGET(offsetStationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getStationOffsetSpreadsheet
         * @param {string} surveyId surveyId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStationOffsetSpreadsheetUsingGET(surveyId: string, authorization?: string, options?: any): AxiosPromise<StationOffsetSpreadsheetDTO> {
            return localVarFp.getStationOffsetSpreadsheetUsingGET(surveyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveSOSurveyCrossSlope
         * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSOSurveyCrossSlopeUsingPOST(aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options?: any): AxiosPromise<SaveSOSurveyCrossSlopeResponse> {
            return localVarFp.saveSOSurveyCrossSlopeUsingPOST(aliStationsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveSOSurvey
         * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSOSurveyUsingPOST(aliStationsJson: SOSurveyInputParm, authorization?: string, options?: any): AxiosPromise<SaveSOSurveySpreadsheetResponse> {
            return localVarFp.saveSOSurveyUsingPOST(aliStationsJson, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateAlignmentStation
         * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlignmentStationUsingPOST(alignmentStationDTO: AlignmentStationDTO, authorization?: string, options?: any): AxiosPromise<AlignmentStationDTO> {
            return localVarFp.updateAlignmentStationUsingPOST(alignmentStationDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateAlignment
         * @param {AlignmentDTO} alignmentDto alignmentDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlignmentUsingPOST(alignmentDto: AlignmentDTO, authorization?: string, options?: any): AxiosPromise<AlignmentDTO> {
            return localVarFp.updateAlignmentUsingPOST(alignmentDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateCrossSlopeStation
         * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopeStationUsingPOST1(crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options?: any): AxiosPromise<CrossSlopeStationDTO> {
            return localVarFp.updateCrossSlopeStationUsingPOST1(crossSlopeStationDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateCrossSlope
         * @param {CrossSlopeDTO} crossSlopeDto crossSlopeDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCrossSlopeUsingPOST(crossSlopeDto: CrossSlopeDTO, authorization?: string, options?: any): AxiosPromise<CrossSlopeDTO> {
            return localVarFp.updateCrossSlopeUsingPOST(crossSlopeDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateOffsetStationOffset
         * @param {SurveyEngineeringProjectDTO} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationOffsetUsingPOST(input: SurveyEngineeringProjectDTO, authorization?: string, options?: any): AxiosPromise<SurveyEngineeringProjectDTO> {
            return localVarFp.updateOffsetStationOffsetUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateOffsetStation
         * @param {OffsetStationDTO} inputPoints inputPoints
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationUsingPOST(inputPoints: OffsetStationDTO, authorization?: string, options?: any): AxiosPromise<OffsetStationDTO> {
            return localVarFp.updateOffsetStationUsingPOST(inputPoints, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SetSurveyStationOffsetControllerApi - object-oriented interface
 * @export
 * @class SetSurveyStationOffsetControllerApi
 * @extends {BaseAPI}
 */
export class SetSurveyStationOffsetControllerApi extends BaseAPI {
    /**
     * 
     * @summary createAlignmentStation
     * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public createAlignmentStationUsingPOST(alignmentStationDTO: AlignmentStationDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).createAlignmentStationUsingPOST(alignmentStationDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createAlignment
     * @param {AlignmentDTO} alignmentDTO alignmentDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public createAlignmentUsingPOST(alignmentDTO: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).createAlignmentUsingPOST(alignmentDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createCrossSlopeStation
     * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public createCrossSlopeStationUsingPOST(crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).createCrossSlopeStationUsingPOST(crossSlopeStationDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createCrossSlope
     * @param {CrossSlopeDTO} crossSlopeDTO crossSlopeDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public createCrossSlopeUsingPOST(crossSlopeDTO: CrossSlopeDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).createCrossSlopeUsingPOST(crossSlopeDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createOffsetStationInput
     * @param {OffsetStationDTO} inputPoints inputPoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public createOffsetStationInputUsingPOST(inputPoints: OffsetStationDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).createOffsetStationInputUsingPOST(inputPoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createOffsetStationOffset
     * @param {SurveyEngineeringProjectDTO} inputPoints inputPoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public createOffsetStationOffsetUsingPOST(inputPoints: SurveyEngineeringProjectDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).createOffsetStationOffsetUsingPOST(inputPoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteAlignmentStation
     * @param {number} alignmentStationId alignmentStationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteAlignmentStationUsingPOST(alignmentStationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteAlignmentStationUsingPOST(alignmentStationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteAlignment
     * @param {number} alignmentId alignmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteAlignmentUsingPOST(alignmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteAlignmentUsingPOST(alignmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteCrossSlopeStation
     * @param {number} crossSlopeStationId crossSlopeStationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteCrossSlopeStationUsingPOST(crossSlopeStationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteCrossSlopeStationUsingPOST(crossSlopeStationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteCrossSlope
     * @param {number} crossSlopeId crossSlopeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteCrossSlopeUsingPOST(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteCrossSlopeUsingPOST(crossSlopeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteOffsetStationOffset
     * @param {number} offsetStationOffsetId offsetStationOffsetId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteOffsetStationOffsetUsingPOST(offsetStationOffsetId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteOffsetStationOffsetUsingPOST(offsetStationOffsetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteOffsetStation
     * @param {number} offsetStationId offsetStationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteOffsetStationUsingPOST(offsetStationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteOffsetStationUsingPOST(offsetStationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteStationOffsetCrossSlope
     * @param {string} surveyId surveyId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteStationOffsetCrossSlopeUsingPOST(surveyId: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteStationOffsetCrossSlopeUsingPOST(surveyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteStationOffsetSpreadsheet
     * @param {string} surveyId surveyId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public deleteStationOffsetSpreadsheetUsingPOST(surveyId: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).deleteStationOffsetSpreadsheetUsingPOST(surveyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateSOSurveyXYZPointsFromCrossSlope
     * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public generateSOSurveyXYZPointsFromCrossSlopeUsingPOST(aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).generateSOSurveyXYZPointsFromCrossSlopeUsingPOST(aliStationsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateSOSurveyXYZPoints
     * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public generateSOSurveyXYZPointsUsingPOST(aliStationsJson: SOSurveyInputParm, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).generateSOSurveyXYZPointsUsingPOST(aliStationsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignmentBySurveyIds
     * @param {AlignmentBySurveyIdsRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getAlignmentBySurveyIdsUsingGET(req: AlignmentBySurveyIdsRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getAlignmentBySurveyIdsUsingGET(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignmentStation
     * @param {number} alignmentStationId alignmentStationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getAlignmentStationUsingGET(alignmentStationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getAlignmentStationUsingGET(alignmentStationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignment
     * @param {number} alignmentId alignmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getAlignmentUsingGET(alignmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getAlignmentUsingGET(alignmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignmentsMetadata
     * @param {AlignmentMetadataRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getAlignmentsMetadataUsingPOST(req: AlignmentMetadataRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getAlignmentsMetadataUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getClossSlope
     * @param {number} crossSlopeId crossSlopeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getClossSlopeUsingGET(crossSlopeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getClossSlopeUsingGET(crossSlopeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCrossSlopeStation
     * @param {number} crossSlopeStationId crossSlopeStationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getCrossSlopeStationUsingGET(crossSlopeStationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getCrossSlopeStationUsingGET(crossSlopeStationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCrossSlopeSurveyById
     * @param {string} surveyId surveyId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getCrossSlopeSurveyByIdUsingGET(surveyId: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getCrossSlopeSurveyByIdUsingGET(surveyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getOffsetStationOffset
     * @param {number} offsetStationOffsetId offsetStationOffsetId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getOffsetStationOffsetUsingGET(offsetStationOffsetId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getOffsetStationOffsetUsingGET(offsetStationOffsetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getOffsetStation
     * @param {number} offsetStationId offsetStationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getOffsetStationUsingGET(offsetStationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getOffsetStationUsingGET(offsetStationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getStationOffsetSpreadsheet
     * @param {string} surveyId surveyId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public getStationOffsetSpreadsheetUsingGET(surveyId: string, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).getStationOffsetSpreadsheetUsingGET(surveyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveSOSurveyCrossSlope
     * @param {SOSurveyCrossSlopeInputParm} aliStationsJson aliStationsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public saveSOSurveyCrossSlopeUsingPOST(aliStationsJson: SOSurveyCrossSlopeInputParm, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).saveSOSurveyCrossSlopeUsingPOST(aliStationsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveSOSurvey
     * @param {SOSurveyInputParm} aliStationsJson aliStationsJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public saveSOSurveyUsingPOST(aliStationsJson: SOSurveyInputParm, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).saveSOSurveyUsingPOST(aliStationsJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateAlignmentStation
     * @param {AlignmentStationDTO} alignmentStationDTO alignmentStationDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public updateAlignmentStationUsingPOST(alignmentStationDTO: AlignmentStationDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).updateAlignmentStationUsingPOST(alignmentStationDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateAlignment
     * @param {AlignmentDTO} alignmentDto alignmentDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public updateAlignmentUsingPOST(alignmentDto: AlignmentDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).updateAlignmentUsingPOST(alignmentDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateCrossSlopeStation
     * @param {CrossSlopeStationDTO} crossSlopeStationDTO crossSlopeStationDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public updateCrossSlopeStationUsingPOST1(crossSlopeStationDTO: CrossSlopeStationDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).updateCrossSlopeStationUsingPOST1(crossSlopeStationDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateCrossSlope
     * @param {CrossSlopeDTO} crossSlopeDto crossSlopeDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public updateCrossSlopeUsingPOST(crossSlopeDto: CrossSlopeDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).updateCrossSlopeUsingPOST(crossSlopeDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateOffsetStationOffset
     * @param {SurveyEngineeringProjectDTO} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public updateOffsetStationOffsetUsingPOST(input: SurveyEngineeringProjectDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).updateOffsetStationOffsetUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateOffsetStation
     * @param {OffsetStationDTO} inputPoints inputPoints
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetSurveyStationOffsetControllerApi
     */
    public updateOffsetStationUsingPOST(inputPoints: OffsetStationDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SetSurveyStationOffsetControllerApiFp(this.configuration).updateOffsetStationUsingPOST(inputPoints, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SoilControllerApi - axios parameter creator
 * @export
 */
export const SoilControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary soilType
         * @param {number} mukey mukey
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilTypeUsingGET: async (mukey: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mukey' is not null or undefined
            assertParamExists('soilTypeUsingGET', 'mukey', mukey)
            const localVarPath = `/survey/soil/SoilType/{mukey}`
                .replace(`{${"mukey"}}`, encodeURIComponent(String(mukey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SoilControllerApi - functional programming interface
 * @export
 */
export const SoilControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SoilControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary soilType
         * @param {number} mukey mukey
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async soilTypeUsingGET(mukey: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoilTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.soilTypeUsingGET(mukey, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SoilControllerApi - factory interface
 * @export
 */
export const SoilControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SoilControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary soilType
         * @param {number} mukey mukey
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        soilTypeUsingGET(mukey: number, authorization?: string, options?: any): AxiosPromise<SoilTypeResponse> {
            return localVarFp.soilTypeUsingGET(mukey, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SoilControllerApi - object-oriented interface
 * @export
 * @class SoilControllerApi
 * @extends {BaseAPI}
 */
export class SoilControllerApi extends BaseAPI {
    /**
     * 
     * @summary soilType
     * @param {number} mukey mukey
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoilControllerApi
     */
    public soilTypeUsingGET(mukey: number, authorization?: string, options?: AxiosRequestConfig) {
        return SoilControllerApiFp(this.configuration).soilTypeUsingGET(mukey, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StationOffsetCrudControllerApi - axios parameter creator
 * @export
 */
export const StationOffsetCrudControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createOffsetStationOffsets
         * @param {Array<SurveyEngineeringProjectDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationOffsetsUsingPOST: async (input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('createOffsetStationOffsetsUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/createOffsetStationOffsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createOffsetStations
         * @param {Array<OffsetStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationsUsingPOST: async (input: Array<OffsetStationDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('createOffsetStationsUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/createOffsetStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteOffsetStationOffsetsByIds
         * @param {Array<number>} offsetIds offsetIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationOffsetsByIdsUsingPOST: async (offsetIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetIds' is not null or undefined
            assertParamExists('deleteOffsetStationOffsetsByIdsUsingPOST', 'offsetIds', offsetIds)
            const localVarPath = `/stationOffset/deleteOffsetStationOffsetsByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offsetIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteOffsetStationsByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationsByAlignmentIdUsingPOST: async (alignmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentId' is not null or undefined
            assertParamExists('deleteOffsetStationsByAlignmentIdUsingPOST', 'alignmentId', alignmentId)
            const localVarPath = `/stationOffset/deleteOffsetStationsByAlignmentId/{alignmentId}`
                .replace(`{${"alignmentId"}}`, encodeURIComponent(String(alignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteOffsetStationsByIds
         * @param {Array<number>} offsetStationIds offsetStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationsByIdsUsingPOST: async (offsetStationIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetStationIds' is not null or undefined
            assertParamExists('deleteOffsetStationsByIdsUsingPOST', 'offsetStationIds', offsetStationIds)
            const localVarPath = `/stationOffset/deleteOffsetStationsByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offsetStationIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteOffsetStationsByOffsetStationId
         * @param {number} stationId stationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationsByOffsetStationIdUsingPOST: async (stationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationId' is not null or undefined
            assertParamExists('deleteOffsetStationsByOffsetStationIdUsingPOST', 'stationId', stationId)
            const localVarPath = `/stationOffset/deleteOffsetStationsByOffsetStationId/{stationId}`
                .replace(`{${"stationId"}}`, encodeURIComponent(String(stationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getOffsetStationOffsetsByIds
         * @param {Array<number>} offsetids offsetids
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationOffsetsByIdsUsingGET: async (offsetids: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetids' is not null or undefined
            assertParamExists('getOffsetStationOffsetsByIdsUsingGET', 'offsetids', offsetids)
            const localVarPath = `/stationOffset/getOffsetStationOffsetsByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offsetids, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getOffsetStationsByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationsByAlignmentIdUsingGET: async (alignmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentId' is not null or undefined
            assertParamExists('getOffsetStationsByAlignmentIdUsingGET', 'alignmentId', alignmentId)
            const localVarPath = `/stationOffset/getOffsetStationsByAlignmentId/{alignmentId}`
                .replace(`{${"alignmentId"}}`, encodeURIComponent(String(alignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getOffsetStationsByIds
         * @param {Array<number>} offsetStationids offsetStationids
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationsByIdsUsingGET: async (offsetStationids: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetStationids' is not null or undefined
            assertParamExists('getOffsetStationsByIdsUsingGET', 'offsetStationids', offsetStationids)
            const localVarPath = `/stationOffset/getOffsetStationsByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offsetStationids, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getOffsetStationsByOffsetStationId
         * @param {number} stationId stationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationsByOffsetStationIdUsingGET: async (stationId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stationId' is not null or undefined
            assertParamExists('getOffsetStationsByOffsetStationIdUsingGET', 'stationId', stationId)
            const localVarPath = `/stationOffset/getOffsetStationsByOffsetStationId/{stationId}`
                .replace(`{${"stationId"}}`, encodeURIComponent(String(stationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateOffsetStationOffsets
         * @param {Array<SurveyEngineeringProjectDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationOffsetsUsingPOST: async (input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('updateOffsetStationOffsetsUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/updateOffsetStationOffsets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateOffsetStations
         * @param {Array<OffsetStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationsUsingPOST: async (input: Array<OffsetStationDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('updateOffsetStationsUsingPOST', 'input', input)
            const localVarPath = `/stationOffset/updateOffsetStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StationOffsetCrudControllerApi - functional programming interface
 * @export
 */
export const StationOffsetCrudControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StationOffsetCrudControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createOffsetStationOffsets
         * @param {Array<SurveyEngineeringProjectDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOffsetStationOffsetsUsingPOST(input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyEngineeringProjectDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOffsetStationOffsetsUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createOffsetStations
         * @param {Array<OffsetStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOffsetStationsUsingPOST(input: Array<OffsetStationDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OffsetStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOffsetStationsUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteOffsetStationOffsetsByIds
         * @param {Array<number>} offsetIds offsetIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffsetStationOffsetsByIdsUsingPOST(offsetIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyEngineeringProjectDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffsetStationOffsetsByIdsUsingPOST(offsetIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteOffsetStationsByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffsetStationsByAlignmentIdUsingPOST(alignmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OffsetStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffsetStationsByAlignmentIdUsingPOST(alignmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteOffsetStationsByIds
         * @param {Array<number>} offsetStationIds offsetStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffsetStationsByIdsUsingPOST(offsetStationIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OffsetStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffsetStationsByIdsUsingPOST(offsetStationIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteOffsetStationsByOffsetStationId
         * @param {number} stationId stationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffsetStationsByOffsetStationIdUsingPOST(stationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyEngineeringProjectDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffsetStationsByOffsetStationIdUsingPOST(stationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getOffsetStationOffsetsByIds
         * @param {Array<number>} offsetids offsetids
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffsetStationOffsetsByIdsUsingGET(offsetids: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyEngineeringProjectDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffsetStationOffsetsByIdsUsingGET(offsetids, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getOffsetStationsByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffsetStationsByAlignmentIdUsingGET(alignmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OffsetStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffsetStationsByAlignmentIdUsingGET(alignmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getOffsetStationsByIds
         * @param {Array<number>} offsetStationids offsetStationids
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffsetStationsByIdsUsingGET(offsetStationids: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OffsetStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffsetStationsByIdsUsingGET(offsetStationids, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getOffsetStationsByOffsetStationId
         * @param {number} stationId stationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffsetStationsByOffsetStationIdUsingGET(stationId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyEngineeringProjectDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffsetStationsByOffsetStationIdUsingGET(stationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateOffsetStationOffsets
         * @param {Array<SurveyEngineeringProjectDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOffsetStationOffsetsUsingPOST(input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyEngineeringProjectDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOffsetStationOffsetsUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateOffsetStations
         * @param {Array<OffsetStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOffsetStationsUsingPOST(input: Array<OffsetStationDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OffsetStationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOffsetStationsUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StationOffsetCrudControllerApi - factory interface
 * @export
 */
export const StationOffsetCrudControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StationOffsetCrudControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createOffsetStationOffsets
         * @param {Array<SurveyEngineeringProjectDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationOffsetsUsingPOST(input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options?: any): AxiosPromise<Array<SurveyEngineeringProjectDTO>> {
            return localVarFp.createOffsetStationOffsetsUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createOffsetStations
         * @param {Array<OffsetStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffsetStationsUsingPOST(input: Array<OffsetStationDTO>, authorization?: string, options?: any): AxiosPromise<Array<OffsetStationDTO>> {
            return localVarFp.createOffsetStationsUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteOffsetStationOffsetsByIds
         * @param {Array<number>} offsetIds offsetIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationOffsetsByIdsUsingPOST(offsetIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<SurveyEngineeringProjectDTO>> {
            return localVarFp.deleteOffsetStationOffsetsByIdsUsingPOST(offsetIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteOffsetStationsByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationsByAlignmentIdUsingPOST(alignmentId: number, authorization?: string, options?: any): AxiosPromise<Array<OffsetStationDTO>> {
            return localVarFp.deleteOffsetStationsByAlignmentIdUsingPOST(alignmentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteOffsetStationsByIds
         * @param {Array<number>} offsetStationIds offsetStationIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationsByIdsUsingPOST(offsetStationIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<OffsetStationDTO>> {
            return localVarFp.deleteOffsetStationsByIdsUsingPOST(offsetStationIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteOffsetStationsByOffsetStationId
         * @param {number} stationId stationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffsetStationsByOffsetStationIdUsingPOST(stationId: number, authorization?: string, options?: any): AxiosPromise<Array<SurveyEngineeringProjectDTO>> {
            return localVarFp.deleteOffsetStationsByOffsetStationIdUsingPOST(stationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getOffsetStationOffsetsByIds
         * @param {Array<number>} offsetids offsetids
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationOffsetsByIdsUsingGET(offsetids: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<SurveyEngineeringProjectDTO>> {
            return localVarFp.getOffsetStationOffsetsByIdsUsingGET(offsetids, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getOffsetStationsByAlignmentId
         * @param {number} alignmentId alignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationsByAlignmentIdUsingGET(alignmentId: number, authorization?: string, options?: any): AxiosPromise<Array<OffsetStationDTO>> {
            return localVarFp.getOffsetStationsByAlignmentIdUsingGET(alignmentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getOffsetStationsByIds
         * @param {Array<number>} offsetStationids offsetStationids
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationsByIdsUsingGET(offsetStationids: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<OffsetStationDTO>> {
            return localVarFp.getOffsetStationsByIdsUsingGET(offsetStationids, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getOffsetStationsByOffsetStationId
         * @param {number} stationId stationId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffsetStationsByOffsetStationIdUsingGET(stationId: number, authorization?: string, options?: any): AxiosPromise<Array<SurveyEngineeringProjectDTO>> {
            return localVarFp.getOffsetStationsByOffsetStationIdUsingGET(stationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateOffsetStationOffsets
         * @param {Array<SurveyEngineeringProjectDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationOffsetsUsingPOST(input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options?: any): AxiosPromise<Array<SurveyEngineeringProjectDTO>> {
            return localVarFp.updateOffsetStationOffsetsUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateOffsetStations
         * @param {Array<OffsetStationDTO>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOffsetStationsUsingPOST(input: Array<OffsetStationDTO>, authorization?: string, options?: any): AxiosPromise<Array<OffsetStationDTO>> {
            return localVarFp.updateOffsetStationsUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StationOffsetCrudControllerApi - object-oriented interface
 * @export
 * @class StationOffsetCrudControllerApi
 * @extends {BaseAPI}
 */
export class StationOffsetCrudControllerApi extends BaseAPI {
    /**
     * 
     * @summary createOffsetStationOffsets
     * @param {Array<SurveyEngineeringProjectDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public createOffsetStationOffsetsUsingPOST(input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).createOffsetStationOffsetsUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createOffsetStations
     * @param {Array<OffsetStationDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public createOffsetStationsUsingPOST(input: Array<OffsetStationDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).createOffsetStationsUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteOffsetStationOffsetsByIds
     * @param {Array<number>} offsetIds offsetIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public deleteOffsetStationOffsetsByIdsUsingPOST(offsetIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).deleteOffsetStationOffsetsByIdsUsingPOST(offsetIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteOffsetStationsByAlignmentId
     * @param {number} alignmentId alignmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public deleteOffsetStationsByAlignmentIdUsingPOST(alignmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).deleteOffsetStationsByAlignmentIdUsingPOST(alignmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteOffsetStationsByIds
     * @param {Array<number>} offsetStationIds offsetStationIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public deleteOffsetStationsByIdsUsingPOST(offsetStationIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).deleteOffsetStationsByIdsUsingPOST(offsetStationIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteOffsetStationsByOffsetStationId
     * @param {number} stationId stationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public deleteOffsetStationsByOffsetStationIdUsingPOST(stationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).deleteOffsetStationsByOffsetStationIdUsingPOST(stationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getOffsetStationOffsetsByIds
     * @param {Array<number>} offsetids offsetids
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public getOffsetStationOffsetsByIdsUsingGET(offsetids: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).getOffsetStationOffsetsByIdsUsingGET(offsetids, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getOffsetStationsByAlignmentId
     * @param {number} alignmentId alignmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public getOffsetStationsByAlignmentIdUsingGET(alignmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).getOffsetStationsByAlignmentIdUsingGET(alignmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getOffsetStationsByIds
     * @param {Array<number>} offsetStationids offsetStationids
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public getOffsetStationsByIdsUsingGET(offsetStationids: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).getOffsetStationsByIdsUsingGET(offsetStationids, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getOffsetStationsByOffsetStationId
     * @param {number} stationId stationId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public getOffsetStationsByOffsetStationIdUsingGET(stationId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).getOffsetStationsByOffsetStationIdUsingGET(stationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateOffsetStationOffsets
     * @param {Array<SurveyEngineeringProjectDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public updateOffsetStationOffsetsUsingPOST(input: Array<SurveyEngineeringProjectDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).updateOffsetStationOffsetsUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateOffsetStations
     * @param {Array<OffsetStationDTO>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationOffsetCrudControllerApi
     */
    public updateOffsetStationsUsingPOST(input: Array<OffsetStationDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return StationOffsetCrudControllerApiFp(this.configuration).updateOffsetStationsUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StructureControllerApi - axios parameter creator
 * @export
 */
export const StructureControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate a collection of construction report Jsons, grouped by element types, listed by ids in each type group
         * @param {ConstructionReportCollectionRequest} constructionReportCollectionRequest constructionReportCollectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectConstructionReportsUsingPOST: async (constructionReportCollectionRequest: ConstructionReportCollectionRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'constructionReportCollectionRequest' is not null or undefined
            assertParamExists('collectConstructionReportsUsingPOST', 'constructionReportCollectionRequest', constructionReportCollectionRequest)
            const localVarPath = `/structure/constructionReportCollection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(constructionReportCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a collection of design report Jsons, grouped by element types, listed by ids in each type group
         * @param {DesignReportCollectionRequest} designReportCollectionRequest designReportCollectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectDesignReportsUsingPOST: async (designReportCollectionRequest: DesignReportCollectionRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designReportCollectionRequest' is not null or undefined
            assertParamExists('collectDesignReportsUsingPOST', 'designReportCollectionRequest', designReportCollectionRequest)
            const localVarPath = `/structure/designReportCollection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(designReportCollectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to delete a structure & project element comment record by Design Element Id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStructureByDesignElementIdUsingDELETE: async (designElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('deleteStructureByDesignElementIdUsingDELETE', 'designElementId', designElementId)
            const localVarPath = `/structure/deleteStructureByDesignElementId/{designElementId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary designLandLeveling
         * @param {LandLevelingRequest} landLevelReq landLevelReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        designLandLevelingUsingPOST: async (landLevelReq: LandLevelingRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'landLevelReq' is not null or undefined
            assertParamExists('designLandLevelingUsingPOST', 'landLevelReq', landLevelReq)
            const localVarPath = `/structure/designLandLeveling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(landLevelReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary exportPitPadStructuresPoints
         * @param {PitPadRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPitPadStructuresPointsUsingPOST: async (req: PitPadRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('exportPitPadStructuresPointsUsingPOST', 'req', req)
            const localVarPath = `/structure/exportPitPadStructuresPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary exportStakeOutPoints1
         * @param {Array<ExportStakeOutPointsRequest>} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStakeOutPoints1UsingPOST: async (req: Array<ExportStakeOutPointsRequest>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('exportStakeOutPoints1UsingPOST', 'req', req)
            const localVarPath = `/structure/exportStakeOutPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeId
         * @param {number} designElementJsonId designElementJsonId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST: async (designElementJsonId: number, designElementTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementJsonId' is not null or undefined
            assertParamExists('generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST', 'designElementJsonId', designElementJsonId)
            // verify required parameter 'designElementTypeId' is not null or undefined
            assertParamExists('generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST', 'designElementTypeId', designElementTypeId)
            const localVarPath = `/structure/generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeId/{designElementJsonId}/{designElementTypeId}`
                .replace(`{${"designElementJsonId"}}`, encodeURIComponent(String(designElementJsonId)))
                .replace(`{${"designElementTypeId"}}`, encodeURIComponent(String(designElementTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateDikedPit
         * @param {DikedPitRequest} dikedPitReq dikedPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDikedPitUsingPOST: async (dikedPitReq: DikedPitRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dikedPitReq' is not null or undefined
            assertParamExists('generateDikedPitUsingPOST', 'dikedPitReq', dikedPitReq)
            const localVarPath = `/structure/generateDikedPit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dikedPitReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generatePad
         * @param {PadRequest} padReq padReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePadUsingPOST: async (padReq: PadRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'padReq' is not null or undefined
            assertParamExists('generatePadUsingPOST', 'padReq', padReq)
            const localVarPath = `/structure/generatePad`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(padReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateRecPit
         * @param {RectangularPitRequest} recPitReq recPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRecPitUsingPOST: async (recPitReq: RectangularPitRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recPitReq' is not null or undefined
            assertParamExists('generateRecPitUsingPOST', 'recPitReq', recPitReq)
            const localVarPath = `/structure/generateRecPit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recPitReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateRoundPit
         * @param {RoundPitRequest} roundPitReq roundPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRoundPitUsingPOST: async (roundPitReq: RoundPitRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roundPitReq' is not null or undefined
            assertParamExists('generateRoundPitUsingPOST', 'roundPitReq', roundPitReq)
            const localVarPath = `/structure/generateRoundPit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roundPitReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getElevationBySessionUuidForVelocity
         * @param {ElevationVelocityRequestDto} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElevationBySessionUuidForVelocityUsingPOST: async (req: ElevationVelocityRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getElevationBySessionUuidForVelocityUsingPOST', 'req', req)
            const localVarPath = `/structure/getElevationBySessionUuidForVelocity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getElevation
         * @param {ElevationRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElevationUsingPOST: async (req: ElevationRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getElevationUsingPOST', 'req', req)
            const localVarPath = `/structure/getElevation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getLandLevelingBestFit
         * @param {LandLevelingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandLevelingBestFitUsingPOST: async (req: LandLevelingRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getLandLevelingBestFitUsingPOST', 'req', req)
            const localVarPath = `/structure/getLandLevelingBestFit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getLandLevelingCentroid
         * @param {LandLevelingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandLevelingCentroidUsingPOST: async (req: LandLevelingRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getLandLevelingCentroidUsingPOST', 'req', req)
            const localVarPath = `/structure/getLandLevelingCentroid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getMultipleDesignSurfaces
         * @param {DesignSurfaceRequest} designSurfReq designSurfReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipleDesignSurfacesUsingPOST: async (designSurfReq: DesignSurfaceRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designSurfReq' is not null or undefined
            assertParamExists('getMultipleDesignSurfacesUsingPOST', 'designSurfReq', designSurfReq)
            const localVarPath = `/structure/getMultipleDesignSurfaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(designSurfReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StructureControllerApi - functional programming interface
 * @export
 */
export const StructureControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StructureControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate a collection of construction report Jsons, grouped by element types, listed by ids in each type group
         * @param {ConstructionReportCollectionRequest} constructionReportCollectionRequest constructionReportCollectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectConstructionReportsUsingPOST(constructionReportCollectionRequest: ConstructionReportCollectionRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConstructionReportCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectConstructionReportsUsingPOST(constructionReportCollectionRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate a collection of design report Jsons, grouped by element types, listed by ids in each type group
         * @param {DesignReportCollectionRequest} designReportCollectionRequest designReportCollectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async collectDesignReportsUsingPOST(designReportCollectionRequest: DesignReportCollectionRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignReportCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.collectDesignReportsUsingPOST(designReportCollectionRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to delete a structure & project element comment record by Design Element Id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStructureByDesignElementIdUsingDELETE(designElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStructureByDesignElementIdUsingDELETE(designElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary designLandLeveling
         * @param {LandLevelingRequest} landLevelReq landLevelReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async designLandLevelingUsingPOST(landLevelReq: LandLevelingRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandLevelingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.designLandLevelingUsingPOST(landLevelReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary exportPitPadStructuresPoints
         * @param {PitPadRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPitPadStructuresPointsUsingPOST(req: PitPadRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPitPadStructuresPointsUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary exportStakeOutPoints1
         * @param {Array<ExportStakeOutPointsRequest>} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportStakeOutPoints1UsingPOST(req: Array<ExportStakeOutPointsRequest>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportStakeOutPoints1UsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeId
         * @param {number} designElementJsonId designElementJsonId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST(designElementJsonId: number, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST(designElementJsonId, designElementTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateDikedPit
         * @param {DikedPitRequest} dikedPitReq dikedPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDikedPitUsingPOST(dikedPitReq: DikedPitRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DikedPitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDikedPitUsingPOST(dikedPitReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generatePad
         * @param {PadRequest} padReq padReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePadUsingPOST(padReq: PadRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePadUsingPOST(padReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateRecPit
         * @param {RectangularPitRequest} recPitReq recPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRecPitUsingPOST(recPitReq: RectangularPitRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RectangularPitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRecPitUsingPOST(recPitReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateRoundPit
         * @param {RoundPitRequest} roundPitReq roundPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateRoundPitUsingPOST(roundPitReq: RoundPitRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoundPitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateRoundPitUsingPOST(roundPitReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getElevationBySessionUuidForVelocity
         * @param {ElevationVelocityRequestDto} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getElevationBySessionUuidForVelocityUsingPOST(req: ElevationVelocityRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElevationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getElevationBySessionUuidForVelocityUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getElevation
         * @param {ElevationRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getElevationUsingPOST(req: ElevationRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElevationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getElevationUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getLandLevelingBestFit
         * @param {LandLevelingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandLevelingBestFitUsingPOST(req: LandLevelingRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandLevelingBestFitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandLevelingBestFitUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getLandLevelingCentroid
         * @param {LandLevelingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLandLevelingCentroidUsingPOST(req: LandLevelingRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandLevelingCentroidResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLandLevelingCentroidUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getMultipleDesignSurfaces
         * @param {DesignSurfaceRequest} designSurfReq designSurfReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMultipleDesignSurfacesUsingPOST(designSurfReq: DesignSurfaceRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignSurfaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMultipleDesignSurfacesUsingPOST(designSurfReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StructureControllerApi - factory interface
 * @export
 */
export const StructureControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StructureControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate a collection of construction report Jsons, grouped by element types, listed by ids in each type group
         * @param {ConstructionReportCollectionRequest} constructionReportCollectionRequest constructionReportCollectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectConstructionReportsUsingPOST(constructionReportCollectionRequest: ConstructionReportCollectionRequest, authorization?: string, options?: any): AxiosPromise<ConstructionReportCollectionResponse> {
            return localVarFp.collectConstructionReportsUsingPOST(constructionReportCollectionRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a collection of design report Jsons, grouped by element types, listed by ids in each type group
         * @param {DesignReportCollectionRequest} designReportCollectionRequest designReportCollectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        collectDesignReportsUsingPOST(designReportCollectionRequest: DesignReportCollectionRequest, authorization?: string, options?: any): AxiosPromise<DesignReportCollectionResponse> {
            return localVarFp.collectDesignReportsUsingPOST(designReportCollectionRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to delete a structure & project element comment record by Design Element Id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStructureByDesignElementIdUsingDELETE(designElementId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteStructureByDesignElementIdUsingDELETE(designElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary designLandLeveling
         * @param {LandLevelingRequest} landLevelReq landLevelReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        designLandLevelingUsingPOST(landLevelReq: LandLevelingRequest, authorization?: string, options?: any): AxiosPromise<LandLevelingResponse> {
            return localVarFp.designLandLevelingUsingPOST(landLevelReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary exportPitPadStructuresPoints
         * @param {PitPadRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPitPadStructuresPointsUsingPOST(req: PitPadRequest, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportPitPadStructuresPointsUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary exportStakeOutPoints1
         * @param {Array<ExportStakeOutPointsRequest>} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportStakeOutPoints1UsingPOST(req: Array<ExportStakeOutPointsRequest>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportStakeOutPoints1UsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeId
         * @param {number} designElementJsonId designElementJsonId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST(designElementJsonId: number, designElementTypeId: number, authorization?: string, options?: any): AxiosPromise<object> {
            return localVarFp.generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST(designElementJsonId, designElementTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateDikedPit
         * @param {DikedPitRequest} dikedPitReq dikedPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDikedPitUsingPOST(dikedPitReq: DikedPitRequest, authorization?: string, options?: any): AxiosPromise<DikedPitResponse> {
            return localVarFp.generateDikedPitUsingPOST(dikedPitReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generatePad
         * @param {PadRequest} padReq padReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePadUsingPOST(padReq: PadRequest, authorization?: string, options?: any): AxiosPromise<PadResponse> {
            return localVarFp.generatePadUsingPOST(padReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateRecPit
         * @param {RectangularPitRequest} recPitReq recPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRecPitUsingPOST(recPitReq: RectangularPitRequest, authorization?: string, options?: any): AxiosPromise<RectangularPitResponse> {
            return localVarFp.generateRecPitUsingPOST(recPitReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateRoundPit
         * @param {RoundPitRequest} roundPitReq roundPitReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateRoundPitUsingPOST(roundPitReq: RoundPitRequest, authorization?: string, options?: any): AxiosPromise<RoundPitResponse> {
            return localVarFp.generateRoundPitUsingPOST(roundPitReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getElevationBySessionUuidForVelocity
         * @param {ElevationVelocityRequestDto} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElevationBySessionUuidForVelocityUsingPOST(req: ElevationVelocityRequestDto, authorization?: string, options?: any): AxiosPromise<ElevationResponse> {
            return localVarFp.getElevationBySessionUuidForVelocityUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getElevation
         * @param {ElevationRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElevationUsingPOST(req: ElevationRequest, authorization?: string, options?: any): AxiosPromise<ElevationResponse> {
            return localVarFp.getElevationUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getLandLevelingBestFit
         * @param {LandLevelingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandLevelingBestFitUsingPOST(req: LandLevelingRequest, authorization?: string, options?: any): AxiosPromise<LandLevelingBestFitResponse> {
            return localVarFp.getLandLevelingBestFitUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getLandLevelingCentroid
         * @param {LandLevelingRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandLevelingCentroidUsingPOST(req: LandLevelingRequest, authorization?: string, options?: any): AxiosPromise<LandLevelingCentroidResponse> {
            return localVarFp.getLandLevelingCentroidUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getMultipleDesignSurfaces
         * @param {DesignSurfaceRequest} designSurfReq designSurfReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultipleDesignSurfacesUsingPOST(designSurfReq: DesignSurfaceRequest, authorization?: string, options?: any): AxiosPromise<DesignSurfaceResponse> {
            return localVarFp.getMultipleDesignSurfacesUsingPOST(designSurfReq, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StructureControllerApi - object-oriented interface
 * @export
 * @class StructureControllerApi
 * @extends {BaseAPI}
 */
export class StructureControllerApi extends BaseAPI {
    /**
     * 
     * @summary Generate a collection of construction report Jsons, grouped by element types, listed by ids in each type group
     * @param {ConstructionReportCollectionRequest} constructionReportCollectionRequest constructionReportCollectionRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public collectConstructionReportsUsingPOST(constructionReportCollectionRequest: ConstructionReportCollectionRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).collectConstructionReportsUsingPOST(constructionReportCollectionRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a collection of design report Jsons, grouped by element types, listed by ids in each type group
     * @param {DesignReportCollectionRequest} designReportCollectionRequest designReportCollectionRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public collectDesignReportsUsingPOST(designReportCollectionRequest: DesignReportCollectionRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).collectDesignReportsUsingPOST(designReportCollectionRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to delete a structure & project element comment record by Design Element Id
     * @param {number} designElementId designElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public deleteStructureByDesignElementIdUsingDELETE(designElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).deleteStructureByDesignElementIdUsingDELETE(designElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary designLandLeveling
     * @param {LandLevelingRequest} landLevelReq landLevelReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public designLandLevelingUsingPOST(landLevelReq: LandLevelingRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).designLandLevelingUsingPOST(landLevelReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary exportPitPadStructuresPoints
     * @param {PitPadRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public exportPitPadStructuresPointsUsingPOST(req: PitPadRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).exportPitPadStructuresPointsUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary exportStakeOutPoints1
     * @param {Array<ExportStakeOutPointsRequest>} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public exportStakeOutPoints1UsingPOST(req: Array<ExportStakeOutPointsRequest>, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).exportStakeOutPoints1UsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeId
     * @param {number} designElementJsonId designElementJsonId
     * @param {number} designElementTypeId designElementTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST(designElementJsonId: number, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).generateConstructionReportJsonByDesignElementJsonIdAndDesignElementTypeIdUsingPOST(designElementJsonId, designElementTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateDikedPit
     * @param {DikedPitRequest} dikedPitReq dikedPitReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public generateDikedPitUsingPOST(dikedPitReq: DikedPitRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).generateDikedPitUsingPOST(dikedPitReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generatePad
     * @param {PadRequest} padReq padReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public generatePadUsingPOST(padReq: PadRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).generatePadUsingPOST(padReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateRecPit
     * @param {RectangularPitRequest} recPitReq recPitReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public generateRecPitUsingPOST(recPitReq: RectangularPitRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).generateRecPitUsingPOST(recPitReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateRoundPit
     * @param {RoundPitRequest} roundPitReq roundPitReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public generateRoundPitUsingPOST(roundPitReq: RoundPitRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).generateRoundPitUsingPOST(roundPitReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getElevationBySessionUuidForVelocity
     * @param {ElevationVelocityRequestDto} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public getElevationBySessionUuidForVelocityUsingPOST(req: ElevationVelocityRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).getElevationBySessionUuidForVelocityUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getElevation
     * @param {ElevationRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public getElevationUsingPOST(req: ElevationRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).getElevationUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getLandLevelingBestFit
     * @param {LandLevelingRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public getLandLevelingBestFitUsingPOST(req: LandLevelingRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).getLandLevelingBestFitUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getLandLevelingCentroid
     * @param {LandLevelingRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public getLandLevelingCentroidUsingPOST(req: LandLevelingRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).getLandLevelingCentroidUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getMultipleDesignSurfaces
     * @param {DesignSurfaceRequest} designSurfReq designSurfReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureControllerApi
     */
    public getMultipleDesignSurfacesUsingPOST(designSurfReq: DesignSurfaceRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureControllerApiFp(this.configuration).getMultipleDesignSurfacesUsingPOST(designSurfReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StructureDrawingsControllerApi - axios parameter creator
 * @export
 */
export const StructureDrawingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createStructureDrawings
         * @param {Array<DrawingRequestDto>} drawingRequestDtoList drawingRequestDtoList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStructureDrawingsUsingPOST: async (drawingRequestDtoList: Array<DrawingRequestDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'drawingRequestDtoList' is not null or undefined
            assertParamExists('createStructureDrawingsUsingPOST', 'drawingRequestDtoList', drawingRequestDtoList)
            const localVarPath = `/drawings/createUpdateStructureDrawings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(drawingRequestDtoList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteDrawing
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrawingUsingDELETE: async (request: DrawingRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('deleteDrawingUsingDELETE', 'request', request)
            const localVarPath = `/drawings/deleteDrawing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDrawingsBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawingsBySessionUuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getDrawingsBySessionUuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/drawings/getDrawingsBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDrawings
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawingsUsingPOST: async (request: DrawingRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('getDrawingsUsingPOST', 'request', request)
            const localVarPath = `/drawings/getDrawings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateDrawings
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrawingsUsingPOST: async (request: DrawingRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('updateDrawingsUsingPOST', 'request', request)
            const localVarPath = `/drawings/updateDrawings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StructureDrawingsControllerApi - functional programming interface
 * @export
 */
export const StructureDrawingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StructureDrawingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createStructureDrawings
         * @param {Array<DrawingRequestDto>} drawingRequestDtoList drawingRequestDtoList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStructureDrawingsUsingPOST(drawingRequestDtoList: Array<DrawingRequestDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignElementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStructureDrawingsUsingPOST(drawingRequestDtoList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteDrawing
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDrawingUsingDELETE(request: DrawingRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDrawingUsingDELETE(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDrawingsBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawingsBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignElementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawingsBySessionUuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDrawings
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawingsUsingPOST(request: DrawingRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignElementResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawingsUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateDrawings
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDrawingsUsingPOST(request: DrawingRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignElementResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDrawingsUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StructureDrawingsControllerApi - factory interface
 * @export
 */
export const StructureDrawingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StructureDrawingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createStructureDrawings
         * @param {Array<DrawingRequestDto>} drawingRequestDtoList drawingRequestDtoList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStructureDrawingsUsingPOST(drawingRequestDtoList: Array<DrawingRequestDto>, authorization?: string, options?: any): AxiosPromise<Array<DesignElementResponse>> {
            return localVarFp.createStructureDrawingsUsingPOST(drawingRequestDtoList, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteDrawing
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrawingUsingDELETE(request: DrawingRequestDto, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteDrawingUsingDELETE(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDrawingsBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawingsBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<Array<DesignElementResponse>> {
            return localVarFp.getDrawingsBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDrawings
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawingsUsingPOST(request: DrawingRequestDto, authorization?: string, options?: any): AxiosPromise<Array<DesignElementResponse>> {
            return localVarFp.getDrawingsUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateDrawings
         * @param {DrawingRequestDto} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDrawingsUsingPOST(request: DrawingRequestDto, authorization?: string, options?: any): AxiosPromise<DesignElementResponse> {
            return localVarFp.updateDrawingsUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StructureDrawingsControllerApi - object-oriented interface
 * @export
 * @class StructureDrawingsControllerApi
 * @extends {BaseAPI}
 */
export class StructureDrawingsControllerApi extends BaseAPI {
    /**
     * 
     * @summary createStructureDrawings
     * @param {Array<DrawingRequestDto>} drawingRequestDtoList drawingRequestDtoList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureDrawingsControllerApi
     */
    public createStructureDrawingsUsingPOST(drawingRequestDtoList: Array<DrawingRequestDto>, authorization?: string, options?: AxiosRequestConfig) {
        return StructureDrawingsControllerApiFp(this.configuration).createStructureDrawingsUsingPOST(drawingRequestDtoList, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteDrawing
     * @param {DrawingRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureDrawingsControllerApi
     */
    public deleteDrawingUsingDELETE(request: DrawingRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return StructureDrawingsControllerApiFp(this.configuration).deleteDrawingUsingDELETE(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDrawingsBySessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureDrawingsControllerApi
     */
    public getDrawingsBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return StructureDrawingsControllerApiFp(this.configuration).getDrawingsBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDrawings
     * @param {DrawingRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureDrawingsControllerApi
     */
    public getDrawingsUsingPOST(request: DrawingRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return StructureDrawingsControllerApiFp(this.configuration).getDrawingsUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateDrawings
     * @param {DrawingRequestDto} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureDrawingsControllerApi
     */
    public updateDrawingsUsingPOST(request: DrawingRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return StructureDrawingsControllerApiFp(this.configuration).updateDrawingsUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StructureProfileControllerApi - axios parameter creator
 * @export
 */
export const StructureProfileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This service is used to add adhoc three cross-section
         * @param {StructureCrossSectionAdhocRequest} structureCrossSectionAdhocRequest structureCrossSectionAdhocRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdhocCrossSectionUsingPOST: async (structureCrossSectionAdhocRequest: StructureCrossSectionAdhocRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureCrossSectionAdhocRequest' is not null or undefined
            assertParamExists('addAdhocCrossSectionUsingPOST', 'structureCrossSectionAdhocRequest', structureCrossSectionAdhocRequest)
            const localVarPath = `/structure/addThreeCrossSectionAdhoc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(structureCrossSectionAdhocRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary alignmentCrossSection
         * @param {AlignmentProfileRequest} alignmentProfileRequest alignmentProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alignmentCrossSectionUsingPOST: async (alignmentProfileRequest: AlignmentProfileRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentProfileRequest' is not null or undefined
            assertParamExists('alignmentCrossSectionUsingPOST', 'alignmentProfileRequest', alignmentProfileRequest)
            const localVarPath = `/structure/generateAlignmentProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to delete a structure profile by structureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStructureProfileByStructureProfilesIdUsingPOST: async (structureProfilesId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfilesId' is not null or undefined
            assertParamExists('deleteStructureProfileByStructureProfilesIdUsingPOST', 'structureProfilesId', structureProfilesId)
            const localVarPath = `/structure/deleteStructureProfileByStructureProfilesId/{structureProfilesId}`
                .replace(`{${"structureProfilesId"}}`, encodeURIComponent(String(structureProfilesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to delete a structure profile by projectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStructureProfilesByProjectUuidUsingPOST: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('deleteStructureProfilesByProjectUuidUsingPOST', 'projectUuid', projectUuid)
            const localVarPath = `/structure/deleteStructureProfilesByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary downloadCrossSectionSnapshot
         * @param {CrossSectionImageDto} crossSectionImageDto crossSectionImageDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCrossSectionSnapshotUsingPOST: async (crossSectionImageDto: CrossSectionImageDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crossSectionImageDto' is not null or undefined
            assertParamExists('downloadCrossSectionSnapshotUsingPOST', 'crossSectionImageDto', crossSectionImageDto)
            const localVarPath = `/structure/downloadCrossSectionSnapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crossSectionImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateAlignedStructureCrossSections
         * @param {AlignedElementCrossSectionRequest} alignedElementCrossSectionRequest alignedElementCrossSectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAlignedStructureCrossSectionsUsingPOST: async (alignedElementCrossSectionRequest: AlignedElementCrossSectionRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementCrossSectionRequest' is not null or undefined
            assertParamExists('generateAlignedStructureCrossSectionsUsingPOST', 'alignedElementCrossSectionRequest', alignedElementCrossSectionRequest)
            const localVarPath = `/structure/generateAlignedStructureCrossSections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignedElementCrossSectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateCrossSection
         * @param {StructureCrossSectionRequest} structureCrossSectionRequest structureCrossSectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCrossSectionUsingPOST: async (structureCrossSectionRequest: StructureCrossSectionRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureCrossSectionRequest' is not null or undefined
            assertParamExists('generateCrossSectionUsingPOST', 'structureCrossSectionRequest', structureCrossSectionRequest)
            const localVarPath = `/structure/generateCrossSection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(structureCrossSectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to save/update cross-section snapshot
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUpdateStructureCrossSectionImageUsingPOST: async (structureProfileRequest: StructureProfileRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfileRequest' is not null or undefined
            assertParamExists('generateUpdateStructureCrossSectionImageUsingPOST', 'structureProfileRequest', structureProfileRequest)
            const localVarPath = `/structure/generateUpdateStructureCrossSectionImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(structureProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateUpdateStructureMapImage
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUpdateStructureMapImageUsingPOST: async (structureProfileRequest: StructureProfileRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfileRequest' is not null or undefined
            assertParamExists('generateUpdateStructureMapImageUsingPOST', 'structureProfileRequest', structureProfileRequest)
            const localVarPath = `/structure/generateUpdateStructureMapImage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(structureProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateUpdateStructureProfile
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUpdateStructureProfileUsingPOST: async (structureProfileRequest: StructureProfileRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfileRequest' is not null or undefined
            assertParamExists('generateUpdateStructureProfileUsingPOST', 'structureProfileRequest', structureProfileRequest)
            const localVarPath = `/structure/generateUpdateStructureProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(structureProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to save/update cross-section snapshot
         * @param {DefinedMapRequest} definedMapRequest definedMapRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUserDefinedMapUsingPOST: async (definedMapRequest: DefinedMapRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definedMapRequest' is not null or undefined
            assertParamExists('generateUserDefinedMapUsingPOST', 'definedMapRequest', definedMapRequest)
            const localVarPath = `/structure/generateUserDefinedMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(definedMapRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllStructureProfileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStructureProfileByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getAllStructureProfileByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/structure/getAllStructureProfilesByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllStructureProfileByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStructureProfileByStructureProfilesIdUsingGET: async (structureProfilesId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfilesId' is not null or undefined
            assertParamExists('getAllStructureProfileByStructureProfilesIdUsingGET', 'structureProfilesId', structureProfilesId)
            const localVarPath = `/structure/getStructureProfileByStructureProfilesId/{structureProfilesId}`
                .replace(`{${"structureProfilesId"}}`, encodeURIComponent(String(structureProfilesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve cross-section snapshots by alignedElementDesignParameterId (aligned_element_design_parameters_id)
         * @param {number} alignedElementDesignParameterId alignedElementDesignParameterId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET: async (alignedElementDesignParameterId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParameterId' is not null or undefined
            assertParamExists('getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET', 'alignedElementDesignParameterId', alignedElementDesignParameterId)
            const localVarPath = `/structure/getCrossSectionSnapshotsByAlignedElementDesignParameterId/{alignedElementDesignParameterId}`
                .replace(`{${"alignedElementDesignParameterId"}}`, encodeURIComponent(String(alignedElementDesignParameterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroMapImagesByProjectUuidUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getHydroMapImagesByProjectUuidUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/structure/getHydroMapImagesByProjectUuid/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve structure profiles by designElementId
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageIdsByDesignElementIdUsingGET: async (designElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('getImageIdsByDesignElementIdUsingGET', 'designElementId', designElementId)
            const localVarPath = `/structure/getImageIdsByDesignElementId/{designElementId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id and image type id
         * @param {number} designElementId designElementId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagebyDesignElementIdAndImageTypeIdUsingGET: async (designElementId: number, imageTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('getImagebyDesignElementIdAndImageTypeIdUsingGET', 'designElementId', designElementId)
            // verify required parameter 'imageTypeId' is not null or undefined
            assertParamExists('getImagebyDesignElementIdAndImageTypeIdUsingGET', 'imageTypeId', imageTypeId)
            const localVarPath = `/structure/getImagebyDesignElementIdAndImageTypeId/{designElementId}/{imageTypeId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)))
                .replace(`{${"imageTypeId"}}`, encodeURIComponent(String(imageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by sessionUuid and image type id
         * @param {string} sessionUuid sessionUuid
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagebyDesignElementIdAndImageTypeIdUsingGET1: async (sessionUuid: string, imageTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getImagebyDesignElementIdAndImageTypeIdUsingGET1', 'sessionUuid', sessionUuid)
            // verify required parameter 'imageTypeId' is not null or undefined
            assertParamExists('getImagebyDesignElementIdAndImageTypeIdUsingGET1', 'imageTypeId', imageTypeId)
            const localVarPath = `/structure/getImagebySessionUuidAndImageTypeId/{sessionUuid}/{imageTypeId}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)))
                .replace(`{${"imageTypeId"}}`, encodeURIComponent(String(imageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesByDesignElementIdUsingGET: async (designElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('getImagesByDesignElementIdUsingGET', 'designElementId', designElementId)
            const localVarPath = `/structure/getImagesByDesignElementId/{designElementId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to download profile images as a zip
         * @param {Array<number>} structureProfilesIds structureProfilesIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesZipFileBySelectedImageIdsUsingPOST: async (structureProfilesIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfilesIds' is not null or undefined
            assertParamExists('getImagesZipFileBySelectedImageIdsUsingPOST', 'structureProfilesIds', structureProfilesIds)
            const localVarPath = `/structure/getImagesZipFileBySelectedImageIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(structureProfilesIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesbyDesignElementIdUsingGET: async (designElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('getImagesbyDesignElementIdUsingGET', 'designElementId', designElementId)
            const localVarPath = `/structure/getImageListbyDesignElementId/{designElementId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getMapImagesByDesignElementIdUsingGET: async (designElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('getMapImagesByDesignElementIdUsingGET', 'designElementId', designElementId)
            const localVarPath = `/structure/getMapImagesByDesignElementId/{designElementId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} elementId elementId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapImagesByElementIdAndDesignElementTypeIdUsingGET: async (elementId: number, designElementTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'elementId' is not null or undefined
            assertParamExists('getMapImagesByElementIdAndDesignElementTypeIdUsingGET', 'elementId', elementId)
            // verify required parameter 'designElementTypeId' is not null or undefined
            assertParamExists('getMapImagesByElementIdAndDesignElementTypeIdUsingGET', 'designElementTypeId', designElementTypeId)
            const localVarPath = `/structure/getMapImagesByElementIdAndDesignElementTypeId/{elementId}/{designElementTypeId}`
                .replace(`{${"elementId"}}`, encodeURIComponent(String(elementId)))
                .replace(`{${"designElementTypeId"}}`, encodeURIComponent(String(designElementTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is used to retrieve location and plan map by sessionuuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanLocationImageIdsBySessionuuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getPlanLocationImageIdsBySessionuuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/structure/getPlanLocationImageIdsBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProfileImageURLByStructureProfilesIdAndImageTypeId
         * @param {number} structureProfilesId structureProfilesId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET: async (structureProfilesId: number, imageTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfilesId' is not null or undefined
            assertParamExists('getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET', 'structureProfilesId', structureProfilesId)
            // verify required parameter 'imageTypeId' is not null or undefined
            assertParamExists('getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET', 'imageTypeId', imageTypeId)
            const localVarPath = `/structure/getProfileImageURLByStructureProfilesIdAndImageTypeId/{structureProfilesId}/{imageTypeId}`
                .replace(`{${"structureProfilesId"}}`, encodeURIComponent(String(structureProfilesId)))
                .replace(`{${"imageTypeId"}}`, encodeURIComponent(String(imageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getProfileImageURLByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImageURLByStructureProfilesIdUsingGET: async (structureProfilesId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfilesId' is not null or undefined
            assertParamExists('getProfileImageURLByStructureProfilesIdUsingGET', 'structureProfilesId', structureProfilesId)
            const localVarPath = `/structure/getProfileImageURLByStructureProfilesId/{structureProfilesId}`
                .replace(`{${"structureProfilesId"}}`, encodeURIComponent(String(structureProfilesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of selected images by design element id and image type id
         * @param {number} designElementId designElementId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET: async (designElementId: number, imageTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET', 'designElementId', designElementId)
            // verify required parameter 'imageTypeId' is not null or undefined
            assertParamExists('getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET', 'imageTypeId', imageTypeId)
            const localVarPath = `/structure/getSelectedImagesbyDesignElementIdAndImageTypeId/{designElementId}/{imageTypeId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)))
                .replace(`{${"imageTypeId"}}`, encodeURIComponent(String(imageTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getStructureMapImageURLByDesignElementIdAndDesignElementTypeId
         * @param {number} designElementId designElementId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET: async (designElementId: number, designElementTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET', 'designElementId', designElementId)
            // verify required parameter 'designElementTypeId' is not null or undefined
            assertParamExists('getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET', 'designElementTypeId', designElementTypeId)
            const localVarPath = `/structure/getStructureMapImageURLByDesignElementIdAndDesignElementTypeId/{designElementId}/{designElementTypeId}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)))
                .replace(`{${"designElementTypeId"}}`, encodeURIComponent(String(designElementTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getStructureMapImageURLByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStructureMapImageURLByStructureProfilesIdUsingGET: async (structureProfilesId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'structureProfilesId' is not null or undefined
            assertParamExists('getStructureMapImageURLByStructureProfilesIdUsingGET', 'structureProfilesId', structureProfilesId)
            const localVarPath = `/structure/getStructureMapImageURLByStructureProfilesId/{structureProfilesId}`
                .replace(`{${"structureProfilesId"}}`, encodeURIComponent(String(structureProfilesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This service is to check if image count for the given designElementId >= threshold.
         * @param {number} designElementId designElementId
         * @param {number} threshold threshold
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isImageCountAboveThresholdUsingGET: async (designElementId: number, threshold: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementId' is not null or undefined
            assertParamExists('isImageCountAboveThresholdUsingGET', 'designElementId', designElementId)
            // verify required parameter 'threshold' is not null or undefined
            assertParamExists('isImageCountAboveThresholdUsingGET', 'threshold', threshold)
            const localVarPath = `/structure/isImageCountAboveThreshold/{designElementId}/{threshold}`
                .replace(`{${"designElementId"}}`, encodeURIComponent(String(designElementId)))
                .replace(`{${"threshold"}}`, encodeURIComponent(String(threshold)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StructureProfileControllerApi - functional programming interface
 * @export
 */
export const StructureProfileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StructureProfileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This service is used to add adhoc three cross-section
         * @param {StructureCrossSectionAdhocRequest} structureCrossSectionAdhocRequest structureCrossSectionAdhocRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdhocCrossSectionUsingPOST(structureCrossSectionAdhocRequest: StructureCrossSectionAdhocRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureCrossSectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdhocCrossSectionUsingPOST(structureCrossSectionAdhocRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary alignmentCrossSection
         * @param {AlignmentProfileRequest} alignmentProfileRequest alignmentProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async alignmentCrossSectionUsingPOST(alignmentProfileRequest: AlignmentProfileRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.alignmentCrossSectionUsingPOST(alignmentProfileRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to delete a structure profile by structureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStructureProfileByStructureProfilesIdUsingPOST(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStructureProfileByStructureProfilesIdUsingPOST(structureProfilesId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to delete a structure profile by projectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStructureProfilesByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StructureProfileResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStructureProfilesByProjectUuidUsingPOST(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary downloadCrossSectionSnapshot
         * @param {CrossSectionImageDto} crossSectionImageDto crossSectionImageDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCrossSectionSnapshotUsingPOST(crossSectionImageDto: CrossSectionImageDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileSystemResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCrossSectionSnapshotUsingPOST(crossSectionImageDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateAlignedStructureCrossSections
         * @param {AlignedElementCrossSectionRequest} alignedElementCrossSectionRequest alignedElementCrossSectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAlignedStructureCrossSectionsUsingPOST(alignedElementCrossSectionRequest: AlignedElementCrossSectionRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementCrossSectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAlignedStructureCrossSectionsUsingPOST(alignedElementCrossSectionRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateCrossSection
         * @param {StructureCrossSectionRequest} structureCrossSectionRequest structureCrossSectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCrossSectionUsingPOST(structureCrossSectionRequest: StructureCrossSectionRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureCrossSectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCrossSectionUsingPOST(structureCrossSectionRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to save/update cross-section snapshot
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateUpdateStructureCrossSectionImageUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateUpdateStructureCrossSectionImageUsingPOST(structureProfileRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateUpdateStructureMapImage
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateUpdateStructureMapImageUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateUpdateStructureMapImageUsingPOST(structureProfileRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateUpdateStructureProfile
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateUpdateStructureProfileUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateUpdateStructureProfileUsingPOST(structureProfileRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to save/update cross-section snapshot
         * @param {DefinedMapRequest} definedMapRequest definedMapRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateUserDefinedMapUsingPOST(definedMapRequest: DefinedMapRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefinedMapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateUserDefinedMapUsingPOST(definedMapRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllStructureProfileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStructureProfileByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StructureProfileResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStructureProfileByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllStructureProfileByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStructureProfileByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StructureProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStructureProfileByStructureProfilesIdUsingGET(structureProfilesId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve cross-section snapshots by alignedElementDesignParameterId (aligned_element_design_parameters_id)
         * @param {number} alignedElementDesignParameterId alignedElementDesignParameterId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET(alignedElementDesignParameterId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CrossSectionImageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET(alignedElementDesignParameterId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHydroMapImagesByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDefinedImages>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHydroMapImagesByProjectUuidUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve structure profiles by designElementId
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageIdsByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<StructureProfileSummaryDTO>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageIdsByDesignElementIdUsingGET(designElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id and image type id
         * @param {number} designElementId designElementId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImagebyDesignElementIdAndImageTypeIdUsingGET(designElementId: number, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImagebyDesignElementIdAndImageTypeIdUsingGET(designElementId, imageTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by sessionUuid and image type id
         * @param {string} sessionUuid sessionUuid
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImagebyDesignElementIdAndImageTypeIdUsingGET1(sessionUuid: string, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImagebyDesignElementIdAndImageTypeIdUsingGET1(sessionUuid, imageTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImagesByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDefinedImages>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImagesByDesignElementIdUsingGET(designElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to download profile images as a zip
         * @param {Array<number>} structureProfilesIds structureProfilesIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImagesZipFileBySelectedImageIdsUsingPOST(structureProfilesIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageZipDownloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImagesZipFileBySelectedImageIdsUsingPOST(structureProfilesIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImagesbyDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImagesbyDesignElementIdUsingGET(designElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getMapImagesByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDefinedImages>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMapImagesByDesignElementIdUsingGET(designElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} elementId elementId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMapImagesByElementIdAndDesignElementTypeIdUsingGET(elementId: number, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDefinedImages>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMapImagesByElementIdAndDesignElementTypeIdUsingGET(elementId, designElementTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is used to retrieve location and plan map by sessionuuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanLocationImageIdsBySessionuuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StructureProfileSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanLocationImageIdsBySessionuuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProfileImageURLByStructureProfilesIdAndImageTypeId
         * @param {number} structureProfilesId structureProfilesId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET(structureProfilesId: number, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET(structureProfilesId, imageTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getProfileImageURLByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileImageURLByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileImageURLByStructureProfilesIdUsingGET(structureProfilesId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of selected images by design element id and image type id
         * @param {number} designElementId designElementId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET(designElementId: number, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SelectedImageResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET(designElementId, imageTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getStructureMapImageURLByDesignElementIdAndDesignElementTypeId
         * @param {number} designElementId designElementId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET(designElementId: number, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET(designElementId, designElementTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getStructureMapImageURLByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStructureMapImageURLByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStructureMapImageURLByStructureProfilesIdUsingGET(structureProfilesId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This service is to check if image count for the given designElementId >= threshold.
         * @param {number} designElementId designElementId
         * @param {number} threshold threshold
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isImageCountAboveThresholdUsingGET(designElementId: number, threshold: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isImageCountAboveThresholdUsingGET(designElementId, threshold, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StructureProfileControllerApi - factory interface
 * @export
 */
export const StructureProfileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StructureProfileControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This service is used to add adhoc three cross-section
         * @param {StructureCrossSectionAdhocRequest} structureCrossSectionAdhocRequest structureCrossSectionAdhocRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdhocCrossSectionUsingPOST(structureCrossSectionAdhocRequest: StructureCrossSectionAdhocRequest, authorization?: string, options?: any): AxiosPromise<StructureCrossSectionResponse> {
            return localVarFp.addAdhocCrossSectionUsingPOST(structureCrossSectionAdhocRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary alignmentCrossSection
         * @param {AlignmentProfileRequest} alignmentProfileRequest alignmentProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alignmentCrossSectionUsingPOST(alignmentProfileRequest: AlignmentProfileRequest, authorization?: string, options?: any): AxiosPromise<ProfileDTO> {
            return localVarFp.alignmentCrossSectionUsingPOST(alignmentProfileRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to delete a structure profile by structureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStructureProfileByStructureProfilesIdUsingPOST(structureProfilesId: number, authorization?: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteStructureProfileByStructureProfilesIdUsingPOST(structureProfilesId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to delete a structure profile by projectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStructureProfilesByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<StructureProfileResponse>> {
            return localVarFp.deleteStructureProfilesByProjectUuidUsingPOST(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary downloadCrossSectionSnapshot
         * @param {CrossSectionImageDto} crossSectionImageDto crossSectionImageDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCrossSectionSnapshotUsingPOST(crossSectionImageDto: CrossSectionImageDto, authorization?: string, options?: any): AxiosPromise<FileSystemResource> {
            return localVarFp.downloadCrossSectionSnapshotUsingPOST(crossSectionImageDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateAlignedStructureCrossSections
         * @param {AlignedElementCrossSectionRequest} alignedElementCrossSectionRequest alignedElementCrossSectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAlignedStructureCrossSectionsUsingPOST(alignedElementCrossSectionRequest: AlignedElementCrossSectionRequest, authorization?: string, options?: any): AxiosPromise<AlignedElementCrossSectionResponse> {
            return localVarFp.generateAlignedStructureCrossSectionsUsingPOST(alignedElementCrossSectionRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateCrossSection
         * @param {StructureCrossSectionRequest} structureCrossSectionRequest structureCrossSectionRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCrossSectionUsingPOST(structureCrossSectionRequest: StructureCrossSectionRequest, authorization?: string, options?: any): AxiosPromise<StructureCrossSectionResponse> {
            return localVarFp.generateCrossSectionUsingPOST(structureCrossSectionRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to save/update cross-section snapshot
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUpdateStructureCrossSectionImageUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: any): AxiosPromise<StructureProfileResponse> {
            return localVarFp.generateUpdateStructureCrossSectionImageUsingPOST(structureProfileRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateUpdateStructureMapImage
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUpdateStructureMapImageUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: any): AxiosPromise<StructureProfileResponse> {
            return localVarFp.generateUpdateStructureMapImageUsingPOST(structureProfileRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateUpdateStructureProfile
         * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUpdateStructureProfileUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: any): AxiosPromise<StructureProfileResponse> {
            return localVarFp.generateUpdateStructureProfileUsingPOST(structureProfileRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to save/update cross-section snapshot
         * @param {DefinedMapRequest} definedMapRequest definedMapRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateUserDefinedMapUsingPOST(definedMapRequest: DefinedMapRequest, authorization?: string, options?: any): AxiosPromise<DefinedMapResponse> {
            return localVarFp.generateUserDefinedMapUsingPOST(definedMapRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllStructureProfileByProjectUuid
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStructureProfileByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<StructureProfileResponse>> {
            return localVarFp.getAllStructureProfileByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllStructureProfileByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStructureProfileByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: any): AxiosPromise<StructureProfileResponse> {
            return localVarFp.getAllStructureProfileByStructureProfilesIdUsingGET(structureProfilesId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve cross-section snapshots by alignedElementDesignParameterId (aligned_element_design_parameters_id)
         * @param {number} alignedElementDesignParameterId alignedElementDesignParameterId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET(alignedElementDesignParameterId: number, authorization?: string, options?: any): AxiosPromise<Array<CrossSectionImageDTO>> {
            return localVarFp.getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET(alignedElementDesignParameterId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHydroMapImagesByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<UserDefinedImages>> {
            return localVarFp.getHydroMapImagesByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve structure profiles by designElementId
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageIdsByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: any): AxiosPromise<{ [key: string]: Array<StructureProfileSummaryDTO>; }> {
            return localVarFp.getImageIdsByDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id and image type id
         * @param {number} designElementId designElementId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagebyDesignElementIdAndImageTypeIdUsingGET(designElementId: number, imageTypeId: number, authorization?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getImagebyDesignElementIdAndImageTypeIdUsingGET(designElementId, imageTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by sessionUuid and image type id
         * @param {string} sessionUuid sessionUuid
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagebyDesignElementIdAndImageTypeIdUsingGET1(sessionUuid: string, imageTypeId: number, authorization?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getImagebyDesignElementIdAndImageTypeIdUsingGET1(sessionUuid, imageTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: any): AxiosPromise<Array<UserDefinedImages>> {
            return localVarFp.getImagesByDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to download profile images as a zip
         * @param {Array<number>} structureProfilesIds structureProfilesIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesZipFileBySelectedImageIdsUsingPOST(structureProfilesIds: Array<number>, authorization?: string, options?: any): AxiosPromise<ImageZipDownloadDto> {
            return localVarFp.getImagesZipFileBySelectedImageIdsUsingPOST(structureProfilesIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImagesbyDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getImagesbyDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} designElementId designElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getMapImagesByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: any): AxiosPromise<Array<UserDefinedImages>> {
            return localVarFp.getMapImagesByDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of map images by design element id
         * @param {number} elementId elementId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMapImagesByElementIdAndDesignElementTypeIdUsingGET(elementId: number, designElementTypeId: number, authorization?: string, options?: any): AxiosPromise<Array<UserDefinedImages>> {
            return localVarFp.getMapImagesByElementIdAndDesignElementTypeIdUsingGET(elementId, designElementTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is used to retrieve location and plan map by sessionuuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanLocationImageIdsBySessionuuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<Array<StructureProfileSummaryDTO>> {
            return localVarFp.getPlanLocationImageIdsBySessionuuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProfileImageURLByStructureProfilesIdAndImageTypeId
         * @param {number} structureProfilesId structureProfilesId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET(structureProfilesId: number, imageTypeId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET(structureProfilesId, imageTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getProfileImageURLByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileImageURLByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getProfileImageURLByStructureProfilesIdUsingGET(structureProfilesId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This StructureProfileService is used to return a list of selected images by design element id and image type id
         * @param {number} designElementId designElementId
         * @param {number} imageTypeId imageTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET(designElementId: number, imageTypeId: number, authorization?: string, options?: any): AxiosPromise<Array<SelectedImageResponse>> {
            return localVarFp.getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET(designElementId, imageTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getStructureMapImageURLByDesignElementIdAndDesignElementTypeId
         * @param {number} designElementId designElementId
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET(designElementId: number, designElementTypeId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET(designElementId, designElementTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getStructureMapImageURLByStructureProfilesId
         * @param {number} structureProfilesId structureProfilesId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStructureMapImageURLByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getStructureMapImageURLByStructureProfilesIdUsingGET(structureProfilesId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This service is to check if image count for the given designElementId >= threshold.
         * @param {number} designElementId designElementId
         * @param {number} threshold threshold
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isImageCountAboveThresholdUsingGET(designElementId: number, threshold: number, authorization?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.isImageCountAboveThresholdUsingGET(designElementId, threshold, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StructureProfileControllerApi - object-oriented interface
 * @export
 * @class StructureProfileControllerApi
 * @extends {BaseAPI}
 */
export class StructureProfileControllerApi extends BaseAPI {
    /**
     * 
     * @summary This service is used to add adhoc three cross-section
     * @param {StructureCrossSectionAdhocRequest} structureCrossSectionAdhocRequest structureCrossSectionAdhocRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public addAdhocCrossSectionUsingPOST(structureCrossSectionAdhocRequest: StructureCrossSectionAdhocRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).addAdhocCrossSectionUsingPOST(structureCrossSectionAdhocRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary alignmentCrossSection
     * @param {AlignmentProfileRequest} alignmentProfileRequest alignmentProfileRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public alignmentCrossSectionUsingPOST(alignmentProfileRequest: AlignmentProfileRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).alignmentCrossSectionUsingPOST(alignmentProfileRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to delete a structure profile by structureProfilesId
     * @param {number} structureProfilesId structureProfilesId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public deleteStructureProfileByStructureProfilesIdUsingPOST(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).deleteStructureProfileByStructureProfilesIdUsingPOST(structureProfilesId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to delete a structure profile by projectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public deleteStructureProfilesByProjectUuidUsingPOST(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).deleteStructureProfilesByProjectUuidUsingPOST(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary downloadCrossSectionSnapshot
     * @param {CrossSectionImageDto} crossSectionImageDto crossSectionImageDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public downloadCrossSectionSnapshotUsingPOST(crossSectionImageDto: CrossSectionImageDto, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).downloadCrossSectionSnapshotUsingPOST(crossSectionImageDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateAlignedStructureCrossSections
     * @param {AlignedElementCrossSectionRequest} alignedElementCrossSectionRequest alignedElementCrossSectionRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public generateAlignedStructureCrossSectionsUsingPOST(alignedElementCrossSectionRequest: AlignedElementCrossSectionRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).generateAlignedStructureCrossSectionsUsingPOST(alignedElementCrossSectionRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateCrossSection
     * @param {StructureCrossSectionRequest} structureCrossSectionRequest structureCrossSectionRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public generateCrossSectionUsingPOST(structureCrossSectionRequest: StructureCrossSectionRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).generateCrossSectionUsingPOST(structureCrossSectionRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to save/update cross-section snapshot
     * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public generateUpdateStructureCrossSectionImageUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).generateUpdateStructureCrossSectionImageUsingPOST(structureProfileRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateUpdateStructureMapImage
     * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public generateUpdateStructureMapImageUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).generateUpdateStructureMapImageUsingPOST(structureProfileRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateUpdateStructureProfile
     * @param {StructureProfileRequest} structureProfileRequest structureProfileRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public generateUpdateStructureProfileUsingPOST(structureProfileRequest: StructureProfileRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).generateUpdateStructureProfileUsingPOST(structureProfileRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to save/update cross-section snapshot
     * @param {DefinedMapRequest} definedMapRequest definedMapRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public generateUserDefinedMapUsingPOST(definedMapRequest: DefinedMapRequest, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).generateUserDefinedMapUsingPOST(definedMapRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllStructureProfileByProjectUuid
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getAllStructureProfileByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getAllStructureProfileByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllStructureProfileByStructureProfilesId
     * @param {number} structureProfilesId structureProfilesId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getAllStructureProfileByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getAllStructureProfileByStructureProfilesIdUsingGET(structureProfilesId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve cross-section snapshots by alignedElementDesignParameterId (aligned_element_design_parameters_id)
     * @param {number} alignedElementDesignParameterId alignedElementDesignParameterId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET(alignedElementDesignParameterId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getCrossSectionSnapshotsByAlignedElementDesignParameterIdUsingGET(alignedElementDesignParameterId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of map images by design element id
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getHydroMapImagesByProjectUuidUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getHydroMapImagesByProjectUuidUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve structure profiles by designElementId
     * @param {number} designElementId designElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getImageIdsByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getImageIdsByDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of map images by design element id and image type id
     * @param {number} designElementId designElementId
     * @param {number} imageTypeId imageTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getImagebyDesignElementIdAndImageTypeIdUsingGET(designElementId: number, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getImagebyDesignElementIdAndImageTypeIdUsingGET(designElementId, imageTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of map images by sessionUuid and image type id
     * @param {string} sessionUuid sessionUuid
     * @param {number} imageTypeId imageTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getImagebyDesignElementIdAndImageTypeIdUsingGET1(sessionUuid: string, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getImagebyDesignElementIdAndImageTypeIdUsingGET1(sessionUuid, imageTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of map images by design element id
     * @param {number} designElementId designElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getImagesByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getImagesByDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to download profile images as a zip
     * @param {Array<number>} structureProfilesIds structureProfilesIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getImagesZipFileBySelectedImageIdsUsingPOST(structureProfilesIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getImagesZipFileBySelectedImageIdsUsingPOST(structureProfilesIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of map images by design element id
     * @param {number} designElementId designElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getImagesbyDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getImagesbyDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of map images by design element id
     * @param {number} designElementId designElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getMapImagesByDesignElementIdUsingGET(designElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getMapImagesByDesignElementIdUsingGET(designElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of map images by design element id
     * @param {number} elementId elementId
     * @param {number} designElementTypeId designElementTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getMapImagesByElementIdAndDesignElementTypeIdUsingGET(elementId: number, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getMapImagesByElementIdAndDesignElementTypeIdUsingGET(elementId, designElementTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is used to retrieve location and plan map by sessionuuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getPlanLocationImageIdsBySessionuuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getPlanLocationImageIdsBySessionuuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProfileImageURLByStructureProfilesIdAndImageTypeId
     * @param {number} structureProfilesId structureProfilesId
     * @param {number} imageTypeId imageTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET(structureProfilesId: number, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getProfileImageURLByStructureProfilesIdAndImageTypeIdUsingGET(structureProfilesId, imageTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getProfileImageURLByStructureProfilesId
     * @param {number} structureProfilesId structureProfilesId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getProfileImageURLByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getProfileImageURLByStructureProfilesIdUsingGET(structureProfilesId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This StructureProfileService is used to return a list of selected images by design element id and image type id
     * @param {number} designElementId designElementId
     * @param {number} imageTypeId imageTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET(designElementId: number, imageTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getSelectedImagesbyDesignElementIdAndImageTypeIdUsingGET(designElementId, imageTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getStructureMapImageURLByDesignElementIdAndDesignElementTypeId
     * @param {number} designElementId designElementId
     * @param {number} designElementTypeId designElementTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET(designElementId: number, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getStructureMapImageURLByDesignElementIdAndDesignElementTypeIdUsingGET(designElementId, designElementTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getStructureMapImageURLByStructureProfilesId
     * @param {number} structureProfilesId structureProfilesId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public getStructureMapImageURLByStructureProfilesIdUsingGET(structureProfilesId: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).getStructureMapImageURLByStructureProfilesIdUsingGET(structureProfilesId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This service is to check if image count for the given designElementId >= threshold.
     * @param {number} designElementId designElementId
     * @param {number} threshold threshold
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StructureProfileControllerApi
     */
    public isImageCountAboveThresholdUsingGET(designElementId: number, threshold: number, authorization?: string, options?: AxiosRequestConfig) {
        return StructureProfileControllerApiFp(this.configuration).isImageCountAboveThresholdUsingGET(designElementId, threshold, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SurfaceControllerApi - axios parameter creator
 * @export
 */
export const SurfaceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileUsingGET1: async (fileName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('downloadFileUsingGET1', 'fileName', fileName)
            const localVarPath = `/surface/downloadFile/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary editSurface
         * @param {SurfaceDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSurfaceUsingPOST: async (req: SurfaceDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('editSurfaceUsingPOST', 'req', req)
            const localVarPath = `/surface/editSurface`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary exportLLPointsCSV
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLLPointsCSVUsingPOST: async (id: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportLLPointsCSVUsingPOST', 'id', id)
            const localVarPath = `/surface/exportLLPointsCSV/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary genarateBorder
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genarateBorderUsingGET: async (surfaceDefId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceDefId' is not null or undefined
            assertParamExists('genarateBorderUsingGET', 'surfaceDefId', surfaceDefId)
            const localVarPath = `/surface/generateBorder/{surfaceDefId}`
                .replace(`{${"surfaceDefId"}}`, encodeURIComponent(String(surfaceDefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateLandXML
         * @param {Array<GenerateLandXMLRequest>} designEleIdAndTypeList designEleIdAndTypeList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLandXMLUsingPOST: async (designEleIdAndTypeList: Array<GenerateLandXMLRequest>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designEleIdAndTypeList' is not null or undefined
            assertParamExists('generateLandXMLUsingPOST', 'designEleIdAndTypeList', designEleIdAndTypeList)
            const localVarPath = `/surface/generateLandXML`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(designEleIdAndTypeList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateProjectLandXML
         * @param {ProjectLandXMLRequest} projectLandXMLRequest projectLandXMLRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProjectLandXMLUsingPOST: async (projectLandXMLRequest: ProjectLandXMLRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectLandXMLRequest' is not null or undefined
            assertParamExists('generateProjectLandXMLUsingPOST', 'projectLandXMLRequest', projectLandXMLRequest)
            const localVarPath = `/surface/generateLandXML/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectLandXMLRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API calculates the elvation based on teh given input, determines the surface is DEM or Tin then calculates the elevation
         * @param {ElevationRequestDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElevationUsingPOST1: async (req: ElevationRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getElevationUsingPOST1', 'req', req)
            const localVarPath = `/surface/getElevation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurfaceControllerApi - functional programming interface
 * @export
 */
export const SurfaceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurfaceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFileUsingGET1(fileName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputStreamResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFileUsingGET1(fileName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary editSurface
         * @param {SurfaceDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editSurfaceUsingPOST(req: SurfaceDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EftStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSurfaceUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary exportLLPointsCSV
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLLPointsCSVUsingPOST(id: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLLPointsCSVUsingPOST(id, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary genarateBorder
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async genarateBorderUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BorderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.genarateBorderUsingGET(surfaceDefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateLandXML
         * @param {Array<GenerateLandXMLRequest>} designEleIdAndTypeList designEleIdAndTypeList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLandXMLUsingPOST(designEleIdAndTypeList: Array<GenerateLandXMLRequest>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateLandXMLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLandXMLUsingPOST(designEleIdAndTypeList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateProjectLandXML
         * @param {ProjectLandXMLRequest} projectLandXMLRequest projectLandXMLRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateProjectLandXMLUsingPOST(projectLandXMLRequest: ProjectLandXMLRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateLandXMLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateProjectLandXMLUsingPOST(projectLandXMLRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API calculates the elvation based on teh given input, determines the surface is DEM or Tin then calculates the elevation
         * @param {ElevationRequestDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getElevationUsingPOST1(req: ElevationRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElevationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getElevationUsingPOST1(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SurfaceControllerApi - factory interface
 * @export
 */
export const SurfaceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurfaceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary downloadFile
         * @param {string} fileName fileName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFileUsingGET1(fileName: string, authorization?: string, options?: any): AxiosPromise<InputStreamResource> {
            return localVarFp.downloadFileUsingGET1(fileName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary editSurface
         * @param {SurfaceDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSurfaceUsingPOST(req: SurfaceDTO, authorization?: string, options?: any): AxiosPromise<EftStatusResponse> {
            return localVarFp.editSurfaceUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary exportLLPointsCSV
         * @param {number} id id
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLLPointsCSVUsingPOST(id: number, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportLLPointsCSVUsingPOST(id, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary genarateBorder
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        genarateBorderUsingGET(surfaceDefId: number, authorization?: string, options?: any): AxiosPromise<BorderDTO> {
            return localVarFp.genarateBorderUsingGET(surfaceDefId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateLandXML
         * @param {Array<GenerateLandXMLRequest>} designEleIdAndTypeList designEleIdAndTypeList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLandXMLUsingPOST(designEleIdAndTypeList: Array<GenerateLandXMLRequest>, authorization?: string, options?: any): AxiosPromise<GenerateLandXMLResponse> {
            return localVarFp.generateLandXMLUsingPOST(designEleIdAndTypeList, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateProjectLandXML
         * @param {ProjectLandXMLRequest} projectLandXMLRequest projectLandXMLRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateProjectLandXMLUsingPOST(projectLandXMLRequest: ProjectLandXMLRequest, authorization?: string, options?: any): AxiosPromise<GenerateLandXMLResponse> {
            return localVarFp.generateProjectLandXMLUsingPOST(projectLandXMLRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API calculates the elvation based on teh given input, determines the surface is DEM or Tin then calculates the elevation
         * @param {ElevationRequestDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getElevationUsingPOST1(req: ElevationRequestDTO, authorization?: string, options?: any): AxiosPromise<ElevationResponseDTO> {
            return localVarFp.getElevationUsingPOST1(req, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurfaceControllerApi - object-oriented interface
 * @export
 * @class SurfaceControllerApi
 * @extends {BaseAPI}
 */
export class SurfaceControllerApi extends BaseAPI {
    /**
     * 
     * @summary downloadFile
     * @param {string} fileName fileName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceControllerApi
     */
    public downloadFileUsingGET1(fileName: string, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceControllerApiFp(this.configuration).downloadFileUsingGET1(fileName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary editSurface
     * @param {SurfaceDTO} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceControllerApi
     */
    public editSurfaceUsingPOST(req: SurfaceDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceControllerApiFp(this.configuration).editSurfaceUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary exportLLPointsCSV
     * @param {number} id id
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceControllerApi
     */
    public exportLLPointsCSVUsingPOST(id: number, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceControllerApiFp(this.configuration).exportLLPointsCSVUsingPOST(id, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary genarateBorder
     * @param {number} surfaceDefId surfaceDefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceControllerApi
     */
    public genarateBorderUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceControllerApiFp(this.configuration).genarateBorderUsingGET(surfaceDefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateLandXML
     * @param {Array<GenerateLandXMLRequest>} designEleIdAndTypeList designEleIdAndTypeList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceControllerApi
     */
    public generateLandXMLUsingPOST(designEleIdAndTypeList: Array<GenerateLandXMLRequest>, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceControllerApiFp(this.configuration).generateLandXMLUsingPOST(designEleIdAndTypeList, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateProjectLandXML
     * @param {ProjectLandXMLRequest} projectLandXMLRequest projectLandXMLRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceControllerApi
     */
    public generateProjectLandXMLUsingPOST(projectLandXMLRequest: ProjectLandXMLRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceControllerApiFp(this.configuration).generateProjectLandXMLUsingPOST(projectLandXMLRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API calculates the elvation based on teh given input, determines the surface is DEM or Tin then calculates the elevation
     * @param {ElevationRequestDTO} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceControllerApi
     */
    public getElevationUsingPOST1(req: ElevationRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceControllerApiFp(this.configuration).getElevationUsingPOST1(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SurfaceDefControllerApi - axios parameter creator
 * @export
 */
export const SurfaceDefControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createDemSurfaceMetadata
         * @param {DemSurfaceMetadataRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemSurfaceMetadataUsingPOST: async (request: DemSurfaceMetadataRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('createDemSurfaceMetadataUsingPOST', 'request', request)
            const localVarPath = `/survey/surfacedef/createDemSurfaceMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createSurfaceDef
         * @param {SurfaceDefRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurfaceDefUsingPOST: async (req: SurfaceDefRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('createSurfaceDefUsingPOST', 'req', req)
            const localVarPath = `/survey/surfacedef/createSurfaceDef`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteSurfaceDefById
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurfaceDefByIdUsingPOST: async (surfaceDefId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceDefId' is not null or undefined
            assertParamExists('deleteSurfaceDefByIdUsingPOST', 'surfaceDefId', surfaceDefId)
            const localVarPath = `/survey/surfacedef/deleteSurfaceDefById/{surfaceDefId}`
                .replace(`{${"surfaceDefId"}}`, encodeURIComponent(String(surfaceDefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getDEMOutlets
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDEMOutletsUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getDEMOutletsUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/survey/surfacedef/getDEMOutlets/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSurfaceDefBySession
         * @param {string} sessionIds sessionIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurfaceDefBySessionUsingGET: async (sessionIds: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionIds' is not null or undefined
            assertParamExists('getSurfaceDefBySessionUsingGET', 'sessionIds', sessionIds)
            const localVarPath = `/survey/surfacedef/getSurfaceDefBySession/{sessionIds}`
                .replace(`{${"sessionIds"}}`, encodeURIComponent(String(sessionIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSurfaceDefSurveyMetadata
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurfaceDefSurveyMetadataUsingGET: async (surfaceDefId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceDefId' is not null or undefined
            assertParamExists('getSurfaceDefSurveyMetadataUsingGET', 'surfaceDefId', surfaceDefId)
            const localVarPath = `/survey/surfacedef/getSurfaceDefSurveyMetadataById/{surfaceDefId}`
                .replace(`{${"surfaceDefId"}}`, encodeURIComponent(String(surfaceDefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSurfaceDef
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurfaceDefUsingGET: async (surfaceDefId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceDefId' is not null or undefined
            assertParamExists('getSurfaceDefUsingGET', 'surfaceDefId', surfaceDefId)
            const localVarPath = `/survey/surfacedef/getSurfaceDefById/{surfaceDefId}`
                .replace(`{${"surfaceDefId"}}`, encodeURIComponent(String(surfaceDefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateContourIntervalBySurfaceDefId
         * @param {number} surfaceDefId surfaceDefId
         * @param {number} contourInterval contourInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContourIntervalBySurfaceDefIdUsingPATCH: async (surfaceDefId: number, contourInterval: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceDefId' is not null or undefined
            assertParamExists('updateContourIntervalBySurfaceDefIdUsingPATCH', 'surfaceDefId', surfaceDefId)
            // verify required parameter 'contourInterval' is not null or undefined
            assertParamExists('updateContourIntervalBySurfaceDefIdUsingPATCH', 'contourInterval', contourInterval)
            const localVarPath = `/survey/surfacedef/updateContourIntervalBySurfaceDefId/{surfaceDefId}/{contourInterval}`
                .replace(`{${"surfaceDefId"}}`, encodeURIComponent(String(surfaceDefId)))
                .replace(`{${"contourInterval"}}`, encodeURIComponent(String(contourInterval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSurfaceDesignProject
         * @param {number} surfaceDefId surfaceDefId
         * @param {SurfaceDefRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurfaceDesignProjectUsingPOST: async (surfaceDefId: number, req: SurfaceDefRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surfaceDefId' is not null or undefined
            assertParamExists('updateSurfaceDesignProjectUsingPOST', 'surfaceDefId', surfaceDefId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateSurfaceDesignProjectUsingPOST', 'req', req)
            const localVarPath = `/survey/surfacedef/updateSurfaceDef/{surfaceDefId}`
                .replace(`{${"surfaceDefId"}}`, encodeURIComponent(String(surfaceDefId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateSurfaceNameByProjectUuid
         * @param {SurfaceDefSurfaceNameDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurfaceNameByProjectUuidUsingPOST: async (req: SurfaceDefSurfaceNameDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateSurfaceNameByProjectUuidUsingPOST', 'req', req)
            const localVarPath = `/survey/surfacedef/updateSurfaceNameByProjectUuid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurfaceDefControllerApi - functional programming interface
 * @export
 */
export const SurfaceDefControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurfaceDefControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createDemSurfaceMetadata
         * @param {DemSurfaceMetadataRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDemSurfaceMetadataUsingPOST(request: DemSurfaceMetadataRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemSurfaceMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDemSurfaceMetadataUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createSurfaceDef
         * @param {SurfaceDefRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurfaceDefUsingPOST(req: SurfaceDefRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceDefResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurfaceDefUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteSurfaceDefById
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurfaceDefByIdUsingPOST(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceDefResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurfaceDefByIdUsingPOST(surfaceDefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getDEMOutlets
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDEMOutletsUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DEMOutletsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDEMOutletsUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSurfaceDefBySession
         * @param {string} sessionIds sessionIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurfaceDefBySessionUsingGET(sessionIds: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurfaceDefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurfaceDefBySessionUsingGET(sessionIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSurfaceDefSurveyMetadata
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurfaceDefSurveyMetadataUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceDefResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurfaceDefSurveyMetadataUsingGET(surfaceDefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSurfaceDef
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurfaceDefUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceDefDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurfaceDefUsingGET(surfaceDefId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateContourIntervalBySurfaceDefId
         * @param {number} surfaceDefId surfaceDefId
         * @param {number} contourInterval contourInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContourIntervalBySurfaceDefIdUsingPATCH(surfaceDefId: number, contourInterval: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContourIntervalBySurfaceDefIdUsingPATCH(surfaceDefId, contourInterval, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSurfaceDesignProject
         * @param {number} surfaceDefId surfaceDefId
         * @param {SurfaceDefRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurfaceDesignProjectUsingPOST(surfaceDefId: number, req: SurfaceDefRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceDefResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurfaceDesignProjectUsingPOST(surfaceDefId, req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateSurfaceNameByProjectUuid
         * @param {SurfaceDefSurfaceNameDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurfaceNameByProjectUuidUsingPOST(req: SurfaceDefSurfaceNameDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurfaceDefSurfaceNameDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurfaceNameByProjectUuidUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SurfaceDefControllerApi - factory interface
 * @export
 */
export const SurfaceDefControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurfaceDefControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createDemSurfaceMetadata
         * @param {DemSurfaceMetadataRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemSurfaceMetadataUsingPOST(request: DemSurfaceMetadataRequest, authorization?: string, options?: any): AxiosPromise<DemSurfaceMetadataResponse> {
            return localVarFp.createDemSurfaceMetadataUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createSurfaceDef
         * @param {SurfaceDefRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurfaceDefUsingPOST(req: SurfaceDefRequest, authorization?: string, options?: any): AxiosPromise<SurfaceDefResponse> {
            return localVarFp.createSurfaceDefUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteSurfaceDefById
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurfaceDefByIdUsingPOST(surfaceDefId: number, authorization?: string, options?: any): AxiosPromise<SurfaceDefResponse> {
            return localVarFp.deleteSurfaceDefByIdUsingPOST(surfaceDefId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getDEMOutlets
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDEMOutletsUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<DEMOutletsResponseDTO> {
            return localVarFp.getDEMOutletsUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSurfaceDefBySession
         * @param {string} sessionIds sessionIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurfaceDefBySessionUsingGET(sessionIds: string, authorization?: string, options?: any): AxiosPromise<Array<SurfaceDefResponse>> {
            return localVarFp.getSurfaceDefBySessionUsingGET(sessionIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSurfaceDefSurveyMetadata
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurfaceDefSurveyMetadataUsingGET(surfaceDefId: number, authorization?: string, options?: any): AxiosPromise<SurfaceDefResponse> {
            return localVarFp.getSurfaceDefSurveyMetadataUsingGET(surfaceDefId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSurfaceDef
         * @param {number} surfaceDefId surfaceDefId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurfaceDefUsingGET(surfaceDefId: number, authorization?: string, options?: any): AxiosPromise<SurfaceDefDTO> {
            return localVarFp.getSurfaceDefUsingGET(surfaceDefId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateContourIntervalBySurfaceDefId
         * @param {number} surfaceDefId surfaceDefId
         * @param {number} contourInterval contourInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContourIntervalBySurfaceDefIdUsingPATCH(surfaceDefId: number, contourInterval: number, authorization?: string, options?: any): AxiosPromise<number> {
            return localVarFp.updateContourIntervalBySurfaceDefIdUsingPATCH(surfaceDefId, contourInterval, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSurfaceDesignProject
         * @param {number} surfaceDefId surfaceDefId
         * @param {SurfaceDefRequest} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurfaceDesignProjectUsingPOST(surfaceDefId: number, req: SurfaceDefRequest, authorization?: string, options?: any): AxiosPromise<SurfaceDefResponse> {
            return localVarFp.updateSurfaceDesignProjectUsingPOST(surfaceDefId, req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateSurfaceNameByProjectUuid
         * @param {SurfaceDefSurfaceNameDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurfaceNameByProjectUuidUsingPOST(req: SurfaceDefSurfaceNameDTO, authorization?: string, options?: any): AxiosPromise<SurfaceDefSurfaceNameDTO> {
            return localVarFp.updateSurfaceNameByProjectUuidUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurfaceDefControllerApi - object-oriented interface
 * @export
 * @class SurfaceDefControllerApi
 * @extends {BaseAPI}
 */
export class SurfaceDefControllerApi extends BaseAPI {
    /**
     * 
     * @summary createDemSurfaceMetadata
     * @param {DemSurfaceMetadataRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public createDemSurfaceMetadataUsingPOST(request: DemSurfaceMetadataRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).createDemSurfaceMetadataUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createSurfaceDef
     * @param {SurfaceDefRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public createSurfaceDefUsingPOST(req: SurfaceDefRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).createSurfaceDefUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteSurfaceDefById
     * @param {number} surfaceDefId surfaceDefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public deleteSurfaceDefByIdUsingPOST(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).deleteSurfaceDefByIdUsingPOST(surfaceDefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getDEMOutlets
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public getDEMOutletsUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).getDEMOutletsUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSurfaceDefBySession
     * @param {string} sessionIds sessionIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public getSurfaceDefBySessionUsingGET(sessionIds: string, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).getSurfaceDefBySessionUsingGET(sessionIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSurfaceDefSurveyMetadata
     * @param {number} surfaceDefId surfaceDefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public getSurfaceDefSurveyMetadataUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).getSurfaceDefSurveyMetadataUsingGET(surfaceDefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSurfaceDef
     * @param {number} surfaceDefId surfaceDefId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public getSurfaceDefUsingGET(surfaceDefId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).getSurfaceDefUsingGET(surfaceDefId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateContourIntervalBySurfaceDefId
     * @param {number} surfaceDefId surfaceDefId
     * @param {number} contourInterval contourInterval
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public updateContourIntervalBySurfaceDefIdUsingPATCH(surfaceDefId: number, contourInterval: number, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).updateContourIntervalBySurfaceDefIdUsingPATCH(surfaceDefId, contourInterval, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSurfaceDesignProject
     * @param {number} surfaceDefId surfaceDefId
     * @param {SurfaceDefRequest} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public updateSurfaceDesignProjectUsingPOST(surfaceDefId: number, req: SurfaceDefRequest, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).updateSurfaceDesignProjectUsingPOST(surfaceDefId, req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateSurfaceNameByProjectUuid
     * @param {SurfaceDefSurfaceNameDTO} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurfaceDefControllerApi
     */
    public updateSurfaceNameByProjectUuidUsingPOST(req: SurfaceDefSurfaceNameDTO, authorization?: string, options?: AxiosRequestConfig) {
        return SurfaceDefControllerApiFp(this.configuration).updateSurfaceNameByProjectUuidUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * Survey2CsvControllerApi - axios parameter creator
 * @export
 */
export const Survey2CsvControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary exportSurveysToCSV
         * @param {Array<Survey2CSVRequest>} exportSurveysJson exportSurveysJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSurveysToCSVUsingPOST1: async (exportSurveysJson: Array<Survey2CSVRequest>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportSurveysJson' is not null or undefined
            assertParamExists('exportSurveysToCSVUsingPOST1', 'exportSurveysJson', exportSurveysJson)
            const localVarPath = `/surface/exportSurveysToCSV`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportSurveysJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Survey2CsvControllerApi - functional programming interface
 * @export
 */
export const Survey2CsvControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Survey2CsvControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary exportSurveysToCSV
         * @param {Array<Survey2CSVRequest>} exportSurveysJson exportSurveysJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSurveysToCSVUsingPOST1(exportSurveysJson: Array<Survey2CSVRequest>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSurveysToCSVUsingPOST1(exportSurveysJson, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * Survey2CsvControllerApi - factory interface
 * @export
 */
export const Survey2CsvControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Survey2CsvControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary exportSurveysToCSV
         * @param {Array<Survey2CSVRequest>} exportSurveysJson exportSurveysJson
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSurveysToCSVUsingPOST1(exportSurveysJson: Array<Survey2CSVRequest>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportSurveysToCSVUsingPOST1(exportSurveysJson, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Survey2CsvControllerApi - object-oriented interface
 * @export
 * @class Survey2CsvControllerApi
 * @extends {BaseAPI}
 */
export class Survey2CsvControllerApi extends BaseAPI {
    /**
     * 
     * @summary exportSurveysToCSV
     * @param {Array<Survey2CSVRequest>} exportSurveysJson exportSurveysJson
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Survey2CsvControllerApi
     */
    public exportSurveysToCSVUsingPOST1(exportSurveysJson: Array<Survey2CSVRequest>, authorization?: string, options?: AxiosRequestConfig) {
        return Survey2CsvControllerApiFp(this.configuration).exportSurveysToCSVUsingPOST1(exportSurveysJson, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SurveyTypeControllerApi - axios parameter creator
 * @export
 */
export const SurveyTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getAllSurveyTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurveyTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey/surveyEngProj/getAllSurveyTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSurveyTypeByIds
         * @param {Array<number>} surveyTypeIds surveyTypeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyTypeByIdsUsingGET: async (surveyTypeIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyTypeIds' is not null or undefined
            assertParamExists('getSurveyTypeByIdsUsingGET', 'surveyTypeIds', surveyTypeIds)
            const localVarPath = `/survey/surveyEngProj/getSurveyTypeByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyTypeIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getSurveyType
         * @param {number} surveyTypeId surveyTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyTypeUsingGET: async (surveyTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyTypeId' is not null or undefined
            assertParamExists('getSurveyTypeUsingGET', 'surveyTypeId', surveyTypeId)
            const localVarPath = `/survey/surveyEngProj/getSurveyType/{surveyTypeId}`
                .replace(`{${"surveyTypeId"}}`, encodeURIComponent(String(surveyTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyTypeControllerApi - functional programming interface
 * @export
 */
export const SurveyTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getAllSurveyTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSurveyTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyTypeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSurveyTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSurveyTypeByIds
         * @param {Array<number>} surveyTypeIds surveyTypeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyTypeByIdsUsingGET(surveyTypeIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveyTypeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyTypeByIdsUsingGET(surveyTypeIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getSurveyType
         * @param {number} surveyTypeId surveyTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyTypeUsingGET(surveyTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyTypeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyTypeUsingGET(surveyTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SurveyTypeControllerApi - factory interface
 * @export
 */
export const SurveyTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyTypeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getAllSurveyTypes
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSurveyTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<SurveyTypeDTO>> {
            return localVarFp.getAllSurveyTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSurveyTypeByIds
         * @param {Array<number>} surveyTypeIds surveyTypeIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyTypeByIdsUsingGET(surveyTypeIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<SurveyTypeDTO>> {
            return localVarFp.getSurveyTypeByIdsUsingGET(surveyTypeIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getSurveyType
         * @param {number} surveyTypeId surveyTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyTypeUsingGET(surveyTypeId: number, authorization?: string, options?: any): AxiosPromise<SurveyTypeDTO> {
            return localVarFp.getSurveyTypeUsingGET(surveyTypeId, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyTypeControllerApi - object-oriented interface
 * @export
 * @class SurveyTypeControllerApi
 * @extends {BaseAPI}
 */
export class SurveyTypeControllerApi extends BaseAPI {
    /**
     * 
     * @summary getAllSurveyTypes
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyTypeControllerApi
     */
    public getAllSurveyTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return SurveyTypeControllerApiFp(this.configuration).getAllSurveyTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSurveyTypeByIds
     * @param {Array<number>} surveyTypeIds surveyTypeIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyTypeControllerApi
     */
    public getSurveyTypeByIdsUsingGET(surveyTypeIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return SurveyTypeControllerApiFp(this.configuration).getSurveyTypeByIdsUsingGET(surveyTypeIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getSurveyType
     * @param {number} surveyTypeId surveyTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyTypeControllerApi
     */
    public getSurveyTypeUsingGET(surveyTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return SurveyTypeControllerApiFp(this.configuration).getSurveyTypeUsingGET(surveyTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TerraceChannelTemplateControllerApi - axios parameter creator
 * @export
 */
export const TerraceChannelTemplateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createTerraceChannelTemplate
         * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceChannelTemplateUsingPOST: async (terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceChannelTemplateDTO' is not null or undefined
            assertParamExists('createTerraceChannelTemplateUsingPOST', 'terraceChannelTemplateDTO', terraceChannelTemplateDTO)
            const localVarPath = `/terraceChannelTemplate/createTerraceChannelTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceChannelTemplateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceChannelTemplateByTemplateNameUsingPOST: async (templateName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateName' is not null or undefined
            assertParamExists('deleteTerraceChannelTemplateByTemplateNameUsingPOST', 'templateName', templateName)
            const localVarPath = `/terraceChannelTemplate/deleteTerraceChannelTemplateByTemplateName/{templateName}`
                .replace(`{${"templateName"}}`, encodeURIComponent(String(templateName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information Terace Template from d_Terrace_Channel_Template table
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTerraceTemplateUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/terraceChannelTemplate/getAllTerraceTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return the Terrace\'s default Channel Template from design control ready to use immediately for the terrace design. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.
         * @param {number} terraceAlignedElementId terraceAlignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTerraceDesignControlChannelTemplateUsingGET: async (terraceAlignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceAlignedElementId' is not null or undefined
            assertParamExists('getDefaultTerraceDesignControlChannelTemplateUsingGET', 'terraceAlignedElementId', terraceAlignedElementId)
            const localVarPath = `/terraceChannelTemplate/defaultTerraceDesignControlChannelTemplate/{terraceAlignedElementId}`
                .replace(`{${"terraceAlignedElementId"}}`, encodeURIComponent(String(terraceAlignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getTerraceChannelTemplateByTemplateGroupName
         * @param {string} templateGroupName templateGroupName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceChannelTemplateByTemplateGroupNameUsingGET: async (templateGroupName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateGroupName' is not null or undefined
            assertParamExists('getTerraceChannelTemplateByTemplateGroupNameUsingGET', 'templateGroupName', templateGroupName)
            const localVarPath = `/terraceChannelTemplate/getTerraceChannelTemplateByTemplateGroupName/{templateGroupName}`
                .replace(`{${"templateGroupName"}}`, encodeURIComponent(String(templateGroupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceChannelTemplateByTemplateNameUsingGET: async (templateName: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateName' is not null or undefined
            assertParamExists('getTerraceChannelTemplateByTemplateNameUsingGET', 'templateName', templateName)
            const localVarPath = `/terraceChannelTemplate/getTerraceChannelTemplateByTemplateName/{templateName}`
                .replace(`{${"templateName"}}`, encodeURIComponent(String(templateName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return the same TerraceVertexParamsDTO with updated fields related to channel template. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.Noted that this is a soft update, no data is written into DB. FE needs to send the updated TerraceVertexParamsDTO to saveTerraceReachEdits API as part of a Pending Edit manager item
         * @param {number} terraceAlignedElementId terraceAlignedElementId
         * @param {TerraceVertexParamsDTO} terraceVertexParamsDTO terraceVertexParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH: async (terraceAlignedElementId: number, terraceVertexParamsDTO: TerraceVertexParamsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceAlignedElementId' is not null or undefined
            assertParamExists('resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH', 'terraceAlignedElementId', terraceAlignedElementId)
            // verify required parameter 'terraceVertexParamsDTO' is not null or undefined
            assertParamExists('resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH', 'terraceVertexParamsDTO', terraceVertexParamsDTO)
            const localVarPath = `/terraceChannelTemplate/resetChannelTemplateForTerraceVertexParamsDTO/{terraceAlignedElementId}`
                .replace(`{${"terraceAlignedElementId"}}`, encodeURIComponent(String(terraceAlignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceVertexParamsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceChannelTemplateByTemplateNameUsingPOST: async (templateName: string, terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateName' is not null or undefined
            assertParamExists('updateTerraceChannelTemplateByTemplateNameUsingPOST', 'templateName', templateName)
            // verify required parameter 'terraceChannelTemplateDTO' is not null or undefined
            assertParamExists('updateTerraceChannelTemplateByTemplateNameUsingPOST', 'terraceChannelTemplateDTO', terraceChannelTemplateDTO)
            const localVarPath = `/terraceChannelTemplate/updateTerraceChannelTemplateByTemplateName/{templateName}`
                .replace(`{${"templateName"}}`, encodeURIComponent(String(templateName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceChannelTemplateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerraceChannelTemplateControllerApi - functional programming interface
 * @export
 */
export const TerraceChannelTemplateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerraceChannelTemplateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createTerraceChannelTemplate
         * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTerraceChannelTemplateUsingPOST(terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceChannelTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTerraceChannelTemplateUsingPOST(terraceChannelTemplateDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTerraceChannelTemplateByTemplateNameUsingPOST(templateName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceChannelTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTerraceChannelTemplateByTemplateNameUsingPOST(templateName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information Terace Template from d_Terrace_Channel_Template table
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTerraceTemplateUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceChannelTemplateResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTerraceTemplateUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return the Terrace\'s default Channel Template from design control ready to use immediately for the terrace design. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.
         * @param {number} terraceAlignedElementId terraceAlignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultTerraceDesignControlChannelTemplateUsingGET(terraceAlignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceChannelTemplateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultTerraceDesignControlChannelTemplateUsingGET(terraceAlignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getTerraceChannelTemplateByTemplateGroupName
         * @param {string} templateGroupName templateGroupName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceChannelTemplateByTemplateGroupNameUsingGET(templateGroupName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceChannelTemplateResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceChannelTemplateByTemplateGroupNameUsingGET(templateGroupName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceChannelTemplateByTemplateNameUsingGET(templateName: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceChannelTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceChannelTemplateByTemplateNameUsingGET(templateName, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return the same TerraceVertexParamsDTO with updated fields related to channel template. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.Noted that this is a soft update, no data is written into DB. FE needs to send the updated TerraceVertexParamsDTO to saveTerraceReachEdits API as part of a Pending Edit manager item
         * @param {number} terraceAlignedElementId terraceAlignedElementId
         * @param {TerraceVertexParamsDTO} terraceVertexParamsDTO terraceVertexParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH(terraceAlignedElementId: number, terraceVertexParamsDTO: TerraceVertexParamsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceVertexParamsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH(terraceAlignedElementId, terraceVertexParamsDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerraceChannelTemplateByTemplateNameUsingPOST(templateName: string, terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceChannelTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerraceChannelTemplateByTemplateNameUsingPOST(templateName, terraceChannelTemplateDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TerraceChannelTemplateControllerApi - factory interface
 * @export
 */
export const TerraceChannelTemplateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerraceChannelTemplateControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createTerraceChannelTemplate
         * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceChannelTemplateUsingPOST(terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options?: any): AxiosPromise<TerraceChannelTemplateResponseDto> {
            return localVarFp.createTerraceChannelTemplateUsingPOST(terraceChannelTemplateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceChannelTemplateByTemplateNameUsingPOST(templateName: string, authorization?: string, options?: any): AxiosPromise<TerraceChannelTemplateResponseDto> {
            return localVarFp.deleteTerraceChannelTemplateByTemplateNameUsingPOST(templateName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information Terace Template from d_Terrace_Channel_Template table
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTerraceTemplateUsingGET(authorization?: string, options?: any): AxiosPromise<Array<TerraceChannelTemplateResponseDto>> {
            return localVarFp.getAllTerraceTemplateUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return the Terrace\'s default Channel Template from design control ready to use immediately for the terrace design. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.
         * @param {number} terraceAlignedElementId terraceAlignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultTerraceDesignControlChannelTemplateUsingGET(terraceAlignedElementId: number, authorization?: string, options?: any): AxiosPromise<TerraceChannelTemplateDTO> {
            return localVarFp.getDefaultTerraceDesignControlChannelTemplateUsingGET(terraceAlignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getTerraceChannelTemplateByTemplateGroupName
         * @param {string} templateGroupName templateGroupName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceChannelTemplateByTemplateGroupNameUsingGET(templateGroupName: string, authorization?: string, options?: any): AxiosPromise<Array<TerraceChannelTemplateResponseDto>> {
            return localVarFp.getTerraceChannelTemplateByTemplateGroupNameUsingGET(templateGroupName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceChannelTemplateByTemplateNameUsingGET(templateName: string, authorization?: string, options?: any): AxiosPromise<TerraceChannelTemplateResponseDto> {
            return localVarFp.getTerraceChannelTemplateByTemplateNameUsingGET(templateName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return the same TerraceVertexParamsDTO with updated fields related to channel template. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.Noted that this is a soft update, no data is written into DB. FE needs to send the updated TerraceVertexParamsDTO to saveTerraceReachEdits API as part of a Pending Edit manager item
         * @param {number} terraceAlignedElementId terraceAlignedElementId
         * @param {TerraceVertexParamsDTO} terraceVertexParamsDTO terraceVertexParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH(terraceAlignedElementId: number, terraceVertexParamsDTO: TerraceVertexParamsDTO, authorization?: string, options?: any): AxiosPromise<TerraceVertexParamsDTO> {
            return localVarFp.resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH(terraceAlignedElementId, terraceVertexParamsDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateTerraceChannelTemplateByTemplateName
         * @param {string} templateName templateName
         * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceChannelTemplateByTemplateNameUsingPOST(templateName: string, terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options?: any): AxiosPromise<TerraceChannelTemplateResponseDto> {
            return localVarFp.updateTerraceChannelTemplateByTemplateNameUsingPOST(templateName, terraceChannelTemplateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerraceChannelTemplateControllerApi - object-oriented interface
 * @export
 * @class TerraceChannelTemplateControllerApi
 * @extends {BaseAPI}
 */
export class TerraceChannelTemplateControllerApi extends BaseAPI {
    /**
     * 
     * @summary createTerraceChannelTemplate
     * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public createTerraceChannelTemplateUsingPOST(terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).createTerraceChannelTemplateUsingPOST(terraceChannelTemplateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteTerraceChannelTemplateByTemplateName
     * @param {string} templateName templateName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public deleteTerraceChannelTemplateByTemplateNameUsingPOST(templateName: string, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).deleteTerraceChannelTemplateByTemplateNameUsingPOST(templateName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information Terace Template from d_Terrace_Channel_Template table
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public getAllTerraceTemplateUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).getAllTerraceTemplateUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return the Terrace\'s default Channel Template from design control ready to use immediately for the terrace design. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.
     * @param {number} terraceAlignedElementId terraceAlignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public getDefaultTerraceDesignControlChannelTemplateUsingGET(terraceAlignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).getDefaultTerraceDesignControlChannelTemplateUsingGET(terraceAlignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getTerraceChannelTemplateByTemplateGroupName
     * @param {string} templateGroupName templateGroupName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public getTerraceChannelTemplateByTemplateGroupNameUsingGET(templateGroupName: string, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).getTerraceChannelTemplateByTemplateGroupNameUsingGET(templateGroupName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getTerraceChannelTemplateByTemplateName
     * @param {string} templateName templateName
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public getTerraceChannelTemplateByTemplateNameUsingGET(templateName: string, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).getTerraceChannelTemplateByTemplateNameUsingGET(templateName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return the same TerraceVertexParamsDTO with updated fields related to channel template. Only Terrace AlignedElementId is needed, channel template is populated based on isUserDefinedTemplate behind the scene.Noted that this is a soft update, no data is written into DB. FE needs to send the updated TerraceVertexParamsDTO to saveTerraceReachEdits API as part of a Pending Edit manager item
     * @param {number} terraceAlignedElementId terraceAlignedElementId
     * @param {TerraceVertexParamsDTO} terraceVertexParamsDTO terraceVertexParamsDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH(terraceAlignedElementId: number, terraceVertexParamsDTO: TerraceVertexParamsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).resetChannelTemplateForTerraceVertexParamsDTOUsingPATCH(terraceAlignedElementId, terraceVertexParamsDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateTerraceChannelTemplateByTemplateName
     * @param {string} templateName templateName
     * @param {TerraceChannelTemplateDTO} terraceChannelTemplateDTO terraceChannelTemplateDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceChannelTemplateControllerApi
     */
    public updateTerraceChannelTemplateByTemplateNameUsingPOST(templateName: string, terraceChannelTemplateDTO: TerraceChannelTemplateDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceChannelTemplateControllerApiFp(this.configuration).updateTerraceChannelTemplateByTemplateNameUsingPOST(templateName, terraceChannelTemplateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TerraceControllerApi - axios parameter creator
 * @export
 */
export const TerraceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This endpoint is used to create a terrace profile in TDT.
         * @param {TerraceProfileRequestDTO} terraceProfileRequestDTO terraceProfileRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceProfileUsingPOST: async (terraceProfileRequestDTO: TerraceProfileRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceProfileRequestDTO' is not null or undefined
            assertParamExists('createTerraceProfileUsingPOST', 'terraceProfileRequestDTO', terraceProfileRequestDTO)
            const localVarPath = `/terrace/createTerraceProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceProfileRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAdjacentTerracesOrWaterways
         * @param {AdjacentTerracesOrWaterwaysRequestDTO} adjacentTerracesOrWaterwaysRequestDTO adjacentTerracesOrWaterwaysRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdjacentTerracesOrWaterwaysUsingPOST: async (adjacentTerracesOrWaterwaysRequestDTO: AdjacentTerracesOrWaterwaysRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adjacentTerracesOrWaterwaysRequestDTO' is not null or undefined
            assertParamExists('getAdjacentTerracesOrWaterwaysUsingPOST', 'adjacentTerracesOrWaterwaysRequestDTO', adjacentTerracesOrWaterwaysRequestDTO)
            const localVarPath = `/terrace/getAdjacentTerracesOrWaterways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adjacentTerracesOrWaterwaysRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getIntersectionPoints
         * @param {number} sourceAlignmentId sourceAlignmentId
         * @param {number} targetAlignmentId targetAlignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntersectionPointsUsingPOST: async (sourceAlignmentId: number, targetAlignmentId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceAlignmentId' is not null or undefined
            assertParamExists('getIntersectionPointsUsingPOST', 'sourceAlignmentId', sourceAlignmentId)
            // verify required parameter 'targetAlignmentId' is not null or undefined
            assertParamExists('getIntersectionPointsUsingPOST', 'targetAlignmentId', targetAlignmentId)
            const localVarPath = `/terrace/getAlignmentsIntersectionPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sourceAlignmentId !== undefined) {
                localVarQueryParameter['sourceAlignmentId'] = sourceAlignmentId;
            }

            if (targetAlignmentId !== undefined) {
                localVarQueryParameter['targetAlignmentId'] = targetAlignmentId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary terraceCalWithDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terraceCalWithDTOUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/terrace/terraceCalWithDTO`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary terraceEngineTestWithDB
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        terraceEngineTestWithDBUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('terraceEngineTestWithDBUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/terrace/terraceEngineTestWithDB/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary verifyTestData
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTestDataUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/terrace/verifySampleData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerraceControllerApi - functional programming interface
 * @export
 */
export const TerraceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerraceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This endpoint is used to create a terrace profile in TDT.
         * @param {TerraceProfileRequestDTO} terraceProfileRequestDTO terraceProfileRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTerraceProfileUsingPOST(terraceProfileRequestDTO: TerraceProfileRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceProfileResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTerraceProfileUsingPOST(terraceProfileRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAdjacentTerracesOrWaterways
         * @param {AdjacentTerracesOrWaterwaysRequestDTO} adjacentTerracesOrWaterwaysRequestDTO adjacentTerracesOrWaterwaysRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdjacentTerracesOrWaterwaysUsingPOST(adjacentTerracesOrWaterwaysRequestDTO: AdjacentTerracesOrWaterwaysRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdjacentTerracesOrWaterwaysResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdjacentTerracesOrWaterwaysUsingPOST(adjacentTerracesOrWaterwaysRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getIntersectionPoints
         * @param {number} sourceAlignmentId sourceAlignmentId
         * @param {number} targetAlignmentId targetAlignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntersectionPointsUsingPOST(sourceAlignmentId: number, targetAlignmentId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InputPoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntersectionPointsUsingPOST(sourceAlignmentId, targetAlignmentId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary terraceCalWithDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terraceCalWithDTOUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terraceCalWithDTOUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary terraceEngineTestWithDB
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async terraceEngineTestWithDBUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terraceEngineTestWithDBUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary verifyTestData
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTestDataUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTestDataUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TerraceControllerApi - factory interface
 * @export
 */
export const TerraceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerraceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This endpoint is used to create a terrace profile in TDT.
         * @param {TerraceProfileRequestDTO} terraceProfileRequestDTO terraceProfileRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceProfileUsingPOST(terraceProfileRequestDTO: TerraceProfileRequestDTO, authorization?: string, options?: any): AxiosPromise<TerraceProfileResponseDTO> {
            return localVarFp.createTerraceProfileUsingPOST(terraceProfileRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAdjacentTerracesOrWaterways
         * @param {AdjacentTerracesOrWaterwaysRequestDTO} adjacentTerracesOrWaterwaysRequestDTO adjacentTerracesOrWaterwaysRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdjacentTerracesOrWaterwaysUsingPOST(adjacentTerracesOrWaterwaysRequestDTO: AdjacentTerracesOrWaterwaysRequestDTO, authorization?: string, options?: any): AxiosPromise<AdjacentTerracesOrWaterwaysResponseDTO> {
            return localVarFp.getAdjacentTerracesOrWaterwaysUsingPOST(adjacentTerracesOrWaterwaysRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getIntersectionPoints
         * @param {number} sourceAlignmentId sourceAlignmentId
         * @param {number} targetAlignmentId targetAlignmentId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntersectionPointsUsingPOST(sourceAlignmentId: number, targetAlignmentId: number, authorization?: string, options?: any): AxiosPromise<Array<InputPoint>> {
            return localVarFp.getIntersectionPointsUsingPOST(sourceAlignmentId, targetAlignmentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary terraceCalWithDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terraceCalWithDTOUsingGET(authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.terraceCalWithDTOUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary terraceEngineTestWithDB
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        terraceEngineTestWithDBUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<ErrorResponse> {
            return localVarFp.terraceEngineTestWithDBUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary verifyTestData
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTestDataUsingGET(authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.verifyTestDataUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerraceControllerApi - object-oriented interface
 * @export
 * @class TerraceControllerApi
 * @extends {BaseAPI}
 */
export class TerraceControllerApi extends BaseAPI {
    /**
     * 
     * @summary This endpoint is used to create a terrace profile in TDT.
     * @param {TerraceProfileRequestDTO} terraceProfileRequestDTO terraceProfileRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceControllerApi
     */
    public createTerraceProfileUsingPOST(terraceProfileRequestDTO: TerraceProfileRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceControllerApiFp(this.configuration).createTerraceProfileUsingPOST(terraceProfileRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAdjacentTerracesOrWaterways
     * @param {AdjacentTerracesOrWaterwaysRequestDTO} adjacentTerracesOrWaterwaysRequestDTO adjacentTerracesOrWaterwaysRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceControllerApi
     */
    public getAdjacentTerracesOrWaterwaysUsingPOST(adjacentTerracesOrWaterwaysRequestDTO: AdjacentTerracesOrWaterwaysRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceControllerApiFp(this.configuration).getAdjacentTerracesOrWaterwaysUsingPOST(adjacentTerracesOrWaterwaysRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getIntersectionPoints
     * @param {number} sourceAlignmentId sourceAlignmentId
     * @param {number} targetAlignmentId targetAlignmentId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceControllerApi
     */
    public getIntersectionPointsUsingPOST(sourceAlignmentId: number, targetAlignmentId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceControllerApiFp(this.configuration).getIntersectionPointsUsingPOST(sourceAlignmentId, targetAlignmentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary terraceCalWithDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceControllerApi
     */
    public terraceCalWithDTOUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return TerraceControllerApiFp(this.configuration).terraceCalWithDTOUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary terraceEngineTestWithDB
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TerraceControllerApi
     */
    public terraceEngineTestWithDBUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceControllerApiFp(this.configuration).terraceEngineTestWithDBUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary verifyTestData
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceControllerApi
     */
    public verifyTestDataUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return TerraceControllerApiFp(this.configuration).verifyTestDataUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TerraceDesignToolsControllerApi - axios parameter creator
 * @export
 */
export const TerraceDesignToolsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API return TerraceDesignShapeResponseDTO by alignmentJsonId, which defines the Terrace channel shapes and its design surface
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTerraceChannelShapeUsingPOST: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('calculateTerraceChannelShapeUsingPOST', 'alignedElementId', alignedElementId)
            const localVarPath = `/terracedesign/calculateTerraceChannelShape/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given Terrace
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTerraceAlignedElementDesignParamsUsingPOST: async (alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsRequest' is not null or undefined
            assertParamExists('createOrUpdateTerraceAlignedElementDesignParamsUsingPOST', 'alignedElementDesignParamsRequest', alignedElementDesignParamsRequest)
            const localVarPath = `/terracedesign/createOrUpdateTerraceAlignedElementDesignParams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignedElementDesignParamsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API create or update Terrace Hydro Params by AlignmentId
         * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST: async (terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceHydroParamsDTO' is not null or undefined
            assertParamExists('createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST', 'terraceHydroParamsDTO', terraceHydroParamsDTO)
            const localVarPath = `/terracedesign/createOrUpdateTerraceHydroParamsByAlignedDesignElementId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceHydroParamsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API create or update Terrace Hydro Params by AlignmentId
         * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST: async (terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceHydroParamsDTO' is not null or undefined
            assertParamExists('createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST', 'terraceHydroParamsDTO', terraceHydroParamsDTO)
            const localVarPath = `/terracedesign/createOrUpdateTerraceHydroParamsByAlignmentId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceHydroParamsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint is used to create terrace default reach by alignedElementId and by a query defined by TerraceChannelTemplateRequest.
         * @param {TerraceDefaultReachRequest} terraceDefaultReachRequest terraceDefaultReachRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceDefaultReachesUsingPOST: async (terraceDefaultReachRequest: TerraceDefaultReachRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceDefaultReachRequest' is not null or undefined
            assertParamExists('createTerraceDefaultReachesUsingPOST', 'terraceDefaultReachRequest', terraceDefaultReachRequest)
            const localVarPath = `/terracedesign/createTerraceDefaultReaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceDefaultReachRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint is used to clear out drainStationDto and blockStationDto in waterwayVertexJson when terrace type changes from storage to gradient or from storage to level
         * @param {DeleteTerraceBlocksOrDrainsRequestDTO} deleteTerraceBlocksOrDrainsRequestDTO deleteTerraceBlocksOrDrainsRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST: async (deleteTerraceBlocksOrDrainsRequestDTO: DeleteTerraceBlocksOrDrainsRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteTerraceBlocksOrDrainsRequestDTO' is not null or undefined
            assertParamExists('deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST', 'deleteTerraceBlocksOrDrainsRequestDTO', deleteTerraceBlocksOrDrainsRequestDTO)
            const localVarPath = `/terracedesign/deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTerraceBlocksOrDrainsRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to delete Terrace and its related entities using alignedElementDesignParametersId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceByAlignedElementDesignParamsIdUsingDELETE: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('deleteTerraceByAlignedElementDesignParamsIdUsingDELETE', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/terracedesign/deleteTerraceByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API used to Export Terrace Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} xsectionInterval xsectionInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTerraceCrossSectionsUsingPOST: async (alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('exportTerraceCrossSectionsUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            // verify required parameter 'xsectionInterval' is not null or undefined
            assertParamExists('exportTerraceCrossSectionsUsingPOST', 'xsectionInterval', xsectionInterval)
            const localVarPath = `/terracedesign/exportTerraceCrossSections/{alignedElementDesignParametersId}/{xsectionInterval}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)))
                .replace(`{${"xsectionInterval"}}`, encodeURIComponent(String(xsectionInterval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API generates data for the Terrace 3 cross-section view, returning a list of responses where each entry represents a single cross-section.
         * @param {AlignedElementCrossSectionRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTerrace3XSectionsUsingPOST: async (request: AlignedElementCrossSectionRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('generateTerrace3XSectionsUsingPOST', 'request', request)
            const localVarPath = `/terracedesign/generateTerrace3XSections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API generate terrace design surface contour, tin and survey surface, save it into design element json table 
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTerraceDesignSurfaceByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('generateTerraceDesignSurfaceByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/terracedesign/generateTerraceDesignSurfaceByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasinCharacteristicsDtoByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('getBasinCharacteristicsDtoByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/terracedesign/getBasinCharacteristicsDtoByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignmentJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET: async (alignmentDesignElementJsonId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentDesignElementJsonId' is not null or undefined
            assertParamExists('getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET', 'alignmentDesignElementJsonId', alignmentDesignElementJsonId)
            const localVarPath = `/terracedesign/getBasinCharacteristicsDtoByAlignmentDesignJsonId/{alignmentDesignElementJsonId}`
                .replace(`{${"alignmentDesignElementJsonId"}}`, encodeURIComponent(String(alignmentDesignElementJsonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API gets basic details about the terrace like name,type and alignment designeleemntjsonid by taking alignedElementDesignParamsId as input 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceBasicInfoUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getTerraceBasicInfoUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/terracedesign/getTerraceBasicInfo/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information required to build Terrace construction report
         * @param {TerracConstructionReportReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceConstructionReportUsingPOST: async (req: TerracConstructionReportReqDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getTerraceConstructionReportUsingPOST', 'req', req)
            const localVarPath = `/terracedesign/getTerraceConstructionReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API retrieve terrace design control dto by AlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignControlByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('getTerraceDesignControlByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/terracedesign/getTerraceDesignControlByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information required to build terrace design report by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignReportUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getTerraceDesignReportUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/terracedesign/getTerraceDesignReport/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignSummariesBySessionUuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getTerraceDesignSummariesBySessionUuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/terracedesign/getTerraceDesignSummariesBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignSummaryBySessionUuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getTerraceDesignSummaryBySessionUuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/terracedesign/getTerraceDesignSummaryBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API gets TerraceInputs info by taking alignedElementDesignParamsId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceInputsByAlignedElementDesignParamsIdUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getTerraceInputsByAlignedElementDesignParamsIdUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/terracedesign/getTerraceInputsByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceSummaryResultsUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getTerraceSummaryResultsUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/terracedesign/getTerraceSummaryResults/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Vertex Params Dto by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceVertexParamsDtoByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('getTerraceVertexParamsDtoByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/terracedesign/getTerraceVertexParamsDtoByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API gets storage calculation by taking alignedElementDesignParamsId and testedWaterLevel as inputs
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {number} testedWaterLevel testedWaterLevel
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getstorageCalculationUsingGET: async (alignedElementDesignParamsId: number, testedWaterLevel: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getstorageCalculationUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            // verify required parameter 'testedWaterLevel' is not null or undefined
            assertParamExists('getstorageCalculationUsingGET', 'testedWaterLevel', testedWaterLevel)
            const localVarPath = `/terracedesign/getStorageCalculation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (alignedElementDesignParamsId !== undefined) {
                localVarQueryParameter['alignedElementDesignParamsId'] = alignedElementDesignParamsId;
            }

            if (testedWaterLevel !== undefined) {
                localVarQueryParameter['testedWaterLevel'] = testedWaterLevel;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/terracedesign/loadTerraceAlignedElementDesignParamsByAlignedElementParamsId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API gets TerraceHydroParams info by taking alignedElementDesignParamsId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadTerraceHydroParamsUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('loadTerraceHydroParamsUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/terracedesign/loadTerraceHydroParams/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API calculates the runOffSedimentStorage by taking TerraceHydroParamsDTO as input and RunoffSedimentStorageDTO as output 
         * @param {RunoffSedimentStorageCalReqDTO} runoffSedimentStorageCalReqDTO runoffSedimentStorageCalReqDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runoffSedimentStorageCalculationUsingPOST: async (runoffSedimentStorageCalReqDTO: RunoffSedimentStorageCalReqDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runoffSedimentStorageCalReqDTO' is not null or undefined
            assertParamExists('runoffSedimentStorageCalculationUsingPOST', 'runoffSedimentStorageCalReqDTO', runoffSedimentStorageCalReqDTO)
            const localVarPath = `/terracedesign/runoffSedimentStorageCalculation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runoffSedimentStorageCalReqDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API split terrace into 2 provided the terrace aligned element id and a reach Id of the terrace as a splitting location
         * @param {SplitTerraceRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitTerraceUsingPOST: async (request: SplitTerraceRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('splitTerraceUsingPOST', 'request', request)
            const localVarPath = `/terracedesign/splitTerrace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terraceSimulationAndValidationUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('terraceSimulationAndValidationUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/terracedesign/terraceSimulationAndValidation/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API find if there is an offset distance between reaches
         * @param {AlignmentEditRequestDTO} offsetDistanceRequestDTO offsetDistanceRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAlignmentEditUsingPOST: async (offsetDistanceRequestDTO: AlignmentEditRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offsetDistanceRequestDTO' is not null or undefined
            assertParamExists('testAlignmentEditUsingPOST', 'offsetDistanceRequestDTO', offsetDistanceRequestDTO)
            const localVarPath = `/terracedesign/testAlignmentEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offsetDistanceRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API updates already created Terrace with DesignControl
         * @param {UpdateTerraceDesignControlDTO} terraceDesignControlDTO terraceDesignControlDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceDesignControlUsingPOST: async (terraceDesignControlDTO: UpdateTerraceDesignControlDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceDesignControlDTO' is not null or undefined
            assertParamExists('updateTerraceDesignControlUsingPOST', 'terraceDesignControlDTO', terraceDesignControlDTO)
            const localVarPath = `/terracedesign/updateTerraceDesignControl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceDesignControlDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerraceDesignToolsControllerApi - functional programming interface
 * @export
 */
export const TerraceDesignToolsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerraceDesignToolsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API return TerraceDesignShapeResponseDTO by alignmentJsonId, which defines the Terrace channel shapes and its design surface
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateTerraceChannelShapeUsingPOST(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceDesignShapeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateTerraceChannelShapeUsingPOST(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given Terrace
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateTerraceAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateTerraceAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API create or update Terrace Hydro Params by AlignmentId
         * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST(terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceAlignElementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST(terraceHydroParamsDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API create or update Terrace Hydro Params by AlignmentId
         * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST(terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceAlignElementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST(terraceHydroParamsDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This endpoint is used to create terrace default reach by alignedElementId and by a query defined by TerraceChannelTemplateRequest.
         * @param {TerraceDefaultReachRequest} terraceDefaultReachRequest terraceDefaultReachRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTerraceDefaultReachesUsingPOST(terraceDefaultReachRequest: TerraceDefaultReachRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceDefaultReachResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTerraceDefaultReachesUsingPOST(terraceDefaultReachRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This endpoint is used to clear out drainStationDto and blockStationDto in waterwayVertexJson when terrace type changes from storage to gradient or from storage to level
         * @param {DeleteTerraceBlocksOrDrainsRequestDTO} deleteTerraceBlocksOrDrainsRequestDTO deleteTerraceBlocksOrDrainsRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST(deleteTerraceBlocksOrDrainsRequestDTO: DeleteTerraceBlocksOrDrainsRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTerraceBlocksOrDrainsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST(deleteTerraceBlocksOrDrainsRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to delete Terrace and its related entities using alignedElementDesignParametersId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTerraceByAlignedElementDesignParamsIdUsingDELETE(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTerraceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTerraceByAlignedElementDesignParamsIdUsingDELETE(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API used to Export Terrace Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} xsectionInterval xsectionInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTerraceCrossSectionsUsingPOST(alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTerraceCrossSectionsUsingPOST(alignedElementDesignParametersId, xsectionInterval, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API generates data for the Terrace 3 cross-section view, returning a list of responses where each entry represents a single cross-section.
         * @param {AlignedElementCrossSectionRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTerrace3XSectionsUsingPOST(request: AlignedElementCrossSectionRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceCrossSectionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTerrace3XSectionsUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API generate terrace design surface contour, tin and survey surface, save it into design element json table 
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTerraceDesignSurfaceByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceDesignShapeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTerraceDesignSurfaceByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBasinCharacteristicsDtoByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasinCharacteristicsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBasinCharacteristicsDtoByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignmentJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasinCharacteristicsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET(alignmentDesignElementJsonId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API gets basic details about the terrace like name,type and alignment designeleemntjsonid by taking alignedElementDesignParamsId as input 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceBasicInfoUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceBasicInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceBasicInfoUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information required to build Terrace construction report
         * @param {TerracConstructionReportReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceConstructionReportUsingPOST(req: TerracConstructionReportReqDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceConstructionReportRespDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceConstructionReportUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API retrieve terrace design control dto by AlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceDesignControlByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceDesignControlResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceDesignControlByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information required to build terrace design report by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceDesignReportUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceDesignReportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceDesignReportUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceDesignSummariesBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceDesignSummariesResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceDesignSummariesBySessionUuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceDesignSummaryBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceDesignSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceDesignSummaryBySessionUuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API gets TerraceInputs info by taking alignedElementDesignParamsId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceInputsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceSummaryResultsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceSummaryResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceSummaryResultsUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Vertex Params Dto by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceVertexParamsDtoByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceVertexParamsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceVertexParamsDtoByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API gets storage calculation by taking alignedElementDesignParamsId and testedWaterLevel as inputs
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {number} testedWaterLevel testedWaterLevel
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getstorageCalculationUsingGET(alignedElementDesignParamsId: number, testedWaterLevel: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageCaculationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getstorageCalculationUsingGET(alignedElementDesignParamsId, testedWaterLevel, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API gets TerraceHydroParams info by taking alignedElementDesignParamsId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadTerraceHydroParamsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadTerraceHydroParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadTerraceHydroParamsUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API calculates the runOffSedimentStorage by taking TerraceHydroParamsDTO as input and RunoffSedimentStorageDTO as output 
         * @param {RunoffSedimentStorageCalReqDTO} runoffSedimentStorageCalReqDTO runoffSedimentStorageCalReqDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runoffSedimentStorageCalculationUsingPOST(runoffSedimentStorageCalReqDTO: RunoffSedimentStorageCalReqDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunoffSedimentStorageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runoffSedimentStorageCalculationUsingPOST(runoffSedimentStorageCalReqDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API split terrace into 2 provided the terrace aligned element id and a reach Id of the terrace as a splitting location
         * @param {SplitTerraceRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitTerraceUsingPOST(request: SplitTerraceRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SplitTerraceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitTerraceUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terraceSimulationAndValidationUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerraceSimulationAndValidationRespDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terraceSimulationAndValidationUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API find if there is an offset distance between reaches
         * @param {AlignmentEditRequestDTO} offsetDistanceRequestDTO offsetDistanceRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testAlignmentEditUsingPOST(offsetDistanceRequestDTO: AlignmentEditRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentEditResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testAlignmentEditUsingPOST(offsetDistanceRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API updates already created Terrace with DesignControl
         * @param {UpdateTerraceDesignControlDTO} terraceDesignControlDTO terraceDesignControlDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerraceDesignControlUsingPOST(terraceDesignControlDTO: UpdateTerraceDesignControlDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTerraceDesignControlResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerraceDesignControlUsingPOST(terraceDesignControlDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TerraceDesignToolsControllerApi - factory interface
 * @export
 */
export const TerraceDesignToolsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerraceDesignToolsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API return TerraceDesignShapeResponseDTO by alignmentJsonId, which defines the Terrace channel shapes and its design surface
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateTerraceChannelShapeUsingPOST(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<TerraceDesignShapeResponseDTO> {
            return localVarFp.calculateTerraceChannelShapeUsingPOST(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given Terrace
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTerraceAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.createOrUpdateTerraceAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API create or update Terrace Hydro Params by AlignmentId
         * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST(terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options?: any): AxiosPromise<TerraceAlignElementResponseDto> {
            return localVarFp.createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST(terraceHydroParamsDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API create or update Terrace Hydro Params by AlignmentId
         * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST(terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options?: any): AxiosPromise<TerraceAlignElementResponseDto> {
            return localVarFp.createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST(terraceHydroParamsDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint is used to create terrace default reach by alignedElementId and by a query defined by TerraceChannelTemplateRequest.
         * @param {TerraceDefaultReachRequest} terraceDefaultReachRequest terraceDefaultReachRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceDefaultReachesUsingPOST(terraceDefaultReachRequest: TerraceDefaultReachRequest, authorization?: string, options?: any): AxiosPromise<TerraceDefaultReachResponseDTO> {
            return localVarFp.createTerraceDefaultReachesUsingPOST(terraceDefaultReachRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint is used to clear out drainStationDto and blockStationDto in waterwayVertexJson when terrace type changes from storage to gradient or from storage to level
         * @param {DeleteTerraceBlocksOrDrainsRequestDTO} deleteTerraceBlocksOrDrainsRequestDTO deleteTerraceBlocksOrDrainsRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST(deleteTerraceBlocksOrDrainsRequestDTO: DeleteTerraceBlocksOrDrainsRequestDTO, authorization?: string, options?: any): AxiosPromise<DeleteTerraceBlocksOrDrainsResponseDTO> {
            return localVarFp.deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST(deleteTerraceBlocksOrDrainsRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to delete Terrace and its related entities using alignedElementDesignParametersId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceByAlignedElementDesignParamsIdUsingDELETE(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<DeleteTerraceResponseDTO> {
            return localVarFp.deleteTerraceByAlignedElementDesignParamsIdUsingDELETE(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API used to Export Terrace Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} xsectionInterval xsectionInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTerraceCrossSectionsUsingPOST(alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportTerraceCrossSectionsUsingPOST(alignedElementDesignParametersId, xsectionInterval, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API generates data for the Terrace 3 cross-section view, returning a list of responses where each entry represents a single cross-section.
         * @param {AlignedElementCrossSectionRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTerrace3XSectionsUsingPOST(request: AlignedElementCrossSectionRequest, authorization?: string, options?: any): AxiosPromise<Array<TerraceCrossSectionResponse>> {
            return localVarFp.generateTerrace3XSectionsUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API generate terrace design surface contour, tin and survey surface, save it into design element json table 
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTerraceDesignSurfaceByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<TerraceDesignShapeResponseDTO> {
            return localVarFp.generateTerraceDesignSurfaceByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasinCharacteristicsDtoByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<BasinCharacteristicsDTO> {
            return localVarFp.getBasinCharacteristicsDtoByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignmentJsonId
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: any): AxiosPromise<BasinCharacteristicsDTO> {
            return localVarFp.getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET(alignmentDesignElementJsonId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API gets basic details about the terrace like name,type and alignment designeleemntjsonid by taking alignedElementDesignParamsId as input 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceBasicInfoUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<TerraceBasicInfoDTO> {
            return localVarFp.getTerraceBasicInfoUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information required to build Terrace construction report
         * @param {TerracConstructionReportReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceConstructionReportUsingPOST(req: TerracConstructionReportReqDTO, authorization?: string, options?: any): AxiosPromise<TerraceConstructionReportRespDTO> {
            return localVarFp.getTerraceConstructionReportUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API retrieve terrace design control dto by AlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignControlByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<TerraceDesignControlResponseDTO> {
            return localVarFp.getTerraceDesignControlByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information required to build terrace design report by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignReportUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<TerraceDesignReportDTO> {
            return localVarFp.getTerraceDesignReportUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignSummariesBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<Array<TerraceDesignSummariesResponseDto>> {
            return localVarFp.getTerraceDesignSummariesBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceDesignSummaryBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<Array<TerraceDesignSummaryDto>> {
            return localVarFp.getTerraceDesignSummaryBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API gets TerraceInputs info by taking alignedElementDesignParamsId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<TerraceInputsDTO> {
            return localVarFp.getTerraceInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceSummaryResultsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<TerraceSummaryResultDTO> {
            return localVarFp.getTerraceSummaryResultsUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint is used to get Terrace Vertex Params Dto by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceVertexParamsDtoByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<Array<TerraceVertexParamsDTO>> {
            return localVarFp.getTerraceVertexParamsDtoByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API gets storage calculation by taking alignedElementDesignParamsId and testedWaterLevel as inputs
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {number} testedWaterLevel testedWaterLevel
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getstorageCalculationUsingGET(alignedElementDesignParamsId: number, testedWaterLevel: number, authorization?: string, options?: any): AxiosPromise<StorageCaculationResponseDto> {
            return localVarFp.getstorageCalculationUsingGET(alignedElementDesignParamsId, testedWaterLevel, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API gets TerraceHydroParams info by taking alignedElementDesignParamsId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadTerraceHydroParamsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<LoadTerraceHydroParamsResponseDTO> {
            return localVarFp.loadTerraceHydroParamsUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API calculates the runOffSedimentStorage by taking TerraceHydroParamsDTO as input and RunoffSedimentStorageDTO as output 
         * @param {RunoffSedimentStorageCalReqDTO} runoffSedimentStorageCalReqDTO runoffSedimentStorageCalReqDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runoffSedimentStorageCalculationUsingPOST(runoffSedimentStorageCalReqDTO: RunoffSedimentStorageCalReqDTO, authorization?: string, options?: any): AxiosPromise<RunoffSedimentStorageDTO> {
            return localVarFp.runoffSedimentStorageCalculationUsingPOST(runoffSedimentStorageCalReqDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API split terrace into 2 provided the terrace aligned element id and a reach Id of the terrace as a splitting location
         * @param {SplitTerraceRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitTerraceUsingPOST(request: SplitTerraceRequest, authorization?: string, options?: any): AxiosPromise<SplitTerraceResponse> {
            return localVarFp.splitTerraceUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terraceSimulationAndValidationUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<TerraceSimulationAndValidationRespDTO> {
            return localVarFp.terraceSimulationAndValidationUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API find if there is an offset distance between reaches
         * @param {AlignmentEditRequestDTO} offsetDistanceRequestDTO offsetDistanceRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAlignmentEditUsingPOST(offsetDistanceRequestDTO: AlignmentEditRequestDTO, authorization?: string, options?: any): AxiosPromise<AlignmentEditResponseDTO> {
            return localVarFp.testAlignmentEditUsingPOST(offsetDistanceRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API updates already created Terrace with DesignControl
         * @param {UpdateTerraceDesignControlDTO} terraceDesignControlDTO terraceDesignControlDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceDesignControlUsingPOST(terraceDesignControlDTO: UpdateTerraceDesignControlDTO, authorization?: string, options?: any): AxiosPromise<UpdateTerraceDesignControlResponseDTO> {
            return localVarFp.updateTerraceDesignControlUsingPOST(terraceDesignControlDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerraceDesignToolsControllerApi - object-oriented interface
 * @export
 * @class TerraceDesignToolsControllerApi
 * @extends {BaseAPI}
 */
export class TerraceDesignToolsControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API return TerraceDesignShapeResponseDTO by alignmentJsonId, which defines the Terrace channel shapes and its design surface
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public calculateTerraceChannelShapeUsingPOST(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).calculateTerraceChannelShapeUsingPOST(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given Terrace
     * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public createOrUpdateTerraceAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).createOrUpdateTerraceAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API create or update Terrace Hydro Params by AlignmentId
     * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST(terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).createOrUpdateTerraceHydroParamsByAlignedDesignElementIdUsingPOST(terraceHydroParamsDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API create or update Terrace Hydro Params by AlignmentId
     * @param {TerraceHydroParamsDTO} terraceHydroParamsDTO terraceHydroParamsDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST(terraceHydroParamsDTO: TerraceHydroParamsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).createOrUpdateTerraceHydroParamsByAlignmentIdUsingPOST(terraceHydroParamsDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint is used to create terrace default reach by alignedElementId and by a query defined by TerraceChannelTemplateRequest.
     * @param {TerraceDefaultReachRequest} terraceDefaultReachRequest terraceDefaultReachRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public createTerraceDefaultReachesUsingPOST(terraceDefaultReachRequest: TerraceDefaultReachRequest, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).createTerraceDefaultReachesUsingPOST(terraceDefaultReachRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint is used to clear out drainStationDto and blockStationDto in waterwayVertexJson when terrace type changes from storage to gradient or from storage to level
     * @param {DeleteTerraceBlocksOrDrainsRequestDTO} deleteTerraceBlocksOrDrainsRequestDTO deleteTerraceBlocksOrDrainsRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST(deleteTerraceBlocksOrDrainsRequestDTO: DeleteTerraceBlocksOrDrainsRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).deleteReachesBlocksOrDrainsByAlignedElementIdAndTerraceTypeUsingPOST(deleteTerraceBlocksOrDrainsRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to delete Terrace and its related entities using alignedElementDesignParametersId
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public deleteTerraceByAlignedElementDesignParamsIdUsingDELETE(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).deleteTerraceByAlignedElementDesignParamsIdUsingDELETE(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API used to Export Terrace Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {number} xsectionInterval xsectionInterval
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public exportTerraceCrossSectionsUsingPOST(alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).exportTerraceCrossSectionsUsingPOST(alignedElementDesignParametersId, xsectionInterval, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API generates data for the Terrace 3 cross-section view, returning a list of responses where each entry represents a single cross-section.
     * @param {AlignedElementCrossSectionRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public generateTerrace3XSectionsUsingPOST(request: AlignedElementCrossSectionRequest, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).generateTerrace3XSectionsUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API generate terrace design surface contour, tin and survey surface, save it into design element json table 
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public generateTerraceDesignSurfaceByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).generateTerraceDesignSurfaceByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getBasinCharacteristicsDtoByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getBasinCharacteristicsDtoByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API return AlignedElementDesignParamsResponseDTO by alignmentJsonId
     * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getBasinCharacteristicsDtoByAlignmentDesignJsonIdUsingGET(alignmentDesignElementJsonId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API gets basic details about the terrace like name,type and alignment designeleemntjsonid by taking alignedElementDesignParamsId as input 
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceBasicInfoUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceBasicInfoUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information required to build Terrace construction report
     * @param {TerracConstructionReportReqDTO} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceConstructionReportUsingPOST(req: TerracConstructionReportReqDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceConstructionReportUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API retrieve terrace design control dto by AlignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceDesignControlByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceDesignControlByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information required to build terrace design report by passing  alignedDesignParametersId as input
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceDesignReportUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceDesignReportUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceDesignSummariesBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceDesignSummariesBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint is used to get Terrace Design Summary by sessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceDesignSummaryBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceDesignSummaryBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API gets TerraceInputs info by taking alignedElementDesignParamsId as input
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceSummaryResultsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceSummaryResultsUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint is used to get Terrace Vertex Params Dto by alignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getTerraceVertexParamsDtoByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getTerraceVertexParamsDtoByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API gets storage calculation by taking alignedElementDesignParamsId and testedWaterLevel as inputs
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {number} testedWaterLevel testedWaterLevel
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public getstorageCalculationUsingGET(alignedElementDesignParamsId: number, testedWaterLevel: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).getstorageCalculationUsingGET(alignedElementDesignParamsId, testedWaterLevel, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API return AlignedElementDesignParamsResponseDTO by alignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).loadTerraceAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API gets TerraceHydroParams info by taking alignedElementDesignParamsId as input
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public loadTerraceHydroParamsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).loadTerraceHydroParamsUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API calculates the runOffSedimentStorage by taking TerraceHydroParamsDTO as input and RunoffSedimentStorageDTO as output 
     * @param {RunoffSedimentStorageCalReqDTO} runoffSedimentStorageCalReqDTO runoffSedimentStorageCalReqDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public runoffSedimentStorageCalculationUsingPOST(runoffSedimentStorageCalReqDTO: RunoffSedimentStorageCalReqDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).runoffSedimentStorageCalculationUsingPOST(runoffSedimentStorageCalReqDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API split terrace into 2 provided the terrace aligned element id and a reach Id of the terrace as a splitting location
     * @param {SplitTerraceRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public splitTerraceUsingPOST(request: SplitTerraceRequest, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).splitTerraceUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API calculates terraceSimulationAndValidation by taking alignedElementDesignParamsId as input and terraceSimulationAndValidationRespDTO as output 
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public terraceSimulationAndValidationUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).terraceSimulationAndValidationUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API find if there is an offset distance between reaches
     * @param {AlignmentEditRequestDTO} offsetDistanceRequestDTO offsetDistanceRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public testAlignmentEditUsingPOST(offsetDistanceRequestDTO: AlignmentEditRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).testAlignmentEditUsingPOST(offsetDistanceRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API updates already created Terrace with DesignControl
     * @param {UpdateTerraceDesignControlDTO} terraceDesignControlDTO terraceDesignControlDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceDesignToolsControllerApi
     */
    public updateTerraceDesignControlUsingPOST(terraceDesignControlDTO: UpdateTerraceDesignControlDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceDesignToolsControllerApiFp(this.configuration).updateTerraceDesignControlUsingPOST(terraceDesignControlDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TerraceReachControllerApi - axios parameter creator
 * @export
 */
export const TerraceReachControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary After Alignment is edited, provide the new AlignmentDTO, this API will recalculate the new positions of the terrace reach stations
         * @param {ReachStationAdjustmentRequest} reachStationAdjustmentRequest reachStationAdjustmentRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustReachStationNamesUsingPOST: async (reachStationAdjustmentRequest: ReachStationAdjustmentRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reachStationAdjustmentRequest' is not null or undefined
            assertParamExists('adjustReachStationNamesUsingPOST', 'reachStationAdjustmentRequest', reachStationAdjustmentRequest)
            const localVarPath = `/terracedesign/reachjson/adjustReachStationNames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reachStationAdjustmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createTerraceReach
         * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceReachUsingPOST: async (terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceReachDTO' is not null or undefined
            assertParamExists('createTerraceReachUsingPOST', 'terraceReachDTO', terraceReachDTO)
            const localVarPath = `/terracedesign/reachjson/createTerraceReach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceReachDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteAllTerraceReachWithAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/terracedesign/reachjson/deleteAllTerraceReachWithAlignedElementDesignParametersId/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteTerraceReachWithReachJsonId
         * @param {Array<number>} reachJsonId reachJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceReachWithReachJsonIdUsingPOST: async (reachJsonId: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reachJsonId' is not null or undefined
            assertParamExists('deleteTerraceReachWithReachJsonIdUsingPOST', 'reachJsonId', reachJsonId)
            const localVarPath = `/terracedesign/reachjson/deleteTerraceReachWithReachJsonId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reachJsonId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getTerraceReachAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceReachAlignedElementDesignParametersIdUsingGET: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getTerraceReachAlignedElementDesignParametersIdUsingGET', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/terracedesign/reachjson/getAllTerraceReachWithAlignedElementDesignParametersId/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API handles multiple edits on Terrace Reaches sent by front end and updates database accordingly
         * @param {SaveTerraceReachEditsDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTerraceReachEditsUsingPOST: async (requestDTO: SaveTerraceReachEditsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('saveTerraceReachEditsUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/terracedesign/reachjson/saveTerraceReachEdits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API updates already created Terrace with DesignControl
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTemplateToReachesUsingPOST: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('syncTemplateToReachesUsingPOST', 'alignedElementId', alignedElementId)
            const localVarPath = `/terracedesign/reachjson/syncTemplateToReaches/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateTerraceReach
         * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceReachUsingPOST: async (terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'terraceReachDTO' is not null or undefined
            assertParamExists('updateTerraceReachUsingPOST', 'terraceReachDTO', terraceReachDTO)
            const localVarPath = `/terracedesign/reachjson/updateTerraceReachWithAlignedElementDesignParametersId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(terraceReachDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerraceReachControllerApi - functional programming interface
 * @export
 */
export const TerraceReachControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerraceReachControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary After Alignment is edited, provide the new AlignmentDTO, this API will recalculate the new positions of the terrace reach stations
         * @param {ReachStationAdjustmentRequest} reachStationAdjustmentRequest reachStationAdjustmentRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adjustReachStationNamesUsingPOST(reachStationAdjustmentRequest: ReachStationAdjustmentRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReachStationAdjustmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adjustReachStationNamesUsingPOST(reachStationAdjustmentRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createTerraceReach
         * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTerraceReachUsingPOST(terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceReachResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTerraceReachUsingPOST(terraceReachDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteAllTerraceReachWithAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteTerraceReachWithReachJsonId
         * @param {Array<number>} reachJsonId reachJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTerraceReachWithReachJsonIdUsingPOST(reachJsonId: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTerraceReachWithReachJsonIdUsingPOST(reachJsonId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getTerraceReachAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerraceReachAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceReachResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerraceReachAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API handles multiple edits on Terrace Reaches sent by front end and updates database accordingly
         * @param {SaveTerraceReachEditsDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTerraceReachEditsUsingPOST(requestDTO: SaveTerraceReachEditsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveTerraceReachEditsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTerraceReachEditsUsingPOST(requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API updates already created Terrace with DesignControl
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTemplateToReachesUsingPOST(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTerraceDesignControlResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTemplateToReachesUsingPOST(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateTerraceReach
         * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTerraceReachUsingPOST(terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TerraceReachResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTerraceReachUsingPOST(terraceReachDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TerraceReachControllerApi - factory interface
 * @export
 */
export const TerraceReachControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerraceReachControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary After Alignment is edited, provide the new AlignmentDTO, this API will recalculate the new positions of the terrace reach stations
         * @param {ReachStationAdjustmentRequest} reachStationAdjustmentRequest reachStationAdjustmentRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adjustReachStationNamesUsingPOST(reachStationAdjustmentRequest: ReachStationAdjustmentRequest, authorization?: string, options?: any): AxiosPromise<ReachStationAdjustmentResponse> {
            return localVarFp.adjustReachStationNamesUsingPOST(reachStationAdjustmentRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createTerraceReach
         * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTerraceReachUsingPOST(terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options?: any): AxiosPromise<Array<TerraceReachResponseDTO>> {
            return localVarFp.createTerraceReachUsingPOST(terraceReachDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteAllTerraceReachWithAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteTerraceReachWithReachJsonId
         * @param {Array<number>} reachJsonId reachJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTerraceReachWithReachJsonIdUsingPOST(reachJsonId: Array<number>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteTerraceReachWithReachJsonIdUsingPOST(reachJsonId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getTerraceReachAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerraceReachAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<Array<TerraceReachResponseDTO>> {
            return localVarFp.getTerraceReachAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API handles multiple edits on Terrace Reaches sent by front end and updates database accordingly
         * @param {SaveTerraceReachEditsDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTerraceReachEditsUsingPOST(requestDTO: SaveTerraceReachEditsDTO, authorization?: string, options?: any): AxiosPromise<SaveTerraceReachEditsResponseDTO> {
            return localVarFp.saveTerraceReachEditsUsingPOST(requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API updates already created Terrace with DesignControl
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTemplateToReachesUsingPOST(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<UpdateTerraceDesignControlResponseDTO> {
            return localVarFp.syncTemplateToReachesUsingPOST(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateTerraceReach
         * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTerraceReachUsingPOST(terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options?: any): AxiosPromise<Array<TerraceReachResponseDTO>> {
            return localVarFp.updateTerraceReachUsingPOST(terraceReachDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerraceReachControllerApi - object-oriented interface
 * @export
 * @class TerraceReachControllerApi
 * @extends {BaseAPI}
 */
export class TerraceReachControllerApi extends BaseAPI {
    /**
     * 
     * @summary After Alignment is edited, provide the new AlignmentDTO, this API will recalculate the new positions of the terrace reach stations
     * @param {ReachStationAdjustmentRequest} reachStationAdjustmentRequest reachStationAdjustmentRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public adjustReachStationNamesUsingPOST(reachStationAdjustmentRequest: ReachStationAdjustmentRequest, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).adjustReachStationNamesUsingPOST(reachStationAdjustmentRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createTerraceReach
     * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public createTerraceReachUsingPOST(terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).createTerraceReachUsingPOST(terraceReachDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteAllTerraceReachWithAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).deleteAllTerraceReachWithAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteTerraceReachWithReachJsonId
     * @param {Array<number>} reachJsonId reachJsonId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public deleteTerraceReachWithReachJsonIdUsingPOST(reachJsonId: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).deleteTerraceReachWithReachJsonIdUsingPOST(reachJsonId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getTerraceReachAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public getTerraceReachAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).getTerraceReachAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API handles multiple edits on Terrace Reaches sent by front end and updates database accordingly
     * @param {SaveTerraceReachEditsDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public saveTerraceReachEditsUsingPOST(requestDTO: SaveTerraceReachEditsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).saveTerraceReachEditsUsingPOST(requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API updates already created Terrace with DesignControl
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public syncTemplateToReachesUsingPOST(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).syncTemplateToReachesUsingPOST(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateTerraceReach
     * @param {Array<TerraceReachDTO>} terraceReachDTO terraceReachDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerraceReachControllerApi
     */
    public updateTerraceReachUsingPOST(terraceReachDTO: Array<TerraceReachDTO>, authorization?: string, options?: AxiosRequestConfig) {
        return TerraceReachControllerApiFp(this.configuration).updateTerraceReachUsingPOST(terraceReachDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UgoDesignToolsControllerApi - axios parameter creator
 * @export
 */
export const UgoDesignToolsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary calculate InletQ when fixture type is riser inlet given alignedElementDesignParamsId and UgoRiserInletDTOJson
         * @param {UgoFixtureRiserInletQCalculationRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateUgoFixtureRiserInletQUsingPOST: async (request: UgoFixtureRiserInletQCalculationRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('calculateUgoFixtureRiserInletQUsingPOST', 'request', request)
            const localVarPath = `/ugodesign/calculateUgoFixtureRiserInletQ`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API calculates the profiles when a UGO cross sects multiple terraces, provided a UGO\'s aligned Design element params Id
         * @param {number} ugoAlignedElementId ugoAlignedElementId
         * @param {number} sampleInterval sampleInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateUgoTerraceCrossSectionProfileUsingGET: async (ugoAlignedElementId: number, sampleInterval: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ugoAlignedElementId' is not null or undefined
            assertParamExists('calculateUgoTerraceCrossSectionProfileUsingGET', 'ugoAlignedElementId', ugoAlignedElementId)
            // verify required parameter 'sampleInterval' is not null or undefined
            assertParamExists('calculateUgoTerraceCrossSectionProfileUsingGET', 'sampleInterval', sampleInterval)
            const localVarPath = `/ugodesign/calculateUgoTerraceCrossSectionProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ugoAlignedElementId !== undefined) {
                localVarQueryParameter['ugoAlignedElementId'] = ugoAlignedElementId;
            }

            if (sampleInterval !== undefined) {
                localVarQueryParameter['sampleInterval'] = sampleInterval;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given UGO
         * @param {UgoAlignedElementDesignParamsRequestDTO} ugoAlignedElementDesignParamsRequestDTO ugoAlignedElementDesignParamsRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateUgoAlignedElementDesignParamsUsingPOST: async (ugoAlignedElementDesignParamsRequestDTO: UgoAlignedElementDesignParamsRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ugoAlignedElementDesignParamsRequestDTO' is not null or undefined
            assertParamExists('createOrUpdateUgoAlignedElementDesignParamsUsingPOST', 'ugoAlignedElementDesignParamsRequestDTO', ugoAlignedElementDesignParamsRequestDTO)
            const localVarPath = `/ugodesign/createOrUpdateUgoAlignedElementDesignParams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ugoAlignedElementDesignParamsRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create default UGO reaches by AlignedElementDesignParamsId and station vertices
         * @param {UgoDefaultReachRequest} ugoDefaultReachRequest ugoDefaultReachRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST: async (ugoDefaultReachRequest: UgoDefaultReachRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ugoDefaultReachRequest' is not null or undefined
            assertParamExists('createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST', 'ugoDefaultReachRequest', ugoDefaultReachRequest)
            const localVarPath = `/ugodesign/createUgoDefaultReachesByAlignedElementDesignParamsIdAndStations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ugoDefaultReachRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete UGO by alignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUgoByAlignedElementDesignParamsIdUsingPOST: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('deleteUgoByAlignedElementDesignParamsIdUsingPOST', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/ugodesign/deleteUgoByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all terraces that intersect with a specified UGO alignment within the session UUID
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTerracesIntersectingWithUgoAlignmentUsingGET: async (alignmentDesignElementJsonId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentDesignElementJsonId' is not null or undefined
            assertParamExists('getAllTerracesIntersectingWithUgoAlignmentUsingGET', 'alignmentDesignElementJsonId', alignmentDesignElementJsonId)
            const localVarPath = `/ugodesign/getAllTerracesIntersectingWithUgoAlignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (alignmentDesignElementJsonId !== undefined) {
                localVarQueryParameter['alignmentDesignElementJsonId'] = alignmentDesignElementJsonId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get connected UGOs given a UGO alignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedUgosByAlignedElementDesignParamsIdUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getConnectedUgosByAlignedElementDesignParamsIdUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/ugodesign/getConnectedUgosByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOJunctionNameListUsingPOST: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getUGOJunctionNameListUsingPOST', 'sessionUuid', sessionUuid)
            const localVarPath = `/ugodesign/getUGOJunctionNameList/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is retrieve the water resource information, provided the specified terrace/outlet name
         * @param {UgoWaterResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOWaterSourceFromNameUsingPOST: async (request: UgoWaterResourceRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('getUGOWaterSourceFromNameUsingPOST', 'request', request)
            const localVarPath = `/ugodesign/getUGOWaterSourceFromName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is retrieve the list of possible water resource information list, provided the list of alignedElementId list
         * @param {Array<number>} alignedElementIdList alignedElementIdList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOWaterSourceListUsingPOST: async (alignedElementIdList: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementIdList' is not null or undefined
            assertParamExists('getUGOWaterSourceListUsingPOST', 'alignedElementIdList', alignedElementIdList)
            const localVarPath = `/ugodesign/getUGOWaterSourceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignedElementIdList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOWaterSourceNameListUsingPOST: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getUGOWaterSourceNameListUsingPOST', 'sessionUuid', sessionUuid)
            const localVarPath = `/ugodesign/getUGOWaterSourceNameList/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch a UGO\'s alignment coordinates and intersected terrace(s)  
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoAlignedElementShapeByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('getUgoAlignedElementShapeByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/ugodesign/getUgoAlignedElementShapeByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information required to build ugo construction sheet report by passing sessionUuid and a list of alignedElementDesignParamsId
         * @param {string} sessionUuid sessionUuid
         * @param {Array<number>} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoConstructionReportUsingGET: async (sessionUuid: string, alignedElementDesignParamsId: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getUgoConstructionReportUsingGET', 'sessionUuid', sessionUuid)
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getUgoConstructionReportUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/ugodesign/getUgoConstructionReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionUuid !== undefined) {
                localVarQueryParameter['sessionUuid'] = sessionUuid;
            }

            if (alignedElementDesignParamsId) {
                localVarQueryParameter['alignedElementDesignParamsId'] = alignedElementDesignParamsId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch all UGOs\' summaries in a sessionUuid  
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoSummariesBySessionUuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getUgoSummariesBySessionUuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/ugodesign/getUgoSummariesBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is retrieve AlignedElementDesignParameters entity in database for a given UGO, provided UGO\'s aligned design element params Id
         * @param {number} ugoAlignedElementId ugoAlignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET: async (ugoAlignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ugoAlignedElementId' is not null or undefined
            assertParamExists('loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET', 'ugoAlignedElementId', ugoAlignedElementId)
            const localVarPath = `/ugodesign/loadUgoAlignedElementDesignParamsByAlignedElementParamsId/{ugoAlignedElementId}`
                .replace(`{${"ugoAlignedElementId"}}`, encodeURIComponent(String(ugoAlignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to simulate and validate pipeline network
         * @param {PipeNetworkSimulationAndValidationRequestDto} pipeNetworkSimulationAndValidationRequestDto pipeNetworkSimulationAndValidationRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pipeNetworkSimulationAndValidationUsingPOST: async (pipeNetworkSimulationAndValidationRequestDto: PipeNetworkSimulationAndValidationRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipeNetworkSimulationAndValidationRequestDto' is not null or undefined
            assertParamExists('pipeNetworkSimulationAndValidationUsingPOST', 'pipeNetworkSimulationAndValidationRequestDto', pipeNetworkSimulationAndValidationRequestDto)
            const localVarPath = `/ugodesign/pipeNetworkSimulationAndValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pipeNetworkSimulationAndValidationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to trigger simulation and validation process for the pipeline
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pipeSimulationAndValidationUsingPOST: async (sessionUuid: string, alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('pipeSimulationAndValidationUsingPOST', 'sessionUuid', sessionUuid)
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('pipeSimulationAndValidationUsingPOST', 'alignedElementId', alignedElementId)
            const localVarPath = `/ugodesign/pipeSimulationAndValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionUuid !== undefined) {
                localVarQueryParameter['sessionUuid'] = sessionUuid;
            }

            if (alignedElementId !== undefined) {
                localVarQueryParameter['alignedElementId'] = alignedElementId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to save the status for simulation and validation process for the pipeline
         * @param {SavePipeNetworkSimulationRequestDto} savePipeNetworkSimulationRequestDto savePipeNetworkSimulationRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePipeSimulationAndValidationUsingPOST: async (savePipeNetworkSimulationRequestDto: SavePipeNetworkSimulationRequestDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'savePipeNetworkSimulationRequestDto' is not null or undefined
            assertParamExists('savePipeSimulationAndValidationUsingPOST', 'savePipeNetworkSimulationRequestDto', savePipeNetworkSimulationRequestDto)
            const localVarPath = `/ugodesign/savePipeSimulationAndValidation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePipeNetworkSimulationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UgoDesignToolsControllerApi - functional programming interface
 * @export
 */
export const UgoDesignToolsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UgoDesignToolsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary calculate InletQ when fixture type is riser inlet given alignedElementDesignParamsId and UgoRiserInletDTOJson
         * @param {UgoFixtureRiserInletQCalculationRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateUgoFixtureRiserInletQUsingPOST(request: UgoFixtureRiserInletQCalculationRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoFixtureRiserInletQCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateUgoFixtureRiserInletQUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API calculates the profiles when a UGO cross sects multiple terraces, provided a UGO\'s aligned Design element params Id
         * @param {number} ugoAlignedElementId ugoAlignedElementId
         * @param {number} sampleInterval sampleInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateUgoTerraceCrossSectionProfileUsingGET(ugoAlignedElementId: number, sampleInterval: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoTerraceCrossSectionProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateUgoTerraceCrossSectionProfileUsingGET(ugoAlignedElementId, sampleInterval, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given UGO
         * @param {UgoAlignedElementDesignParamsRequestDTO} ugoAlignedElementDesignParamsRequestDTO ugoAlignedElementDesignParamsRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateUgoAlignedElementDesignParamsUsingPOST(ugoAlignedElementDesignParamsRequestDTO: UgoAlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateUgoAlignedElementDesignParamsUsingPOST(ugoAlignedElementDesignParamsRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create default UGO reaches by AlignedElementDesignParamsId and station vertices
         * @param {UgoDefaultReachRequest} ugoDefaultReachRequest ugoDefaultReachRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST(ugoDefaultReachRequest: UgoDefaultReachRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoDefaultReachResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST(ugoDefaultReachRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete UGO by alignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUgoByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteUgoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUgoByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves all terraces that intersect with a specified UGO alignment within the session UUID
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTerracesIntersectingWithUgoAlignmentUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IntersectingTerraceDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTerracesIntersectingWithUgoAlignmentUsingGET(alignmentDesignElementJsonId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get connected UGOs given a UGO alignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectedUgosByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectedUgosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectedUgosByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUGOJunctionNameListUsingPOST(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoJunctionNamelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUGOJunctionNameListUsingPOST(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is retrieve the water resource information, provided the specified terrace/outlet name
         * @param {UgoWaterResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUGOWaterSourceFromNameUsingPOST(request: UgoWaterResourceRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoWaterSourceDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUGOWaterSourceFromNameUsingPOST(request, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is retrieve the list of possible water resource information list, provided the list of alignedElementId list
         * @param {Array<number>} alignedElementIdList alignedElementIdList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUGOWaterSourceListUsingPOST(alignedElementIdList: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoWaterResourceResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUGOWaterSourceListUsingPOST(alignedElementIdList, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUGOWaterSourceNameListUsingPOST(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoWaterResourceNameListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUGOWaterSourceNameListUsingPOST(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary fetch a UGO\'s alignment coordinates and intersected terrace(s)  
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUgoAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoAlignedElementShapeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUgoAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information required to build ugo construction sheet report by passing sessionUuid and a list of alignedElementDesignParamsId
         * @param {string} sessionUuid sessionUuid
         * @param {Array<number>} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUgoConstructionReportUsingGET(sessionUuid: string, alignedElementDesignParamsId: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoConstructionReportResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUgoConstructionReportUsingGET(sessionUuid, alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary fetch all UGOs\' summaries in a sessionUuid  
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUgoSummariesBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoSummariesResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUgoSummariesBySessionUuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is retrieve AlignedElementDesignParameters entity in database for a given UGO, provided UGO\'s aligned design element params Id
         * @param {number} ugoAlignedElementId ugoAlignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(ugoAlignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParameters>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(ugoAlignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to simulate and validate pipeline network
         * @param {PipeNetworkSimulationAndValidationRequestDto} pipeNetworkSimulationAndValidationRequestDto pipeNetworkSimulationAndValidationRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pipeNetworkSimulationAndValidationUsingPOST(pipeNetworkSimulationAndValidationRequestDto: PipeNetworkSimulationAndValidationRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipeNetworkSimulationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pipeNetworkSimulationAndValidationUsingPOST(pipeNetworkSimulationAndValidationRequestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to trigger simulation and validation process for the pipeline
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pipeSimulationAndValidationUsingPOST(sessionUuid: string, alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipeNetworkSimulationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pipeSimulationAndValidationUsingPOST(sessionUuid, alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to save the status for simulation and validation process for the pipeline
         * @param {SavePipeNetworkSimulationRequestDto} savePipeNetworkSimulationRequestDto savePipeNetworkSimulationRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePipeSimulationAndValidationUsingPOST(savePipeNetworkSimulationRequestDto: SavePipeNetworkSimulationRequestDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePipeSimulationAndValidationUsingPOST(savePipeNetworkSimulationRequestDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UgoDesignToolsControllerApi - factory interface
 * @export
 */
export const UgoDesignToolsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UgoDesignToolsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary calculate InletQ when fixture type is riser inlet given alignedElementDesignParamsId and UgoRiserInletDTOJson
         * @param {UgoFixtureRiserInletQCalculationRequest} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateUgoFixtureRiserInletQUsingPOST(request: UgoFixtureRiserInletQCalculationRequest, authorization?: string, options?: any): AxiosPromise<UgoFixtureRiserInletQCalculationResponse> {
            return localVarFp.calculateUgoFixtureRiserInletQUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API calculates the profiles when a UGO cross sects multiple terraces, provided a UGO\'s aligned Design element params Id
         * @param {number} ugoAlignedElementId ugoAlignedElementId
         * @param {number} sampleInterval sampleInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateUgoTerraceCrossSectionProfileUsingGET(ugoAlignedElementId: number, sampleInterval: number, authorization?: string, options?: any): AxiosPromise<UgoTerraceCrossSectionProfileResponse> {
            return localVarFp.calculateUgoTerraceCrossSectionProfileUsingGET(ugoAlignedElementId, sampleInterval, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given UGO
         * @param {UgoAlignedElementDesignParamsRequestDTO} ugoAlignedElementDesignParamsRequestDTO ugoAlignedElementDesignParamsRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateUgoAlignedElementDesignParamsUsingPOST(ugoAlignedElementDesignParamsRequestDTO: UgoAlignedElementDesignParamsRequestDTO, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.createOrUpdateUgoAlignedElementDesignParamsUsingPOST(ugoAlignedElementDesignParamsRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create default UGO reaches by AlignedElementDesignParamsId and station vertices
         * @param {UgoDefaultReachRequest} ugoDefaultReachRequest ugoDefaultReachRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST(ugoDefaultReachRequest: UgoDefaultReachRequest, authorization?: string, options?: any): AxiosPromise<UgoDefaultReachResponse> {
            return localVarFp.createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST(ugoDefaultReachRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete UGO by alignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUgoByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<DeleteUgoResponse> {
            return localVarFp.deleteUgoByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all terraces that intersect with a specified UGO alignment within the session UUID
         * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTerracesIntersectingWithUgoAlignmentUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: any): AxiosPromise<Array<IntersectingTerraceDTO>> {
            return localVarFp.getAllTerracesIntersectingWithUgoAlignmentUsingGET(alignmentDesignElementJsonId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get connected UGOs given a UGO alignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectedUgosByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<ConnectedUgosResponse> {
            return localVarFp.getConnectedUgosByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOJunctionNameListUsingPOST(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<UgoJunctionNamelListResponseDTO> {
            return localVarFp.getUGOJunctionNameListUsingPOST(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is retrieve the water resource information, provided the specified terrace/outlet name
         * @param {UgoWaterResourceRequestDTO} request request
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOWaterSourceFromNameUsingPOST(request: UgoWaterResourceRequestDTO, authorization?: string, options?: any): AxiosPromise<UgoWaterSourceDTO> {
            return localVarFp.getUGOWaterSourceFromNameUsingPOST(request, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is retrieve the list of possible water resource information list, provided the list of alignedElementId list
         * @param {Array<number>} alignedElementIdList alignedElementIdList
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOWaterSourceListUsingPOST(alignedElementIdList: Array<number>, authorization?: string, options?: any): AxiosPromise<UgoWaterResourceResponseDTO> {
            return localVarFp.getUGOWaterSourceListUsingPOST(alignedElementIdList, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUGOWaterSourceNameListUsingPOST(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<UgoWaterResourceNameListResponseDTO> {
            return localVarFp.getUGOWaterSourceNameListUsingPOST(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch a UGO\'s alignment coordinates and intersected terrace(s)  
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<UgoAlignedElementShapeResponseDTO> {
            return localVarFp.getUgoAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information required to build ugo construction sheet report by passing sessionUuid and a list of alignedElementDesignParamsId
         * @param {string} sessionUuid sessionUuid
         * @param {Array<number>} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoConstructionReportUsingGET(sessionUuid: string, alignedElementDesignParamsId: Array<number>, authorization?: string, options?: any): AxiosPromise<UgoConstructionReportResponseDTO> {
            return localVarFp.getUgoConstructionReportUsingGET(sessionUuid, alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch all UGOs\' summaries in a sessionUuid  
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoSummariesBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<UgoSummariesResponseDTO> {
            return localVarFp.getUgoSummariesBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is retrieve AlignedElementDesignParameters entity in database for a given UGO, provided UGO\'s aligned design element params Id
         * @param {number} ugoAlignedElementId ugoAlignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(ugoAlignedElementId: number, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParameters> {
            return localVarFp.loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(ugoAlignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to simulate and validate pipeline network
         * @param {PipeNetworkSimulationAndValidationRequestDto} pipeNetworkSimulationAndValidationRequestDto pipeNetworkSimulationAndValidationRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pipeNetworkSimulationAndValidationUsingPOST(pipeNetworkSimulationAndValidationRequestDto: PipeNetworkSimulationAndValidationRequestDto, authorization?: string, options?: any): AxiosPromise<PipeNetworkSimulationResponseDto> {
            return localVarFp.pipeNetworkSimulationAndValidationUsingPOST(pipeNetworkSimulationAndValidationRequestDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to trigger simulation and validation process for the pipeline
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pipeSimulationAndValidationUsingPOST(sessionUuid: string, alignedElementId: number, authorization?: string, options?: any): AxiosPromise<PipeNetworkSimulationResponseDto> {
            return localVarFp.pipeSimulationAndValidationUsingPOST(sessionUuid, alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to save the status for simulation and validation process for the pipeline
         * @param {SavePipeNetworkSimulationRequestDto} savePipeNetworkSimulationRequestDto savePipeNetworkSimulationRequestDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePipeSimulationAndValidationUsingPOST(savePipeNetworkSimulationRequestDto: SavePipeNetworkSimulationRequestDto, authorization?: string, options?: any): AxiosPromise<ErrorResponse> {
            return localVarFp.savePipeSimulationAndValidationUsingPOST(savePipeNetworkSimulationRequestDto, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UgoDesignToolsControllerApi - object-oriented interface
 * @export
 * @class UgoDesignToolsControllerApi
 * @extends {BaseAPI}
 */
export class UgoDesignToolsControllerApi extends BaseAPI {
    /**
     * 
     * @summary calculate InletQ when fixture type is riser inlet given alignedElementDesignParamsId and UgoRiserInletDTOJson
     * @param {UgoFixtureRiserInletQCalculationRequest} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public calculateUgoFixtureRiserInletQUsingPOST(request: UgoFixtureRiserInletQCalculationRequest, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).calculateUgoFixtureRiserInletQUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API calculates the profiles when a UGO cross sects multiple terraces, provided a UGO\'s aligned Design element params Id
     * @param {number} ugoAlignedElementId ugoAlignedElementId
     * @param {number} sampleInterval sampleInterval
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public calculateUgoTerraceCrossSectionProfileUsingGET(ugoAlignedElementId: number, sampleInterval: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).calculateUgoTerraceCrossSectionProfileUsingGET(ugoAlignedElementId, sampleInterval, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to either create or update AlignedElementDesignParameters entry in database for a given UGO
     * @param {UgoAlignedElementDesignParamsRequestDTO} ugoAlignedElementDesignParamsRequestDTO ugoAlignedElementDesignParamsRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public createOrUpdateUgoAlignedElementDesignParamsUsingPOST(ugoAlignedElementDesignParamsRequestDTO: UgoAlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).createOrUpdateUgoAlignedElementDesignParamsUsingPOST(ugoAlignedElementDesignParamsRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create default UGO reaches by AlignedElementDesignParamsId and station vertices
     * @param {UgoDefaultReachRequest} ugoDefaultReachRequest ugoDefaultReachRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST(ugoDefaultReachRequest: UgoDefaultReachRequest, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).createUgoDefaultReachesByAlignedElementDesignParamsIdAndStationsUsingPOST(ugoDefaultReachRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete UGO by alignedElementDesignParamsId
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public deleteUgoByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).deleteUgoByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all terraces that intersect with a specified UGO alignment within the session UUID
     * @param {number} alignmentDesignElementJsonId alignmentDesignElementJsonId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getAllTerracesIntersectingWithUgoAlignmentUsingGET(alignmentDesignElementJsonId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getAllTerracesIntersectingWithUgoAlignmentUsingGET(alignmentDesignElementJsonId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get connected UGOs given a UGO alignedElementDesignParamsId
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getConnectedUgosByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getConnectedUgosByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getUGOJunctionNameListUsingPOST(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getUGOJunctionNameListUsingPOST(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is retrieve the water resource information, provided the specified terrace/outlet name
     * @param {UgoWaterResourceRequestDTO} request request
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getUGOWaterSourceFromNameUsingPOST(request: UgoWaterResourceRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getUGOWaterSourceFromNameUsingPOST(request, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is retrieve the list of possible water resource information list, provided the list of alignedElementId list
     * @param {Array<number>} alignedElementIdList alignedElementIdList
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getUGOWaterSourceListUsingPOST(alignedElementIdList: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getUGOWaterSourceListUsingPOST(alignedElementIdList, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary \"This API is retrieve all possible water resources name list, provided the whole project sessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getUGOWaterSourceNameListUsingPOST(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getUGOWaterSourceNameListUsingPOST(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch a UGO\'s alignment coordinates and intersected terrace(s)  
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getUgoAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getUgoAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information required to build ugo construction sheet report by passing sessionUuid and a list of alignedElementDesignParamsId
     * @param {string} sessionUuid sessionUuid
     * @param {Array<number>} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getUgoConstructionReportUsingGET(sessionUuid: string, alignedElementDesignParamsId: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getUgoConstructionReportUsingGET(sessionUuid, alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch all UGOs\' summaries in a sessionUuid  
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public getUgoSummariesBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).getUgoSummariesBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is retrieve AlignedElementDesignParameters entity in database for a given UGO, provided UGO\'s aligned design element params Id
     * @param {number} ugoAlignedElementId ugoAlignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(ugoAlignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).loadUgoAlignedElementDesignParamsByAlignedElementParamsIdUsingGET(ugoAlignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to simulate and validate pipeline network
     * @param {PipeNetworkSimulationAndValidationRequestDto} pipeNetworkSimulationAndValidationRequestDto pipeNetworkSimulationAndValidationRequestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public pipeNetworkSimulationAndValidationUsingPOST(pipeNetworkSimulationAndValidationRequestDto: PipeNetworkSimulationAndValidationRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).pipeNetworkSimulationAndValidationUsingPOST(pipeNetworkSimulationAndValidationRequestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to trigger simulation and validation process for the pipeline
     * @param {string} sessionUuid sessionUuid
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public pipeSimulationAndValidationUsingPOST(sessionUuid: string, alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).pipeSimulationAndValidationUsingPOST(sessionUuid, alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to save the status for simulation and validation process for the pipeline
     * @param {SavePipeNetworkSimulationRequestDto} savePipeNetworkSimulationRequestDto savePipeNetworkSimulationRequestDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoDesignToolsControllerApi
     */
    public savePipeSimulationAndValidationUsingPOST(savePipeNetworkSimulationRequestDto: SavePipeNetworkSimulationRequestDto, authorization?: string, options?: AxiosRequestConfig) {
        return UgoDesignToolsControllerApiFp(this.configuration).savePipeSimulationAndValidationUsingPOST(savePipeNetworkSimulationRequestDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UgoFixtureTypeControllerApi - axios parameter creator
 * @export
 */
export const UgoFixtureTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API is used to create a new UGO fixture type record. This operation is allowed only for system admins.
         * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUgoFixtureTypeUsingPOST: async (requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('createUgoFixtureTypeUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/ugoFixtureTypes/createUgoFixtureType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to soft delete a UGO fixture type record. Allowed only for system admins.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE: async (fixtureTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureTypeId' is not null or undefined
            assertParamExists('deleteUsingDELETE', 'fixtureTypeId', fixtureTypeId)
            const localVarPath = `/ugoFixtureTypes/deleteUgoFixtureType/{fixtureTypeId}`
                .replace(`{${"fixtureTypeId"}}`, encodeURIComponent(String(fixtureTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get all UGO fixture types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUgoFixtureTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ugoFixtureTypes/getAllUgoFixtureTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get UGO fixture type record by Id.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoFixtureTypeByIdUsingGET: async (fixtureTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureTypeId' is not null or undefined
            assertParamExists('getUgoFixtureTypeByIdUsingGET', 'fixtureTypeId', fixtureTypeId)
            const localVarPath = `/ugoFixtureTypes/getUgoFixtureTypeById/{fixtureTypeId}`
                .replace(`{${"fixtureTypeId"}}`, encodeURIComponent(String(fixtureTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to update an existing UGO fixture type record. This operation is allowed only for system admins.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUgoFixtureTypeUsingPOST: async (fixtureTypeId: number, requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fixtureTypeId' is not null or undefined
            assertParamExists('updateUgoFixtureTypeUsingPOST', 'fixtureTypeId', fixtureTypeId)
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('updateUgoFixtureTypeUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/ugoFixtureTypes/updateUgoFixtureType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fixtureTypeId !== undefined) {
                localVarQueryParameter['fixtureTypeId'] = fixtureTypeId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UgoFixtureTypeControllerApi - functional programming interface
 * @export
 */
export const UgoFixtureTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UgoFixtureTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API is used to create a new UGO fixture type record. This operation is allowed only for system admins.
         * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUgoFixtureTypeUsingPOST(requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoFixtureTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUgoFixtureTypeUsingPOST(requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to soft delete a UGO fixture type record. Allowed only for system admins.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsingDELETE(fixtureTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsingDELETE(fixtureTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get all UGO fixture types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUgoFixtureTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UgoFixtureTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUgoFixtureTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get UGO fixture type record by Id.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUgoFixtureTypeByIdUsingGET(fixtureTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoFixtureTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUgoFixtureTypeByIdUsingGET(fixtureTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to update an existing UGO fixture type record. This operation is allowed only for system admins.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUgoFixtureTypeUsingPOST(fixtureTypeId: number, requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoFixtureTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUgoFixtureTypeUsingPOST(fixtureTypeId, requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UgoFixtureTypeControllerApi - factory interface
 * @export
 */
export const UgoFixtureTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UgoFixtureTypeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API is used to create a new UGO fixture type record. This operation is allowed only for system admins.
         * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUgoFixtureTypeUsingPOST(requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options?: any): AxiosPromise<UgoFixtureTypeResponseDTO> {
            return localVarFp.createUgoFixtureTypeUsingPOST(requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to soft delete a UGO fixture type record. Allowed only for system admins.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE(fixtureTypeId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteUsingDELETE(fixtureTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get all UGO fixture types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUgoFixtureTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<UgoFixtureTypeResponseDTO>> {
            return localVarFp.getAllUgoFixtureTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get UGO fixture type record by Id.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoFixtureTypeByIdUsingGET(fixtureTypeId: number, authorization?: string, options?: any): AxiosPromise<UgoFixtureTypeResponseDTO> {
            return localVarFp.getUgoFixtureTypeByIdUsingGET(fixtureTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to update an existing UGO fixture type record. This operation is allowed only for system admins.
         * @param {number} fixtureTypeId fixtureTypeId
         * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUgoFixtureTypeUsingPOST(fixtureTypeId: number, requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options?: any): AxiosPromise<UgoFixtureTypeResponseDTO> {
            return localVarFp.updateUgoFixtureTypeUsingPOST(fixtureTypeId, requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UgoFixtureTypeControllerApi - object-oriented interface
 * @export
 * @class UgoFixtureTypeControllerApi
 * @extends {BaseAPI}
 */
export class UgoFixtureTypeControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API is used to create a new UGO fixture type record. This operation is allowed only for system admins.
     * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoFixtureTypeControllerApi
     */
    public createUgoFixtureTypeUsingPOST(requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoFixtureTypeControllerApiFp(this.configuration).createUgoFixtureTypeUsingPOST(requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to soft delete a UGO fixture type record. Allowed only for system admins.
     * @param {number} fixtureTypeId fixtureTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoFixtureTypeControllerApi
     */
    public deleteUsingDELETE(fixtureTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoFixtureTypeControllerApiFp(this.configuration).deleteUsingDELETE(fixtureTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get all UGO fixture types.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoFixtureTypeControllerApi
     */
    public getAllUgoFixtureTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return UgoFixtureTypeControllerApiFp(this.configuration).getAllUgoFixtureTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get UGO fixture type record by Id.
     * @param {number} fixtureTypeId fixtureTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoFixtureTypeControllerApi
     */
    public getUgoFixtureTypeByIdUsingGET(fixtureTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoFixtureTypeControllerApiFp(this.configuration).getUgoFixtureTypeByIdUsingGET(fixtureTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to update an existing UGO fixture type record. This operation is allowed only for system admins.
     * @param {number} fixtureTypeId fixtureTypeId
     * @param {UgoFixtureTypeRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoFixtureTypeControllerApi
     */
    public updateUgoFixtureTypeUsingPOST(fixtureTypeId: number, requestDTO: UgoFixtureTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoFixtureTypeControllerApiFp(this.configuration).updateUgoFixtureTypeUsingPOST(fixtureTypeId, requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UgoManufacturedRiserTypeControllerApi - axios parameter creator
 * @export
 */
export const UgoManufacturedRiserTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new manufactured riser type.
         * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManufacturedRiserTypeUsingPOST: async (requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('createManufacturedRiserTypeUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/ugoManufacturedRiserTypes/createManufacturedRiserType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft delete a manufactured riser type (Admin only).
         * @param {number} typeId typeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManufacturedRiserTypeByTypeIdUsingDELETE: async (typeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('deleteManufacturedRiserTypeByTypeIdUsingDELETE', 'typeId', typeId)
            const localVarPath = `/ugoManufacturedRiserTypes/deleteManufacturedRiserTypeByTypeId/{typeId}`
                .replace(`{${"typeId"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all manufactured riser types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManufacturedRiserTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ugoManufacturedRiserTypes/getAllManufacturedRiserTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get manufactured riser type by ID.
         * @param {number} typeId typeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByRiserTypeIdUsingGET: async (typeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('getByRiserTypeIdUsingGET', 'typeId', typeId)
            const localVarPath = `/ugoManufacturedRiserTypes/getByRiserTypeId/{typeId}`
                .replace(`{${"typeId"}}`, encodeURIComponent(String(typeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a manufactured riser type.
         * @param {number} typeId typeId
         * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManufacturedRiserTypeUsingPOST: async (typeId: number, requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'typeId' is not null or undefined
            assertParamExists('updateManufacturedRiserTypeUsingPOST', 'typeId', typeId)
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('updateManufacturedRiserTypeUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/ugoManufacturedRiserTypes/updateManufacturedRiserType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typeId !== undefined) {
                localVarQueryParameter['typeId'] = typeId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UgoManufacturedRiserTypeControllerApi - functional programming interface
 * @export
 */
export const UgoManufacturedRiserTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UgoManufacturedRiserTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new manufactured riser type.
         * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManufacturedRiserTypeUsingPOST(requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManufacturedRiserTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManufacturedRiserTypeUsingPOST(requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft delete a manufactured riser type (Admin only).
         * @param {number} typeId typeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteManufacturedRiserTypeByTypeIdUsingDELETE(typeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteManufacturedRiserTypeByTypeIdUsingDELETE(typeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all manufactured riser types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllManufacturedRiserTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ManufacturedRiserTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllManufacturedRiserTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get manufactured riser type by ID.
         * @param {number} typeId typeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByRiserTypeIdUsingGET(typeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManufacturedRiserTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByRiserTypeIdUsingGET(typeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a manufactured riser type.
         * @param {number} typeId typeId
         * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateManufacturedRiserTypeUsingPOST(typeId: number, requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManufacturedRiserTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateManufacturedRiserTypeUsingPOST(typeId, requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UgoManufacturedRiserTypeControllerApi - factory interface
 * @export
 */
export const UgoManufacturedRiserTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UgoManufacturedRiserTypeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new manufactured riser type.
         * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManufacturedRiserTypeUsingPOST(requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options?: any): AxiosPromise<ManufacturedRiserTypeResponseDTO> {
            return localVarFp.createManufacturedRiserTypeUsingPOST(requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft delete a manufactured riser type (Admin only).
         * @param {number} typeId typeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManufacturedRiserTypeByTypeIdUsingDELETE(typeId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteManufacturedRiserTypeByTypeIdUsingDELETE(typeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all manufactured riser types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManufacturedRiserTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<ManufacturedRiserTypeResponseDTO>> {
            return localVarFp.getAllManufacturedRiserTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get manufactured riser type by ID.
         * @param {number} typeId typeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByRiserTypeIdUsingGET(typeId: number, authorization?: string, options?: any): AxiosPromise<ManufacturedRiserTypeResponseDTO> {
            return localVarFp.getByRiserTypeIdUsingGET(typeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a manufactured riser type.
         * @param {number} typeId typeId
         * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManufacturedRiserTypeUsingPOST(typeId: number, requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options?: any): AxiosPromise<ManufacturedRiserTypeResponseDTO> {
            return localVarFp.updateManufacturedRiserTypeUsingPOST(typeId, requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UgoManufacturedRiserTypeControllerApi - object-oriented interface
 * @export
 * @class UgoManufacturedRiserTypeControllerApi
 * @extends {BaseAPI}
 */
export class UgoManufacturedRiserTypeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create a new manufactured riser type.
     * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoManufacturedRiserTypeControllerApi
     */
    public createManufacturedRiserTypeUsingPOST(requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoManufacturedRiserTypeControllerApiFp(this.configuration).createManufacturedRiserTypeUsingPOST(requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft delete a manufactured riser type (Admin only).
     * @param {number} typeId typeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoManufacturedRiserTypeControllerApi
     */
    public deleteManufacturedRiserTypeByTypeIdUsingDELETE(typeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoManufacturedRiserTypeControllerApiFp(this.configuration).deleteManufacturedRiserTypeByTypeIdUsingDELETE(typeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all manufactured riser types.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoManufacturedRiserTypeControllerApi
     */
    public getAllManufacturedRiserTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return UgoManufacturedRiserTypeControllerApiFp(this.configuration).getAllManufacturedRiserTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get manufactured riser type by ID.
     * @param {number} typeId typeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoManufacturedRiserTypeControllerApi
     */
    public getByRiserTypeIdUsingGET(typeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoManufacturedRiserTypeControllerApiFp(this.configuration).getByRiserTypeIdUsingGET(typeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a manufactured riser type.
     * @param {number} typeId typeId
     * @param {ManufacturedRiserTypeRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoManufacturedRiserTypeControllerApi
     */
    public updateManufacturedRiserTypeUsingPOST(typeId: number, requestDTO: ManufacturedRiserTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoManufacturedRiserTypeControllerApiFp(this.configuration).updateManufacturedRiserTypeUsingPOST(typeId, requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UgoPipelineMaterialTypeControllerApi - axios parameter creator
 * @export
 */
export const UgoPipelineMaterialTypeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API is used to create a new UGO pipeline material type record. This operation is allowed only for system admin.
         * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUgoPipelineMaterialTypeUsingPOST: async (requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('createUgoPipelineMaterialTypeUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/ugoMaterialTypes/createUgoPipelineMaterialType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to soft delete a UGO pipeline material type record. Allowed only for system admins.
         * @param {number} materialTypeId materialTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE1: async (materialTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialTypeId' is not null or undefined
            assertParamExists('deleteUsingDELETE1', 'materialTypeId', materialTypeId)
            const localVarPath = `/ugoMaterialTypes/deleteUgoPipelineMaterialType/{materialTypeId}`
                .replace(`{${"materialTypeId"}}`, encodeURIComponent(String(materialTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get all UGO pipeline material types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUgoPipelineMaterialTypesUsingGET: async (authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ugoMaterialTypes/getAllUgoPipelineMaterialTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get UGO pipeline material type record by Id.
         * @param {number} materialTypeByTypeId materialTypeByTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoPipelineMaterialTypeByTypeIdUsingGET: async (materialTypeByTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialTypeByTypeId' is not null or undefined
            assertParamExists('getUgoPipelineMaterialTypeByTypeIdUsingGET', 'materialTypeByTypeId', materialTypeByTypeId)
            const localVarPath = `/ugoMaterialTypes/getUgoPipelineMaterialTypeByTypeId/{materialTypeByTypeId}`
                .replace(`{${"materialTypeByTypeId"}}`, encodeURIComponent(String(materialTypeByTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to update the existing UGO pipeline material type record. This operation is allowed only for system admin.
         * @param {number} materialTypeId materialTypeId
         * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUgoPipelineMaterialTypeUsingPOST: async (materialTypeId: number, requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialTypeId' is not null or undefined
            assertParamExists('updateUgoPipelineMaterialTypeUsingPOST', 'materialTypeId', materialTypeId)
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('updateUgoPipelineMaterialTypeUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/ugoMaterialTypes/updateUgoPipelineMaterialType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (materialTypeId !== undefined) {
                localVarQueryParameter['materialTypeId'] = materialTypeId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UgoPipelineMaterialTypeControllerApi - functional programming interface
 * @export
 */
export const UgoPipelineMaterialTypeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UgoPipelineMaterialTypeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API is used to create a new UGO pipeline material type record. This operation is allowed only for system admin.
         * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUgoPipelineMaterialTypeUsingPOST(requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoPipelineMaterialTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUgoPipelineMaterialTypeUsingPOST(requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to soft delete a UGO pipeline material type record. Allowed only for system admins.
         * @param {number} materialTypeId materialTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsingDELETE1(materialTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsingDELETE1(materialTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get all UGO pipeline material types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUgoPipelineMaterialTypesUsingGET(authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UgoPipelineMaterialTypeResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUgoPipelineMaterialTypesUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get UGO pipeline material type record by Id.
         * @param {number} materialTypeByTypeId materialTypeByTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUgoPipelineMaterialTypeByTypeIdUsingGET(materialTypeByTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoPipelineMaterialTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUgoPipelineMaterialTypeByTypeIdUsingGET(materialTypeByTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to update the existing UGO pipeline material type record. This operation is allowed only for system admin.
         * @param {number} materialTypeId materialTypeId
         * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUgoPipelineMaterialTypeUsingPOST(materialTypeId: number, requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UgoPipelineMaterialTypeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUgoPipelineMaterialTypeUsingPOST(materialTypeId, requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UgoPipelineMaterialTypeControllerApi - factory interface
 * @export
 */
export const UgoPipelineMaterialTypeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UgoPipelineMaterialTypeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API is used to create a new UGO pipeline material type record. This operation is allowed only for system admin.
         * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUgoPipelineMaterialTypeUsingPOST(requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options?: any): AxiosPromise<UgoPipelineMaterialTypeResponseDTO> {
            return localVarFp.createUgoPipelineMaterialTypeUsingPOST(requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to soft delete a UGO pipeline material type record. Allowed only for system admins.
         * @param {number} materialTypeId materialTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsingDELETE1(materialTypeId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteUsingDELETE1(materialTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get all UGO pipeline material types.
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUgoPipelineMaterialTypesUsingGET(authorization?: string, options?: any): AxiosPromise<Array<UgoPipelineMaterialTypeResponseDTO>> {
            return localVarFp.getAllUgoPipelineMaterialTypesUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get UGO pipeline material type record by Id.
         * @param {number} materialTypeByTypeId materialTypeByTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoPipelineMaterialTypeByTypeIdUsingGET(materialTypeByTypeId: number, authorization?: string, options?: any): AxiosPromise<UgoPipelineMaterialTypeResponseDTO> {
            return localVarFp.getUgoPipelineMaterialTypeByTypeIdUsingGET(materialTypeByTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to update the existing UGO pipeline material type record. This operation is allowed only for system admin.
         * @param {number} materialTypeId materialTypeId
         * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUgoPipelineMaterialTypeUsingPOST(materialTypeId: number, requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options?: any): AxiosPromise<UgoPipelineMaterialTypeResponseDTO> {
            return localVarFp.updateUgoPipelineMaterialTypeUsingPOST(materialTypeId, requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UgoPipelineMaterialTypeControllerApi - object-oriented interface
 * @export
 * @class UgoPipelineMaterialTypeControllerApi
 * @extends {BaseAPI}
 */
export class UgoPipelineMaterialTypeControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API is used to create a new UGO pipeline material type record. This operation is allowed only for system admin.
     * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoPipelineMaterialTypeControllerApi
     */
    public createUgoPipelineMaterialTypeUsingPOST(requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoPipelineMaterialTypeControllerApiFp(this.configuration).createUgoPipelineMaterialTypeUsingPOST(requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to soft delete a UGO pipeline material type record. Allowed only for system admins.
     * @param {number} materialTypeId materialTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoPipelineMaterialTypeControllerApi
     */
    public deleteUsingDELETE1(materialTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoPipelineMaterialTypeControllerApiFp(this.configuration).deleteUsingDELETE1(materialTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get all UGO pipeline material types.
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoPipelineMaterialTypeControllerApi
     */
    public getAllUgoPipelineMaterialTypesUsingGET(authorization?: string, options?: AxiosRequestConfig) {
        return UgoPipelineMaterialTypeControllerApiFp(this.configuration).getAllUgoPipelineMaterialTypesUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get UGO pipeline material type record by Id.
     * @param {number} materialTypeByTypeId materialTypeByTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoPipelineMaterialTypeControllerApi
     */
    public getUgoPipelineMaterialTypeByTypeIdUsingGET(materialTypeByTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoPipelineMaterialTypeControllerApiFp(this.configuration).getUgoPipelineMaterialTypeByTypeIdUsingGET(materialTypeByTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to update the existing UGO pipeline material type record. This operation is allowed only for system admin.
     * @param {number} materialTypeId materialTypeId
     * @param {UgoPipelineMaterialTypeRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoPipelineMaterialTypeControllerApi
     */
    public updateUgoPipelineMaterialTypeUsingPOST(materialTypeId: number, requestDTO: UgoPipelineMaterialTypeRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoPipelineMaterialTypeControllerApiFp(this.configuration).updateUgoPipelineMaterialTypeUsingPOST(materialTypeId, requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UgoReachControllerApi - axios parameter creator
 * @export
 */
export const UgoReachControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This endpoint is used to get Ugo Vertex Params Dto List by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoVertexParamsDTOsByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('getUgoVertexParamsDTOsByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/ugodesign/getUgoVertexParamsDTOsByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API handles multiple edits on UGO Reaches sent by front end and updates database accordingly
         * @param {SaveUgoReachEditsRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUgoReachEditsUsingPOST: async (requestDTO: SaveUgoReachEditsRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('saveUgoReachEditsUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/ugodesign/saveUgoReachEdits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UgoReachControllerApi - functional programming interface
 * @export
 */
export const UgoReachControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UgoReachControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This endpoint is used to get Ugo Vertex Params Dto List by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUgoVertexParamsDTOsByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UgoVertexParamsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUgoVertexParamsDTOsByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API handles multiple edits on UGO Reaches sent by front end and updates database accordingly
         * @param {SaveUgoReachEditsRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUgoReachEditsUsingPOST(requestDTO: SaveUgoReachEditsRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveUgoReachEditsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUgoReachEditsUsingPOST(requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UgoReachControllerApi - factory interface
 * @export
 */
export const UgoReachControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UgoReachControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This endpoint is used to get Ugo Vertex Params Dto List by alignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUgoVertexParamsDTOsByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<Array<UgoVertexParamsDTO>> {
            return localVarFp.getUgoVertexParamsDTOsByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API handles multiple edits on UGO Reaches sent by front end and updates database accordingly
         * @param {SaveUgoReachEditsRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUgoReachEditsUsingPOST(requestDTO: SaveUgoReachEditsRequestDTO, authorization?: string, options?: any): AxiosPromise<SaveUgoReachEditsResponseDTO> {
            return localVarFp.saveUgoReachEditsUsingPOST(requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UgoReachControllerApi - object-oriented interface
 * @export
 * @class UgoReachControllerApi
 * @extends {BaseAPI}
 */
export class UgoReachControllerApi extends BaseAPI {
    /**
     * 
     * @summary This endpoint is used to get Ugo Vertex Params Dto List by alignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoReachControllerApi
     */
    public getUgoVertexParamsDTOsByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return UgoReachControllerApiFp(this.configuration).getUgoVertexParamsDTOsByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API handles multiple edits on UGO Reaches sent by front end and updates database accordingly
     * @param {SaveUgoReachEditsRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UgoReachControllerApi
     */
    public saveUgoReachEditsUsingPOST(requestDTO: SaveUgoReachEditsRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return UgoReachControllerApiFp(this.configuration).saveUgoReachEditsUsingPOST(requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WaterwayDesignToolsAiControllerApi - axios parameter creator
 * @export
 */
export const WaterwayDesignToolsAiControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary this api is used for ai training to run simulation and validation
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionWrapperUsingPOST: async (actionRequest: WaterwayActionRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionRequest' is not null or undefined
            assertParamExists('actionWrapperUsingPOST', 'actionRequest', actionRequest)
            const localVarPath = `/aiwdt/waterwayActionWrapper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary this can automatically generate a default waterway
         * @param {AutoDefaultReachesRequest} autoDefaultReachesRequest autoDefaultReachesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutoDefaultReachesUsingPOST: async (autoDefaultReachesRequest: AutoDefaultReachesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'autoDefaultReachesRequest' is not null or undefined
            assertParamExists('createAutoDefaultReachesUsingPOST', 'autoDefaultReachesRequest', autoDefaultReachesRequest)
            const localVarPath = `/aiwdt/createAutoDefaultReaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(autoDefaultReachesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary this is to capture human feedback examples
         * @param {WaterwayHumanFeedbackRequestDto} waterwayHumanFeedbackRequestDto waterwayHumanFeedbackRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHumanFeedbackExampleUsingPOST: async (waterwayHumanFeedbackRequestDto: WaterwayHumanFeedbackRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwayHumanFeedbackRequestDto' is not null or undefined
            assertParamExists('createHumanFeedbackExampleUsingPOST', 'waterwayHumanFeedbackRequestDto', waterwayHumanFeedbackRequestDto)
            const localVarPath = `/aiwdt/createHumanFeedbackExample`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterwayHumanFeedbackRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently deletes a human feedback example
         * @param {number} episodeId episodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEpisodeUsingDELETE: async (episodeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'episodeId' is not null or undefined
            assertParamExists('deleteEpisodeUsingDELETE', 'episodeId', episodeId)
            const localVarPath = `/aiwdt/hardDeleteHumanFeedbackExampleByEpisodeId/{episodeId}`
                .replace(`{${"episodeId"}}`, encodeURIComponent(String(episodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API suggests 3 specific and actionable technical changes.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET: async (alignedElementDesignParamsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/aiwdt/generateAlternativeQuestionsByAlignedElementDesignParmasId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateEpisodeJson
         * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateEpisodeJsonUsingPOST: async (generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateEpisodeJsonRequestDto' is not null or undefined
            assertParamExists('generateEpisodeJsonUsingPOST', 'generateEpisodeJsonRequestDto', generateEpisodeJsonRequestDto)
            const localVarPath = `/aiwdt/generateGnnEpisodeJson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateEpisodeJsonRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateHumanFeedbackJson
         * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateHumanFeedbackJsonUsingPOST: async (generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateEpisodeJsonRequestDto' is not null or undefined
            assertParamExists('generateHumanFeedbackJsonUsingPOST', 'generateEpisodeJsonRequestDto', generateEpisodeJsonRequestDto)
            const localVarPath = `/aiwdt/generateGatEpisodeJson`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateEpisodeJsonRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateSetPayloadWithOpenAI
         * @param {object} requestBody requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSetPayloadWithOpenAIUsingPOST: async (requestBody: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('generateSetPayloadWithOpenAIUsingPOST', 'requestBody', requestBody)
            const localVarPath = `/aiwdt/generateSetPayload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API retrieves alignment information necessary to validate waterway reaches by accepting the alignedDesignParametersId as input, and supports both Lined and Grassed Waterways.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET: async (alignedElementDesignParamsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/aiwdt/getAlignmentTotalLengthbyAlignedElementDesignParmasId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a human feedback example as deleted without removing it from the database
         * @param {number} episodeId episodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteEpisodeUsingDELETE: async (episodeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'episodeId' is not null or undefined
            assertParamExists('softDeleteEpisodeUsingDELETE', 'episodeId', episodeId)
            const localVarPath = `/aiwdt/softDeleteHumanFeedbackExampleByEpisodeId/{episodeId}`
                .replace(`{${"episodeId"}}`, encodeURIComponent(String(episodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API evaluates waterway designs and provides optimization recommendations.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayAssessmentAndRecommendationByGCPAIUsingGET: async (alignedElementDesignParamsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('waterwayAssessmentAndRecommendationByGCPAIUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/aiwdt/waterwayAssessmentAndRecommendationWithGeminiAPI/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API evaluates waterway designs and provides optimization recommendations.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayAssessmentAndRecommendationUsingGET: async (alignedElementDesignParamsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('waterwayAssessmentAndRecommendationUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/aiwdt/waterwayAssessmentAndRecommendation/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API endpoint provides AI-generated responses to user inquiries regarding waterway design specifications and considerations.
         * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayDesignAIAssistanceUsingPOST: async (waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwayDesignAIAssistanceRequestDTO' is not null or undefined
            assertParamExists('waterwayDesignAIAssistanceUsingPOST', 'waterwayDesignAIAssistanceRequestDTO', waterwayDesignAIAssistanceRequestDTO)
            const localVarPath = `/aiwdt/waterwayDesignAIAssistance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterwayDesignAIAssistanceRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API endpoint provides GCP AI-generated responses to user inquiries regarding waterway design specifications and considerations.
         * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayDesignGCPAIAssistanceUsingPOST: async (waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwayDesignAIAssistanceRequestDTO' is not null or undefined
            assertParamExists('waterwayDesignGCPAIAssistanceUsingPOST', 'waterwayDesignAIAssistanceRequestDTO', waterwayDesignAIAssistanceRequestDTO)
            const localVarPath = `/aiwdt/waterwayDesignAIAssistanceByGCPAI`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterwayDesignAIAssistanceRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API combines waterwayActionWrapper and waterwayObservationAndRewardWrapper
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayEnvSimulationForDrlTrainingUsingPOST: async (actionRequest: WaterwayActionRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionRequest' is not null or undefined
            assertParamExists('waterwayEnvSimulationForDrlTrainingUsingPOST', 'actionRequest', actionRequest)
            const localVarPath = `/aiwdt/waterwayEnvSimulationForDrlTraining`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get waterway information required to build waterway observation by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayObservationWrapperUsingGET: async (alignedElementDesignParamsId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('waterwayObservationWrapperUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/aiwdt/waterwayObservationWrapper/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is to make a quick calculation on cut/fill stats for a waterway
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayRewardWrapperUsingPOST: async (actionRequest: WaterwayActionRequestDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'actionRequest' is not null or undefined
            assertParamExists('waterwayRewardWrapperUsingPOST', 'actionRequest', actionRequest)
            const localVarPath = `/aiwdt/waterwayObservationAndRewardWrapper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(actionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterwayDesignToolsAiControllerApi - functional programming interface
 * @export
 */
export const WaterwayDesignToolsAiControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaterwayDesignToolsAiControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary this api is used for ai training to run simulation and validation
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionWrapperUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WdtSimulationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionWrapperUsingPOST(actionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary this can automatically generate a default waterway
         * @param {AutoDefaultReachesRequest} autoDefaultReachesRequest autoDefaultReachesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAutoDefaultReachesUsingPOST(autoDefaultReachesRequest: AutoDefaultReachesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultReachesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAutoDefaultReachesUsingPOST(autoDefaultReachesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary this is to capture human feedback examples
         * @param {WaterwayHumanFeedbackRequestDto} waterwayHumanFeedbackRequestDto waterwayHumanFeedbackRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHumanFeedbackExampleUsingPOST(waterwayHumanFeedbackRequestDto: WaterwayHumanFeedbackRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EpisodeMetadata>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHumanFeedbackExampleUsingPOST(waterwayHumanFeedbackRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Permanently deletes a human feedback example
         * @param {number} episodeId episodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEpisodeUsingDELETE(episodeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEpisodeUsingDELETE(episodeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API suggests 3 specific and actionable technical changes.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateAlternativeQuestionsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateEpisodeJson
         * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async generateEpisodeJsonUsingPOST(generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateEpisodeJsonUsingPOST(generateEpisodeJsonRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateHumanFeedbackJson
         * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateHumanFeedbackJsonUsingPOST(generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateHumanFeedbackJsonUsingPOST(generateEpisodeJsonRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateSetPayloadWithOpenAI
         * @param {object} requestBody requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSetPayloadWithOpenAIUsingPOST(requestBody: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSetPayloadWithOpenAIUsingPOST(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API retrieves alignment information necessary to validate waterway reaches by accepting the alignedDesignParametersId as input, and supports both Lined and Grassed Waterways.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentTotalLengthDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Marks a human feedback example as deleted without removing it from the database
         * @param {number} episodeId episodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async softDeleteEpisodeUsingDELETE(episodeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.softDeleteEpisodeUsingDELETE(episodeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API evaluates waterway designs and provides optimization recommendations.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwayAssessmentAndRecommendationByGCPAIUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayAssessmentAndRecommendationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwayAssessmentAndRecommendationByGCPAIUsingGET(alignedElementDesignParamsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API evaluates waterway designs and provides optimization recommendations.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwayAssessmentAndRecommendationUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayAssessmentAndRecommendationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwayAssessmentAndRecommendationUsingGET(alignedElementDesignParamsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API endpoint provides AI-generated responses to user inquiries regarding waterway design specifications and considerations.
         * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwayDesignAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayDesignQueryResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwayDesignAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API endpoint provides GCP AI-generated responses to user inquiries regarding waterway design specifications and considerations.
         * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwayDesignGCPAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayDesignQueryResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwayDesignGCPAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API combines waterwayActionWrapper and waterwayObservationAndRewardWrapper
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwayEnvSimulationForDrlTrainingUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayEnvResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwayEnvSimulationForDrlTrainingUsingPOST(actionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get waterway information required to build waterway observation by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwayObservationWrapperUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterwayObservationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwayObservationWrapperUsingGET(alignedElementDesignParamsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is to make a quick calculation on cut/fill stats for a waterway
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwayRewardWrapperUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayEnvResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwayRewardWrapperUsingPOST(actionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WaterwayDesignToolsAiControllerApi - factory interface
 * @export
 */
export const WaterwayDesignToolsAiControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaterwayDesignToolsAiControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary this api is used for ai training to run simulation and validation
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionWrapperUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: any): AxiosPromise<WdtSimulationResponseDTO> {
            return localVarFp.actionWrapperUsingPOST(actionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary this can automatically generate a default waterway
         * @param {AutoDefaultReachesRequest} autoDefaultReachesRequest autoDefaultReachesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAutoDefaultReachesUsingPOST(autoDefaultReachesRequest: AutoDefaultReachesRequest, options?: any): AxiosPromise<DefaultReachesResponse> {
            return localVarFp.createAutoDefaultReachesUsingPOST(autoDefaultReachesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary this is to capture human feedback examples
         * @param {WaterwayHumanFeedbackRequestDto} waterwayHumanFeedbackRequestDto waterwayHumanFeedbackRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHumanFeedbackExampleUsingPOST(waterwayHumanFeedbackRequestDto: WaterwayHumanFeedbackRequestDto, options?: any): AxiosPromise<Array<EpisodeMetadata>> {
            return localVarFp.createHumanFeedbackExampleUsingPOST(waterwayHumanFeedbackRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently deletes a human feedback example
         * @param {number} episodeId episodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEpisodeUsingDELETE(episodeId: number, options?: any): AxiosPromise<object> {
            return localVarFp.deleteEpisodeUsingDELETE(episodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API suggests 3 specific and actionable technical changes.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId: number, options?: any): AxiosPromise<GenerateAlternativeQuestionsDTO> {
            return localVarFp.generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateEpisodeJson
         * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        generateEpisodeJsonUsingPOST(generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.generateEpisodeJsonUsingPOST(generateEpisodeJsonRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateHumanFeedbackJson
         * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateHumanFeedbackJsonUsingPOST(generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.generateHumanFeedbackJsonUsingPOST(generateEpisodeJsonRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateSetPayloadWithOpenAI
         * @param {object} requestBody requestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSetPayloadWithOpenAIUsingPOST(requestBody: object, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.generateSetPayloadWithOpenAIUsingPOST(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API retrieves alignment information necessary to validate waterway reaches by accepting the alignedDesignParametersId as input, and supports both Lined and Grassed Waterways.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId: number, options?: any): AxiosPromise<AlignmentTotalLengthDTO> {
            return localVarFp.getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a human feedback example as deleted without removing it from the database
         * @param {number} episodeId episodeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        softDeleteEpisodeUsingDELETE(episodeId: number, options?: any): AxiosPromise<object> {
            return localVarFp.softDeleteEpisodeUsingDELETE(episodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API evaluates waterway designs and provides optimization recommendations.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayAssessmentAndRecommendationByGCPAIUsingGET(alignedElementDesignParamsId: number, options?: any): AxiosPromise<WaterwayAssessmentAndRecommendationDTO> {
            return localVarFp.waterwayAssessmentAndRecommendationByGCPAIUsingGET(alignedElementDesignParamsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API evaluates waterway designs and provides optimization recommendations.
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayAssessmentAndRecommendationUsingGET(alignedElementDesignParamsId: number, options?: any): AxiosPromise<WaterwayAssessmentAndRecommendationDTO> {
            return localVarFp.waterwayAssessmentAndRecommendationUsingGET(alignedElementDesignParamsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API endpoint provides AI-generated responses to user inquiries regarding waterway design specifications and considerations.
         * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayDesignAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options?: any): AxiosPromise<WaterwayDesignQueryResponseDTO> {
            return localVarFp.waterwayDesignAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API endpoint provides GCP AI-generated responses to user inquiries regarding waterway design specifications and considerations.
         * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayDesignGCPAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options?: any): AxiosPromise<WaterwayDesignQueryResponseDTO> {
            return localVarFp.waterwayDesignGCPAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API combines waterwayActionWrapper and waterwayObservationAndRewardWrapper
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayEnvSimulationForDrlTrainingUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: any): AxiosPromise<WaterwayEnvResponseDto> {
            return localVarFp.waterwayEnvSimulationForDrlTrainingUsingPOST(actionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get waterway information required to build waterway observation by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayObservationWrapperUsingGET(alignedElementDesignParamsId: number, options?: any): AxiosPromise<Array<WaterwayObservationDTO>> {
            return localVarFp.waterwayObservationWrapperUsingGET(alignedElementDesignParamsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is to make a quick calculation on cut/fill stats for a waterway
         * @param {WaterwayActionRequestDTO} actionRequest actionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwayRewardWrapperUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: any): AxiosPromise<WaterwayEnvResponseDto> {
            return localVarFp.waterwayRewardWrapperUsingPOST(actionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterwayDesignToolsAiControllerApi - object-oriented interface
 * @export
 * @class WaterwayDesignToolsAiControllerApi
 * @extends {BaseAPI}
 */
export class WaterwayDesignToolsAiControllerApi extends BaseAPI {
    /**
     * 
     * @summary this api is used for ai training to run simulation and validation
     * @param {WaterwayActionRequestDTO} actionRequest actionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public actionWrapperUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).actionWrapperUsingPOST(actionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary this can automatically generate a default waterway
     * @param {AutoDefaultReachesRequest} autoDefaultReachesRequest autoDefaultReachesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public createAutoDefaultReachesUsingPOST(autoDefaultReachesRequest: AutoDefaultReachesRequest, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).createAutoDefaultReachesUsingPOST(autoDefaultReachesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary this is to capture human feedback examples
     * @param {WaterwayHumanFeedbackRequestDto} waterwayHumanFeedbackRequestDto waterwayHumanFeedbackRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public createHumanFeedbackExampleUsingPOST(waterwayHumanFeedbackRequestDto: WaterwayHumanFeedbackRequestDto, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).createHumanFeedbackExampleUsingPOST(waterwayHumanFeedbackRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently deletes a human feedback example
     * @param {number} episodeId episodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public deleteEpisodeUsingDELETE(episodeId: number, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).deleteEpisodeUsingDELETE(episodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API suggests 3 specific and actionable technical changes.
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).generateAlternativeQuestionsByAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateEpisodeJson
     * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public generateEpisodeJsonUsingPOST(generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).generateEpisodeJsonUsingPOST(generateEpisodeJsonRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateHumanFeedbackJson
     * @param {GenerateEpisodeJsonRequestDto} generateEpisodeJsonRequestDto generateEpisodeJsonRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public generateHumanFeedbackJsonUsingPOST(generateEpisodeJsonRequestDto: GenerateEpisodeJsonRequestDto, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).generateHumanFeedbackJsonUsingPOST(generateEpisodeJsonRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateSetPayloadWithOpenAI
     * @param {object} requestBody requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public generateSetPayloadWithOpenAIUsingPOST(requestBody: object, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).generateSetPayloadWithOpenAIUsingPOST(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API retrieves alignment information necessary to validate waterway reaches by accepting the alignedDesignParametersId as input, and supports both Lined and Grassed Waterways.
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).getAlignmentTotalLengthbyAlignedElementDesignParmasIdUsingGET(alignedElementDesignParamsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a human feedback example as deleted without removing it from the database
     * @param {number} episodeId episodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public softDeleteEpisodeUsingDELETE(episodeId: number, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).softDeleteEpisodeUsingDELETE(episodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API evaluates waterway designs and provides optimization recommendations.
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public waterwayAssessmentAndRecommendationByGCPAIUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).waterwayAssessmentAndRecommendationByGCPAIUsingGET(alignedElementDesignParamsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API evaluates waterway designs and provides optimization recommendations.
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public waterwayAssessmentAndRecommendationUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).waterwayAssessmentAndRecommendationUsingGET(alignedElementDesignParamsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API endpoint provides AI-generated responses to user inquiries regarding waterway design specifications and considerations.
     * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public waterwayDesignAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).waterwayDesignAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API endpoint provides GCP AI-generated responses to user inquiries regarding waterway design specifications and considerations.
     * @param {WaterwayDesignAIAssistanceRequestDTO} waterwayDesignAIAssistanceRequestDTO waterwayDesignAIAssistanceRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public waterwayDesignGCPAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO: WaterwayDesignAIAssistanceRequestDTO, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).waterwayDesignGCPAIAssistanceUsingPOST(waterwayDesignAIAssistanceRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API combines waterwayActionWrapper and waterwayObservationAndRewardWrapper
     * @param {WaterwayActionRequestDTO} actionRequest actionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public waterwayEnvSimulationForDrlTrainingUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).waterwayEnvSimulationForDrlTrainingUsingPOST(actionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get waterway information required to build waterway observation by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public waterwayObservationWrapperUsingGET(alignedElementDesignParamsId: number, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).waterwayObservationWrapperUsingGET(alignedElementDesignParamsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is to make a quick calculation on cut/fill stats for a waterway
     * @param {WaterwayActionRequestDTO} actionRequest actionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsAiControllerApi
     */
    public waterwayRewardWrapperUsingPOST(actionRequest: WaterwayActionRequestDTO, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsAiControllerApiFp(this.configuration).waterwayRewardWrapperUsingPOST(actionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WaterwayDesignToolsControllerApi - axios parameter creator
 * @export
 */
export const WaterwayDesignToolsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary channelStructureCalculation
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelStructureCalculationUsingPOST: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('channelStructureCalculationUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/waterwaydesign/channelStructureCalculation/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createDefaultLinedReaches
         * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createDefaultLinedReachesUsingPOST: async (defaultReachesRequest: DefaultReachesRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defaultReachesRequest' is not null or undefined
            assertParamExists('createDefaultLinedReachesUsingPOST', 'defaultReachesRequest', defaultReachesRequest)
            const localVarPath = `/waterwaydesign/createDefaultLinedReaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(defaultReachesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createDefaultReaches
         * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultReachesUsingPOST: async (defaultReachesRequest: DefaultReachesRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'defaultReachesRequest' is not null or undefined
            assertParamExists('createDefaultReachesUsingPOST', 'defaultReachesRequest', defaultReachesRequest)
            const localVarPath = `/waterwaydesign/createDefaultReaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(defaultReachesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createOrUpdateAlignedElementDesignParams
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateAlignedElementDesignParamsUsingPOST: async (alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsRequest' is not null or undefined
            assertParamExists('createOrUpdateAlignedElementDesignParamsUsingPOST', 'alignedElementDesignParamsRequest', alignedElementDesignParamsRequest)
            const localVarPath = `/waterwaydesign/createAlignedElementDesignParams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignedElementDesignParamsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteAlignedElementDesignParamsByAlignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/deleteAlignedElementDesignParamsByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsId
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST: async (sessionUuid: string, alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST', 'sessionUuid', sessionUuid)
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsId/{sessionUuid}/{alignedElementDesignParamsId}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)))
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteDesignSurfaceAndReachesByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST', 'alignedElementId', alignedElementId)
            const localVarPath = `/waterwaydesign/deleteDesignSurfaceAndReachesByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to delete waterway and its related entities using alignedDesignParametersId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterwayByAlignedElementDesignParamsIdUsingPOST: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('deleteWaterwayByAlignedElementDesignParamsIdUsingPOST', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/deleteWaterwayByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API used to Export Waterway Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} xsectionInterval xsectionInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportWaterwayCrossSectionsUsingPOST: async (alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('exportWaterwayCrossSectionsUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            // verify required parameter 'xsectionInterval' is not null or undefined
            assertParamExists('exportWaterwayCrossSectionsUsingPOST', 'xsectionInterval', xsectionInterval)
            const localVarPath = `/waterwaydesign/exportWaterwayCrossSections/{alignedElementDesignParametersId}/{xsectionInterval}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)))
                .replace(`{${"xsectionInterval"}}`, encodeURIComponent(String(xsectionInterval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generateWaterwayDesignSurfaceByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWaterwayDesignSurfaceByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('generateWaterwayDesignSurfaceByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/waterwaydesign/generateWaterwayDesignSurfaceByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeId
         * @param {string} sessionUuid sessionUuid
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET: async (sessionUuid: string, designElementTypeId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET', 'sessionUuid', sessionUuid)
            // verify required parameter 'designElementTypeId' is not null or undefined
            assertParamExists('getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET', 'designElementTypeId', designElementTypeId)
            const localVarPath = `/waterwaydesign/getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeId/{sessionUuid}/{designElementTypeId}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)))
                .replace(`{${"designElementTypeId"}}`, encodeURIComponent(String(designElementTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignedElementDesignParamsIdsAndNotificationsBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/waterwaydesign/getAlignedElementDesignParamsIdsAndNotificationsBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignedElementShapeByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignedElementShapeByAlignedElementIdUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('getAlignedElementShapeByAlignedElementIdUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/waterwaydesign/getAlignedElementShapeByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignmentForWDTByDesignElementJsonId
         * @param {number} designElementJsonId designElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentForWDTByDesignElementJsonIdUsingGET: async (designElementJsonId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designElementJsonId' is not null or undefined
            assertParamExists('getAlignmentForWDTByDesignElementJsonIdUsingGET', 'designElementJsonId', designElementJsonId)
            const localVarPath = `/waterwaydesign/getAlignmentForWDTByDesignElementJsonId/{designElementJsonId}`
                .replace(`{${"designElementJsonId"}}`, encodeURIComponent(String(designElementJsonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAlignmentsForDWT
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentsForDWTUsingGET: async (projectUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectUuid' is not null or undefined
            assertParamExists('getAlignmentsForDWTUsingGET', 'projectUuid', projectUuid)
            const localVarPath = `/waterwaydesign/getAlignmentsForDWT/{projectUuid}`
                .replace(`{${"projectUuid"}}`, encodeURIComponent(String(projectUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllAlignmentsForWDTByStateAndCounty
         * @param {AlignmentForWDTRequestDTO} alignmentForWDTRequestDTO alignmentForWDTRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlignmentsForWDTByStateAndCountyUsingPOST: async (alignmentForWDTRequestDTO: AlignmentForWDTRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignmentForWDTRequestDTO' is not null or undefined
            assertParamExists('getAllAlignmentsForWDTByStateAndCountyUsingPOST', 'alignmentForWDTRequestDTO', alignmentForWDTRequestDTO)
            const localVarPath = `/waterwaydesign/getAllAlignmentsForWDTByStateAndCounty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignmentForWDTRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllNotificationStatus
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificationStatusUsingGET: async (alignedElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementId' is not null or undefined
            assertParamExists('getAllNotificationStatusUsingGET', 'alignedElementId', alignedElementId)
            const localVarPath = `/waterwaydesign/getAllNotificationStatusByAlignedElementId/{alignedElementId}`
                .replace(`{${"alignedElementId"}}`, encodeURIComponent(String(alignedElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get the lining material of a specific aligned design element
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiningMaterialByAlignedElementDesignParamsIdUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getLiningMaterialByAlignedElementDesignParamsIdUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/getLiningMaterialByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getReachChannelParametersByAlignedElementDesignParametersIdAndReachId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST: async (alignedElementDesignParametersId: number, reachId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            // verify required parameter 'reachId' is not null or undefined
            assertParamExists('getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST', 'reachId', reachId)
            const localVarPath = `/waterwaydesign/getReachChannelParametersByAlignedElementDesignParametersIdAndReachId/{alignedElementDesignParametersId}/{reachId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)))
                .replace(`{${"reachId"}}`, encodeURIComponent(String(reachId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway construction report
         * @param {WaterwayConstructionReportReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayConstructionReportUsingPOST: async (req: WaterwayConstructionReportReqDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('getWaterwayConstructionReportUsingPOST', 'req', req)
            const localVarPath = `/waterwaydesign/getWaterwayConstructionReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getWaterwayDesignSummaryBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayDesignSummaryBySessionUuidUsingGET: async (sessionUuid: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('getWaterwayDesignSummaryBySessionUuidUsingGET', 'sessionUuid', sessionUuid)
            const localVarPath = `/waterwaydesign/getWaterwayDesignSummaryBySessionUuid/{sessionUuid}`
                .replace(`{${"sessionUuid"}}`, encodeURIComponent(String(sessionUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getWaterwayInputsByAlignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayInputsByAlignedElementDesignParamsIdUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getWaterwayInputsByAlignedElementDesignParamsIdUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/getWaterwayInputsByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/getWaterwaySummaryReportByAlignedElementDesignParamsId/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwaySummaryReportUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getWaterwaySummaryReportUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/getWaterwaySummaryReport/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary page by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwaySummaryResultsUsingGET: async (alignedElementDesignParamsId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('getWaterwaySummaryResultsUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            const localVarPath = `/waterwaydesign/getWaterwaySummaryResults/{alignedElementDesignParamsId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to distribute runoffQ per length of each reach and re-calculate totalQ using the updated runoffQ
         * @param {ReDistributeRunoffDTO} reRunWSCDTO reRunWSCDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redistributeRunoffUsingPOST: async (reRunWSCDTO: ReDistributeRunoffDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reRunWSCDTO' is not null or undefined
            assertParamExists('redistributeRunoffUsingPOST', 'reRunWSCDTO', reRunWSCDTO)
            const localVarPath = `/waterwaydesign/redistributeRunoff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reRunWSCDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary resetDefaultLinedReach
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetDefaultLinedReachUsingGET: async (alignedElementDesignParamsId: number, reachId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsId' is not null or undefined
            assertParamExists('resetDefaultLinedReachUsingGET', 'alignedElementDesignParamsId', alignedElementDesignParamsId)
            // verify required parameter 'reachId' is not null or undefined
            assertParamExists('resetDefaultLinedReachUsingGET', 'reachId', reachId)
            const localVarPath = `/waterwaydesign/resetDefaultLinedReach/{alignedElementDesignParamsId}/{reachId}`
                .replace(`{${"alignedElementDesignParamsId"}}`, encodeURIComponent(String(alignedElementDesignParamsId)))
                .replace(`{${"reachId"}}`, encodeURIComponent(String(reachId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API reset waterway profiles, provided the alignedElementDesignParametersId: clean up all the reach jsons, structure profiles records for this waterway, and set reachesChanges to 0
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetWaterwayProfileResponseUsingDELETE: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('resetWaterwayProfileResponseUsingDELETE', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/waterwaydesign/resetWaterwayProfile/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API is used to save lining material to a aligned design element
         * @param {AlignedElementIdWithLiningMaterialDTO} alignedElementIdWithLiningMaterialDTO alignedElementIdWithLiningMaterialDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLiningMaterialByAlignedDesignElementIDUsingPOST: async (alignedElementIdWithLiningMaterialDTO: AlignedElementIdWithLiningMaterialDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementIdWithLiningMaterialDTO' is not null or undefined
            assertParamExists('saveLiningMaterialByAlignedDesignElementIDUsingPOST', 'alignedElementIdWithLiningMaterialDTO', alignedElementIdWithLiningMaterialDTO)
            const localVarPath = `/waterwaydesign/saveLiningMaterialByAlignedDesignElementId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignedElementIdWithLiningMaterialDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateAllNotificationStatus
         * @param {WaterwayInputChangeDto} waterwayInputChangeDto waterwayInputChangeDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllNotificationStatusUsingPOST: async (waterwayInputChangeDto: WaterwayInputChangeDto, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwayInputChangeDto' is not null or undefined
            assertParamExists('updateAllNotificationStatusUsingPOST', 'waterwayInputChangeDto', waterwayInputChangeDto)
            const localVarPath = `/waterwaydesign/updateAllNotificationStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterwayInputChangeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateInvalidDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignmentElementId alignmentElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvalidDesignUiStateUsingPOST: async (sessionUuid: string, alignmentElementId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUuid' is not null or undefined
            assertParamExists('updateInvalidDesignUiStateUsingPOST', 'sessionUuid', sessionUuid)
            // verify required parameter 'alignmentElementId' is not null or undefined
            assertParamExists('updateInvalidDesignUiStateUsingPOST', 'alignmentElementId', alignmentElementId)
            const localVarPath = `/waterwaydesign/updateDesignUiStateIfInvalid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionUuid !== undefined) {
                localVarQueryParameter['sessionUuid'] = sessionUuid;
            }

            if (alignmentElementId !== undefined) {
                localVarQueryParameter['alignmentElementId'] = alignmentElementId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateOrUpdateAlignedElementDesignParams
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrUpdateAlignedElementDesignParamsUsingPOST: async (alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParamsRequest' is not null or undefined
            assertParamExists('updateOrUpdateAlignedElementDesignParamsUsingPOST', 'alignedElementDesignParamsRequest', alignedElementDesignParamsRequest)
            const localVarPath = `/waterwaydesign/updateAlignedElementDesignParams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignedElementDesignParamsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateOrUpdateAlignedElementShape
         * @param {AlignedElementShapeDTO} alignedElementShapeRequest alignedElementShapeRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrUpdateAlignedElementShapeUsingPOST: async (alignedElementShapeRequest: AlignedElementShapeDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementShapeRequest' is not null or undefined
            assertParamExists('updateOrUpdateAlignedElementShapeUsingPOST', 'alignedElementShapeRequest', alignedElementShapeRequest)
            const localVarPath = `/waterwaydesign/updateAlignedElementShape`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alignedElementShapeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateReachLiningMaterials
         * @param {LiningMaterialPatchRequest} liningMaterialPatchRequest liningMaterialPatchRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReachLiningMaterialsUsingPATCH: async (liningMaterialPatchRequest: LiningMaterialPatchRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'liningMaterialPatchRequest' is not null or undefined
            assertParamExists('updateReachLiningMaterialsUsingPATCH', 'liningMaterialPatchRequest', liningMaterialPatchRequest)
            const localVarPath = `/waterwaydesign/reachLiningMaterials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(liningMaterialPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API synchronizes waterway design control\'s Channel Ends settings:  1. When Slope Distances are provided, calculate Slope Percentages;  2. When Slope Percentages are provided, calculate Slope Distances.
         * @param {DesignControlChannelEndsDTO} designControlChannelEndsRequest designControlChannelEndsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterwayDesignControlSettingsUsingPOST: async (designControlChannelEndsRequest: DesignControlChannelEndsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designControlChannelEndsRequest' is not null or undefined
            assertParamExists('updateWaterwayDesignControlSettingsUsingPOST', 'designControlChannelEndsRequest', designControlChannelEndsRequest)
            const localVarPath = `/waterwaydesign/updateWaterwayDesignControlSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(designControlChannelEndsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary waterwaySimulationAndValidation
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwaySimulationAndValidationUsingPOST: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('waterwaySimulationAndValidationUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/waterwaydesign/waterwaySimulationAndValidation/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterwayDesignToolsControllerApi - functional programming interface
 * @export
 */
export const WaterwayDesignToolsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaterwayDesignToolsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary channelStructureCalculation
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async channelStructureCalculationUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedFeatureDesignShapeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.channelStructureCalculationUsingPOST(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createDefaultLinedReaches
         * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async createDefaultLinedReachesUsingPOST(defaultReachesRequest: DefaultReachesRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultReachesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDefaultLinedReachesUsingPOST(defaultReachesRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createDefaultReaches
         * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDefaultReachesUsingPOST(defaultReachesRequest: DefaultReachesRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultReachesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDefaultReachesUsingPOST(defaultReachesRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary createOrUpdateAlignedElementDesignParams
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteAlignedElementDesignParamsByAlignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsId
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST(sessionUuid: string, alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST(sessionUuid, alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteDesignSurfaceAndReachesByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to delete waterway and its related entities using alignedDesignParametersId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWaterwayByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWaterwayByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API used to Export Waterway Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} xsectionInterval xsectionInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportWaterwayCrossSectionsUsingPOST(alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportWaterwayCrossSectionsUsingPOST(alignedElementDesignParametersId, xsectionInterval, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generateWaterwayDesignSurfaceByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWaterwayDesignSurfaceByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedFeatureDesignShapeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWaterwayDesignSurfaceByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeId
         * @param {string} sessionUuid sessionUuid
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET(sessionUuid: string, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlignedElementDesignParameters>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET(sessionUuid, designElementTypeId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignedElementDesignParamsIdsAndNotificationsBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementsWithNotificationsAndStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignedElementShapeByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementShapeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignmentForWDTByDesignElementJsonId
         * @param {number} designElementJsonId designElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignmentForWDTByDesignElementJsonIdUsingGET(designElementJsonId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignmentForWDTParamsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignmentForWDTByDesignElementJsonIdUsingGET(designElementJsonId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAlignmentsForDWT
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlignmentsForDWTUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlignmentForWDTResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlignmentsForDWTUsingGET(projectUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllAlignmentsForWDTByStateAndCounty
         * @param {AlignmentForWDTRequestDTO} alignmentForWDTRequestDTO alignmentForWDTRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAlignmentsForWDTByStateAndCountyUsingPOST(alignmentForWDTRequestDTO: AlignmentForWDTRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlignmentForWDTResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAlignmentsForWDTByStateAndCountyUsingPOST(alignmentForWDTRequestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllNotificationStatus
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotificationStatusUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayInputChangeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNotificationStatusUsingGET(alignedElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get the lining material of a specific aligned design element
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLiningMaterialByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLiningMaterialByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getReachChannelParametersByAlignedElementDesignParametersIdAndReachId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelParametersDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST(alignedElementDesignParametersId, reachId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway construction report
         * @param {WaterwayConstructionReportReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwayConstructionReportUsingPOST(req: WaterwayConstructionReportReqDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayConstructionReportRespDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwayConstructionReportUsingPOST(req, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getWaterwayDesignSummaryBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwayDesignSummaryBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterwayDesignSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwayDesignSummaryBySessionUuidUsingGET(sessionUuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getWaterwayInputsByAlignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwayInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwayInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwaySummaryReportDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwaySummaryReportUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwaySummaryReportRespDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwaySummaryReportUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary page by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwaySummaryResultsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwaySummaryResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwaySummaryResultsUsingGET(alignedElementDesignParamsId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to distribute runoffQ per length of each reach and re-calculate totalQ using the updated runoffQ
         * @param {ReDistributeRunoffDTO} reRunWSCDTO reRunWSCDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redistributeRunoffUsingPOST(reRunWSCDTO: ReDistributeRunoffDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReDistributeRunoffDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redistributeRunoffUsingPOST(reRunWSCDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary resetDefaultLinedReach
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetDefaultLinedReachUsingGET(alignedElementDesignParamsId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultReachesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetDefaultLinedReachUsingGET(alignedElementDesignParamsId, reachId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API reset waterway profiles, provided the alignedElementDesignParametersId: clean up all the reach jsons, structure profiles records for this waterway, and set reachesChanges to 0
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetWaterwayProfileResponseUsingDELETE(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetWaterwayProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetWaterwayProfileResponseUsingDELETE(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API is used to save lining material to a aligned design element
         * @param {AlignedElementIdWithLiningMaterialDTO} alignedElementIdWithLiningMaterialDTO alignedElementIdWithLiningMaterialDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLiningMaterialByAlignedDesignElementIDUsingPOST(alignedElementIdWithLiningMaterialDTO: AlignedElementIdWithLiningMaterialDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLiningMaterialByAlignedDesignElementIDUsingPOST(alignedElementIdWithLiningMaterialDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateAllNotificationStatus
         * @param {WaterwayInputChangeDto} waterwayInputChangeDto waterwayInputChangeDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAllNotificationStatusUsingPOST(waterwayInputChangeDto: WaterwayInputChangeDto, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAllNotificationStatusUsingPOST(waterwayInputChangeDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateInvalidDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignmentElementId alignmentElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInvalidDesignUiStateUsingPOST(sessionUuid: string, alignmentElementId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInvalidDesignUiStateUsingPOST(sessionUuid, alignmentElementId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateOrUpdateAlignedElementDesignParams
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateOrUpdateAlignedElementShape
         * @param {AlignedElementShapeDTO} alignedElementShapeRequest alignedElementShapeRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrUpdateAlignedElementShapeUsingPOST(alignedElementShapeRequest: AlignedElementShapeDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlignedElementDesignParamsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrUpdateAlignedElementShapeUsingPOST(alignedElementShapeRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateReachLiningMaterials
         * @param {LiningMaterialPatchRequest} liningMaterialPatchRequest liningMaterialPatchRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReachLiningMaterialsUsingPATCH(liningMaterialPatchRequest: LiningMaterialPatchRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiningMaterialPatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReachLiningMaterialsUsingPATCH(liningMaterialPatchRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API synchronizes waterway design control\'s Channel Ends settings:  1. When Slope Distances are provided, calculate Slope Percentages;  2. When Slope Percentages are provided, calculate Slope Distances.
         * @param {DesignControlChannelEndsDTO} designControlChannelEndsRequest designControlChannelEndsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWaterwayDesignControlSettingsUsingPOST(designControlChannelEndsRequest: DesignControlChannelEndsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignControlChannelEndsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWaterwayDesignControlSettingsUsingPOST(designControlChannelEndsRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary waterwaySimulationAndValidation
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async waterwaySimulationAndValidationUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WdtSimulationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.waterwaySimulationAndValidationUsingPOST(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WaterwayDesignToolsControllerApi - factory interface
 * @export
 */
export const WaterwayDesignToolsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaterwayDesignToolsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary channelStructureCalculation
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channelStructureCalculationUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<AlignedFeatureDesignShapeResponseDTO> {
            return localVarFp.channelStructureCalculationUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createDefaultLinedReaches
         * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createDefaultLinedReachesUsingPOST(defaultReachesRequest: DefaultReachesRequest, authorization?: string, options?: any): AxiosPromise<DefaultReachesResponse> {
            return localVarFp.createDefaultLinedReachesUsingPOST(defaultReachesRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createDefaultReaches
         * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDefaultReachesUsingPOST(defaultReachesRequest: DefaultReachesRequest, authorization?: string, options?: any): AxiosPromise<DefaultReachesResponse> {
            return localVarFp.createDefaultReachesUsingPOST(defaultReachesRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createOrUpdateAlignedElementDesignParams
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.createOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteAlignedElementDesignParamsByAlignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsId
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST(sessionUuid: string, alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST(sessionUuid, alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteDesignSurfaceAndReachesByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to delete waterway and its related entities using alignedDesignParametersId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWaterwayByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteWaterwayByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API used to Export Waterway Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} xsectionInterval xsectionInterval
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportWaterwayCrossSectionsUsingPOST(alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options?: any): AxiosPromise<void> {
            return localVarFp.exportWaterwayCrossSectionsUsingPOST(alignedElementDesignParametersId, xsectionInterval, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generateWaterwayDesignSurfaceByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWaterwayDesignSurfaceByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<AlignedFeatureDesignShapeResponseDTO> {
            return localVarFp.generateWaterwayDesignSurfaceByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeId
         * @param {string} sessionUuid sessionUuid
         * @param {number} designElementTypeId designElementTypeId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET(sessionUuid: string, designElementTypeId: number, authorization?: string, options?: any): AxiosPromise<Array<AlignedElementDesignParameters>> {
            return localVarFp.getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET(sessionUuid, designElementTypeId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignedElementDesignParamsIdsAndNotificationsBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<AlignedElementsWithNotificationsAndStatusResponse> {
            return localVarFp.getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignedElementShapeByAlignedElementId
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<AlignedElementShapeDTO> {
            return localVarFp.getAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignmentForWDTByDesignElementJsonId
         * @param {number} designElementJsonId designElementJsonId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentForWDTByDesignElementJsonIdUsingGET(designElementJsonId: number, authorization?: string, options?: any): AxiosPromise<AlignmentForWDTParamsDTO> {
            return localVarFp.getAlignmentForWDTByDesignElementJsonIdUsingGET(designElementJsonId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAlignmentsForDWT
         * @param {string} projectUuid projectUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlignmentsForDWTUsingGET(projectUuid: string, authorization?: string, options?: any): AxiosPromise<Array<AlignmentForWDTResponseDTO>> {
            return localVarFp.getAlignmentsForDWTUsingGET(projectUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllAlignmentsForWDTByStateAndCounty
         * @param {AlignmentForWDTRequestDTO} alignmentForWDTRequestDTO alignmentForWDTRequestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlignmentsForWDTByStateAndCountyUsingPOST(alignmentForWDTRequestDTO: AlignmentForWDTRequestDTO, authorization?: string, options?: any): AxiosPromise<Array<AlignmentForWDTResponseDTO>> {
            return localVarFp.getAllAlignmentsForWDTByStateAndCountyUsingPOST(alignmentForWDTRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllNotificationStatus
         * @param {number} alignedElementId alignedElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotificationStatusUsingGET(alignedElementId: number, authorization?: string, options?: any): AxiosPromise<WaterwayInputChangeDto> {
            return localVarFp.getAllNotificationStatusUsingGET(alignedElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get the lining material of a specific aligned design element
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLiningMaterialByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getLiningMaterialByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getReachChannelParametersByAlignedElementDesignParametersIdAndReachId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: any): AxiosPromise<ChannelParametersDTO> {
            return localVarFp.getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST(alignedElementDesignParametersId, reachId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway construction report
         * @param {WaterwayConstructionReportReqDTO} req req
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayConstructionReportUsingPOST(req: WaterwayConstructionReportReqDTO, authorization?: string, options?: any): AxiosPromise<WaterwayConstructionReportRespDTO> {
            return localVarFp.getWaterwayConstructionReportUsingPOST(req, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getWaterwayDesignSummaryBySessionUuid
         * @param {string} sessionUuid sessionUuid
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayDesignSummaryBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: any): AxiosPromise<Array<WaterwayDesignSummaryDto>> {
            return localVarFp.getWaterwayDesignSummaryBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getWaterwayInputsByAlignedElementDesignParamsId
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<WaterwayDTO> {
            return localVarFp.getWaterwayInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<WaterwaySummaryReportDTO> {
            return localVarFp.getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwaySummaryReportUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<WaterwaySummaryReportRespDTO> {
            return localVarFp.getWaterwaySummaryReportUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to get information required to build waterway summary page by passing  alignedDesignParametersId as input
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwaySummaryResultsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: any): AxiosPromise<WaterwaySummaryResultDTO> {
            return localVarFp.getWaterwaySummaryResultsUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to distribute runoffQ per length of each reach and re-calculate totalQ using the updated runoffQ
         * @param {ReDistributeRunoffDTO} reRunWSCDTO reRunWSCDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redistributeRunoffUsingPOST(reRunWSCDTO: ReDistributeRunoffDTO, authorization?: string, options?: any): AxiosPromise<ReDistributeRunoffDTO> {
            return localVarFp.redistributeRunoffUsingPOST(reRunWSCDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary resetDefaultLinedReach
         * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetDefaultLinedReachUsingGET(alignedElementDesignParamsId: number, reachId: string, authorization?: string, options?: any): AxiosPromise<DefaultReachesResponse> {
            return localVarFp.resetDefaultLinedReachUsingGET(alignedElementDesignParamsId, reachId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API reset waterway profiles, provided the alignedElementDesignParametersId: clean up all the reach jsons, structure profiles records for this waterway, and set reachesChanges to 0
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetWaterwayProfileResponseUsingDELETE(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<ResetWaterwayProfileResponse> {
            return localVarFp.resetWaterwayProfileResponseUsingDELETE(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API is used to save lining material to a aligned design element
         * @param {AlignedElementIdWithLiningMaterialDTO} alignedElementIdWithLiningMaterialDTO alignedElementIdWithLiningMaterialDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLiningMaterialByAlignedDesignElementIDUsingPOST(alignedElementIdWithLiningMaterialDTO: AlignedElementIdWithLiningMaterialDTO, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.saveLiningMaterialByAlignedDesignElementIDUsingPOST(alignedElementIdWithLiningMaterialDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateAllNotificationStatus
         * @param {WaterwayInputChangeDto} waterwayInputChangeDto waterwayInputChangeDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllNotificationStatusUsingPOST(waterwayInputChangeDto: WaterwayInputChangeDto, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateAllNotificationStatusUsingPOST(waterwayInputChangeDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateInvalidDesignUiState
         * @param {string} sessionUuid sessionUuid
         * @param {number} alignmentElementId alignmentElementId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInvalidDesignUiStateUsingPOST(sessionUuid: string, alignmentElementId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.updateInvalidDesignUiStateUsingPOST(sessionUuid, alignmentElementId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateOrUpdateAlignedElementDesignParams
         * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.updateOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateOrUpdateAlignedElementShape
         * @param {AlignedElementShapeDTO} alignedElementShapeRequest alignedElementShapeRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrUpdateAlignedElementShapeUsingPOST(alignedElementShapeRequest: AlignedElementShapeDTO, authorization?: string, options?: any): AxiosPromise<AlignedElementDesignParamsResponseDTO> {
            return localVarFp.updateOrUpdateAlignedElementShapeUsingPOST(alignedElementShapeRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateReachLiningMaterials
         * @param {LiningMaterialPatchRequest} liningMaterialPatchRequest liningMaterialPatchRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReachLiningMaterialsUsingPATCH(liningMaterialPatchRequest: LiningMaterialPatchRequest, authorization?: string, options?: any): AxiosPromise<LiningMaterialPatchResponse> {
            return localVarFp.updateReachLiningMaterialsUsingPATCH(liningMaterialPatchRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API synchronizes waterway design control\'s Channel Ends settings:  1. When Slope Distances are provided, calculate Slope Percentages;  2. When Slope Percentages are provided, calculate Slope Distances.
         * @param {DesignControlChannelEndsDTO} designControlChannelEndsRequest designControlChannelEndsRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWaterwayDesignControlSettingsUsingPOST(designControlChannelEndsRequest: DesignControlChannelEndsDTO, authorization?: string, options?: any): AxiosPromise<DesignControlChannelEndsDTO> {
            return localVarFp.updateWaterwayDesignControlSettingsUsingPOST(designControlChannelEndsRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary waterwaySimulationAndValidation
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waterwaySimulationAndValidationUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<WdtSimulationResponseDTO> {
            return localVarFp.waterwaySimulationAndValidationUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterwayDesignToolsControllerApi - object-oriented interface
 * @export
 * @class WaterwayDesignToolsControllerApi
 * @extends {BaseAPI}
 */
export class WaterwayDesignToolsControllerApi extends BaseAPI {
    /**
     * 
     * @summary channelStructureCalculation
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public channelStructureCalculationUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).channelStructureCalculationUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createDefaultLinedReaches
     * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public createDefaultLinedReachesUsingPOST(defaultReachesRequest: DefaultReachesRequest, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).createDefaultLinedReachesUsingPOST(defaultReachesRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createDefaultReaches
     * @param {DefaultReachesRequest} defaultReachesRequest defaultReachesRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public createDefaultReachesUsingPOST(defaultReachesRequest: DefaultReachesRequest, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).createDefaultReachesUsingPOST(defaultReachesRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createOrUpdateAlignedElementDesignParams
     * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public createOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).createOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteAlignedElementDesignParamsByAlignedElementDesignParamsId
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).deleteAlignedElementDesignParamsByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsId
     * @param {string} sessionUuid sessionUuid
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST(sessionUuid: string, alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).deleteAlignedElementDesignParamsBySessionUuidAndAlignedElementDesignParamsIdUsingPOST(sessionUuid, alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteDesignSurfaceAndReachesByAlignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).deleteDesignSurfaceAndReachesByAlignedElementIdUsingPOST(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to delete waterway and its related entities using alignedDesignParametersId
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public deleteWaterwayByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).deleteWaterwayByAlignedElementDesignParamsIdUsingPOST(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API used to Export Waterway Xsection Points in to Csv file while taking inputs as alignedElementDesignParameterId and crossSectionIntervals
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {number} xsectionInterval xsectionInterval
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public exportWaterwayCrossSectionsUsingPOST(alignedElementDesignParametersId: number, xsectionInterval: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).exportWaterwayCrossSectionsUsingPOST(alignedElementDesignParametersId, xsectionInterval, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generateWaterwayDesignSurfaceByAlignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public generateWaterwayDesignSurfaceByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).generateWaterwayDesignSurfaceByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeId
     * @param {string} sessionUuid sessionUuid
     * @param {number} designElementTypeId designElementTypeId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET(sessionUuid: string, designElementTypeId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getAlignedElementDesignParamsBySessionUuidAndDesignElementTypeIdUsingGET(sessionUuid, designElementTypeId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignedElementDesignParamsIdsAndNotificationsBySessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getAlignedElementDesignParamsIdsAndNotificationsBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignedElementShapeByAlignedElementId
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getAlignedElementShapeByAlignedElementIdUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignmentForWDTByDesignElementJsonId
     * @param {number} designElementJsonId designElementJsonId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getAlignmentForWDTByDesignElementJsonIdUsingGET(designElementJsonId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getAlignmentForWDTByDesignElementJsonIdUsingGET(designElementJsonId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAlignmentsForDWT
     * @param {string} projectUuid projectUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getAlignmentsForDWTUsingGET(projectUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getAlignmentsForDWTUsingGET(projectUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllAlignmentsForWDTByStateAndCounty
     * @param {AlignmentForWDTRequestDTO} alignmentForWDTRequestDTO alignmentForWDTRequestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getAllAlignmentsForWDTByStateAndCountyUsingPOST(alignmentForWDTRequestDTO: AlignmentForWDTRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getAllAlignmentsForWDTByStateAndCountyUsingPOST(alignmentForWDTRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllNotificationStatus
     * @param {number} alignedElementId alignedElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getAllNotificationStatusUsingGET(alignedElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getAllNotificationStatusUsingGET(alignedElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get the lining material of a specific aligned design element
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getLiningMaterialByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getLiningMaterialByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getReachChannelParametersByAlignedElementDesignParametersIdAndReachId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} reachId reachId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getReachChannelParametersByAlignedElementDesignParametersIdAndReachIdUsingPOST(alignedElementDesignParametersId, reachId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information required to build waterway construction report
     * @param {WaterwayConstructionReportReqDTO} req req
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getWaterwayConstructionReportUsingPOST(req: WaterwayConstructionReportReqDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getWaterwayConstructionReportUsingPOST(req, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getWaterwayDesignSummaryBySessionUuid
     * @param {string} sessionUuid sessionUuid
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getWaterwayDesignSummaryBySessionUuidUsingGET(sessionUuid: string, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getWaterwayDesignSummaryBySessionUuidUsingGET(sessionUuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getWaterwayInputsByAlignedElementDesignParamsId
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getWaterwayInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getWaterwayInputsByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getWaterwaySummaryReportByAlignedElementDesignParamsIdUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information required to build waterway summary report by passing  alignedDesignParametersId as input for both Lined and Grassed Waterway
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getWaterwaySummaryReportUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getWaterwaySummaryReportUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to get information required to build waterway summary page by passing  alignedDesignParametersId as input
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public getWaterwaySummaryResultsUsingGET(alignedElementDesignParamsId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).getWaterwaySummaryResultsUsingGET(alignedElementDesignParamsId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to distribute runoffQ per length of each reach and re-calculate totalQ using the updated runoffQ
     * @param {ReDistributeRunoffDTO} reRunWSCDTO reRunWSCDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public redistributeRunoffUsingPOST(reRunWSCDTO: ReDistributeRunoffDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).redistributeRunoffUsingPOST(reRunWSCDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary resetDefaultLinedReach
     * @param {number} alignedElementDesignParamsId alignedElementDesignParamsId
     * @param {string} reachId reachId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public resetDefaultLinedReachUsingGET(alignedElementDesignParamsId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).resetDefaultLinedReachUsingGET(alignedElementDesignParamsId, reachId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API reset waterway profiles, provided the alignedElementDesignParametersId: clean up all the reach jsons, structure profiles records for this waterway, and set reachesChanges to 0
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public resetWaterwayProfileResponseUsingDELETE(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).resetWaterwayProfileResponseUsingDELETE(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API is used to save lining material to a aligned design element
     * @param {AlignedElementIdWithLiningMaterialDTO} alignedElementIdWithLiningMaterialDTO alignedElementIdWithLiningMaterialDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public saveLiningMaterialByAlignedDesignElementIDUsingPOST(alignedElementIdWithLiningMaterialDTO: AlignedElementIdWithLiningMaterialDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).saveLiningMaterialByAlignedDesignElementIDUsingPOST(alignedElementIdWithLiningMaterialDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateAllNotificationStatus
     * @param {WaterwayInputChangeDto} waterwayInputChangeDto waterwayInputChangeDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public updateAllNotificationStatusUsingPOST(waterwayInputChangeDto: WaterwayInputChangeDto, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).updateAllNotificationStatusUsingPOST(waterwayInputChangeDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateInvalidDesignUiState
     * @param {string} sessionUuid sessionUuid
     * @param {number} alignmentElementId alignmentElementId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public updateInvalidDesignUiStateUsingPOST(sessionUuid: string, alignmentElementId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).updateInvalidDesignUiStateUsingPOST(sessionUuid, alignmentElementId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateOrUpdateAlignedElementDesignParams
     * @param {AlignedElementDesignParamsRequestDTO} alignedElementDesignParamsRequest alignedElementDesignParamsRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public updateOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest: AlignedElementDesignParamsRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).updateOrUpdateAlignedElementDesignParamsUsingPOST(alignedElementDesignParamsRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateOrUpdateAlignedElementShape
     * @param {AlignedElementShapeDTO} alignedElementShapeRequest alignedElementShapeRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public updateOrUpdateAlignedElementShapeUsingPOST(alignedElementShapeRequest: AlignedElementShapeDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).updateOrUpdateAlignedElementShapeUsingPOST(alignedElementShapeRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateReachLiningMaterials
     * @param {LiningMaterialPatchRequest} liningMaterialPatchRequest liningMaterialPatchRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public updateReachLiningMaterialsUsingPATCH(liningMaterialPatchRequest: LiningMaterialPatchRequest, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).updateReachLiningMaterialsUsingPATCH(liningMaterialPatchRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API synchronizes waterway design control\'s Channel Ends settings:  1. When Slope Distances are provided, calculate Slope Percentages;  2. When Slope Percentages are provided, calculate Slope Distances.
     * @param {DesignControlChannelEndsDTO} designControlChannelEndsRequest designControlChannelEndsRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public updateWaterwayDesignControlSettingsUsingPOST(designControlChannelEndsRequest: DesignControlChannelEndsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).updateWaterwayDesignControlSettingsUsingPOST(designControlChannelEndsRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary waterwaySimulationAndValidation
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayDesignToolsControllerApi
     */
    public waterwaySimulationAndValidationUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayDesignToolsControllerApiFp(this.configuration).waterwaySimulationAndValidationUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WaterwayReachControllerApi - axios parameter creator
 * @export
 */
export const WaterwayReachControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createReach
         * @param {Array<ReachJsonRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReachUsingPOST: async (input: Array<ReachJsonRequestDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('createReachUsingPOST', 'input', input)
            const localVarPath = `/waterwaydesign/ReachJson/createReach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteReachByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReachByAlignedElementDesignParametersIdUsingPOST: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('deleteReachByAlignedElementDesignParametersIdUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/waterwaydesign/ReachJson/deleteReachByAlignedElementDesignParametersId/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteReachByReachIds
         * @param {Array<number>} reachIds reachIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReachByReachIdsUsingPOST: async (reachIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reachIds' is not null or undefined
            assertParamExists('deleteReachByReachIdsUsingPOST', 'reachIds', reachIds)
            const localVarPath = `/waterwaydesign/ReachJson/deleteReachByReachIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reachIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllReachByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReachByAlignedElementDesignParametersIdUsingGET: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getAllReachByAlignedElementDesignParametersIdUsingGET', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/waterwaydesign/ReachJson/getAllReachByAlignedElementDesignParametersId/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllReachByReachIds
         * @param {Array<number>} reachJsonIds reachJsonIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReachByReachIdsUsingGET: async (reachJsonIds: Array<number>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reachJsonIds' is not null or undefined
            assertParamExists('getAllReachByReachIdsUsingGET', 'reachJsonIds', reachJsonIds)
            const localVarPath = `/waterwaydesign/ReachJson/getAllReachByReachIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reachJsonIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAllWaterwayVertexDtoByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET: async (alignedElementDesignParametersId: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            const localVarPath = `/waterwaydesign/ReachJson/getAllWaterwayVertexDtoByAlignedElementDesignParametersId/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET: async (alignedElementDesignParametersId: number, reachId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            // verify required parameter 'reachId' is not null or undefined
            assertParamExists('getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET', 'reachId', reachId)
            const localVarPath = `/waterwaydesign/ReachJson/getWaterwayVertexParamForWscByAlignedElementDesignParametersIdAndReachId/{alignedElementDesignParametersId}/{reachId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)))
                .replace(`{${"reachId"}}`, encodeURIComponent(String(reachId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET: async (alignedElementDesignParametersId: number, reachId: string, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            // verify required parameter 'reachId' is not null or undefined
            assertParamExists('getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET', 'reachId', reachId)
            const localVarPath = `/waterwaydesign/ReachJson/getWaterwayVertexParamForLastWscByAlignedElementDesignParametersIdAndReachId/{alignedElementDesignParametersId}/{reachId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)))
                .replace(`{${"reachId"}}`, encodeURIComponent(String(reachId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API handles multiple edits on WDT Reaches sent by front end and updates database accordingly
         * @param {SaveReachEditsRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReachEditsUsingPOST: async (requestDTO: SaveReachEditsRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('saveReachEditsUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/waterwaydesign/ReachJson/saveReachEdits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary saveWaterwaySizingResponseDtoReaches
         * @param {WaterwaySizingRequestReachDTO} waterwaySizingRequestReachDto waterwaySizingRequestReachDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWaterwaySizingResponseDtoReachesUsingPOST: async (waterwaySizingRequestReachDto: WaterwaySizingRequestReachDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwaySizingRequestReachDto' is not null or undefined
            assertParamExists('saveWaterwaySizingResponseDtoReachesUsingPOST', 'waterwaySizingRequestReachDto', waterwaySizingRequestReachDto)
            const localVarPath = `/waterwaydesign/ReachJson/saveWaterwaySizingResponseDtoReaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterwaySizingRequestReachDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Call insert/update/delete Reach based on alignment AlignedElementDesignParametersId & Station Name 
         * @param {WdtReachesRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWdtReachesUsingPOST: async (requestDTO: WdtReachesRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestDTO' is not null or undefined
            assertParamExists('saveWdtReachesUsingPOST', 'requestDTO', requestDTO)
            const localVarPath = `/waterwaydesign/ReachJson/saveWdtReaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API update elevations for every reach in a waterway, provided the alignedElementDesignParametersId of the waterway and a delta elevation value
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} deltaElevation deltaElevation
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shiftWaterwayElevationsUsingPOST: async (alignedElementDesignParametersId: number, deltaElevation: number, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'alignedElementDesignParametersId' is not null or undefined
            assertParamExists('shiftWaterwayElevationsUsingPOST', 'alignedElementDesignParametersId', alignedElementDesignParametersId)
            // verify required parameter 'deltaElevation' is not null or undefined
            assertParamExists('shiftWaterwayElevationsUsingPOST', 'deltaElevation', deltaElevation)
            const localVarPath = `/waterwaydesign/ReachJson/shiftWaterwayElevations/{alignedElementDesignParametersId}`
                .replace(`{${"alignedElementDesignParametersId"}}`, encodeURIComponent(String(alignedElementDesignParametersId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deltaElevation !== undefined) {
                localVarQueryParameter['deltaElevation'] = deltaElevation;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateEditReaches
         * @param {ReachesUpdateEditRequest} reachesUpdateEditRequest reachesUpdateEditRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEditReachesUsingPOST: async (reachesUpdateEditRequest: ReachesUpdateEditRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reachesUpdateEditRequest' is not null or undefined
            assertParamExists('updateEditReachesUsingPOST', 'reachesUpdateEditRequest', reachesUpdateEditRequest)
            const localVarPath = `/waterwaydesign/ReachJson/updateEditReaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reachesUpdateEditRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateFixedWidthOrDepth
         * @param {ReachFixedWidthDepthRequest} reachFixedWidthDepthRequest reachFixedWidthDepthRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFixedWidthOrDepthUsingPOST: async (reachFixedWidthDepthRequest: ReachFixedWidthDepthRequest, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reachFixedWidthDepthRequest' is not null or undefined
            assertParamExists('updateFixedWidthOrDepthUsingPOST', 'reachFixedWidthDepthRequest', reachFixedWidthDepthRequest)
            const localVarPath = `/waterwaydesign/ReachJson/updateFixedWidthOrDepth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reachFixedWidthDepthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateReach
         * @param {Array<ReachJsonRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReachUsingPUT: async (input: Array<ReachJsonRequestDto>, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'input' is not null or undefined
            assertParamExists('updateReachUsingPUT', 'input', input)
            const localVarPath = `/waterwaydesign/ReachJson/updateReach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(input, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterwayReachControllerApi - functional programming interface
 * @export
 */
export const WaterwayReachControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaterwayReachControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createReach
         * @param {Array<ReachJsonRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReachUsingPOST(input: Array<ReachJsonRequestDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReachJsonResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReachUsingPOST(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteReachByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReachByAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReachByAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary deleteReachByReachIds
         * @param {Array<number>} reachIds reachIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReachByReachIdsUsingPOST(reachIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReachByReachIdsUsingPOST(reachIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllReachByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReachByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReachJsonResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReachByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllReachByReachIds
         * @param {Array<number>} reachJsonIds reachJsonIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReachByReachIdsUsingGET(reachJsonIds: Array<number>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReachJsonResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReachByReachIdsUsingGET(reachJsonIds, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getAllWaterwayVertexDtoByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterwayVertexParamDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayVertexParamDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, reachId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwayVertexParamDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, reachId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API handles multiple edits on WDT Reaches sent by front end and updates database accordingly
         * @param {SaveReachEditsRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveReachEditsUsingPOST(requestDTO: SaveReachEditsRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveReachEditsUsingPOST(requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary saveWaterwaySizingResponseDtoReaches
         * @param {WaterwaySizingRequestReachDTO} waterwaySizingRequestReachDto waterwaySizingRequestReachDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWaterwaySizingResponseDtoReachesUsingPOST(waterwaySizingRequestReachDto: WaterwaySizingRequestReachDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWaterwaySizingResponseDtoReachesUsingPOST(waterwaySizingRequestReachDto, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Call insert/update/delete Reach based on alignment AlignedElementDesignParametersId & Station Name 
         * @param {WdtReachesRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWdtReachesUsingPOST(requestDTO: WdtReachesRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWdtReachesUsingPOST(requestDTO, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API update elevations for every reach in a waterway, provided the alignedElementDesignParametersId of the waterway and a delta elevation value
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} deltaElevation deltaElevation
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async shiftWaterwayElevationsUsingPOST(alignedElementDesignParametersId: number, deltaElevation: number, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShiftWaterwayElevationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shiftWaterwayElevationsUsingPOST(alignedElementDesignParametersId, deltaElevation, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateEditReaches
         * @param {ReachesUpdateEditRequest} reachesUpdateEditRequest reachesUpdateEditRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEditReachesUsingPOST(reachesUpdateEditRequest: ReachesUpdateEditRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterwayVertexParamDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEditReachesUsingPOST(reachesUpdateEditRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateFixedWidthOrDepth
         * @param {ReachFixedWidthDepthRequest} reachFixedWidthDepthRequest reachFixedWidthDepthRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFixedWidthOrDepthUsingPOST(reachFixedWidthDepthRequest: ReachFixedWidthDepthRequest, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReachFixedWidthDepthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFixedWidthOrDepthUsingPOST(reachFixedWidthDepthRequest, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary updateReach
         * @param {Array<ReachJsonRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReachUsingPUT(input: Array<ReachJsonRequestDto>, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReachJsonResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReachUsingPUT(input, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WaterwayReachControllerApi - factory interface
 * @export
 */
export const WaterwayReachControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaterwayReachControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary createReach
         * @param {Array<ReachJsonRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReachUsingPOST(input: Array<ReachJsonRequestDto>, authorization?: string, options?: any): AxiosPromise<Array<ReachJsonResponseDto>> {
            return localVarFp.createReachUsingPOST(input, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteReachByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReachByAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteReachByAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteReachByReachIds
         * @param {Array<number>} reachIds reachIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReachByReachIdsUsingPOST(reachIds: Array<number>, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.deleteReachByReachIdsUsingPOST(reachIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllReachByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReachByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<Array<ReachJsonResponseDto>> {
            return localVarFp.getAllReachByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllReachByReachIds
         * @param {Array<number>} reachJsonIds reachJsonIds
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReachByReachIdsUsingGET(reachJsonIds: Array<number>, authorization?: string, options?: any): AxiosPromise<Array<ReachJsonResponseDto>> {
            return localVarFp.getAllReachByReachIdsUsingGET(reachJsonIds, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAllWaterwayVertexDtoByAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: any): AxiosPromise<Array<WaterwayVertexParamDTO>> {
            return localVarFp.getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: any): AxiosPromise<WaterwayVertexParamDTO> {
            return localVarFp.getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, reachId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersId
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {string} reachId reachId
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: any): AxiosPromise<WaterwayVertexParamDTO> {
            return localVarFp.getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, reachId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API handles multiple edits on WDT Reaches sent by front end and updates database accordingly
         * @param {SaveReachEditsRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReachEditsUsingPOST(requestDTO: SaveReachEditsRequestDTO, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.saveReachEditsUsingPOST(requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary saveWaterwaySizingResponseDtoReaches
         * @param {WaterwaySizingRequestReachDTO} waterwaySizingRequestReachDto waterwaySizingRequestReachDto
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWaterwaySizingResponseDtoReachesUsingPOST(waterwaySizingRequestReachDto: WaterwaySizingRequestReachDTO, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.saveWaterwaySizingResponseDtoReachesUsingPOST(waterwaySizingRequestReachDto, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Call insert/update/delete Reach based on alignment AlignedElementDesignParametersId & Station Name 
         * @param {WdtReachesRequestDTO} requestDTO requestDTO
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWdtReachesUsingPOST(requestDTO: WdtReachesRequestDTO, authorization?: string, options?: any): AxiosPromise<string> {
            return localVarFp.saveWdtReachesUsingPOST(requestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API update elevations for every reach in a waterway, provided the alignedElementDesignParametersId of the waterway and a delta elevation value
         * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
         * @param {number} deltaElevation deltaElevation
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shiftWaterwayElevationsUsingPOST(alignedElementDesignParametersId: number, deltaElevation: number, authorization?: string, options?: any): AxiosPromise<ShiftWaterwayElevationResponse> {
            return localVarFp.shiftWaterwayElevationsUsingPOST(alignedElementDesignParametersId, deltaElevation, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateEditReaches
         * @param {ReachesUpdateEditRequest} reachesUpdateEditRequest reachesUpdateEditRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEditReachesUsingPOST(reachesUpdateEditRequest: ReachesUpdateEditRequest, authorization?: string, options?: any): AxiosPromise<Array<WaterwayVertexParamDTO>> {
            return localVarFp.updateEditReachesUsingPOST(reachesUpdateEditRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateFixedWidthOrDepth
         * @param {ReachFixedWidthDepthRequest} reachFixedWidthDepthRequest reachFixedWidthDepthRequest
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFixedWidthOrDepthUsingPOST(reachFixedWidthDepthRequest: ReachFixedWidthDepthRequest, authorization?: string, options?: any): AxiosPromise<ReachFixedWidthDepthResponse> {
            return localVarFp.updateFixedWidthOrDepthUsingPOST(reachFixedWidthDepthRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateReach
         * @param {Array<ReachJsonRequestDto>} input input
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReachUsingPUT(input: Array<ReachJsonRequestDto>, authorization?: string, options?: any): AxiosPromise<Array<ReachJsonResponseDto>> {
            return localVarFp.updateReachUsingPUT(input, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterwayReachControllerApi - object-oriented interface
 * @export
 * @class WaterwayReachControllerApi
 * @extends {BaseAPI}
 */
export class WaterwayReachControllerApi extends BaseAPI {
    /**
     * 
     * @summary createReach
     * @param {Array<ReachJsonRequestDto>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public createReachUsingPOST(input: Array<ReachJsonRequestDto>, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).createReachUsingPOST(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteReachByAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public deleteReachByAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).deleteReachByAlignedElementDesignParametersIdUsingPOST(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteReachByReachIds
     * @param {Array<number>} reachIds reachIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public deleteReachByReachIdsUsingPOST(reachIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).deleteReachByReachIdsUsingPOST(reachIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllReachByAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public getAllReachByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).getAllReachByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllReachByReachIds
     * @param {Array<number>} reachJsonIds reachJsonIds
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public getAllReachByReachIdsUsingGET(reachJsonIds: Array<number>, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).getAllReachByReachIdsUsingGET(reachJsonIds, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAllWaterwayVertexDtoByAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).getAllWaterwayVertexDtoByAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} reachId reachId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).getWaterwayVertexParamDTOForDefaultWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, reachId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersId
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {string} reachId reachId
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId: number, reachId: string, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).getWaterwayVertexParamDTOForWscByReachIdAndAlignedElementDesignParametersIdUsingGET(alignedElementDesignParametersId, reachId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API handles multiple edits on WDT Reaches sent by front end and updates database accordingly
     * @param {SaveReachEditsRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public saveReachEditsUsingPOST(requestDTO: SaveReachEditsRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).saveReachEditsUsingPOST(requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary saveWaterwaySizingResponseDtoReaches
     * @param {WaterwaySizingRequestReachDTO} waterwaySizingRequestReachDto waterwaySizingRequestReachDto
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public saveWaterwaySizingResponseDtoReachesUsingPOST(waterwaySizingRequestReachDto: WaterwaySizingRequestReachDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).saveWaterwaySizingResponseDtoReachesUsingPOST(waterwaySizingRequestReachDto, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Call insert/update/delete Reach based on alignment AlignedElementDesignParametersId & Station Name 
     * @param {WdtReachesRequestDTO} requestDTO requestDTO
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public saveWdtReachesUsingPOST(requestDTO: WdtReachesRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).saveWdtReachesUsingPOST(requestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API update elevations for every reach in a waterway, provided the alignedElementDesignParametersId of the waterway and a delta elevation value
     * @param {number} alignedElementDesignParametersId alignedElementDesignParametersId
     * @param {number} deltaElevation deltaElevation
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public shiftWaterwayElevationsUsingPOST(alignedElementDesignParametersId: number, deltaElevation: number, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).shiftWaterwayElevationsUsingPOST(alignedElementDesignParametersId, deltaElevation, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateEditReaches
     * @param {ReachesUpdateEditRequest} reachesUpdateEditRequest reachesUpdateEditRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public updateEditReachesUsingPOST(reachesUpdateEditRequest: ReachesUpdateEditRequest, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).updateEditReachesUsingPOST(reachesUpdateEditRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateFixedWidthOrDepth
     * @param {ReachFixedWidthDepthRequest} reachFixedWidthDepthRequest reachFixedWidthDepthRequest
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public updateFixedWidthOrDepthUsingPOST(reachFixedWidthDepthRequest: ReachFixedWidthDepthRequest, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).updateFixedWidthOrDepthUsingPOST(reachFixedWidthDepthRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateReach
     * @param {Array<ReachJsonRequestDto>} input input
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwayReachControllerApi
     */
    public updateReachUsingPUT(input: Array<ReachJsonRequestDto>, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwayReachControllerApiFp(this.configuration).updateReachUsingPUT(input, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WaterwaySizingControllerApi - axios parameter creator
 * @export
 */
export const WaterwaySizingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary This API Calculates Vegetal Cover Stability RCI Takes stabStemLength,stabStemDensity as input parameters  and responds back with calculated stabilityRCI along with Input parameters
         * @param {VegetalCoverStabilityRCICalReqDTO} stabilityRCIReq stabilityRCIReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calVegetalCoverStabilityRCIUsingPOST: async (stabilityRCIReq: VegetalCoverStabilityRCICalReqDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stabilityRCIReq' is not null or undefined
            assertParamExists('calVegetalCoverStabilityRCIUsingPOST', 'stabilityRCIReq', stabilityRCIReq)
            const localVarPath = `/waterwaysizing/calVegetalCoverStabililtyRCI`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stabilityRCIReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates SoilGrainRoughness Takes soilType,d75 as input parameters  and responds back with calculated soilgrainroughness along with Input parameters
         * @param {SoilRoughnessCalRequestDTO} soilRoughnessReq soilRoughnessReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSoilGrainRoughnessUsingPOST: async (soilRoughnessReq: SoilRoughnessCalRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'soilRoughnessReq' is not null or undefined
            assertParamExists('calculateSoilGrainRoughnessUsingPOST', 'soilRoughnessReq', soilRoughnessReq)
            const localVarPath = `/waterwaysizing/calculateSoilRoughness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(soilRoughnessReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Allowable  Soil Stress. Takes soilType,voidRatio,plasticity,d75 as input parameters  and responds back with calculated soil stress along with Input parameters
         * @param {SoilStressCalRequestDTO} soilStressReq soilStressReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSoilStressUsingPOST: async (soilStressReq: SoilStressCalRequestDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'soilStressReq' is not null or undefined
            assertParamExists('calculateSoilStressUsingPOST', 'soilStressReq', soilStressReq)
            const localVarPath = `/waterwaysizing/calculateSoilStress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(soilStressReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This API Calculates Waterwaysizing, takes  WaterwaySizingParamsDTO  as input parameters  and responds back with calculated values  along with Input parameters
         * @param {WaterwaySizingParamsDTO} waterwaySizingParams waterwaySizingParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateWaterwaySizingUsingPOST: async (waterwaySizingParams: WaterwaySizingParamsDTO, authorization?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waterwaySizingParams' is not null or undefined
            assertParamExists('calculateWaterwaySizingUsingPOST', 'waterwaySizingParams', waterwaySizingParams)
            const localVarPath = `/waterwaysizing/calWaterwaySizing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waterwaySizingParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaterwaySizingControllerApi - functional programming interface
 * @export
 */
export const WaterwaySizingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaterwaySizingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary This API Calculates Vegetal Cover Stability RCI Takes stabStemLength,stabStemDensity as input parameters  and responds back with calculated stabilityRCI along with Input parameters
         * @param {VegetalCoverStabilityRCICalReqDTO} stabilityRCIReq stabilityRCIReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calVegetalCoverStabilityRCIUsingPOST(stabilityRCIReq: VegetalCoverStabilityRCICalReqDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VegetalCoverStabilityRCICalRespDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calVegetalCoverStabilityRCIUsingPOST(stabilityRCIReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates SoilGrainRoughness Takes soilType,d75 as input parameters  and responds back with calculated soilgrainroughness along with Input parameters
         * @param {SoilRoughnessCalRequestDTO} soilRoughnessReq soilRoughnessReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateSoilGrainRoughnessUsingPOST(soilRoughnessReq: SoilRoughnessCalRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoilRoughnessCalResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateSoilGrainRoughnessUsingPOST(soilRoughnessReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Allowable  Soil Stress. Takes soilType,voidRatio,plasticity,d75 as input parameters  and responds back with calculated soil stress along with Input parameters
         * @param {SoilStressCalRequestDTO} soilStressReq soilStressReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateSoilStressUsingPOST(soilStressReq: SoilStressCalRequestDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoilStressCalResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateSoilStressUsingPOST(soilStressReq, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This API Calculates Waterwaysizing, takes  WaterwaySizingParamsDTO  as input parameters  and responds back with calculated values  along with Input parameters
         * @param {WaterwaySizingParamsDTO} waterwaySizingParams waterwaySizingParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateWaterwaySizingUsingPOST(waterwaySizingParams: WaterwaySizingParamsDTO, authorization?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterwaySizingResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateWaterwaySizingUsingPOST(waterwaySizingParams, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WaterwaySizingControllerApi - factory interface
 * @export
 */
export const WaterwaySizingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaterwaySizingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary This API Calculates Vegetal Cover Stability RCI Takes stabStemLength,stabStemDensity as input parameters  and responds back with calculated stabilityRCI along with Input parameters
         * @param {VegetalCoverStabilityRCICalReqDTO} stabilityRCIReq stabilityRCIReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calVegetalCoverStabilityRCIUsingPOST(stabilityRCIReq: VegetalCoverStabilityRCICalReqDTO, authorization?: string, options?: any): AxiosPromise<VegetalCoverStabilityRCICalRespDTO> {
            return localVarFp.calVegetalCoverStabilityRCIUsingPOST(stabilityRCIReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates SoilGrainRoughness Takes soilType,d75 as input parameters  and responds back with calculated soilgrainroughness along with Input parameters
         * @param {SoilRoughnessCalRequestDTO} soilRoughnessReq soilRoughnessReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSoilGrainRoughnessUsingPOST(soilRoughnessReq: SoilRoughnessCalRequestDTO, authorization?: string, options?: any): AxiosPromise<SoilRoughnessCalResponseDTO> {
            return localVarFp.calculateSoilGrainRoughnessUsingPOST(soilRoughnessReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Allowable  Soil Stress. Takes soilType,voidRatio,plasticity,d75 as input parameters  and responds back with calculated soil stress along with Input parameters
         * @param {SoilStressCalRequestDTO} soilStressReq soilStressReq
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateSoilStressUsingPOST(soilStressReq: SoilStressCalRequestDTO, authorization?: string, options?: any): AxiosPromise<SoilStressCalResponseDTO> {
            return localVarFp.calculateSoilStressUsingPOST(soilStressReq, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This API Calculates Waterwaysizing, takes  WaterwaySizingParamsDTO  as input parameters  and responds back with calculated values  along with Input parameters
         * @param {WaterwaySizingParamsDTO} waterwaySizingParams waterwaySizingParams
         * @param {string} [authorization] Access Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateWaterwaySizingUsingPOST(waterwaySizingParams: WaterwaySizingParamsDTO, authorization?: string, options?: any): AxiosPromise<WaterwaySizingResponseDTO> {
            return localVarFp.calculateWaterwaySizingUsingPOST(waterwaySizingParams, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaterwaySizingControllerApi - object-oriented interface
 * @export
 * @class WaterwaySizingControllerApi
 * @extends {BaseAPI}
 */
export class WaterwaySizingControllerApi extends BaseAPI {
    /**
     * 
     * @summary This API Calculates Vegetal Cover Stability RCI Takes stabStemLength,stabStemDensity as input parameters  and responds back with calculated stabilityRCI along with Input parameters
     * @param {VegetalCoverStabilityRCICalReqDTO} stabilityRCIReq stabilityRCIReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwaySizingControllerApi
     */
    public calVegetalCoverStabilityRCIUsingPOST(stabilityRCIReq: VegetalCoverStabilityRCICalReqDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwaySizingControllerApiFp(this.configuration).calVegetalCoverStabilityRCIUsingPOST(stabilityRCIReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates SoilGrainRoughness Takes soilType,d75 as input parameters  and responds back with calculated soilgrainroughness along with Input parameters
     * @param {SoilRoughnessCalRequestDTO} soilRoughnessReq soilRoughnessReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwaySizingControllerApi
     */
    public calculateSoilGrainRoughnessUsingPOST(soilRoughnessReq: SoilRoughnessCalRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwaySizingControllerApiFp(this.configuration).calculateSoilGrainRoughnessUsingPOST(soilRoughnessReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Allowable  Soil Stress. Takes soilType,voidRatio,plasticity,d75 as input parameters  and responds back with calculated soil stress along with Input parameters
     * @param {SoilStressCalRequestDTO} soilStressReq soilStressReq
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwaySizingControllerApi
     */
    public calculateSoilStressUsingPOST(soilStressReq: SoilStressCalRequestDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwaySizingControllerApiFp(this.configuration).calculateSoilStressUsingPOST(soilStressReq, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This API Calculates Waterwaysizing, takes  WaterwaySizingParamsDTO  as input parameters  and responds back with calculated values  along with Input parameters
     * @param {WaterwaySizingParamsDTO} waterwaySizingParams waterwaySizingParams
     * @param {string} [authorization] Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaterwaySizingControllerApi
     */
    public calculateWaterwaySizingUsingPOST(waterwaySizingParams: WaterwaySizingParamsDTO, authorization?: string, options?: AxiosRequestConfig) {
        return WaterwaySizingControllerApiFp(this.configuration).calculateWaterwaySizingUsingPOST(waterwaySizingParams, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


